// WorkflowModalSnapshotPage.tsx · v12.10.27 (#2170 "Workflow saved" toast) · 2026-10-31 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.26 (#2143 T2: + Add language for AI Agent languages missing from the workflow; T2 + T4: x removes a non-primary language, asks first) · 2026-10-30 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.25 (#2103 Change template shown only when the host allows it - T2: Support visit) · 2026-10-30 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.23 (#2012 #2028 #2029 UI-PROTO-MENUS-T174 v1.5 LOCKED: Classify card order Re-ask line · When nothing matches (On fail + the Keypad menu as ONE collapsed Interceptor-style row) · Keyword library; Silent caller moved to Settings › Call Handling; every caller-type card: Re-ask line + Keypad menu row (requestReask / requestMenuPrompt); Something else always last, never deleted) · 2026-10-29 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx - v12.10.22.2 (#2061): a step's routing list names a shared card by its own name ('Identity'), not 'Node 1'. · 2026-10-28
// WorkflowModalSnapshotPage.tsx · v12.10.22 (#2011 intent card Category - its own or an existing one; #2037 #2038 #2039 #2040 terminal cards per prototype v1.4 - Take a message, Handoff | Take a message, Reference number block, Anything else? block; #2033 Classify: AI processing switch replaces Process data; #1984 Move earlier / later and Copy to intent save at once; #1985 request-type keywords per language in the drawer; #1994 request types Move earlier / later; #1988 Read-backs: real switches + on / off count per block; #1986 Next step for staff box removed) · 2026-10-28 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.21 (#1957 Read-backs card in lane 7 + one pointer line per step + Confidence default from configuration; #1917 ID check: Verified after 0..10, Skip verification for contacts with External ID, match fields shown) · 2026-10-26 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.19 (#1925 Next step line per request type; #1907 Silent caller rule; #1928 #1913 the lines a step can also speak, below its fields) · 2026-10-23 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.18 (#1866 changes counted per intent; our own last save is the expected version; no second save while one is on its way) · 2026-10-22 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.17 (#1723 T120 follow-up: intent "Files under" picker RETIRED per Tushar 10/16 - the category is the intent card itself (BDR-018 D10/D12); old snapshots keep the field untouched) · 2026-10-16 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.17 (T123 #1747 the ID check card - Pre-routing, pinned before the Greeting, its drawer per UI-PROTO-ID-CHECK-T123 v1.1; #1776 the Greeting's Regular / ID matched / Repeat caller prompts) · 2026-10-16 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.16.1 (#1711 Save sends the version it loaded; 409 = changed since - reload) · 2026-10-14 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.16 (#1672 ticks; #1674 Re-ask preview; #1675 Callback card Store default + no Steps; #1676 Ask together fills the combined question; #1695 help text) · 2026-10-14 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.15 (#1500 no-staff offer switch + per-language line on Transfer or end call; #1641 keypad If no key is pressed; #1644 Classify "If the reason can't be worked out"; #1643 Ask together on Identity + request types, Question budget; #1653 Interceptor › Call intent verification; #1660 Text card Re-ask + Ask cap; #1663 Callback card) · 2026-10-13 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.11.1 (#1465 Spanish proofreading 12.10.11) · 2026-10-09
// WorkflowModalSnapshotPage.tsx · v12.10.11.1 (#1486 intent card "Files under" - the category its calls are filed under; ?card=intent deep link from Edit category) · 2026-10-09
// WorkflowModalSnapshotPage.tsx · v12.10.11 (#1458 new text uses {organization.name} - the vocabulary token; {organization.practiceName} / {tenant.practiceName} stay readable as aliases) · 2026-10-08
// WorkflowModalSnapshotPage.tsx · v12.10.10.1 (#1417 switch line + #1418 Confirm re-ask lines show the built-in text, not grey; #1428 drawerOpen in the shell state) · 2026-10-08 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.10 (#1401 a failed save is never silent - 'Could not save' with the reason, the drawer stays open; #1409 template header V1 + page line; #1408 prompt boxes) · 2026-10-08 · VoiceSpectrum AI
// WorkflowModalSnapshotPage.tsx · v12.10.9.4 (#1357 US spelling) · 2026-10-07 · VoiceSpectrum AI
// WorkflowModalSnapshotPage · v12.10.8 (#1190 the Identity card loses "+ Add identity field..." and its help line - steps are added with
//   "+ Add step" and say what they store by token; no identifiers are read; #1227 Off fields are not suggested in Stores / Your fields) · 2026-10-05
// WorkflowModalSnapshotPage.tsx - v12.10.7.1 (#1195 the Preview runtime bar is hidden in template mode - T4 has it in More actions).
// WorkflowModalSnapshotPage.tsx - v12.10.7 (#937 #947 #1151, T19 first version): ONE language rail (LanguageRail) on every card - the retired strip and the dead header strip are deleted; order on every card = settings box -> rail -> per-language content (§37): Hours check rail moved below its settings, Language detect splits its Detection box from the per-language offer and says what each tab holds, Classify's When-nothing-matches + keypad keys and Terminal's After speaking / Wait / anything-else switch moved into the settings box; Offer <language> carries its Announce switch on the title row; mid-section titles no longer overlap the field above (#1151).
// WorkflowModalSnapshotPage.tsx - v12.10.5.1 (#1149): the interceptor card "Terminal keyword" reads "Transfer or end call"; (#1148): the Language detect card's offer tab carries the "Confirm switch" question.
// WorkflowModalSnapshotPage.tsx - v12.10.5 (#1130): Route to operator is offered in every destination list and runs at ANY hour when the Outside operator line is set and VERIFIED (#1131) - the After hours switch no longer decides it. (#1129): its drawer says why the switch is held, with a link to AI Agent › Handoff.
// WorkflowModalSnapshotPage.tsx - v12.10.4 (#1119): Route to operator is shown DISABLED on the grid and is not selectable (with why) in every destination list while the Outside operator line is off (useOffTerminals). (#1120): the Text card preview fills {request.feedbackLink} with a sample short link.
// WorkflowModalSnapshotPage.tsx - v12.10.3 (BDR-016 step 1): MOVED from VoiceSpectrum.Web.T2/src/pages to Source/src/shared-designer/src/pages - the one designer T2 and T4 share. api / toast / Phone & Activation come from the host (host.tsx); 'template' mode (T4) hides the tenant-only Change template.
// WorkflowModalSnapshotPage.tsx - v12.10.2 (#1087): warm transfer - Press 1 switch and "Hold the line and keep trying" enabled. (#1114/#1097): Route to operator FOLLOWS the Outside operator line (shown on/off with it, no switch of its own); Who answers shows the After hours line switched on.
// WorkflowModalSnapshotPage.tsx - v12.10.2 (#1093): normalizeNode keeps the five Announce fields (a save no longer erases the line). (#1094): Announce settings below the line in one row, Ask cap, template line shown and spoken when blank. (#1095): Description full width on the Text and Announce cards. (#1096): the old shipped whisper counts as not set.
// WorkflowModalSnapshotPage.tsx - v12.10.1 (#1086 UI-LOCK-12.10.1 v1.5): Transfer to staff / Route to operator cards - Who answers (read-only), Announce before the transfer, Whisper (+ Press 1, Phase 2, locked), If no one answers (Say per language, Then), anything-else; After speaking / Wait removed from both; Route to operator has no keywords, shows the Outside operator line and cannot be enabled while it is off. (#1085 UI-LOCK v1.6 screen 4): the Announce card type.
// WorkflowModalSnapshotPage.tsx - v12.9.28 (#1077): terminal cards show their template message in light gray when blank or still a card name; Fallback card carries the outside operator number. (#1057): Text message card - Feedback form address for {request.feedbackLink}.
// WorkflowModalSnapshotPage.tsx - v12.9.27 (#1044): Language detect card - the locked language rail, and a Switch line section on every tab (the one place it is edited); #1042 no Enabled switch on the Phrases drawer.
// WorkflowModalSnapshotPage.tsx - v12.9.26 (#988 request-type chips show and rename the tab language's name; #946 no Machine-translated wording; failed texts named at save time with Retry; #928 Detect mode removed; #932 Offer <language>; #933 platform lines shown; #934 threshold shows the stored value; #969 lane 7 'Phrases' - every line a tenant may reword, every enabled language; #954 Wait-for-response tooltips; #966 Classify re-ask line) (#967): 'Ask cap' on every card that asks (total asks, silence counts); Classify / Language detect store askCap. (#985): Confirm card 'Skip the read-back when already confirmed' + 'Skip only when at least N'; (#987) blank Confirm boxes show the built-in line in the tab language.
// WorkflowModalSnapshotPage.tsx - v12.9.25 (#965): Confirm "can't be confirmed" route lists the cards AHEAD + terminals, default named, and a per-language line; (#927) terminal keywords per language; (#956) request-type names/keywords per language survive save.
// WorkflowModalSnapshotPage.tsx - v12.9.24 (#921): Classify drawer - language strip below the header block, notes into tooltips, JSX \u text fixed.
// WorkflowModalSnapshotPage.tsx - v12.9.24 (#911): publish reports auto-translation; machine-filled texts are badged through MachineFilledContext.
// WorkflowModalSnapshotPage.tsx - v12.9.24 (#910): Language detect card - re-ask question (primary tab) + per-language Announce / invite / language-name lines; manual fallback prompt retired.
// WorkflowModalSnapshotPage.tsx - v12.9.1 (#707/#708): Input cleanup now sits ABOVE the Retry line (his order: how the answer is READ, then what is said when it fails, then the ladder).
// v12.9.1 (#707): step Confidence is a stepper with a type-aware default (name 0.60), and its help no longer describes behaviour the confidence band replaced.
// v12.7.2 (#616): a Connect node points at its connected system by STABLE ID, and a node whose connection is
//   gone says so on the card and in the tree - not only inside its own drawer, where #487 put it and where
//   nobody looked while two calls failed. providerId is read in normalizeDoc or the next save deletes it (#294).
// v12.7.2 (#610): THE #566 NOTE IS GONE FROM THE STEP ROW. It was a <div> inside a grid cell sized for a
//   dropdown, so on a name step it wrapped and pushed the whole Identity row out of shape - Tushar's
//   screenshot, 2026-09-22: "see how it messed up the format? why this happens... not sure why it is there
//   and it should be part of a tooltip". He is right, and it already IS: the Unsure tooltip's fourth
//   section ("On a name step") says the same sentence, and the option labels carry "(same as Default
//   here)" inline. The note was a third copy of one fact, and the only one of the three that could
//   change a row's height.
//   MINE, AND SHIPPED WITHOUT OPENING THE SCREEN in 12.7.1 - which is what section 3.5 of
//   BUILD_DEPLOY_VERIFY exists to prevent. The UI pass is not optional on this release.
// v12.6.2 (#569): the Confidence and Unsure help text says what the engine now does - a low score FLAGS a
//   capture for review and never re-asks it; Unsure chooses how a value that failed its TYPE is asked again.
// WorkflowModalSnapshotPage.tsx - v12.5.0 (#525): THE TEXT CONFIRMATION CARD.
//   A new node type, "TextConfirm", the tenant drops where they want it - in the Harlem flow, straight after
//   the Reference Number card. It ASKS first and sends only on a clear yes (Tushar's decision, and the standard
//   TCPA defence for texting someone who called you), and it carries three per-language texts authored here:
//   textOffer (what the agent asks), textMessage (what the SMS contains) and textSent (an optional spoken
//   acknowledgement). Each is blank-means-nothing: no offer = the card does nothing, no message = nothing is
//   sent, no acknowledgement = silence.
//   THE DEFAULTS ARE SEEDED HERE, NOT COMPILED INTO THE CALL ENGINE - the same choice identStepPrompt makes,
//   and WorkflowDesignerNode.TextOffer says so in its own comment. A tenant owns editable content instead of
//   inheriting a sentence nobody in the practice ever wrote (#503/#508, and his blunter rule: "i hate hard
//   coded values surface at unexpected times").
//   THE MESSAGE DEFAULT IS DELIBERATELY THIN - practice name and reference number, nothing else. Appointment
//   details are PHI and SMS is not encrypted, so they go out only if the tenant deliberately adds them.
//   Composes with #505 unchanged: a TextConfirm card is an ordinary continuing card, so endsEveryBranch says
//   false for it and its success/fail outcomes flow through jumpTargets like every other card's.
// v12.4.16 (#504 follow-up): "On confirm → go to" writes the explicit `success` outcome the engine reads,
//   through the same setOutcomeRoute/ROUTE_CONTINUE mechanism as the Connect error route. It had gone on
//   writing node.terminalKey, which #504 stopped anyone reading on a Confirm card - a dead dropdown. An
//   un-migrated node still displays its legacy value; the save converts it and clears the legacy field.
//   The ENGINE IS UNCHANGED and the retired fallback stays retired.
// v12.4.16 (#505): an ENABLED card that no call can reach now says so - on its own card, in the sequence
//   view, and in a warning shown before the save that names the stranded card AND the route that strands it.
//   Scope is Tushar's correction, not my first proposal: an early terminal route with nothing enabled behind
//   it is a CORRECT workflow and draws nothing at all. The walk mirrors the engine after #504 retired the
//   legacy node.TerminalKey fallback - a missing outcome means continue, so only a Terminal card or a Confirm
//   whose explicit success outcome is a terminal can strand anything.
// v12.4.14 (#85c): a Connect node's editor matches what the node actually is - no Retry cap, no On fail
//   (it asks the caller nothing), and the stale "default terminal" note replaced by what the engine now does:
//   this node's error terminal if one is set, otherwise the Caller fallback in the Integrations failure policy.
// v12.4.12 (#477 comment text rendered under Name in the Request drawer; #478 node delete + tree + summary count request-type steps via nodeStepCount)
// v12.2.47.8 (#273 optional/branch capture step: Optional flag + If-captured route; #274 Confirm node per-request-type read-backs auto-discovered from the Request node)
// v12.2.47.7 (#271 unify workflow cards: Disable/Enable on workflow+intent+node menus + disabled view + removed workflow-card +; engine skips disabled workflow/intent at runtime)
// v12.2.47.6 (#272 Request-node drawer QA fixes A-H: field-grid alignment+44px, restore field ? tooltips, Request-types separators, ? alignment, Confidence default placeholder/stepper/clear, If unsure->Unsure, equal conf/unsure widths, lang-hint no-clip, disabled step greys whole card, disabled chip reads disabled when selected)
// v12.2.47.5 (#269 Request-node drawer REBUILD to SPEC v1.3/ref v1.8 — nodecard+band, plain request-types section, tinted scope panel w/ language rail, 2-row step grid, ladder, confirm dialog; #270 FlowCard uniform ⋮ menu + node Disable + Disabled badge bottom-right)
// v12.2.47.4 (#266/#267/#268): drawer polish — Unable-to-capture next to Description; Request-types tooltip; drop 'ready'; remove lang hint; chip hover+disabled; step 'Step N' header + 60% name; remove node arrange footer
// v12.2.47.3: node/workflow ⋮ Edit opens the drawer (like intents); all card/chip/step three-dots triggers now vertical (⋮)
// v12.2.47.1 (#260): step ⋯ menu + inline confidence; prior 47.0 (Request-node): chips + popup + per-step confidence
// v12.2.43.2 (#235 Stores labeled chips + false-unrecognized fix + entity default labels; #252 terminal formatting)
// v12.2.43.1 (#225 tooltip final sweep; #235/#236/#246 alias+label-aware token picker — patient./subject./vocab-label all resolve to ONE canonical labeled entry; split comma-Stores)
// v12.2.41.0 (#239): per-node outcome routing (Confirm exhausted / Connect error -> terminal) + Default-terminal fallback flag + outcomes schema.
// WorkflowModalSnapshotPage.tsx - v12.2.36.0 (designer polish 4: #192 Save via shell hero, #196 Classify remove controls, #198 keypad note, #199 picker nav, #200 patient-only names, #201 appointment tokens, #202 node/step preview)
// WorkflowModalSnapshotPage.tsx - v12.2.40.0 (#225 '?' help on captions, #226 Play speaks sample preview, #227 identity Stores editable+multi-key, #234 Confirm correction prompt; prior #217/#206/#218/#213/#174)
// WorkflowModalSnapshotPage.tsx — v12.2.34.0 (designer batch: #184 drawer close/baseline, #185/#186/#187 card ⋯ menu + type-to-confirm delete + header, #188 dynamic tokens, #189 add-step button + linked identity)
// v12.2.25.0: (#159b) node run-order can now be changed RIGHT ON the Card View — each Nodes card shows ◀ / ▶
// move controls + an "N/total" order badge, so e.g. an Appointment (Steps) node can be dragged in front of
// Book slot without opening its editor. (Reorder still also available as Move up/down inside the node editor.)
// Persists on the page "Save" like any other canvas edit. NOTE: this build also carries the full v12.2.24.0
// NODE-FLOW-2 set (below), whose version stamp never reached the browser because package.json wasn't bumped.
// v12.2.24.0 (NODE-FLOW-2)
// v12.2.24.0: (#158) node steps are now INLINE-editable — name, stores key, prompt + insert-token chips, all
// editable after adding. (#151) each step has a Remove (×) control. (#159) steps AND nodes reorder with
// Move up / Move down. (#152) a node can be removed from its editor (save + close). (#153) disabled ("parked")
// nodes now render dimmed on the Card View canvas, not just inside the drawer. (#154) the Terminal editor gains
// the full prompt editor (insert-token picker + live PREVIEW + ▶ Play) so Thank-You read-backs can be authored.
// WorkflowModalSnapshotPage.tsx — v12.2.23.0 (NODE-FLOW)
// v12.2.23.0: (#145) node enable/disable toggle now works for node cards (persists node.enabled; runtime skips
// disabled nodes). (#147) Identity nodes add steps by picking a configured Identity-extraction field (editable
// prompt). (#149) new "Thank You" terminal outcome + a Terminal node "Outcome" picker to route to it.
// WorkflowModalSnapshotPage.tsx — v12.2.20.0 (PRE-FIX)
// v12.2.20.0 (PRE-FIX): (1) drawer "Done" now PERSISTS (saves the whole doc so edits survive navigating
// away — the reported "data not saving" bug on Hours/Disclosure/etc.); "Cancel"/x/backdrop DISCARD the
// edits made while the drawer was open. (2) Preview boxes resolve {organization.*} tokens with the SAME
// context the runtime uses (practiceName / phone / supported+primary language) via resolveTokens, so
// preview == call. (3) Language-detect + Classify gain a "Wait for response" (silence) control; when the
// caller says nothing within it the manual fallback / keypad plays. (4) Classify keyword-add fix +
// Keypad-menu grouping/relabel. NOTE: rebuilt from the v12.2.19.0 build source (the working-tree file had
// been reverted to v12.2.17.0, losing the WF-KEYPAD editor — recovered from the dist sourcemap).
// v12.2.19.0 (WF-KEYPAD): Classify editor gains a Keypad menu (digit -> caller type) shown when Classify is
// disabled (primary IVR) or the on-fail is a keypad mode. Stored at preRouting.classify.keypad = {prompt:{en}, options}.
// Per-card bespoke pre-routing editors: Inbound reuses the AI Agent Phone & Activation element,
// Hours = Name/Purpose + after-hours + On-fail locked to Voicemail, Disclosure = repeatable spoken
// announcement blocks. Enabled toggle moved into the drawer header. Language tabs only on language-
// specific cards (Disclosure, Greeting). Fixes: French·FR / German·DE tab labels, missing disclosure
// text config, stray language-tab scrollbar.
// v12.2.17.0: Classify card = keyword library (caller types + intents, each with keyword tags) +
// confidence threshold + repeat frequency; Language detect gains the matching Repeat frequency control.
import { createContext, useContext, useEffect, useMemo, useRef, useState, type ReactNode } from 'react';   // v12.10.21 (#1957): createContext / useContext - the step pointer opens the Read-backs card
import { createPortal } from 'react-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
// v12.3.10 (#299): every delete in the drawer confirms itself. A silent removal reads as a lost click.
import { toast } from '../lib/toast';
import { Alert } from '../components/ds';
// v12.10.3 (BDR-016): Phone & Activation is T2's own section - the host passes it in (shared-designer/src/host.tsx).
import { PhoneActivationSection, usePhoneHandlesLabel, designerMode, type PhoneActivationHandle, canChangeTemplate } from '../host';
import { TokenPicker, type TokenGroup } from '../components/aiagent/TokenPicker';
import { resolveTokens, resolveTokenSegments, RESOLVER_KNOWN_TOKENS, type TokenContext } from '../lib/tokenPreview';
import { HelpTooltip, type HelpSection } from '../components/aiagent/HelpTooltip';
// v12.3.9 (#238-A): PromptEditor + its token/language helpers moved to components/PromptEditor.tsx so the
// Knowledge Base Quick-Answer editor uses the SAME editor. Same code, imported — no behaviour change here.
import { MachineFilledContext, PromptEditor, UnresolvedTokenNote, canonLang, canonToken, catalogGroups, platformGroups, langLabel, makeAliasOf, renderPromptPreview, tokenContextFrom, tokenLabel, useVocabulary, ENTITY_ALIAS, ENTITY_DEFAULT_LABEL, FIELD_PRETTY, LANGUAGE_INFO, prettyField, type AiAgentTokenSettings, type VocabCatalogEntity, type CustomField, type RefListLite } from '../components/PromptEditor';
import { LadderBlock, reaskPlatformDefault, identSeedPrompt, CONFIRM_BUILTIN } from '../components/designer/LadderBlock';   // v12.7.3 (#647) + v12.9.21 (#860, #863)
import { StepCleanupSelect } from '../components/designer/StepCleanupSelect';   // v12.8.1 (#672)
import { RetryLine } from '../components/designer/RetryLine';   // v12.8.2 (#676/#685)
// v12.10.17 (#1723 T120 follow-up): lib/filesUnder no longer imported - the "Files under" picker is retired (Tushar 10/16).
import './workflow-modal-snapshot.css';

type TabKey = 'card' | 'tree' | 'tech';

// v12.2.23.0 (#147) / v12.9.21 (#863): DELETED, not translated.
// This was seven English literals with no language parameter, and the call site below stores the result
// under the ACTIVE language key - so adding an identity step on the Spanish tab wrote an ENGLISH question
// into the Spanish slot, where it then looked authored rather than missing.
// The sentences are now `identSeed.*` rows in PlatformPhrases, read through identSeedPrompt() in
// LadderBlock.tsx and guarded by Check-LadderDefaults_v1.1.
//
// AND IT SITS AGAINST A DECISION RECORDED FURTHER DOWN THIS FILE, so read both before changing either.
// The TEXT_OFFER_DEFAULT note says seeders here are English-only on purpose: "A Spanish default would be a
// translation nobody reviewed, sitting in the document looking approved."
// THAT OBJECTION IS ABOUT UNREVIEWED TRANSLATIONS, AND IT IS RIGHT. It does not apply to a PLATFORM PHRASE
// ROW: `identSeed.*` is reviewed platform speech, carried in the same table as every other sentence the
// engine speaks, covered by the accent gate and by #848's human Spanish pass. Seeding English into the
// SPANISH slot - which is what this did - is the version that looks authored and is actually wrong.
//
// THE MORE HONEST DESIGN IS STILL THE THIRD ONE: seed nothing, leave the box empty, and let the editor show
// the platform default behind its "Template default" badge, exactly as the rungs do. That is a behaviour
// change for English too, so it is NOT done here - flagged for him rather than taken.

type PreRoutingKey = 'inbound' | 'disclosure' | 'hours' | 'idCheck' | 'greeting' | 'language' | 'classify';   // v12.10.17 (#1747): + idCheck
type CardRef =
  | { kind: 'preRouting'; key: PreRoutingKey }
  | { kind: 'workflow'; workflowId: string }
  | { kind: 'intent'; workflowId: string; intentId: string }
  | { kind: 'node'; workflowId: string; intentId: string; nodeId: string }
  | { kind: 'step'; workflowId: string; intentId: string; nodeId: string; stepId: string }
  | { kind: 'terminal'; terminalKey: string }
  | { kind: 'interceptor' }   // v12.3.1 (#238): the global mid-call interceptor stage (stage 5)
  | { kind: 'phrases' }       // v12.9.26 (#969): lane 7 - the agent's spoken lines (tenant agentPhrases, NOT the workflow doc)
  | { kind: 'readbacks'; focus?: string }   // v12.10.21 (#1957): lane 7 - the Read-backs card; focus = the field token to scroll to
  | { kind: 'sharedNode'; nodeId: string };   // v12.3.11 (#312): a node every intent runs, edited in one place

interface TenantWorkflowSnapshot {
  id: number;
  platformTemplateId: number;
  templateKey: string;
  templateName: string;
  categoryCode: string;
  categoryName: string;
  templateVersion: number;
  status: string;
  isActive: boolean;
  configJson: string;
  summaryJson: string | null;
  updatedAt: string;
}

interface WorkflowTemplateOption {
  id: number;
  categoryId: number;
  categoryCode: string;
  categoryName: string;
  templateKey: string;
  templateName: string;
  description: string | null;
  templateVersion: number;
  status: string;
  publishedAt: string | null;
  summaryJson: string | null;
}

interface TerminalConfig {
  action?: string;                               // v12.2.44.0 (#253): 'end-call' | 'voicemail'
  waitSeconds?: number;                          // seconds to hold the line before the action runs
  askAnythingElse?: boolean;                     // run the "is there anything else?" wrap-up loop
  anythingElsePrompt?: Record<string, string>;   // per-language wrap-up prompt
  message?: Record<string, string>;              // v12.3.6 (#238-H): per-language spoken-message OVERRIDES; the
                                                 // default language stays in doc.terminal[key] (enumerable + back-compat)
  // v12.3.0 (#238 interceptor): a terminal card is self-describing. name/description drive its title + subtitle;
  // keywords are the caller phrases the mid-call interceptor matches to route here.
  name?: string;
  description?: string;
  keywords?: string[];
  keywordsByLang?: Record<string, string[]>;   // v12.9.25 (#927): the same phrases per language (primary stays in keywords)
  enabled?: boolean;   // v12.3.2 (#238): a terminal can be disabled (undefined = enabled)
  transferNumber?: string;   // v12.9.28 (#1077): RETIRED in 12.10.1 - the number is Handoff › Outside operator line
  // v12.10.1 (#1086): what the two transfer cards say (HANDOFF-TRANSFER-DESIGN v1.0). The card message = Announce.
  whisper?: string;                        // to the person answering, English, tokens; blank = the default
  noAnswerSay?: Record<string, string>;    // If no one answers - Say, per language
  noAnswerThen?: string;                   // voicemail | anything_else | end_summary | hold (Phase 2)
  pressOne?: boolean;                      // Phase 2 (#1087) - shown, cannot be switched on yet
  // v12.10.22 (#2037 #2038 #2039 #2040, UI-PROTO-TERMINALS-TAKE-MESSAGE-T174 v1.4 APPROVED 10/27):
  handoffMode?: 'handoff' | 'take-message';  // Transfer to staff: Handoff (today) | Take a message. Unset = Take a message when handoff is off
  takeMessagePrompt?: Record<string, string>; // the Take a message line, per language; blank = the platform line
  refEnabled?: boolean;                        // the Reference number block; unset = the reference sentence the old message carries
  refPrompt?: Record<string, string>;          // its prompt, per language; blank = the platform line
  refOnlyIfNotGiven?: boolean;                 // Announce only if not provided earlier (default on)
}

// v12.10.1 (#1086): the Handoff settings a transfer card shows read-only (GET /t2/settings/ai-agent).
interface HandoffSettingsView {
  handoffEnabled?: boolean;
  handoff?: { liveOn?: boolean; userOn?: boolean; bizLine?: string | null; afterHoursLine?: string | null; ringTimeoutSec?: number;
    whisper?: string | null; fallback?: string; busyMessages?: { code: string; message: string | null }[];
    operatorLine?: string | null; operatorOn?: boolean; afterHoursOn?: boolean;   // v12.10.2 (#1114)
    checks?: Record<string, { verified?: boolean } | undefined> };   // v12.10.5 (#1131): biz / afterHours / operator
}
const WHISPER_TEMPLATE = 'Incoming call, reference {request.referenceNumber}. {subject.firstName} {subject.lastName}, about {request.reason}.';
const LEGACY_SHIPPED_WHISPER = 'Incoming caller {caller.name}, calling about {slot.reason}.';   // v12.10.2 (#1096)
const NO_ANSWER_DEFAULTS: Record<string, string> = { en: 'Sorry, no one is available right now.', es: 'Lo siento, no hay nadie disponible en este momento.' };
// v12.10.5 (#1130 / #1131): Route to operator can run when the Outside operator line has a number AND is Verified - at any hour,
// whatever its After hours switch says. (Before 12.10.5 it followed the switch.)
function operatorLineOn(s?: HandoffSettingsView): boolean {
  return !!(s?.handoff?.operatorLine ?? '').trim() && !!s?.handoff?.checks?.operator?.verified;
}
// v12.10.5: the after-hours destination for Transfer to staff - the Outside operator line when it is switched on (and verified).
function operatorAfterHours(s?: HandoffSettingsView): boolean {
  return !!s?.handoff?.operatorOn && operatorLineOn(s);
}
// v12.10.5 (#1129): what the Route to operator drawer says while it cannot run.
function operatorWhy(s?: HandoffSettingsView): string {
  return !(s?.handoff?.operatorLine ?? '').trim()
    ? 'Route to operator follows the Outside operator line - type its number and Verify it in'
    : 'Route to operator follows the Outside operator line - Verify it in';
}
const HANDOFF_SETTINGS_PATH = '/configuration/assistant';   // T2 Settings › AI Agent (Handoff is a section of it)
// v12.10.4 (#1119, #1114 c): a terminal that cannot run is shown, but not offered - every destination list marks it off and
// the grid card shows DISABLED. Today that is Route to operator while the Outside operator line is off. Same query (and cache)
// as the drawer's Who answers. Unknown yet (still loading) = nothing locked. A platform template (T4) has no tenant line,
// so its placeholder settings keep the line on (#1097 is a TENANT rule).
const OPERATOR_OFF_HINT = 'verify the Outside operator line first';   // v12.10.5 (UI-LOCK-12.10.5 v1.3)
function useOffTerminals(): Record<string, string> {
  const { data } = useQuery<HandoffSettingsView>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<HandoffSettingsView>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  return data && !operatorLineOn(data) ? { fallback: OPERATOR_OFF_HINT } : {};
}

interface DesignerDocument {
  schemaVersion?: string;
  // v12.9.24 (#911): the publish-time translation record (server-written). MUST survive normalizeDoc (#294 trap).
  machineFilled?: Record<string, { src?: string; at?: string; why?: string; text?: string; failed?: boolean }>;
  modal?: {
    category?: string;
    templateKey?: string;
    displayName?: string;
    languages?: Array<string | LanguageConfig>;
    tenantDefaultPolicy?: string;
  };
  preRouting?: PreRoutingConfig;
  workflows?: WorkflowLane[];
  terminal?: Record<string, string>;
  defaultTerminalKey?: string | null;   // v12.2.41.0 (#239): catch-all fallback terminal
  terminalConfig?: Record<string, TerminalConfig>;   // v12.2.44.0 (#253): per-terminal action / wait / "anything else?" wrap-up
  terminalOrder?: string[];             // v12.3.2 (#238): explicit terminal card order (built-in merge otherwise wins)
  interceptor?: InterceptorConfig;  // v12.3.2 (#238) on/off; v12.3.4 (Slice 2) KB quick answers; v12.3.8 (D-12) looser keyword match; v12.4.0 (#398/#401) commands
  // v12.3.11 (#312): nodes EVERY intent runs, defined once. sharedPosition decides before/after an intent's own nodes.
  sharedNodes?: WorkflowNode[];
  // v12.10.19 (#1907): the silent-caller rule (template 2 turns / End call / Send to voicemail)
  silenceRule?: SilenceRule;
  // v12.10.21 (#1957, contract C1): the Read-backs card. Absent = enabled, nothing off. off = field tokens (capture keys;
  // a person's name = "<entity>.name", e.g. "subject.name" = first + last together).
  readbacks?: ReadbacksConfig;
}

interface ReadbacksConfig { enabled?: boolean; off?: string[] }

interface SilenceRule { turns?: number; nothingGiven?: string; somethingGiven?: string }

interface LanguageConfig {
  code: string;
  displayName?: string;
  isEnabled?: boolean;
}

interface PreRoutingConfig {
  label?: string;
  routingGoal?: string;
  greeting?: Record<string, string>;
  fallbackMode?: string;
  tokens?: string[];
  [key: string]: unknown;
}

// A single spoken disclosure announcement. Blocks are read aloud in order at the very start of the
// call (announcements, not questions), then the agent moves on. Text is per-language.
interface DisclosureBlock {
  id: string;
  caption: string;
  enabled: boolean;
  text: Record<string, string>;
}

interface DisclosureConfig {
  isEnabled?: boolean;
  blocks?: DisclosureBlock[];
  // legacy (pre-12.2.15.0) fixed fields, migrated into blocks on first read
  recordingText?: Record<string, string> | string;
  legalText?: Record<string, string> | string;
}

interface WorkflowLane {
  id?: string;
  name?: string;
  description?: string | null;
  enabled?: boolean;   // v12.2.47.7 (#271): false = caller-type disabled (engine skips it)
  // v12.2.17.0 (Classify keyword library): caller-type-level keyword hints. Intents carry their own
  // keywords; these ground the classifier at the workflow (caller type) level.
  keywords?: string[];
  // v12.9.23 (#903): the same keywords, one set per language. The flat list above stays and is the
  // fallback, so a tenant who never opens the Spanish tab is unaffected.
  keywordsByLang?: Record<string, string[]>;
  // v12.9.24 (#902): the caller-type name per language, filled at publish (#911). MUST survive normalize.
  nameByLang?: Record<string, string>;
  intents?: WorkflowIntent[];
  // v12.10.23 (#2028 #2029): the caller type's own re-ask line and keypad menu wording, per language. Blank = built from its requests.
  requestReask?: Record<string, string>;
  requestMenuPrompt?: Record<string, string>;
}

interface WorkflowIntent {
  id?: string;
  label?: string;
  // v12.10.22 (#2011, UI-PROTO-SHARED-CATEGORY-T173 v1.0 LOCKED): blank = its own category (this card); else the id of another intent
  // whose category this one files under - the practice's own statement that the two intents mean the same.
  category?: string;
  enabled?: boolean;   // v12.2.47.7 (#271): false = intent disabled (engine skips it)
  keywords?: string[];
  keywordsByLang?: Record<string, string[]>;   // v12.9.23 (#903)
  labelByLang?: Record<string, string>;         // v12.9.24 (#902) - filled at publish (#911)
  confidenceThreshold?: number;
  fallbackMode?: string;
  // v12.7.3 (#646): the keypad digit that reaches THIS intent. Absent = voice only, which is what every
  // intent was before this field existed - so no snapshot needs touching.
  key?: string;
  // v12.10.11.1 (#1486): the Personalization category KEY calls that take this intent are filed under ("Files under").
  // v12.10.17 (#1723 T120 follow-up): RETIRED per Tushar 10/16 - no picker, nothing reads it for the card or category (the
  // category is the intent card itself, BDR-018 D10/D12). Still read and written back as-is so stored snapshots are not altered.
  filesUnder?: string;
  nodes?: WorkflowNode[];
  // v12.4.16 (#516): which terminal closes a call that ran EVERY card. Absent = Thank You (Success).
  // Before this the engine hard-coded thankyou-FAILURE for that case, so a booking that worked closed on
  // "I'm sorry we couldn't finish your request just now" - nobody heard it only because the legacy Confirm
  // terminal route (retired in #504) short-circuited the sequence first.
  endTerminalKey?: string | null;
}

// v12.4.0 (#398/#401): the interceptor stops being two booleans and becomes a set of situational cards, each
// with its own switch and its own phrases. Order is NOT configurable - Tushar: "all these cards should fire
// based on situation should be the perfect thing" - so where two could claim one utterance the ENGINE applies a
// fixed precedence and the panel shows it as a locked note rather than a control.
interface InterceptorCommand {
  enabled?: boolean;
  phrases?: Record<string, string[]>;   // language -> phrases; empty for a language = use the built-in set
  repeatMax?: number;                   // Say that again only
}

// v12.4.1 (#404/#409): a card's OWN on/off, with nothing else on it. Absent means ENABLED - every snapshot
// written before 12.4.1 has no such field and must behave exactly as it did, so the switch is new and the
// behaviour is not. Read it as `x?.enabled !== false`, never as `x?.enabled === true`.
interface InterceptorCardToggle {
  enabled?: boolean;
}

interface InterceptorCommands {
  sayAgain?: InterceptorCommand;
  goBack?: InterceptorCommand;
  startOver?: InterceptorCommand;
  terminalKeyword?: InterceptorCardToggle;      // v12.4.1 (#404): the switch that used to be dead
  offScript?: InterceptorCardToggle;            // v12.4.1 (#409): NOT the same field as quickAnswers
  declineMessage?: Record<string, string>;      // v12.4.0 (#402)
  noStaffOffer?: { enabled?: boolean; line?: Record<string, string> };   // v12.10.15 (#1500): offer help once when nobody can take the call (default off)
  // v12.10.15 (#1653, BDR-017 v1.1): Call intent verification - the turn guard. enabled false/absent = the checkpoint is skipped.
  intentVerification?: {
    enabled?: boolean; mode?: 'act' | 'listen'; turnOpening?: boolean; turnFirstIdentity?: boolean; turnEvery?: boolean;
    useAi?: boolean; recoveryBudget?: number;
    cues?: Record<string, Record<string, string[]>>; lines?: Record<string, Record<string, string>>;
  };
  questionCues?: Record<string, string[]>;      // v12.4.0 (#399): grammar only, no industry words
}

interface InterceptorConfig {
  enabled?: boolean;
  quickAnswers?: boolean;
  looseKeywords?: boolean;
  commands?: InterceptorCommands;
}

interface WorkflowNode {
  id?: string;
  sharedWorkflowId?: string;             // v12.3.15 (#383): the caller type a shared node belongs to; absent = legacy, runs everywhere
  sharedPosition?: 'before' | 'after';   // v12.3.11 (#312): only set on a node in doc.sharedNodes; superseded by sharedNodeId (#385)
  // v12.4.0 (#385): set on a node inside an INTENT'S nodes list = this entry is a REFERENCE to the shared node
  // with this id, and its array index is that shared node's position in this intent. Its own fields are ignored;
  // the definition stays in doc.sharedNodes, so editing once still applies everywhere. Content is shared,
  // PLACEMENT is per-intent - which is the whole point: "Move later" can finally mean one card later.
  sharedNodeId?: string;
  // v12.3.12 (#320): intents a SHARED node is switched OFF in. Absent/empty => it runs in every intent, which is
  // what every pre-12.3.12 snapshot means. `enabled: false` is still "off everywhere"; this is the narrower case
  // Tushar asked for: "Per intent, it should ask disable for all intent or just the selected intent."
  disabledIntentIds?: string[];
  type?: string;
  label?: string;
  description?: string | null;
  enabled?: boolean;   // v12.2.23.0 (#145): a node can be parked; runtime skips it when false
  retryMax?: number;
  askTogether?: boolean;                       // v12.10.15 (#1643): Identity - one combined question for the node's fields
  askTogetherPrompt?: Record<string, string>;
  questionBudget?: number;                     // v12.10.15 (#1653 D4): Identity - cap on identity questions in one call (default 6)
  fallbackMode?: string;
  integration?: WorkflowIntegration | null;
  tokensOut?: string[];
  terminalKey?: string | null;
  correctionPrompt?: Record<string, string>;   // v12.2.40.0 (#234): per-language Confirm correction prompt
  cantConfirmPrompt?: Record<string, string>;  // v12.9.25 (#965): per-language line before the "can't be confirmed" route
  skipReadbackWhenConfirmed?: boolean;         // v12.9.26 (#985): absent = ON (the engine's default)
  skipReadbackMinFields?: number;              // v12.9.26 (#985): absent = 3
  errorPrompt?: Record<string, string>;        // v12.4.16 (#503): per-language Connect line when the action could not be completed
  // v12.9.11 (#778): the other two of his three pills. successPrompt carries tokens (on success there IS a
  // response); noConnectionPrompt deliberately carries NONE and is spoken verbatim - see the engine note.
  successPrompt?: Record<string, string>;
  noConnectionPrompt?: Record<string, string>;
  // v12.5.0 (#525): the TextConfirm card's three per-language texts. Same shape as errorPrompt above, and the
  // same blank-means-nothing contract the engine documents on WorkflowDesignerNode:
  //   textOffer   - what the agent SAYS to ask permission. Blank => the card is skipped entirely.
  //   textMessage - what the SMS CONTAINS. Blank => nothing is sent, and the call path says so.
  //   textSent    - an optional spoken acknowledgement after a successful send. Blank => silence.
  textOffer?: Record<string, string>;
  textReask?: Record<string, string>;   // v12.10.15 (#1660): the Text card's own Re-ask line (blank = the offer again)
  // v12.10.15 (#1663): the Callback card
  callbackQuestion?: Record<string, string>;
  callbackAskNumber?: Record<string, string>;
  callbackStore?: string | null;
  callbackSkipOnMobile?: boolean;
  textMessage?: Record<string, string>;
  textSent?: Record<string, string>;
  feedbackFormUrl?: string;   // v12.9.28 (#1057): the practice's feedback form - {request.feedbackLink} redirects here
  // v12.10.1 (#1085): the Announce card - say a line, expect no answer
  announceText?: Record<string, string>;
  announceWait?: boolean;            // absent = on
  announceListenSeconds?: number;    // absent = 3
  announceRepeatMax?: number;        // absent = 2
  announceThen?: string;             // absent / 'next' = the next card; else a terminal key
  outcomes?: WorkflowOutcome[];                 // v12.2.41.0 (#239): per-node outcome routing
  requestTypes?: WorkflowRequestType[];         // v12.2.47.0 (Request-node): when set, this node branches by request type
  requestReadbacks?: WorkflowRequestReadback[]; // v12.2.47.8 (#274): Confirm node per-request-type read-back templates
  defaultReadback?: Record<string, string>;     // v12.2.47.9 (#278): Confirm node node-level Default read-back (per lang)
  steps?: WorkflowStep[];
}

// v12.2.47.0 (Request-node): a request type owns its own ordered steps under a Request node. Keywords optional
// (classifier grounding only). enabled=false = the "Off" chip.
interface WorkflowRequestReadback {
  requestTypeId?: string;
  prompt?: Record<string, string>;
}

interface WorkflowRequestType {
  id?: string;
  name?: string;
  nameByLang?: Record<string, string>;         // v12.9.25 (#956): filled at publish (#911)
  keywords?: string[];
  keywordsByLang?: Record<string, string[]>;   // v12.9.25 (#956)
  enabled?: boolean;
  askTogether?: boolean;                        // v12.10.15 (#1643): one combined question for this type's fields
  askTogetherPrompt?: Record<string, string>;
  /** v12.10.19 (#1925): the Next step staff see for this request type (Local version), per language, tokens allowed. */
  nextStep?: Record<string, string>;
  steps?: WorkflowStep[];
}

interface WorkflowOutcome {
  key: string;              // success | fail | change | exhausted | not-available | error
  routeKind: string;        // continue | card | terminal
  routeTarget?: string | null;
  maxLoops?: number | null;
}

interface WorkflowStep {
  id?: string;
  kind?: string;
  label?: string;
  prompt?: Record<string, string>;
  stores?: string | null;
  fallbackMode?: string;
  enabled?: boolean;                       // v12.2.47.0 (Request-node): per-step on/off; false = skipped at runtime
  confidenceThreshold?: number | null;     // v12.2.47.0 (#260): below this capture confidence, run lowConfidenceAction
  // v12.8.0 (#660): THE FIELD SURVIVES, THE CONTROL DOES NOT, AND THE ENGINE NO LONGER READS IT.
  // Parsed and round-tripped so a workflow saved before 12.8.0 is not rewritten on open - but nothing sets
  // it and nothing acts on it. His call, 2026-09-23, given all three options: remove the control AND the
  // engine reads, so that what is on the screen is what runs. The ladder (#647) is the whole recovery model
  // now: fails its type -> plain re-asks to the Retry cap -> rungs.
  lowConfidenceAction?: string | null;     // v12.6.0: "spellback" | "split" | "accept". DEAD since 12.8.0 - see above.
  optional?: boolean;                       // v12.2.47.8 (#273): proceed even if nothing captured
  capturedRouteKind?: string;               // continue | node | terminal
  capturedRouteTarget?: string | null;      // node id / terminal key
  // ── v12.7.3 (#647): the escalation ladder, per step. Absent = off, which is every existing step. ──────
  askToSpell?: boolean;
  splitAsk?: boolean;
  dtmf?: boolean;
  keypadNoKey?: string;   // v12.10.15 (#1641): 'moveon' | 'fail'
  // v12.7.3 (#640/#647): rungPrompts["split:year"]["en"]. Absent = the platform sentence for that rung.
  rungPrompts?: Record<string, Record<string, string>>;
  /** v12.9.5 (#738): the workflow TEMPLATE's sentences, same keys. Read-only in T2 - a cleared box falls
   *  back to these, and the badge calls them "Template default". Edited in T4, carried by the document. */
  rungDefaults?: Record<string, Record<string, string>>;
  // v12.7.3 (#641): this step's cleanup override. Absent = whatever the FIELD says, which falls back to the
  // organization default. Tushar's chain: step -> field -> organization.
  cleanup?: string | null;
}

interface WorkflowIntegration {
  // v12.7.2 (#616): the connection's STABLE id. `provider` is the tenant's word for it and they rename it -
  // on 2026-09-22 a rename left a Connect node naming a system that no longer existed and every booking
  // stopped at 0ms with nothing sent. Both are kept: the id is what resolves, the name is what a person reads.
  providerId?: number | null;
  provider?: string;
  operation?: string;
}

interface SimulationResult {
  language: string;
  status: string;
  workflow?: string | null;
  intent?: string | null;
  message: string;
  candidates: Array<{ workflowName: string; intentLabel: string; score: number }>;
  path: Array<{ nodeId: string; nodeType: string; label: string; runtimeStatus: string; previewPrompts: string[] }>;
}

const HIERARCHY_COLORS = {
  preRouting: '#2563eb',
  workflow: '#1e40af',
  intent: '#16a34a',
  identity: '#c2410c',
  steps: '#0891b2',
  connect: '#7c3aed',
  confirm: '#166534',
  textConfirm: '#be185d',   // v12.5.0 (#525): the text-confirmation card, distinct from Confirm's green
  terminal: '#b91c1c',
};

const FALLBACK_OPTIONS = ['clarify-then-keypad', 're-ask-once', 'operator-fallback', 'voicemail'];
// v12.10.23 (#2012, UI-PROTO-MENUS-T174 v1.5): the Classify On fail choices read as the prototype names them.
const FALLBACK_LABELS: Record<string, string> = { 'clarify-then-keypad': 'Offer keypad', 're-ask-once': 'Re-ask once', 'operator-fallback': 'Operator', 'voicemail': 'Voicemail' };
// v12.2.47.9 (#279): 'Terminal' removed from the selectable node Type list — it is redundant with per-node outcome
// routing to a terminal + the dedicated Terminals tray. The RUNTIME + normalize still handle an existing Terminal node
// (back-compat), and nodeTypeOptions() keeps showing 'Terminal' in the dropdown for any live node that still has it, so
// it stays editable.
// v12.7.3 (#648): 'Steps' LEAVES THE LIST, for exactly the #279 reason above. Every node in the live tenant is
// Request, yet Steps was the parse default here, the C# class default, a node in the built-in seed document and
// what the T4 catalog emitted - so the platform's default was a type nobody chose. Greying the option alone would
// have left a default nobody could select, so the DEFAULT moves too (below, and in all four places at once).
// An existing Steps node still loads, saves and runs unchanged, and nodeTypeOptions() keeps it in ITS dropdown.
// v12.5.0 (#525): 'TextConfirm' joins the list - it is a card the tenant places, not a hidden behaviour
// bolted onto the terminal. #505 is the argument: a caller-facing action hidden inside something that does
// not look like it speaks is exactly the class of thing nobody can see is misconfigured.
const NODE_TYPES = ['Identity', 'Request', 'Callback', 'Connect', 'Confirm', 'TextConfirm', 'Announce'];   // v12.10.15 (#1663): Callback   // v12.10.1 (#1085): Announce   // v12.7.3 (#648): 'Steps' retired
function nodeTypeOptions(current?: string): string[] {
  const c = (current ?? '').trim();
  return c && !NODE_TYPES.includes(c) ? [...NODE_TYPES, c] : NODE_TYPES;
}
// v12.2.34.0 (#188): the token palette is DERIVED from the doc — the tenant/caller tokens plus every slot
// actually captured by a step (its `stores`). This drops unwired integration outputs (BookSlot.*, GetSlots.*)
// that resolve to nothing, and surfaces real captured slots (e.g. appointment.datetime, zip_code).
const BASE_TOKENS = ['organization.name', 'organization.phone', 'caller.phone', 'caller.language'];
// v12.2.35.0 (#191): every slot key captured by a step earlier in the workflow.
// v12.3.12 (#315): this walked ONLY intent.nodes[].steps[]. Two whole populations of steps were invisible to it:
// a Request node's per-request-type steps (since 12.2.47.x) and, new in 12.3.11, doc.sharedNodes. The second is a
// REGRESSION from #312 - the moment Tushar shared "Capture identity", every field it captures (subject.name, dob,
// phone) dropped out of "Captured in this workflow", out of the Stores type-ahead and out of #311's registration
// check. The engine still resolved them (EffectiveNodes), which is why the live call passed and only the DESIGNER
// went blind. One walk over every step that actually runs, used by every derived token list.
// v12.4.10 (#442): THE CARD'S OWN COUNTER, and it uses the same rule eachStep does.
//
// The FlowCard read `node.steps?.length` while a Request node's steps live under
// requestTypes[].steps - so Tushar's Reference Number node, with one step plainly visible in the
// drawer, showed "0 step(s)" on the canvas. A correctly configured node looked broken and he had
// to ask.
//
// SAME BLIND SPOT AS #315, whose note says it exactly: "this walked ONLY intent.nodes[].steps[].
// Two whole populations of steps were invisible to it." #315 fixed the slot scan and left the
// card's counter behind, because it was a different line of code expressing the same idea. That is
// the whole argument for this helper existing rather than the expression being repeated at each
// card: one function, every path calls it (OPERATIONS section 25 rule 3).
// v12.4.11 (#442 REOPENED): THE 12.4.10 VERSION OF THIS WAS ADDITIVE AND THE RUNTIME IS EITHER/OR.
//
// It returned node.steps.length + sum(requestTypes[].steps.length). SnapshotCallInterpreter.EffectiveSteps
// does the opposite: `RequestTypes.Any(rt => rt.Enabled) ? SelectRequestType(...)?.Steps : node.Steps` —
// ONE population or the other, never both. So Process Request read 8 when its drawer showed 6, and
// Prescription read 6 where Tushar saw 4.
//
// I ONLY CHECKED THE NODE THAT WAS REPORTED. Reference Number (one type, one step, no flat steps) is right
// by accident — the sum has nothing to add — and so is Identity. Every node where BOTH populations were
// non-empty was wrong, and I never looked at one. That is the whole lesson of the reopen, not the arithmetic.
//
// THE RULE, IN TUSHAR'S WORDS: "what i see inside, should be reported outside" / "what i see is what it
// needs to be calculated". So this mirrors EffectiveSteps exactly, and he settled the empty case himself:
// "when you add request type and save it but you don't add step yet then the step count is still zero."
//
// NOTE the counter was never the root cause — the wrong numbers came from #471, flat steps stranded on a
// branching node and then counted. With #471 fixed there is nothing stranded left to miscount, and this
// function is a pure display rule.
function nodeStepCount(node: WorkflowNode): number {
  const rts = node.requestTypes ?? [];
  // Mirrors EffectiveSteps: the node BRANCHES the moment any request type is enabled. normalizeNode defaults
  // a missing `enabled` to true, so post-normalize this is the same predicate the engine applies.
  return rts.some(rt => rt.enabled !== false)
    ? rts.reduce((total, rt) => total + (rt.steps?.length ?? 0), 0)
    : (node.steps?.length ?? 0);
}

// v12.4.11 (#471): ADDING THE FIRST REQUEST TYPE USED TO SILENTLY STRAND THE NODE'S FLAT STEPS.
//
// The moment one request type exists, BOTH halves of the product flip mode together and neither migrated
// anything: the engine's EffectiveSteps stops reading node.Steps, and the drawer's stepsTarget switches to
// requestTypes[i].steps. The steps that were on screen a second earlier became invisible AND stopped
// running — while staying in the document, and staying in the card's count.
//
// PROVEN FROM THE ID TIMESTAMPS in the live tenant, not inferred. makeId is `${prefix}-${Date.now()
// .toString(36)}`, so every id is a clock reading: Process Request's two flat steps were added at
// 2026-08-27 02:29:39 and 02:47:52, and its first request type "Schedule" was created at 03:23:17 — the
// steps died 36 minutes after the last one was authored. Reference Number is the control that proves the
// mechanism: its request type was added 48 SECONDS after the node, BEFORE any flat step, and it carries no
// stranded steps at all. Same node type, opposite order, clean result.
//
// So the transition MOVES them instead. Nothing disappears, no dialog, no decision to make — which is what
// "what i see inside, should be reported outside" means at the moment it actually matters. The destructive
// half (dropping steps already stranded in an old document) is deliberately NOT done here; see
// pruneUnreachableNodeContent, and see the note there about why moving and dropping are split.
function absorbFlatStepsIntoRequestType(node: WorkflowNode, rt: WorkflowRequestType): void {
  const flat = node.steps ?? [];
  if (flat.length === 0) return;
  rt.steps = [...(rt.steps ?? []), ...flat];
  node.steps = [];
}

// v12.4.11 (#471): CHANGING A NODE'S TYPE TO REQUEST IS THE MOMENT THE STEPS GO INVISIBLE.
//
// This is the actual entry point of the whole defect, and fixing only addRequestType would have left it wide
// open. The live document dates it exactly: Process Request was created 2026-08-27 02:29:22 as the default
// 'Steps' type, its two steps were added at 02:29:39 and 02:47:52 (correctly, into node.steps), and only
// later was the type switched to Request. From that instant the drawer showed nothing — `stepsTarget` targets
// requestTypes[rtIndex] for ANY node of type Request, and with no request types that is undefined — while
// EffectiveSteps still ran them, because it falls back to node.Steps until a type is enabled. Invisible AND
// running: the worst of the two states, and the one that made the first request type at 03:23:17 look
// harmless.
//
// (It is also why "+ Add step" on a Request node with no request types is a silent no-op today: rtStepsTarget
// returns undefined. So the only way into this state is the type change — which is exactly what happened.)
//
// So the type change carries the steps with it, into a first request type named after the node. Runtime
// behaviour is UNCHANGED by construction: SelectRequestType auto-selects when exactly one type is enabled and
// never asks the caller, so the same steps run in the same order. Nothing is deleted, nothing disappears, and
// the drawer shows on the next render precisely what the document holds.
// v12.5.0 (#525): THE TEXT CARD'S DEFAULTS LIVE HERE, IN THE DESIGNER, NOT IN THE CALL ENGINE.
//
// WorkflowDesignerNode.TextOffer says it in the C#: "THE DEFAULTS LIVE IN T2, NOT HERE, and that is
// deliberate." Same choice identStepPrompt and CONFIRM_READBACK_DEFAULT already make - seeded, visible in the
// editor, and the tenant's to change. #503/#508 settled the principle after call #38-0007: a line nobody
// authored should not be the thing a caller remembers.
//
// THE MESSAGE IS DELIBERATELY THIN, AND THIS IS TUSHAR'S DECISION, NOT AN OVERSIGHT: practice name and
// reference number, nothing else. The date, the time, the provider and the reason are PHI, and SMS is not an
// encrypted channel - so they go out only if the tenant deliberately puts them there. Seeding them would make
// that choice for every practice on the platform, silently, on the day they add the card.
const TEXT_OFFER_DEFAULT = 'I can text you the confirmation. Would you like that?';
const TEXT_MESSAGE_DEFAULT = '{organization.name}: your reference number is {request.referenceNumber}.';
const TEXT_REASK_DEFAULT = 'Would you like me to text you the reference number?';   // v12.10.15 (#1660, LOCKED S148): a NEW card's Re-ask
// textSent has NO default: silence after a successful send is the default, and the engine treats blank as
// "say nothing". An acknowledgement the tenant never asked for would be one more thing a caller sits through.

// Seeds ENGLISH ONLY - which is what every other seeder in this file does (identStepPrompt and
// CONFIRM_READBACK_DEFAULT are both English strings). A Spanish default would be a translation nobody
// reviewed, sitting in the document looking approved; the EN/ES rail and the editor's translate affordance
// are how ES gets written, by someone who can read it.
// NEVER OVERWRITES AUTHORED TEXT: only an empty field is filled, so switching the type away and back cannot
// eat wording a tenant wrote.
function seedTextConfirm(node: WorkflowNode): void {
  const blank = (d?: Record<string, string>) => !d || !Object.values(d).some(v => (v ?? '').trim());
  if (blank(node.textOffer)) node.textOffer = { ...(node.textOffer ?? {}), en: TEXT_OFFER_DEFAULT };
  if (blank(node.textMessage)) node.textMessage = { ...(node.textMessage ?? {}), en: TEXT_MESSAGE_DEFAULT };
  if (blank(node.textReask)) node.textReask = { ...(node.textReask ?? {}), en: TEXT_REASK_DEFAULT };   // v12.10.15 (#1660)
}

function applyNodeTypeChange(node: WorkflowNode, nextType: string): void {
  const wasRequest = (node.type ?? '') === 'Request';
  // v12.5.0 (#525): a node BECOMES a text card here - `addNode` still creates the default 'Steps' node and the
  // Type dropdown is how any type is chosen, so this is the one moment the card is "created" and the only
  // place the seed belongs. Both type-change sites call this function (#471's lesson), so both seed.
  const wasTextConfirm = (node.type ?? '') === 'TextConfirm';
  node.type = nextType;
  if (nextType === 'TextConfirm' && !wasTextConfirm) seedTextConfirm(node);
  // v12.10.16 (#1675): a card that BECOMES a Callback card stores in Caller › Callback number unless one is set.
  if (nextType === 'Callback' && !(node.callbackStore ?? '').trim()) node.callbackStore = 'caller.callback';
  if (nextType !== 'Request' || wasRequest) return;
  if ((node.requestTypes?.length ?? 0) > 0) return;      // already branching — pruneUnreachableNodeContent owns it
  if ((node.steps?.length ?? 0) === 0) return;            // nothing to carry
  const rt: WorkflowRequestType = {
    id: makeId('rt'),
    name: (node.label ?? '').trim() || 'Request',
    keywords: [],
    enabled: true,
    steps: [],
  };
  absorbFlatStepsIntoRequestType(node, rt);
  node.requestTypes = [rt];
}

// v12.4.11 (#471 legacy half + #473 + #474): the document must not store what the UI never shows.
//
// Runs inside normalizeDoc, so it applies on load AND on every save — normalizeDoc rebuilds the document
// from a fixed field list each time, which is exactly the right place for a rule that has to hold forever.
// Idempotent by construction: a second pass finds nothing left to remove.
//
// (a) #471 legacy — a Request node that HAS request types keeps no flat steps. The drawer never renders
//     them for a Request node (stepsTarget always targets a request type), and the engine never runs them
//     while any type is enabled. Tushar's call, and he is right that it is a bug rather than a design
//     question: "if those cards or steps are gone then gone."
//     DELIBERATELY NARROW: a Request node with ZERO request types is left alone. Its flat steps are still
//     what EffectiveSteps runs, so dropping them would be real data loss rather than removing junk. Those
//     get MOVED, not deleted, the moment a first type is added (absorbFlatStepsIntoRequestType above).
//     That split is what keeps "gone means gone" from ever eating authored work.
// (b) #474 — the stranded steps in production are `enabled: true` with empty prompts, and EffectiveSteps
//     falls back to node.Steps whenever NO request type is enabled. Turning every type off on such a node
//     therefore made the agent speak two blank prompts: dead air, then the retry and the fallback. (a)
//     closes that outright — there is nothing left to fall back to.
// (c) #473 — a Confirm node keeps read-backs only for request types that still exist in its intent. The
//     drawer discovers its chips from the sibling Request node, so a renamed or deleted type left its
//     read-back stored forever and invisible: 5 and 4 of them against 2 real types in the live document.
//     #360 already drops foreign read-backs on COPY; nothing pruned them when a type was edited in place.
function pruneUnreachableNodeContent(doc: DesignerDocument): DesignerDocument {
  const pruneNode = (node: WorkflowNode) => {
    if ((node.type ?? '') === 'Request' && (node.requestTypes?.length ?? 0) > 0 && (node.steps?.length ?? 0) > 0) {
      node.steps = [];
    }
  };
  for (const node of doc.sharedNodes ?? []) pruneNode(node);
  for (const workflow of doc.workflows ?? [])
    for (const intent of workflow.intents ?? []) {
      for (const node of intent.nodes ?? []) pruneNode(node);
      // (c): the ids this intent actually offers, from the same expression the Confirm editor discovers with.
      const live = new Set(
        ((intent.nodes ?? []).find(n => (n.type ?? '') === 'Request' && (n.requestTypes?.length ?? 0) > 0)?.requestTypes ?? [])
          .map(rt => rt.id).filter(Boolean) as string[],
      );
      for (const node of intent.nodes ?? []) {
        if ((node.type ?? '') !== 'Confirm') continue;
        const kept = (node.requestReadbacks ?? []).filter(rb => rb.requestTypeId && live.has(rb.requestTypeId));
        if (kept.length !== (node.requestReadbacks ?? []).length) node.requestReadbacks = kept;
      }
    }
  return doc;
}

// v12.4.11 (#442): a Confirm node's content is not steps, so counting steps could never describe it — its
// drawer renders one read-back editor per request type DISCOVERED on the intent's Request node (#274), plus
// the node-level Default. The card now says the same number the drawer shows. Same discovery expression as
// `confirmReqTypes` in the editor; kept in one function so the two cannot drift (OPERATIONS §25 rule 3).
function confirmReadbackTypes(doc: DesignerDocument, workflowId?: string, intentId?: string): WorkflowRequestType[] {
  return doc.workflows?.find(w => w.id === workflowId)?.intents?.find(i => i.id === intentId)
    ?.nodes?.find(n => (n.type ?? '') === 'Request' && (n.requestTypes?.length ?? 0) > 0)?.requestTypes ?? [];
}

interface IntegrationConnection { id: string; name: string; type: string; enabled: boolean; actions?: { name?: string }[] }

// ── v12.7.2 (#616): DOES THIS CONNECT NODE STILL POINT AT SOMETHING? ────────────────────────────────
// Mirrors IntegrationCatalog.ResolveConnection on the engine side: a recorded id wins, and a recorded id
// that resolves to nothing is BROKEN rather than falling back to the name - a new connection that happens to
// reuse the old word is not the one the tenant chose. No id recorded yet => resolve by name, which is every
// document written before 12.7.2 and must keep working unchanged.
// v12.7.2 (#616): the drawer has read this since #487; the CARD and the TREE need the same list to say a node
// is broken, and they are three different components. One hook, called at the top of each - React Query dedupes
// on the key, so it stays one request and one cache entry. Threading it down as a prop instead would have meant
// editing every intermediate signature for a fact only the leaves use.
function useConnectedSystems(): IntegrationConnection[] {
  const { data } = useQuery<{ connectedSystems?: IntegrationConnection[] }>({
    queryKey: ['t2-integrations'],
    queryFn: () => api.get<{ connectedSystems?: IntegrationConnection[] }>('/t2/settings/integrations'),
    staleTime: 60_000,
  });
  return (data?.connectedSystems ?? []).filter(c => c.type === 'rest' || c.type === 'fhir');
}

function connectionIsMissing(integration: WorkflowIntegration, connections: IntegrationConnection[]): boolean {
  const id = integration.providerId ?? 0;
  if (id > 0) return !connections.some(c => Number(c.id) === id);
  const name = (integration.provider ?? '').trim();
  if (name === '') return false;   // nothing chosen yet is not the same as broken
  return !connections.some(c => c.name.trim().toLowerCase() === name.toLowerCase());
}

// v12.4.11 (#442): the ONE place that decides what a node card says under its title. The subtitle was already
// type-aware before this — a Connect node has always shown its integration rather than a count — Request and
// Confirm simply never got their line. Every card site calls this; none of them formats its own string.
// v12.7.2 (#616): connections is OPTIONAL so a caller that has no list still gets today's subtitle rather
// than a wrong claim - absent is "we cannot tell", never "it is fine".
function nodeCardDescription(node: WorkflowNode, doc: DesignerDocument, workflowId?: string, intentId?: string,
                             connections?: IntegrationConnection[]): string {
  if (node.integration) {
    // v12.7.2 (#616): SAY IT WHERE IT IS SEEN. #487 already warns that a connection is not configured, but
    // only inside this node's drawer - so on 39-0013 and 39-0014 a renamed connection stopped every booking
    // and the card still read like an ordinary working node. The card is where somebody looks first.
    if (connections && connectionIsMissing(node.integration, connections)) {
      return `${node.integration.provider || 'integration'} - not configured`;
    }
    return `${node.integration.provider || 'integration'} - ${node.integration.operation || 'operation'}`;
  }
  if ((node.type ?? '') === 'Confirm') {
    const n = confirmReadbackTypes(doc, workflowId, intentId).length;
    // With no request types anywhere in the intent the drawer shows only the node-level Default read-back.
    return n === 0 ? 'Default read-back' : `${n} read-back(s)`;
  }
  // v12.5.0 (#525): a text card holds no steps, so a step count could never describe it - the same argument
  // #442 made for Confirm and Request. It says which of the two blank-means-nothing states it is in, because
  // "0 step(s)" on a card that will never speak is precisely the green-but-dead signal #505 exists to stop.
  if ((node.type ?? '') === 'Announce') {   // v12.10.1 (#1085)
    const said = Object.values(node.announceText ?? {}).some(v => (v ?? '').trim());
    return said ? 'Says one line, then moves on' : 'No line written - this card is skipped';
  }
  if ((node.type ?? '') === 'TextConfirm') {
    const written = (d?: Record<string, string>) => Object.values(d ?? {}).some(v => (v ?? '').trim());
    if (!written(node.textOffer)) return 'No offer written - this card is skipped';
    if (!written(node.textMessage)) return 'Asks, but no message - nothing would be sent';
    return 'Offers a text confirmation on a mobile';
  }
  return `${nodeStepCount(node)} step(s)`;
}

function eachStep(doc: DesignerDocument, visit: (step: WorkflowStep) => void) {
  const walkNode = (node: WorkflowNode) => {
    for (const step of node.steps ?? []) visit(step);
    for (const rt of node.requestTypes ?? [])
      for (const step of rt.steps ?? []) visit(step);
  };
  for (const node of doc.sharedNodes ?? []) walkNode(node);
  for (const workflow of doc.workflows ?? [])
    for (const intent of workflow.intents ?? [])
      for (const node of intent.nodes ?? []) walkNode(node);
}

function collectSlots(doc: DesignerDocument): string[] {
  const slots = new Set<string>();
  eachStep(doc, (step) => {
    if (!step.stores || !step.stores.trim()) return;
    // v12.2.43.1 (#246): a Stores value may name SEVERAL fields (comma/semicolon/newline separated);
    // add each as its OWN slot so the picker never offers a fused "{a, b}" token.
    for (const key of step.stores.split(/[,;\n]+/).map(k => k.trim()).filter(Boolean)) slots.add(key);
  });
  return Array.from(slots).sort();
}

// v12.2.35.0 (#193) / v12.2.36.0 (#200): expose derived {*.firstName}/{*.lastName} for captured
// PERSON-name slots. The engine (TokenResolver) splits the captured full name at render time. Scoped to
// a person allowlist so non-person slots (e.g. medication.name) don't yield nonsense name parts.
// Tushar 2026-08-22: start with patient only; add caller/others later if needed.
// v12.4.3 (#429): ONE ENTRY PER FIELD. `patient`/`appointment` are the tenant-facing LABELS of the canonical
// entities `subject`/`request` (BDR-001 v1.1). This file was offering BOTH spellings as if they were different
// fields - COMMON_STORE_KEYS hardcoded the alias, linked identity fields yielded the canonical, and
// deriveNameParts minted `patient.firstName` off `patient.name`. All three render as "Patient > ..." in the
// chip, so on call #36-0005 Tushar picked one from each group with nothing in the UI able to tell him they
// were the same field, and the engine wrote them to two unrelated slots. The engine now folds them (#428);
// this stops the designer producing the split in the first place.
function canonStoreKey(k: string): string {
  const s = (k || '').trim();
  if (s.toLowerCase().startsWith('patient.')) return 'subject.' + s.slice('patient.'.length);
  if (s.toLowerCase().startsWith('appointment.')) return 'request.' + s.slice('appointment.'.length);
  return s;
}

// v12.4.3 (#429): the store an identity step writes is the {entity}.{field} token the AI Agent screen already
// promises on screen ("The stored token becomes {entity.field} - e.g. subject.firstName"). It was writing the
// identifier's own `key` instead, so a field keyed `last_name` and linked to subject/lastName stored the
// string "last_name" and the link was decorative.
function identStoreKey(key: string, ident?: { entity?: string; field?: string } | null): string {
  const e = (ident?.entity ?? '').trim();
  const f = (ident?.field ?? '').trim();
  return canonStoreKey(e && f ? `${e}.${f}` : key);
}

const PERSON_NAME_SLOTS = ['subject.name', 'caller.name'];

// ── v12.7.1 (#566): does this step capture a PERSON'S NAME? ──────────────────────────────────────────────
//
// It matters because of what the engine does, not what the field is called. On a name step, #258's spell-back
// owns the re-ask, so `LowConfidenceAction` is read in exactly ONE comparison - `lowAct != "accept"` - and
// three of the dropdown's four values are therefore the same value. Default, Spell it back and Split ask all
// mean "not accept". A tenant who chooses Split ask on the Name step saves something that reads as deliberate
// and is inert, and the next person to open that workflow has no way to tell. That is #562's shape one notch
// smaller: not a control that does nothing, but a control offering four choices where there are two.
//
// DELIBERATELY CONSERVATIVE, AND THE ASYMMETRY IS THE POINT. This mirrors the engine's `IsPersonNameKey`
// (a name-shaped field on a person entity) and a second copy of a list is exactly what #412 was - so this one
// is written to FAIL TOWARDS TODAY. If the engine's `PersonEntities` ever grows and this list does not, the
// worst case is that a step stops being annotated, which is the behaviour that shipped before this build.
// Nothing here changes what is saved, what is selectable, or what the engine does - it only says what is true.
const PERSON_ENTITIES_FOR_NAME_STEPS = [
  'caller', 'subject', 'patient', 'provider', 'physician', 'doctor', 'prescriber',
  'guardian', 'contact', 'member', 'guarantor', 'referrer', 'staff', 'user',
];
function stepCapturesAPersonName(stores?: string | null): boolean {
  return (stores ?? '')
    .split(/[,;\n]+/)
    .map(k => canonStoreKey(k).trim())
    .filter(Boolean)
    .some(k => {
      const dot = k.indexOf('.');
      if (dot <= 0) return false;
      const entity = k.slice(0, dot).toLowerCase();
      const field = k.slice(dot + 1).toLowerCase();
      return PERSON_ENTITIES_FOR_NAME_STEPS.includes(entity)
        && (field === 'name' || field === 'firstname' || field === 'lastname');
    });
}
// ── v12.7.2 (#609): OFFER ONLY THE OPTIONS THAT CHANGE SOMETHING. ──────────────────────────────────
//
// #566 marked "Spell it back" and "Split ask" as "(same as Default here)" on a PERSON-NAME step. Tushar,
// verifying 12.7.1: the same is true on a typed step, so the dropdown offers four options with three
// behaviours (two on a name step) and says so on neither.
//
// The engine's own truth, from the re-ask branch of SnapshotCallInterpreter:
//   accept     -> no second ask at all.                                     ALWAYS different.
//   split      -> SplitAskHint(field).  Default -> SplitAskHint(field).     ALWAYS identical to Default.
//   spellback  -> "letter by letter", but v12.7.2 (#602) only where letters make sense; on a ZIP, date,
//                 number, phone or time it falls through to SplitAskHint too - identical to Default.
//
// So Split ask has NEVER differed from Default anywhere, which #566 half-noticed and attributed to name
// steps. Saying it plainly beats hiding the option: a workflow saved earlier may already hold one of
// these values, and an option that vanishes is a value nobody can see or change.
const LETTERLESS_FIELD_TYPES = ['zip', 'date', 'birthdate', 'time', 'number', 'phone'];

// v12.8.2 (#676) / v12.9.21 (#860): DELETED, not translated.
// This was a hardcoded ENGLISH ladder of assembled re-ask sentences that took no language, so the Spanish
// tab showed "Please give it one at a time." while the engine spoke Spanish - #412 returning for the third
// time. It is now `reaskPlatformDefault` in LadderBlock.tsx, composed from the engine's own `reask.giveItAs`
// and `reask.hint.*` rows and guarded by Check-LadderDefaults_v1.1.
//
// A SPANISH BRANCH BESIDE THE ENGLISH ONE WOULD HAVE BEEN THE SAME DEFECT. It also would not have caught
// what generating it did: these literals said "the day and month" and "the area code first" where the
// engine composes no article, so T2 was previewing sentences the caller would never hear - in English.

// ══ v12.9.4 (#733): WHAT THE CONFIDENCE BOX MAY HONESTLY OFFER, PER FIELD TYPE. ══════════════════════
//
// FOUND IN HIS OWN SCREENSHOT, 2026-09-25, while he was making a different point: a ZIP step reading
// **"default · 0.80"**. 12.9.3 (#720) had shipped hours earlier and removed the bar from a ZIP entirely - the
// engine now prints `no bar on a zip field, its shape is the check` on every ZIP turn - and the screen was
// still offering a number that nothing reads.
//
// Not merely stale: it describes a MECHANISM that no longer runs on that field. A tenant reading 0.80 on a ZIP
// step who then watches ZIPs accepted at 0.139 has been told two contradictory things by the product, and the
// screen is the one they will believe.
//
// The rule mirrors `SnapshotCallInterpreter.BarAppliesToType`: the bar applies only where there is no SHAPE we
// can check. Typing a number still overrides on any type - this is what the box says when it is empty.
const SHAPED_TYPES = new Set(['zip', 'phone', 'email', 'date', 'birthdate', 'time', 'number']);
function confidencePlaceholder(type: string | undefined): string {
  const t = (type ?? '').toLowerCase();
  if (SHAPED_TYPES.has(t)) return 'no bar · shape is the check';
  return 'default · ' + (t === 'name' ? '0.60' : '0.80');
}

function stepFieldType(stores: string | null | undefined,
                       catalog: VocabCatalogEntity[] | undefined,
                       custom: Record<string, CustomField>): string | undefined {
  const first = (stores ?? '').split(/[,;\n]+/).map(k => canonStoreKey(k).trim()).filter(Boolean)[0];
  if (!first) return undefined;
  const lower = first.toLowerCase();
  // A tenant's own declaration wins, the same order EffectiveConfigResolver applies on the engine side.
  for (const [k, v] of Object.entries(custom ?? {}))
    if (k.toLowerCase() === lower && v?.type) return v.type.toLowerCase();
  const dot = first.indexOf('.');
  if (dot <= 0) return undefined;
  const entity = first.slice(0, dot).toLowerCase();
  const field = first.slice(dot + 1).toLowerCase();
  const ent = (catalog ?? []).find(e => e.token.toLowerCase() === entity);
  return ent?.fields?.find(f => f.key.toLowerCase() === field)?.type?.toLowerCase();
}

/** The suffix that tells a tenant an option does nothing different on THIS step. */
function unsureSameAsDefault(option: 'spellback' | 'split', stores: string | null | undefined,
                             catalog: VocabCatalogEntity[] | undefined,
                             custom: Record<string, CustomField>): boolean {
  if (option === 'split') return true;                       // never differed from Default, on any step
  if (stepCapturesAPersonName(stores)) return true;          // a name always spells back (#566)
  const t = stepFieldType(stores, catalog, custom);
  return t !== undefined && LETTERLESS_FIELD_TYPES.includes(t);   // v12.7.2 (#602)
}

function deriveNameParts(slots: string[]): string[] {
  const extra: string[] = [];
  for (const raw of slots) {
    const slot = canonStoreKey(raw);   // v12.4.3 (#429): patient.name and subject.name are ONE slot
    if (PERSON_NAME_SLOTS.includes(slot)) {
      const base = slot.slice(0, -'.name'.length);
      extra.push(base + '.firstName', base + '.lastName');
    }
  }
  return extra;
}

// v12.2.36.0 (#201): standard appointment tokens are offered even before a step captures them, so
// authors know the canonical names to use (and read-backs don't false-flag). Capture them via steps
// storing appointment.date / appointment.time (#195); the engine resolves them from those slots.
const APPOINTMENT_TOKENS = ['appointment.date', 'appointment.time', 'appointment.newDate', 'appointment.newTime'];   // v12.2.47.2: new-appointment tokens for the Change flow (engine resolves them as generic captured slots)
// v12.2.43.0 (#235/#236/#246): canonical tokens for the tenant's LINKED Identity-extraction fields
// ({entity}.{field}, e.g. subject.firstName / subject.zip). Each linked field is offered INDIVIDUALLY (never
// a fused "a, b" token), plus the entity's full name so authors can use the whole name or the parts.
function dedupeCanon(tokens: string[]): string[] {
  const seen = new Set<string>(); const out: string[] = [];
  for (const t of tokens) { const c = canonToken(t); const k = c.toLowerCase(); if (!seen.has(k)) { seen.add(k); out.push(c); } }
  return out;
}
type IdRow = { name?: string; key?: string; type?: string; entity?: string; field?: string };
function identifierTokens(identifiers: IdRow[] = []): string[] {
  const out = new Set<string>();
  for (const id of identifiers) {
    const ent = (id.entity ?? '').trim().toLowerCase();
    const fld = (id.field ?? '').trim();
    if (ent && fld) { out.add(`${ent}.${fld}`); out.add(`${ent}.name`); }
    else if (id.key) out.add(id.key.trim());   // legacy/unlinked flat key
  }
  return Array.from(out);
}
// v12.3.12 (#314): `custom` is the tenant's REGISTERED fields (tenant_settings["customFields"]). 12.3.11 wrote
// them and then read them in exactly one place - the "have I already asked about this?" check - so a field you
// registered was offered by nothing and displayed nowhere. Tushar: "i saved and it did ask for field type and i
// saved it but when i logged out and logged back in those tokens were gone. also i don't see that in
// personalization - vocabulary". They are first-class tokens now, everywhere a token can be chosen.
function availableTokens(doc: DesignerDocument, identifiers: IdRow[] = [], catalog?: VocabCatalogEntity[], vocab: Record<string, string> = {}, custom: Record<string, CustomField> = {}, lists: Record<string, RefListLite> = {}): string[] {
  // v12.2.43.1 (#236/#246): canonicalize the dynamic tokens (patient.* -> subject.*) and de-dupe so each field
  // appears ONCE; the curated BASE/APPOINTMENT lists are left as-is.
  // v12.2.47.9 (#277): a captured slot that is ALSO a curated token (e.g. appointment.time via a Stores field) was
  // listed twice — once here in the curated block, once in the dynamic block. Exclude curated tokens from the dynamic
  // list so each token appears exactly once.
  // v12.3.10.1 (#303): the curated set is the SERVED catalog. This matters as much as the picker itself —
  // `known` drives UnresolvedTokenNote, so leaving it on the old constants would have flagged every new
  // catalog token as "the engine can't resolve this" the moment the picker started offering them.
  // v12.4.16 (#499): the tenant's OWN fields go in with the catalog, not into the catch-all afterwards.
  // Without this argument #499 ships a screen that creates a field and a picker that never offers it under
  // its entity - the field would still appear, but in "Captured in this workflow" rather than under Subject,
  // which is the difference between a vocabulary and a list of leftovers.
  const catGroups = catalogGroups(catalog, vocab, custom, lists);   // v12.7.3 (#649)
  const curatedList = catGroups ? catGroups.flatMap(g => g.tokens) : [...BASE_TOKENS, ...APPOINTMENT_TOKENS];
  const curated = new Set(curatedList.map(t => canonToken(t).toLowerCase()));
  const dyn = [...identifierTokens(identifiers), ...collectSlots(doc), ...Object.keys(custom)].map(canonToken);
  const extra = dedupeCanon([...dyn, ...deriveNameParts(dyn)]).filter(t => !curated.has(t.toLowerCase()));
  // v12.3.14 (#371): `known` drives UnresolvedTokenNote. The engine seeds request.referenceNumber on every call,
  // so leaving it out here would warn the tenant that the engine cannot resolve a token it resolves perfectly -
  // #303's lesson, one token later.
  // v12.4.5 (#440): ...and the same lesson ONE MORE TOKEN LATER. The served catalog does not carry
  // organization.practiceName, so the Greeting card warned "Unrecognized token: {organization.practiceName} -
  // dropped at call time" while the preview two lines below it rendered "Harlem Medical". Verified live on
  // harlemm 2026-09-03. `known` must be a SUPERSET of what the resolver resolves, never a different list -
  // a validator that contradicts the thing it validates teaches the tenant to distrust both.
  return [...curatedList, ...extra, 'request.referenceNumber',
          ...platformGroups(lists).flatMap(g => g.tokens),   // v12.7.3 (#649): incl. Lists.*
          ...platformGroups(lists, custom).flatMap(g => g.tokens),   // v12.10.10 (#1406): {lists.entity.field} of tied fields
          ...RESOLVER_KNOWN_TOKENS];
}

// v12.2.35.0 (#191): grouped catalog for the shared TokenPicker — base practice/caller tokens,
// slots captured in THIS workflow, and derived name parts. Empty groups are omitted.
// v12.3.10.1 (#303/#296/#301): built from the SERVED catalog, not BASE_TOKENS/APPOINTMENT_TOKENS. Those two
// constants are why 12.3.10 shipped a Quick-Answer picker with six catalog groups while this drawer still
// offered three `tenant.*` tokens — and why typing `tenant.` still completed after #301 said the word was gone.
// Workflow-SPECIFIC groups (identity fields, captured slots, derived name parts) are still appended: they are
// things only this document knows, which is the reason the drawer supplies groups at all.
function availableTokenGroups(doc: DesignerDocument, identifiers: IdRow[] = [], catalog?: VocabCatalogEntity[], vocab: Record<string, string> = {}, custom: Record<string, CustomField> = {}, lists: Record<string, RefListLite> = {}): TokenGroup[] {
  // v12.2.43.1 (#236/#246): canonicalize (patient.* -> subject.*) + de-dupe within AND across groups so a field
  // never shows twice (e.g. once as an identity field and again as a captured slot).
  // v12.2.47.9 (#277): also de-dupe ACROSS the curated groups — a captured slot / identity field that matches a
  // curated Practice/Appointment token must not reappear in "Identity fields" / "Captured in this workflow".
  // v12.4.16 (#499): the tenant's OWN fields go in with the catalog, not into the catch-all afterwards.
  // Without this argument #499 ships a screen that creates a field and a picker that never offers it under
  // its entity - the field would still appear, but in "Captured in this workflow" rather than under Subject,
  // which is the difference between a vocabulary and a list of leftovers.
  const catGroups = catalogGroups(catalog, vocab, custom, lists);   // v12.7.3 (#649)
  const curatedList = catGroups ? catGroups.flatMap(g => g.tokens) : [...BASE_TOKENS, ...APPOINTMENT_TOKENS];
  const curated = new Set(curatedList.map(t => canonToken(t).toLowerCase()));
  const idToks = dedupeCanon(identifierTokens(identifiers).map(canonToken)).filter(t => !curated.has(t.toLowerCase()));
  const idSet = new Set(idToks.map(t => t.toLowerCase()));
  const slots = dedupeCanon(collectSlots(doc).map(canonToken)).filter(t => !idSet.has(t.toLowerCase()) && !curated.has(t.toLowerCase()));
  const known = new Set([...idToks, ...slots].map(t => t.toLowerCase()).concat([...curated]));
  const derived = dedupeCanon(deriveNameParts([...idToks, ...slots])).filter(t => !known.has(t.toLowerCase()));
  const groups: TokenGroup[] = catGroups
    ? [...catGroups]
    : [{ label: 'Practice & caller', tokens: BASE_TOKENS }, { label: 'Appointment', tokens: APPOINTMENT_TOKENS }];
  if (idToks.length) groups.push({ label: 'Identity fields', tokens: idToks });   // v12.2.43.0 (#235/#236)
  // v12.3.12 (#314): the fields THIS tenant registered get their own group, so a token you named yourself is
  // offered by the picker the same way a platform one is. De-duped against the captured slots, because a
  // registered field is usually also captured by a step.
  const reg = dedupeCanon(Object.keys(custom).filter(k => custom[k]?.isOn !== false).map(canonToken))   // v12.10.8 (#1227)
    .filter(t => !curated.has(t.toLowerCase()) && !idSet.has(t.toLowerCase())
                 && !slots.some(x => x.toLowerCase() === t.toLowerCase()));
  if (reg.length) groups.push({ label: 'Your fields', tokens: reg });
  if (slots.length) groups.push({ label: 'Captured in this workflow', tokens: slots });
  if (derived.length) groups.push({ label: 'Derived name parts', tokens: derived });
  // v12.3.14 (#371) / v12.7.3 (#649): the call's reference number and the tenant's Lists are platform-managed -
  // no step captures them and no tenant declares them, so they are invisible to the catalog walk. They used to be
  // pushed HERE, which is exactly why Integrations never got them. They now come from platformGroups() inside
  // catalogGroups, so every picker has them by construction. Appended here ONLY for the no-catalog fallback,
  // where catGroups is undefined and nothing else would supply them.
  if (!catGroups) groups.push(...platformGroups(lists));
  return groups;
}

// v12.2.47.10 (#278): a suggested confirmation read-back for a request type, built deterministically from the fields
// that type captures (its steps' Stores). Pre-fills the per-type read-back so a Confirm works out-of-box; the user
// edits or clears it. The interpreter computes the SAME suggestion at runtime (SnapshotCallInterpreter) as a fallback.
function suggestReadback(rt: WorkflowRequestType | undefined): string {
  if (!rt) return '';
  const fields: string[] = [];
  for (const s of (rt.steps ?? [])) {
    // v12.2.47.11 (#278): an OPTIONAL or DISABLED step may never capture, so keep its fields out of the
    // suggested read-back (e.g. a Cancel type's optional "reschedule?" step must not add newDate/newTime).
    if (s.enabled === false || s.optional === true) continue;
    for (const raw of (s.stores ?? '').split(',')) {
      const k = canonToken(raw.trim());
      if (k && !fields.some(f => f.toLowerCase() === k.toLowerCase())) fields.push(k);
    }
  }
  const label = (rt.name || 'request').trim().toLowerCase();
  if (!fields.length) return `Just to confirm your ${label} — is that correct?`;
  const toks = fields.map(f => '{' + f + '}').join(', ');
  return `Just to confirm your ${label}: ${toks}. Is that right?`;
}

// v12.3.14 (#376): the suggestion for a Confirm node's node-level DEFAULT read-back. Same shape as
// suggestReadback above, but built from every field the INTENT captures rather than one request type's -
// which is exactly when a Default is the right thing to write: an intent with a single flow.
// v12.3.14 (#370): how many intents actually run a shared node. Shared nodes run in EVERY intent of the
// document, so the count is the number of intents that are switched on - never hardcoded, never estimated.
// v12.3.15 (#383): the shared nodes THIS caller type runs. An unstamped node is legacy and still runs
// everywhere in the engine, so it is shown everywhere here too - the designer must not claim a node is absent
// from a caller type that is actually running it.
/** v12.10.22.2 (#2061): the name a routing list shows for a card - a shared card's reference carries no label of its own
 *  (it read "Node 1" / "Node 3"), so its definition's name is used ("Identity"). */
function routeNodeLabel(doc: DesignerDocument, workflowId: string | undefined, n: WorkflowNode): string {
  if (n.sharedNodeId) {
    const def = sharedNodesFor(doc, workflowId).find(x => x.id === n.sharedNodeId);
    return def?.label || 'Shared node';
  }
  return n.label || 'Node';
}

function sharedNodesFor(doc: DesignerDocument, workflowId?: string): WorkflowNode[] {
  return (doc.sharedNodes ?? []).filter(n =>
    !n.sharedWorkflowId || !workflowId || n.sharedWorkflowId === workflowId);
}

// v12.3.15 (#383): how many intents a shared node runs in - WITHIN ITS CALLER TYPE.
//
// This used to count every intent in the document, which is how the dialog came to say "5 intents" while
// Tushar was standing in a caller type with 3. The number was arithmetically right and told him nothing,
// because the model underneath it was wrong. Scoped now: Patient's shared node reaches Patient's intents.
// A legacy unstamped node still reaches everything, so it counts everything - and says so.
function intentsUsingSharedNode(doc: DesignerDocument, workflowId?: string, nodeId?: string): number {
  const node = nodeId ? (doc.sharedNodes ?? []).find(n => n.id === nodeId) : undefined;
  const legacy = node ? !node.sharedWorkflowId : false;
  const owner = node?.sharedWorkflowId ?? workflowId;
  let n = 0;
  for (const w of (doc.workflows ?? [])) {
    if (w.enabled === false) continue;
    if (!legacy && owner && w.id !== owner) continue;
    for (const i of (w.intents ?? [])) if (i.enabled !== false) n++;
  }
  return n;
}

// v12.3.14 (#370): M5's amber block is "the caller-facing effect, not config language" - what a caller stops
// being asked - and it appears on turn-off only. Built from the fields the node captures so it says something
// true about THIS node; when the node captures nothing there is no consequence sentence and no block.
function sharedNodeConsequence(doc: DesignerDocument, nodeId: string, _intentLabel: string): string | undefined {
  const node = (doc.sharedNodes ?? []).find(n => n.id === nodeId);
  if (!node) return undefined;
  const fields: string[] = [];
  for (const s of (node.steps ?? [])) {
    if (s.enabled === false) continue;
    for (const raw of (s.stores ?? '').split(',')) {
      const k = canonToken(raw.trim());
      if (!k) continue;
      const leaf = k.includes('.') ? k.slice(k.lastIndexOf('.') + 1) : k;
      const words = leaf.replace(/([A-Z])/g, ' $1').trim().toLowerCase();
      if (words && !fields.includes(words)) fields.push(words);
    }
  }
  if (!fields.length) return undefined;
  const list = fields.length === 1 ? fields[0]
    : fields.slice(0, -1).join(', ') + ' or ' + fields[fields.length - 1];
  return `While this node is off, the caller is not asked for their ${list} in the intents you choose.`;
}

function suggestDefaultReadback(doc: DesignerDocument, workflowId?: string, intentId?: string): string {
  const intent = doc.workflows?.find(w => w.id === workflowId)?.intents?.find(i => i.id === intentId);
  if (!intent) return '';
  const fields: string[] = [];
  for (const n of (intent.nodes ?? [])) {
    if ((n.type ?? '') === 'Confirm') continue;          // a read-back does not read back itself
    if (n.enabled === false) continue;
    for (const s of (n.steps ?? [])) {
      if (s.enabled === false || s.optional === true) continue;
      for (const raw of (s.stores ?? '').split(',')) {
        const k = canonToken(raw.trim());
        if (k && !fields.some(f => f.toLowerCase() === k.toLowerCase())) fields.push(k);
      }
    }
  }
  const label = (intent.label || 'request').trim().toLowerCase();
  if (!fields.length) return `Just to confirm your ${label} — is that correct?`;
  return `Just to confirm your ${label}: ${fields.map(f => '{' + f + '}').join(', ')}. Is that right?`;
}

// v12.2.38.0 (#217): canonical CAPTURE keys suggested in the Stores field (a step writes INTO these, so
// tenant/caller read-only tokens are intentionally excluded). Union with whatever this workflow already stores.
// v12.4.3 (#429): canonical spellings only - see canonStoreKey.
const COMMON_STORE_KEYS = ['subject.name', 'subject.dob', 'subject.phone', 'request.date', 'request.time', 'request.reason', 'callback.number'];
// v12.2.42.0 (#235): STORES autocomplete now also offers the derived {*.firstName}/{*.lastName} (matching the
// prompt token-picker) AND the tenant's configured Identity-extraction identifier keys, so a captured value can
// be stored to the right split-name field.
// v12.4.1 (#405): ONE place that answers "what tokens can this field offer?".
//
// #371 fixed the terminal's Message editor and left eleven other PromptEditors alone. Tushar found the next
// one himself during v12.4.0 verification - "why request.referenenumber is not visible in anything else
// prompt?" - because the fix had been applied to a SITE rather than to the pattern. Six of twelve editors
// rendered with no groups and no known, which means their type-ahead offered nothing at all and the reference
// number was invisible in half the designer.
//
// The reason it kept happening is that wiring an editor took five lines - a useVocabulary call, a react-query
// for the AI-Agent identifiers, and two builder calls - so the cheap thing to do was leave them out. It is now
// one line. A new PromptEditor that forgets this is caught by tools\Check-PromptEditors.mjs before hand-over.
//
// This is OPERATIONS §18 again in a different costume: a whitelist (or a wiring) is never in ONE place.
function useTokenSource(doc: DesignerDocument) {
  const { catalog: vocabCatalog, vocab: vocabLabels, customFields: vocabCustom, lists: vocabLists } = useVocabulary();
  const { data: aiAgent } = useQuery<AiAgentTokenSettings>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<AiAgentTokenSettings>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  const identifiers: IdRow[] = [];   // v12.10.8 (#1190): Identity extraction is gone - Vocabulary is the only source
  return useMemo(() => ({
    groups: availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists),
    known: availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists),
    vocabCatalog, vocabLabels, vocabCustom, identifiers,
  }), [doc, identifiers, vocabCatalog, vocabLabels, vocabCustom]);
}

function storeKeySuggestions(doc: DesignerDocument, identifiers: IdRow[] = [], custom: Record<string, CustomField> = {}): string[] {
  // v12.2.43.1 (#236/#246): canonicalize (patient.* -> subject.*) so the Stores type-ahead offers each field ONCE.
  const idToks = identifierTokens(identifiers);   // v12.2.43.0 (#235): {entity.field} for linked fields (+ legacy flat keys)
  // v12.3.12 (#314): a field registered once must be TYPE-AHEAD-able the next time, in any step - otherwise
  // every author re-invents (and re-registers) the same name with a different spelling.
  const off = new Set(Object.keys(custom).filter(k => custom[k]?.isOn === false).map(k => canonToken(k).toLowerCase()));   // v12.10.8 (#1227)
  const all = [...APPOINTMENT_TOKENS, ...COMMON_STORE_KEYS, ...idToks, ...collectSlots(doc), ...Object.keys(custom)].map(canonToken);
  return dedupeCanon([...all, ...deriveNameParts(all)]).filter(t => !off.has(t.toLowerCase())).sort();
}

// v12.2.38.0 (#217): Stores input with type-ahead + MULTI-KEY support. One capture step can name several
// slot keys (comma-separated) so a single question captures several fields (the engine extracts each).
// Suggestions filter on the segment after the last comma; picking one inserts it comma-separated.
function StoresField({ value, onChange, suggestions, placeholder }: {
  value: string; onChange: (v: string) => void; suggestions: string[]; placeholder?: string;
}) {
  const [open, setOpen] = useState(false);
  const [frag, setFrag] = useState('');
  const wrapRef = useRef<HTMLDivElement>(null);
  // v12.2.43.1 (#246): alias/label-aware matching — typing patient. / subject. / a vocab label all find the field.
  const { data: sfVocab } = useQuery<{ vocabulary?: Record<string, string> }>({
    queryKey: ['t2-org-vocabulary'],
    queryFn: () => api.get<{ vocabulary?: Record<string, string> }>('/t2/settings/organization'),
    staleTime: 60_000,
  });
  const sfAliasOf = useMemo(() => makeAliasOf(sfVocab?.vocabulary ?? {}), [sfVocab]);
  useEffect(() => {
    const onDoc = (e: MouseEvent) => { if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  // v12.2.43.2 (#235): committed keys are shown as LABELED chips (store canonical token, display the tenant
  // Vocabulary label) so the words 'subject'/'patient' never appear once a label is set. The text input only
  // holds the in-progress fragment; picking / Enter / comma commits a chip.
  const committed = value.split(',').map(x => x.trim()).filter(Boolean);
  const sfLabelOf = (k: string) => tokenLabel(k, sfVocab?.vocabulary ?? {}) ?? k;
  const commit = (raw: string) => {
    const key = raw.trim();
    if (!key) return;
    if (!committed.some(c => c.toLowerCase() === key.toLowerCase())) onChange([...committed, key].join(', '));
    setFrag('');
    requestAnimationFrame(() => wrapRef.current?.querySelector('input')?.focus());
  };
  const pick = (key: string) => commit(key);
  // v12.3.12 (#313): commit whatever is half-typed. This is the root cause of Tushar's entire custom-token
  // report: the fragment lived in local state and onChange fired ONLY on Enter, comma or picking a suggestion,
  // so typing "medication.pharmacyname" and clicking Done threw the text away - nothing was saved, and #311
  // never saw a field to register. He hit it twice and both times read it as a saving bug:
  // "i was using tab to go to next field... i think pressing tab should also take care of it".
  const flush = () => { if (frag.trim()) commit(frag); };
  const removeKey = (key: string) => onChange(committed.filter(k => k.toLowerCase() !== key.toLowerCase()).join(', '));
  const matches = suggestions
    .filter(k => !committed.some(c => c.toLowerCase() === k.toLowerCase()))
    .filter(k => {
      if (!frag) return true;
      const fl = frag.toLowerCase();
      if (k.toLowerCase().includes(fl)) return true;
      if (sfLabelOf(k).toLowerCase().includes(fl)) return true;   // match against the visible label too
      // alias/label: typing "patient.z" (or "visitor.z") matches the canonical "subject.zip"
      const fd = fl.indexOf('.');
      if (fd > 0) { const canon = sfAliasOf(fl.slice(0, fd)); if (canon) return k.toLowerCase().startsWith(canon + '.' + fl.slice(fd + 1)); }
      return false;
    })
    .slice(0, 8);
  return (
    <div className="tenant-stores-field" ref={wrapRef}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', border: '1px solid var(--tenant-line, #d1d5db)', borderRadius: '8px', padding: '6px 8px', background: 'var(--tenant-input-bg, #fff)', minHeight: '38px', cursor: 'text' }}
        onClick={() => wrapRef.current?.querySelector('input')?.focus()}>
        {committed.map(k => (
          <span key={k} title={k} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', background: 'var(--tenant-chip-bg, #eef2ff)', color: 'var(--tenant-chip-ink, #3730a3)', borderRadius: '6px', padding: '2px 4px 2px 8px', fontSize: '12px', fontWeight: 600, lineHeight: 1.5 }}>
            {sfLabelOf(k)}
            <button type="button" aria-label={`Remove ${k}`} onMouseDown={e => { e.preventDefault(); removeKey(k); }}
              style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: 'inherit', fontSize: '14px', lineHeight: 1, padding: '0 2px' }}>&times;</button>
          </span>
        ))}
        <input
          value={frag}
          placeholder={committed.length ? 'add a field…' : placeholder}
          onChange={e => { setFrag(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onBlur={() => { flush(); setOpen(false); }}
          onKeyDown={e => {
            if (e.key === 'Enter') { e.preventDefault(); if (matches.length) pick(matches[0]); else if (frag.trim()) commit(frag); }
            else if (e.key === ',') { e.preventDefault(); if (frag.trim()) commit(frag); }
            // v12.3.12 (#313): Tab commits and then moves on, which is what Tushar expected twice. It must NOT
            // preventDefault - the caret still has to reach the next field.
            else if (e.key === 'Tab') { flush(); }
            else if (e.key === 'Backspace' && !frag && committed.length) { removeKey(committed[committed.length - 1]); }
          }}
          style={{ flex: '1 1 90px', minWidth: '90px', width: 'auto', border: 'none', outline: 'none', background: 'transparent', fontSize: '13px', padding: '2px' }}
        />
      </div>
      {open && matches.length > 0 && (
        <ul className="tenant-stores-ac" role="listbox">
          {matches.map(k => (
            <li key={k}><button type="button" onMouseDown={e => { e.preventDefault(); pick(k); }}
              style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', width: '100%', alignItems: 'baseline' }}>
              <span>{sfLabelOf(k)}</span>
              <span style={{ fontSize: '11px', opacity: 0.6, fontFamily: 'ui-monospace, monospace' }}>{k}</span>
            </button></li>
          ))}
        </ul>
      )}
    </div>
  );
}

// v12.2.38.0 (#174): recommended default read-back seeded into a Confirm node's first step so the caller
// hears a clean, grammatical confirmation. Sample values fill the preview (#206); unresolved tokens drop
// cleanly at call time. Tenants can edit it like any prompt.
const CONFIRM_READBACK_DEFAULT = 'Just to confirm — an appointment for {patient.name} on {appointment.date} at {appointment.time}. All good?';

const DEFAULT_TERMINALS: Record<string, string> = {
  handoff: 'Transfer to staff',
  voicemail: 'Send to voicemail',
  'end-call': 'End call',
  fallback: 'Route to operator',
  // v12.2.23.0 (#149): "Thank You" — speak a closing line (can read captured values back with tokens) then hang up.
  thankyou: 'Thank you for calling. Have a great day.',
  // v12.2.44.0 (#253): "Thank You (Failure)" - closing line when the flow could not complete (replaces the generic catch-all default).
  'thankyou-failure': 'Sorry, we were not able to complete that. Please call back or stay on the line for staff. Thank you.',
};

// v12.9.28 (#1077, interceptor E): what a terminal card SAYS when its message is blank or still a card name - the
// template's default, shown in light gray. The engine's rows terminal.message.<key> carry the same text.
const TERMINAL_MESSAGE_DEFAULTS: Record<string, Record<string, string>> = {
  handoff: { en: 'Let me connect you with our staff.', es: 'Permítame comunicarle con nuestro personal.' },
  fallback: { en: 'Let me connect you with our operator.', es: 'Permítame comunicarle con nuestra operadora.' },
  'end-call': { en: 'Thank you for calling. Goodbye.', es: 'Gracias por llamar. Que tenga un buen día.' },   // v12.10.11.1 (#1465)
};
// v12.10.2 (#1094): the Announce card's template line - shown in the box and spoken when the card has none (rows announce.default).
const ANNOUNCE_DEFAULTS: Record<string, string> = {
  en: 'Let me give you the reference number for this call: {request.referenceNumber}.',
  es: 'Permítame darle el número de referencia de esta llamada: {request.referenceNumber}.',
};
// v12.9.28 (#1077): card NAMES that older documents hold as the message - never spoken, treated as blank.
const TERMINAL_LABEL_TEXTS = new Set(['transfer to staff', 'transfer to internal staff', 'send to voicemail', 'end call',
  'route to operator', 'route to the operator', 'transfer the caller to staff', 'send the caller to voicemail', 'end the call']);
function isTerminalLabel(text: string | undefined): boolean {
  return TERMINAL_LABEL_TEXTS.has((text ?? '').trim().replace(/[.!]+$/, '').trim().toLowerCase());
}

// v12.2.23.0 (#149): friendly names for the terminal outcomes in the node "Outcome" picker.
const TERMINAL_LABELS: Record<string, string> = {
  handoff: 'Transfer to staff',
  voicemail: 'Send to voicemail',
  'end-call': 'End call',
  fallback: 'Route to operator',
  thankyou: 'Thank You (Success)',
  'thankyou-failure': 'Thank You (Failure)',
};

// v12.2.45.0 (#253): short card SUBTITLES for terminal cards — the canvas card shows this description, NOT the
// full spoken message (which lives inside the editor). Falls back to the raw message for any custom terminal.
// v12.3.3 (#238 . D-05): Thank You (Success) + Thank You (Failure) are the guaranteed terminal safety net -
// a disabled terminal falls back to Thank You (Failure), so these two can never be disabled.
const TERMINAL_LOCKED = new Set<string>(['thankyou', 'thankyou-failure']);
const TERMINAL_DESCRIPTIONS: Record<string, string> = {
  handoff: 'Transfer the caller to staff',
  voicemail: 'Send the caller to voicemail',
  'end-call': 'End the call',
  fallback: 'Route to the operator',
  thankyou: 'Speak a closing line, then end the call',
  'thankyou-failure': "Closing line when the request can't be completed",
};

// v12.3.2 (#238): terminal cards render in the tenant's saved order (doc.terminalOrder). Any terminal missing from the
// saved order keeps a stable spot after the listed ones. Falls back to the object's own key order when nothing is saved.
function terminalOrderedKeys(doc: DesignerDocument): string[] {
  const all = Object.keys(doc.terminal ?? DEFAULT_TERMINALS);
  const saved = doc.terminalOrder;
  if (!Array.isArray(saved) || saved.length === 0) return all;
  const seen = new Set<string>();
  const out: string[] = [];
  for (const k of saved) { if (all.includes(k) && !seen.has(k)) { out.push(k); seen.add(k); } }
  for (const k of all) if (!seen.has(k)) out.push(k);
  return out;
}

// ── v12.4.16 (#505): WHICH CARDS THE CALL CAN ACTUALLY REACH ─────────────────────────────────────────
//
// SCOPE, IN TUSHAR'S WORDS (2026-09-19): "if a node routes to a terminal earlier, then that is a correct
// workflow. the new terminal will be useful only when the flow keeps on passing from one card to another
// card." AN EARLY TERMINAL ROUTE IS NOT A DEFECT - an intent that takes a message and closes SHOULD end on
// its second card, and warning on that would fire on correct designs and teach people to ignore the warning.
// THE ONLY CONDITION FLAGGED HERE is an early terminal route that leaves an ENABLED card stranded behind it,
// and the warning goes on the STRANDED card - not on the end-of-sequence card (#516), which was proposed
// and dropped on his correction.
//
// THE WALK MIRRORS THE ENGINE. #504 retired ApplyNodeOutcome's legacy TerminalKey fallback in this same
// build - agreed with Tushar and staying - so a missing outcome now means CONTINUE.
//
// WHAT ACTUALLY ENDS EVERY BRANCH THROUGH A CARD:
//   - a Terminal-type card (SnapshotCallInterpreter ~1470): sets the terminal and stops, whatever else it holds;
//   - a Confirm card whose success route is a terminal - `success` is its only advancing path (silence and
//     "yes" both take it), so a terminal there closes every way through. That route is read through
//     confirmSuccessRoute, which prefers the explicit outcome and falls back to the legacy node.terminalKey
//     for a document not yet converted - see the note on that function for why the fallback belongs HERE
//     (the designer) and nowhere near the engine.
// Everything else that can route to a terminal - a Connect `error`, a capture `fail` / `exhausted`, an
// optional step's captured route - is CONDITIONAL. The other branch still walks on, nothing behind it is
// stranded, and nothing is flagged. That is the difference between this and a warning nobody reads.

interface ReachEntry { node: WorkflowNode; enabled: boolean; label: string }

// The cards this intent runs, in run order, exactly as the card view draws them: a shared REFERENCE resolves
// to its definition, and `enabled` already accounts for a shared node switched off in this intent alone
// (#320) or belonging to another caller type (#383).
//
// ONE ENTRY PER intent.nodes ENTRY, ALWAYS. A dangling reference - the definition deleted, or owned by
// another caller type - is NOT a node (EffectiveNodes drops it, the card view renders nothing for it), but
// dropping it here would shift every index after it and put the warning on the wrong card. It stays as a
// pass-through: never enabled, so it is never stranded and never strands anything.
function reachEntries(doc: DesignerDocument, workflowId: string | undefined, intent: WorkflowIntent): ReachEntry[] {
  const shared = sharedNodesFor(doc, workflowId);
  const out: ReachEntry[] = [];
  for (const entry of intent.nodes ?? []) {
    if (entry.sharedNodeId) {
      const def = shared.find(n => n.id === entry.sharedNodeId);
      if (!def) { out.push({ node: {}, enabled: false, label: 'Shared node' }); continue; }
      const offHere = def.enabled === false || (def.disabledIntentIds ?? []).includes(intent.id ?? '');
      out.push({ node: def, enabled: !offHere, label: def.label || 'Shared node' });
    } else {
      out.push({ node: entry, enabled: entry.enabled !== false, label: entry.label || 'Node' });
    }
  }
  return out;
}

// The one outcome a Confirm card advances on. Kept in a function so the readers cannot drift.
function confirmSuccessOutcome(node: WorkflowNode): WorkflowOutcome | undefined {
  return (node.outcomes ?? []).find(oc => (oc.key ?? '').toLowerCase() === 'success');
}

// v12.4.16 (#504 follow-up): WHERE A CONFIRM CARD GOES WHEN THE CALLER SAYS YES - its only advancing path.
//
// The explicit `success` outcome first, because that is what the engine reads. Failing that, the legacy
// `node.terminalKey`: #504 retired the engine's fallback (correctly - a missing success outcome means
// CONTINUE), but the "On confirm -> go to" control kept writing that field, so an un-migrated document has
// a terminal sitting there that the control DISPLAYS and the engine ignores. This reads it for the same
// reason the control displays it: it is what the tenant configured, and the next save makes it real.
//
// So every surface agrees - the control, the card, the sequence view and the engine after the save. The one
// thing that disagrees is the engine BEFORE the save, which is exactly the drift being closed here.
function confirmSuccessRoute(node: WorkflowNode): { kind: string; target?: string | null } {
  const oc = confirmSuccessOutcome(node);
  if (oc) return { kind: (oc.routeKind ?? 'continue').toLowerCase(), target: oc.routeTarget };
  const legacy = (node.terminalKey ?? '').trim();
  return legacy ? { kind: 'terminal', target: legacy } : { kind: 'continue' };
}

// The value the "On confirm -> go to" dropdown shows: the explicit outcome, else the legacy field, else
// Continue - which is what "no success outcome" has meant to the engine since #504.
function confirmSuccessValue(node: WorkflowNode): string {
  const explicit = outcomeRouteValue(node.outcomes, 'success');
  if (explicit) return explicit;
  const legacy = (node.terminalKey ?? '').trim();
  return legacy || ROUTE_CONTINUE;
}

// v12.4.16 (#504 follow-up): THE ONE-WAY CONVERSION, AT SAVE, NEVER ON LOAD.
//
// Deliberately not a load-time migration: rewriting a tenant's document because they opened a screen is how
// a change arrives with nobody's name on it. This runs inside the save mutation, so every save route - the
// hero, the drawer, a delete - converts, and only when the tenant has chosen to write.
//
// For a CONFIRM card carrying a legacy terminalKey: write the explicit `success` outcome it always meant
// (unless an explicit one already exists, which wins), then clear the legacy field so the two can never
// disagree again. Terminal-TYPE cards are untouched - node.TerminalKey is that card's real, live setting
// (SnapshotCallInterpreter ~1470) and nothing here may go near it.
function migrateConfirmSuccessRoutes(doc: DesignerDocument): DesignerDocument {
  let touched = false;
  const fixNode = (node: WorkflowNode): WorkflowNode => {
    if ((node.type ?? '').trim().toLowerCase() !== 'confirm') return node;
    const legacy = (node.terminalKey ?? '').trim();
    if (!legacy) return node;
    touched = true;
    const outcomes = confirmSuccessOutcome(node) ? node.outcomes : setOutcomeRoute(node.outcomes, 'success', legacy);
    return { ...node, outcomes, terminalKey: null };
  };
  const sharedNodes = doc.sharedNodes ? doc.sharedNodes.map(fixNode) : doc.sharedNodes;
  const workflows = doc.workflows
    ? doc.workflows.map(w => ({
        ...w,
        intents: w.intents ? w.intents.map(i => ({ ...i, nodes: i.nodes ? i.nodes.map(fixNode) : i.nodes })) : w.intents,
      }))
    : doc.workflows;
  return touched ? { ...doc, sharedNodes, workflows } : doc;
}

// Does this card end EVERY branch through it? See the note above for why the list is this short.
function endsEveryBranch(node: WorkflowNode): boolean {
  const type = (node.type ?? '').trim().toLowerCase();
  if (type === 'terminal') return true;
  if (type === 'confirm') return confirmSuccessRoute(node).kind === 'terminal';
  return false;
}

// Jump targets OUT of a card: an outcome routed to another card, and an optional step's "if captured" route.
function jumpTargets(node: WorkflowNode): string[] {
  const out: string[] = [];
  for (const oc of node.outcomes ?? [])
    if ((oc.routeKind ?? '').toLowerCase() === 'card' && oc.routeTarget) out.push(oc.routeTarget);
  const steps = [...(node.steps ?? []), ...(node.requestTypes ?? []).flatMap(rt => rt.steps ?? [])];
  for (const st of steps)
    if ((st.capturedRouteKind ?? '').toLowerCase() === 'node' && st.capturedRouteTarget) out.push(st.capturedRouteTarget);
  return out;
}

// A terminal's tenant-facing name - their own Name when they set one, else the built-in label.
function terminalDisplayName(doc: DesignerDocument, key?: string | null): string {
  const k = (key ?? '').trim() || 'end-call';
  const named = doc.terminalConfig?.[k]?.name;
  return (named && named.trim()) || TERMINAL_LABELS[k] || k;
}

// v12.10.10 (#1408, Tushar 10/8): "defaults come from the TEMPLATE. A template authored in T4 must give every box a value
// (T4 template save checks it)." The boxes a tenant sees as Template default. Claude's call under the auto-decide rule: the
// check WARNS with the list and lets the author save anyway (like the stranded-card warning) - a hard block could stop a
// template fix on go-live week; Tushar can make it a block later.
function templateBlankBoxes(doc: DesignerDocument): string[] {
  const p = primaryLangCode(doc);
  const has = (m?: Record<string, string> | string | null) => typeof m === 'string' ? !!m.trim() : !!(m?.[p] ?? '').trim();
  const out: string[] = [];
  const hours = (doc.preRouting?.hours ?? {}) as { afterHoursMessage?: string | Record<string, string> };
  if (!has(hours.afterHoursMessage)) out.push('Hours check · Closed message');
  if (!has(doc.preRouting?.greeting as Record<string, string> | undefined)) out.push('Greeting');
  const kp = ((doc.preRouting?.classify ?? {}) as { keypad?: { prompt?: Record<string, string>; options?: unknown[] } }).keypad;
  if (kp && (kp.options ?? []).length > 0 && !has(kp.prompt)) out.push('Classify · Keypad prompt');
  for (const [key, t] of Object.entries(doc.terminalConfig ?? {})) if (t?.askAnythingElse && !has(t.anythingElsePrompt)) out.push(`Terminal ${key} · "Anything else?" prompt`);
  for (const wf of doc.workflows ?? []) for (const it of wf.intents ?? []) for (const n of it.nodes ?? []) {
    if (n.enabled === false || n.sharedNodeId) continue;
    const where = `${wf.name ?? 'Caller type'} › ${it.label ?? 'Intent'} › ${n.label || n.type || 'node'}`;
    if (n.type === 'Connect') {
      if (!has(n.errorPrompt)) out.push(`${where} · If it answers and refuses, say`);
      if (!has(n.noConnectionPrompt)) out.push(`${where} · No connection, say`);
    }
    if (n.type === 'TextConfirm') {
      if (!has(n.textOffer)) out.push(`${where} · Ask the caller`);
      if (!has(n.textMessage)) out.push(`${where} · The text message`);
    }
    if (n.type === 'Confirm') {
      const types = (n.requestTypes ?? []).filter(rt => rt.enabled !== false);
      if (types.length === 0) { if (!has(n.defaultReadback)) out.push(`${where} · Read-back`); }
      else for (const rt of types) if (!has(n.requestReadbacks?.find(rb => rb.requestTypeId === rt.id)?.prompt)) out.push(`${where} · Read-back for ${rt.name || 'a request type'}`);
    }
  }
  return out;
}

// ══ v12.10.10 (#1406, LIST-MAPPING-RAW v1.12 section C): the workflow save checks for the list offer token. ══
// C1 (refuse): {lists.x.y} in a prompt while x.y is not tied to a list - the agent would offer nothing.
// C2 (warn): the token is used but the list offers nothing (cap 0, or no Active entry).
// C3 (warn): a step offers one field and stores another.
function listOfferChecks(doc: DesignerDocument, custom: Record<string, CustomField>, lists: Record<string, RefListLite>): { refuse: string[]; warn: string[] } {
  const refuse: string[] = [], warn: string[] = [];
  const tieOf = (field: string) => { const k = Object.keys(custom).find(x => x.toLowerCase() === field.toLowerCase()); return k ? custom[k] : undefined; };
  const listOf = (key?: string) => { if (!key) return undefined; const k = Object.keys(lists).find(x => x.toLowerCase() === key.toLowerCase()); return k ? lists[k] : undefined; };
  const used = new Set<string>();
  const re = /\{\s*lists\.([A-Za-z0-9_]+\.[A-Za-z0-9_]+)\s*\}/g;
  for (const m of JSON.stringify(doc).matchAll(re)) used.add(m[1]);
  for (const f of used) {
    const t = tieOf(f);
    const l = listOf(t?.listKey);
    if (!t?.listKey || !l) { refuse.push(`{lists.${f}} is used in a prompt, but ${f} is not tied to a list (Vocabulary › Fields)`); continue; }
    const active = (l.entries ?? []).filter(e => e.active !== false).length;
    if (l.offerCap === 0 || (l.entries && active === 0)) warn.push(`{lists.${f}}: nothing would be offered - ${l.name} ${l.offerCap === 0 ? 'has Offer up to 0' : 'has no Active entry'}`);
  }
  for (const wf of doc.workflows ?? []) for (const it of wf.intents ?? []) for (const n of it.nodes ?? []) for (const st of n.steps ?? []) {
    const offered = new Set<string>();
    for (const txt of Object.values(st.prompt ?? {})) for (const m of String(txt ?? '').matchAll(re)) offered.add(m[1].toLowerCase());
    if (offered.size === 0) continue;
    const stores = (st.stores ?? '').split(/[,;\n]+/).map(x => x.trim().replace(/[{}]/g, '').toLowerCase()).filter(Boolean);
    for (const o of offered) if (!stores.includes(o)) warn.push(`${wf.name ?? 'Caller type'} › ${it.label ?? 'Intent'} › ${n.label || 'node'}: offers ${o} but stores ${stores.join(', ') || 'nothing'}`);
  }
  return { refuse, warn };
}

interface StrandedNode { index: number; nodeId: string; label: string; blocker: string }
interface StrandedReport extends StrandedNode { workflowName: string; intentId: string; intentLabel: string }

// The ENABLED cards in one intent that no path reaches, each with the card and route that strands it.
function strandedInIntent(doc: DesignerDocument, workflowId: string | undefined, intent: WorkflowIntent): StrandedNode[] {
  const list = reachEntries(doc, workflowId, intent);
  if (list.length === 0) return [];
  const indexOfId = new Map<string, number>();
  list.forEach((e, i) => { if (e.node.id && !indexOfId.has(e.node.id)) indexOfId.set(e.node.id, i); });

  const reached = new Set<number>();
  const stack: number[] = [0];
  while (stack.length > 0) {
    const i = stack.pop() as number;
    if (i < 0 || i >= list.length || reached.has(i)) continue;
    reached.add(i);
    const entry = list[i];
    // A disabled card is SKIPPED by the engine before its type is ever read (`[node:skipped-disabled]`),
    // so it neither ends a branch nor opens one - the call simply walks past it.
    if (!entry.enabled) { stack.push(i + 1); continue; }
    for (const target of jumpTargets(entry.node)) {
      const j = indexOfId.get(target);
      if (j !== undefined) stack.push(j);
    }
    if (!endsEveryBranch(entry.node)) stack.push(i + 1);
  }

  const out: StrandedNode[] = [];
  list.forEach((entry, i) => {
    if (!entry.enabled || reached.has(i)) return;
    // WHICH ROUTE STRANDS IT: the nearest reachable card ahead of it that ends every branch. There is always
    // one - the walk only stops advancing at such a card - so this names a real route, never a guess.
    let blocker = 'a card ahead of it ends the call first';
    for (let j = i - 1; j >= 0; j--) {
      const b = list[j];
      if (!reached.has(j) || !b.enabled || !endsEveryBranch(b.node)) continue;
      blocker = (b.node.type ?? '').trim().toLowerCase() === 'terminal'
        ? `card ${j + 1} \u201c${b.label}\u201d ends the call at ${terminalDisplayName(doc, b.node.terminalKey)}`
        : `card ${j + 1} \u201c${b.label}\u201d routes to ${terminalDisplayName(doc, confirmSuccessRoute(b.node).target)} as soon as the caller confirms`;
      break;
    }
    out.push({ index: i, nodeId: entry.node.id ?? '', label: entry.label, blocker });
  });
  return out;
}

// Every stranded card in the document - what the save warning names. Disabled caller types and intents are
// skipped: nothing in them runs, so nothing in them is stranded.
function strandedInDocument(doc: DesignerDocument): StrandedReport[] {
  const out: StrandedReport[] = [];
  for (const workflow of doc.workflows ?? []) {
    if (workflow.enabled === false) continue;
    for (const intent of workflow.intents ?? []) {
      if (intent.enabled === false) continue;
      for (const s of strandedInIntent(doc, workflow.id, intent))
        out.push({ ...s, workflowName: workflow.name || 'Caller type', intentId: intent.id ?? '', intentLabel: intent.label || 'Intent' });
    }
  }
  return out;
}

type ApiRecord = Record<string, unknown>;

function asRecord(value: unknown): ApiRecord {
  return value && typeof value === 'object' && !Array.isArray(value) ? value as ApiRecord : {};
}

function asArray(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [];
}

function readRaw(record: ApiRecord, camel: string, pascal?: string): unknown {
  return record[camel] ?? (pascal ? record[pascal] : undefined);
}

function readString(record: ApiRecord, camel: string, pascal: string, fallback = ''): string {
  const value = readRaw(record, camel, pascal);
  return typeof value === 'string' ? value : fallback;
}

function readNullableString(record: ApiRecord, camel: string, pascal: string): string | null {
  const value = readRaw(record, camel, pascal);
  return typeof value === 'string' ? value : null;
}

function readConfigJson(record: ApiRecord): string {
  const value =
    readRaw(record, 'configJson', 'ConfigJson')
    ?? readRaw(record, 'config_json')
    ?? readRaw(record, 'definitionJson', 'DefinitionJson')
    ?? readRaw(record, 'definition_json')
    ?? readRaw(record, 'definition', 'Definition')
    ?? readRaw(record, 'designerJson', 'DesignerJson')
    ?? readRaw(record, 'workflowJson', 'WorkflowJson');

  if (typeof value === 'string' && value.trim()) return value;
  if (value && typeof value === 'object') return JSON.stringify(value);
  return '{}';
}

function readNumber(record: ApiRecord, camel: string, pascal: string, fallback = 0): number {
  const value = readRaw(record, camel, pascal);
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return fallback;
}

function readBoolean(record: ApiRecord, camel: string, pascal: string, fallback = false): boolean {
  const value = readRaw(record, camel, pascal);
  return typeof value === 'boolean' ? value : fallback;
}

function readPrompt(value: unknown): Record<string, string> {
  const record = asRecord(value);
  return Object.fromEntries(Object.entries(record).filter((entry): entry is [string, string] => typeof entry[1] === 'string'));
}

function normalizeSnapshot(raw: unknown): TenantWorkflowSnapshot {
  const record = asRecord(raw);
  return {
    id: readNumber(record, 'id', 'Id'),
    platformTemplateId: readNumber(record, 'platformTemplateId', 'PlatformTemplateId'),
    templateKey: readString(record, 'templateKey', 'TemplateKey', 'tenant-workflow'),
    templateName: readString(record, 'templateName', 'TemplateName', 'Tenant workflow'),
    categoryCode: readString(record, 'categoryCode', 'CategoryCode', 'workflow'),
    categoryName: readString(record, 'categoryName', 'CategoryName', 'Workflow'),
    templateVersion: readNumber(record, 'templateVersion', 'TemplateVersion', 1),
    status: readString(record, 'status', 'Status', 'Active'),
    isActive: readBoolean(record, 'isActive', 'IsActive', true),
    configJson: readConfigJson(record),
    summaryJson: readNullableString(record, 'summaryJson', 'SummaryJson') ?? readNullableString(record, 'summary_json', 'SummaryJson'),
    updatedAt: readString(record, 'updatedAt', 'UpdatedAt', ''),
  };
}

function normalizeTemplateOption(raw: unknown): WorkflowTemplateOption {
  const record = asRecord(raw);
  return {
    id: readNumber(record, 'id', 'Id'),
    categoryId: readNumber(record, 'categoryId', 'CategoryId'),
    categoryCode: readString(record, 'categoryCode', 'CategoryCode', 'workflow'),
    categoryName: readString(record, 'categoryName', 'CategoryName', 'Workflow'),
    templateKey: readString(record, 'templateKey', 'TemplateKey', 'workflow-template'),
    templateName: readString(record, 'templateName', 'TemplateName', 'Workflow template'),
    description: readNullableString(record, 'description', 'Description'),
    templateVersion: readNumber(record, 'templateVersion', 'TemplateVersion', 1),
    status: readString(record, 'status', 'Status', 'Published'),
    publishedAt: readNullableString(record, 'publishedAt', 'PublishedAt'),
    summaryJson: readNullableString(record, 'summaryJson', 'SummaryJson'),
  };
}

function normalizeChangeTemplateResponse(raw: unknown): { saved: boolean; snapshot: TenantWorkflowSnapshot } {
  const record = asRecord(raw);
  return {
    saved: readBoolean(record, 'saved', 'Saved', true),
    snapshot: normalizeSnapshot(readRaw(record, 'snapshot', 'Snapshot')),
  };
}

function normalizeWorkflow(raw: unknown, index: number): WorkflowLane {
  const record = asRecord(raw);
  const intents = asArray(readRaw(record, 'intents', 'Intents')).map((intent, intentIndex) => normalizeIntent(intent, index, intentIndex));
  return {
    id: readString(record, 'id', 'Id', `workflow-${index + 1}`),
    name: readString(record, 'name', 'Name', `Workflow ${index + 1}`),
    description: readNullableString(record, 'description', 'Description') ?? '',
    enabled: readBoolean(record, 'enabled', 'Enabled', true),   // v12.2.47.7 (#271)
    // v12.2.20.0 (#137): preserve caller-type keywords — normalizeDoc runs on every edit, so dropping
    // them here meant Classify keyword chips vanished the moment they were added ("can't add tokens").
    keywords: asArray(readRaw(record, 'keywords', 'Keywords')).filter((item): item is string => typeof item === 'string'),
    keywordsByLang: (readRaw(record, 'keywordsByLang', 'KeywordsByLang') as Record<string, string[]> | undefined),   // v12.9.23 (#903)
    nameByLang: (readRaw(record, 'nameByLang', 'NameByLang') as Record<string, string> | undefined),   // v12.9.24 (#902)
    // v12.10.23 (#2029): Something else is always the last request of a caller type.
    intents: [...intents.filter(i => !isSomethingElseIntent(i)), ...intents.filter(i => isSomethingElseIntent(i))],
    // v12.10.23 (#2028 #2029): kept through normalize / save - the #294 trap.
    requestReask: readRaw(record, 'requestReask', 'RequestReask') === undefined ? undefined : readPrompt(readRaw(record, 'requestReask', 'RequestReask')),
    requestMenuPrompt: readRaw(record, 'requestMenuPrompt', 'RequestMenuPrompt') === undefined ? undefined : readPrompt(readRaw(record, 'requestMenuPrompt', 'RequestMenuPrompt')),
  };
}

function normalizeIntent(raw: unknown, workflowIndex: number, intentIndex: number): WorkflowIntent {
  const record = asRecord(raw);
  const nodes = asArray(readRaw(record, 'nodes', 'Nodes')).map((node, nodeIndex) => normalizeNode(node, workflowIndex, intentIndex, nodeIndex));
  return {
    id: readString(record, 'id', 'Id', `intent-${workflowIndex + 1}-${intentIndex + 1}`),
    label: readString(record, 'label', 'Label', `Intent ${intentIndex + 1}`),
    enabled: readBoolean(record, 'enabled', 'Enabled', true),   // v12.2.47.7 (#271)
    keywords: asArray(readRaw(record, 'keywords', 'Keywords')).filter((item): item is string => typeof item === 'string'),
    keywordsByLang: (readRaw(record, 'keywordsByLang', 'KeywordsByLang') as Record<string, string[]> | undefined),   // v12.9.23 (#903)
    labelByLang: (readRaw(record, 'labelByLang', 'LabelByLang') as Record<string, string> | undefined),   // v12.9.24 (#902)
    confidenceThreshold: readNumber(record, 'confidenceThreshold', 'ConfidenceThreshold', 0.7),
    fallbackMode: readString(record, 'fallbackMode', 'FallbackMode', 'clarify-then-keypad'),
    endTerminalKey: readNullableString(record, 'endTerminalKey', 'EndTerminalKey'),   // v12.4.16 (#516)
    key: readNullableString(record, 'key', 'Key') ?? undefined,   // v12.7.3 (#646)
    category: readNullableString(record, 'category', 'Category') ?? undefined,   // v12.10.22 (#2011)
    filesUnder: readNullableString(record, 'filesUnder', 'FilesUnder') ?? undefined,   // v12.10.11.1 (#1486) · v12.10.17 (#1723 T120 follow-up): retired - kept only so old snapshots save back unchanged
    nodes,
  };
}

function normalizeNode(raw: unknown, workflowIndex: number, intentIndex: number, nodeIndex: number): WorkflowNode {
  const record = asRecord(raw);
  const integrationRaw = readRaw(record, 'integration', 'Integration');
  const integrationRecord = asRecord(integrationRaw);
  const retryPolicy = asRecord(readRaw(record, 'retryPolicy', 'RetryPolicy'));
  const steps = asArray(readRaw(record, 'steps', 'Steps')).map((step, stepIndex) => normalizeStep(step, workflowIndex, intentIndex, nodeIndex, stepIndex));
  // v12.2.47.9 (#278): node-level Default read-back for Confirm nodes. Migration (#278-e): a legacy Confirm authored its
  // read-back in step 1 — if no Default is set yet, carry that first-step prompt into DefaultReadback so no wording is
  // lost when the Confirm Steps section is dropped. Non-Confirm nodes keep their steps untouched.
  const nodeType = readString(record, 'type', 'Type', 'Request');   // v12.7.3 (#648): a node with no type is a Request
  let defaultReadback = readPrompt(readRaw(record, 'defaultReadback', 'DefaultReadback'));
  if (nodeType === 'Confirm' && Object.keys(defaultReadback).length === 0 && steps.length > 0 && steps[0]?.prompt && Object.keys(steps[0].prompt).length > 0) {
    defaultReadback = { ...steps[0].prompt };
  }
  // v12.4.0 (#385): a reference entry carries only its id + sharedNodeId. It MUST be listed here or normalizeDoc
  // strips it on save and every shared node silently jumps back to before/after - the #294 trap that #312 and
  // #320 were both caught by. Empty string is normalised to undefined so an ordinary node never looks like a ref.
  const sharedRef = readString(record, 'sharedNodeId', 'SharedNodeId', '') || undefined;
  return {
    id: readString(record, 'id', 'Id', `node-${workflowIndex + 1}-${intentIndex + 1}-${nodeIndex + 1}`),
    sharedNodeId: sharedRef,
    type: readString(record, 'type', 'Type', 'Request'),   // v12.7.3 (#648)
    label: readString(record, 'label', 'Label', `Node ${nodeIndex + 1}`),
    description: readNullableString(record, 'description', 'Description') ?? '',
    enabled: readBoolean(record, 'enabled', 'Enabled', true),   // v12.2.23.0 (#145): preserve node enable flag
    retryMax: readNumber(record, 'retryMax', 'RetryMax', readNumber(retryPolicy, 'maxAttempts', 'MaxAttempts', 2)),
    // v12.10.15 (#1643 / #1653) - the #294 trap: read here or the first save deletes them. Absent stays absent.
    askTogether: readRaw(record, 'askTogether', 'AskTogether') === undefined ? undefined : readBoolean(record, 'askTogether', 'AskTogether', false),
    askTogetherPrompt: readRaw(record, 'askTogetherPrompt', 'AskTogetherPrompt') === undefined ? undefined : readPrompt(readRaw(record, 'askTogetherPrompt', 'AskTogetherPrompt')),
    questionBudget: (() => { const r = readRaw(record, 'questionBudget', 'QuestionBudget'); return typeof r === 'number' ? r : undefined; })(),
    fallbackMode: readString(record, 'fallbackMode', 'FallbackMode', 'clarify-then-keypad'),
    integration: integrationRaw === null || Object.keys(integrationRecord).length === 0
      ? null
      : {
          // v12.7.2 (#616): providerId is read HERE or the first save after this build deletes it and the
          // whole fix is undone - this function rebuilds the document from its field list on load AND on
          // save, which is the #294 trap #312 and #320 were both caught by. 0 is normalised to null so
          // "not recorded" has one spelling rather than two.
          providerId: readNumber(integrationRecord, 'providerId', 'ProviderId', 0) || null,
          provider: readString(integrationRecord, 'provider', 'Provider'),
          operation: readString(integrationRecord, 'operation', 'Operation'),
        },
    tokensOut: asArray(readRaw(record, 'tokensOut', 'TokensOut')).filter((item): item is string => typeof item === 'string'),
    terminalKey: readNullableString(record, 'terminalKey', 'TerminalKey'),
    correctionPrompt: readPrompt(readRaw(record, 'correctionPrompt', 'CorrectionPrompt')),
    cantConfirmPrompt: readPrompt(readRaw(record, 'cantConfirmPrompt', 'CantConfirmPrompt')),   // v12.9.25 (#965) - #294 trap: a field not read here is deleted on save
    // v12.9.26 (#985) - the #294 trap again: read here or the first save deletes the tenant's choice. Absent stays
    // absent (the engine's defaults - ON, 3 - apply), so a workflow nobody touched is not rewritten by opening it.
    skipReadbackWhenConfirmed: readRaw(record, 'skipReadbackWhenConfirmed', 'SkipReadbackWhenConfirmed') === undefined
      ? undefined : readBoolean(record, 'skipReadbackWhenConfirmed', 'SkipReadbackWhenConfirmed', true),
    skipReadbackMinFields: readRaw(record, 'skipReadbackMinFields', 'SkipReadbackMinFields') === undefined
      ? undefined : Math.max(1, Math.round(readNumber(record, 'skipReadbackMinFields', 'SkipReadbackMinFields', 3))),
    errorPrompt: readPrompt(readRaw(record, 'errorPrompt', 'ErrorPrompt')),   // v12.4.16 (#503)
    successPrompt: readPrompt(readRaw(record, 'successPrompt', 'SuccessPrompt')),             // v12.9.11 (#778)
    noConnectionPrompt: readPrompt(readRaw(record, 'noConnectionPrompt', 'NoConnectionPrompt')), // v12.9.11 (#778)
    // v12.5.0 (#525): normalizeDoc rebuilds the document from THIS field list on load AND on save, so a field
    // missing here is a field the save silently deletes - the #294 trap #312 and #320 were both caught by.
    textOffer: readPrompt(readRaw(record, 'textOffer', 'TextOffer')),
    textReask: readPrompt(readRaw(record, 'textReask', 'TextReask')),   // v12.10.15 (#1660) - #294: read here or a save deletes it
    // v12.10.15 (#1663) the Callback card - #294 again
    callbackQuestion: readPrompt(readRaw(record, 'callbackQuestion', 'CallbackQuestion')),
    callbackAskNumber: readPrompt(readRaw(record, 'callbackAskNumber', 'CallbackAskNumber')),
    callbackStore: readNullableString(record, 'callbackStore', 'CallbackStore'),
    callbackSkipOnMobile: readBoolean(record, 'callbackSkipOnMobile', 'CallbackSkipOnMobile', false),
    textMessage: readPrompt(readRaw(record, 'textMessage', 'TextMessage')),
    textSent: readPrompt(readRaw(record, 'textSent', 'TextSent')),
    feedbackFormUrl: readNullableString(record, 'feedbackFormUrl', 'FeedbackFormUrl') ?? undefined,   // v12.9.28 (#1057) - in the field list or the save drops it (#294)
    // v12.10.2 (#1093): the Announce card's five fields - the #294 trap again: 12.10.1 shipped the card without them
    // here, so opening and saving the workflow erased Harlem's Call Reference line. Absent stays absent (engine defaults).
    announceText: (() => { const r = readRaw(record, 'announceText', 'AnnounceText'); return r === undefined || r === null ? undefined : readPrompt(r); })(),
    announceWait: readRaw(record, 'announceWait', 'AnnounceWait') === undefined || readRaw(record, 'announceWait', 'AnnounceWait') === null ? undefined : readBoolean(record, 'announceWait', 'AnnounceWait', true),
    announceListenSeconds: (() => { const r = readRaw(record, 'announceListenSeconds', 'AnnounceListenSeconds'); return typeof r === 'number' ? r : undefined; })(),
    announceRepeatMax: (() => { const r = readRaw(record, 'announceRepeatMax', 'AnnounceRepeatMax'); return typeof r === 'number' ? r : undefined; })(),
    announceThen: readNullableString(record, 'announceThen', 'AnnounceThen') ?? undefined,
    outcomes: asArray(readRaw(record, 'outcomes', 'Outcomes')).map(oc => { const r = asRecord(oc); return { key: readString(r, 'key', 'Key'), routeKind: readString(r, 'routeKind', 'RouteKind', 'continue'), routeTarget: readNullableString(r, 'routeTarget', 'RouteTarget'), maxLoops: readNumber(r, 'maxLoops', 'MaxLoops', 0) || null }; }).filter(oc => oc.key),
    // v12.2.47.8 (#274): preserve Confirm per-request-type read-backs.
    requestReadbacks: asArray(readRaw(record, 'requestReadbacks', 'RequestReadbacks')).map(rb => { const r = asRecord(rb); return { requestTypeId: readString(r, 'requestTypeId', 'RequestTypeId', ''), prompt: readPrompt(readRaw(r, 'prompt', 'Prompt')) }; }).filter(rb => rb.requestTypeId),
    defaultReadback,   // v12.2.47.9 (#278): Confirm node-level Default read-back (migrated from legacy step-1 prompt when absent)
    // v12.2.47.1 (Request-node): preserve request types (each owns its own steps) through normalize/save.
    requestTypes: asArray(readRaw(record, 'requestTypes', 'RequestTypes')).map((rt, i) => {
      const r = asRecord(rt);
      return {
        id: readString(r, 'id', 'Id', `rt-${workflowIndex + 1}-${intentIndex + 1}-${nodeIndex + 1}-${i + 1}`),
        name: readString(r, 'name', 'Name', ''),
        // v12.9.25 (#956): kept through normalize/save - the #294 trap (a field not read here is deleted on save).
        nameByLang: (readRaw(r, 'nameByLang', 'NameByLang') as Record<string, string> | undefined),
        keywords: asArray(readRaw(r, 'keywords', 'Keywords')).filter((x): x is string => typeof x === 'string'),
        keywordsByLang: (readRaw(r, 'keywordsByLang', 'KeywordsByLang') as Record<string, string[]> | undefined),
        enabled: readBoolean(r, 'enabled', 'Enabled', true),
        askTogether: readRaw(r, 'askTogether', 'AskTogether') === undefined ? undefined : readBoolean(r, 'askTogether', 'AskTogether', false),   // v12.10.15 (#1643)
        askTogetherPrompt: readRaw(r, 'askTogetherPrompt', 'AskTogetherPrompt') === undefined ? undefined : readPrompt(readRaw(r, 'askTogetherPrompt', 'AskTogetherPrompt')),
        nextStep: readRaw(r, 'nextStep', 'NextStep') === undefined ? undefined : readPrompt(readRaw(r, 'nextStep', 'NextStep')),   // v12.10.19 (#1925) - the #294 trap
        steps: asArray(readRaw(r, 'steps', 'Steps')).map((st, si) => normalizeStep(st, workflowIndex, intentIndex, nodeIndex, si)),
      };
    }),
    steps,
  };
}

function normalizeStep(raw: unknown, workflowIndex: number, intentIndex: number, nodeIndex: number, stepIndex: number): WorkflowStep {
  const record = asRecord(raw);
  return {
    id: readString(record, 'id', 'Id', `step-${workflowIndex + 1}-${intentIndex + 1}-${nodeIndex + 1}-${stepIndex + 1}`),
    kind: readString(record, 'kind', 'Kind', 'speak'),
    label: readString(record, 'label', 'Label', `Step ${stepIndex + 1}`),
    prompt: readPrompt(readRaw(record, 'prompt', 'Prompt')),
    stores: readNullableString(record, 'stores', 'Stores'),
    fallbackMode: readString(record, 'fallbackMode', 'FallbackMode', 'clarify-then-keypad'),
    // v12.2.47.1 (Request-node/#260): preserve per-step on/off + confidence gate through normalize/save.
    enabled: readBoolean(record, 'enabled', 'Enabled', true),
    confidenceThreshold: (() => { const r = readRaw(record, 'confidenceThreshold', 'ConfidenceThreshold'); return typeof r === 'number' ? r : (typeof r === 'string' && r.trim() !== '' && !isNaN(Number(r)) ? Number(r) : null); })(),
    lowConfidenceAction: readNullableString(record, 'lowConfidenceAction', 'LowConfidenceAction'),
    // v12.7.3 (#647/#640/#641)
    askToSpell: readBoolean(record, 'askToSpell', 'AskToSpell', false),
    splitAsk:   readBoolean(record, 'splitAsk',   'SplitAsk',   false),
    dtmf:       readBoolean(record, 'dtmf',       'Dtmf',       false),
    keypadNoKey: readString(record, 'keypadNoKey', 'KeypadNoKey', 'moveon'),   // v12.10.15 (#1641)
    rungPrompts: (readRaw(record, 'rungPrompts', 'RungPrompts') ?? undefined) as Record<string, Record<string, string>> | undefined,
    cleanup: readNullableString(record, 'cleanup', 'Cleanup'),
    // v12.2.47.8 (#273): preserve optional + captured-route through normalize/save.
    optional: readBoolean(record, 'optional', 'Optional', false),
    capturedRouteKind: readString(record, 'capturedRouteKind', 'CapturedRouteKind', 'continue'),
    capturedRouteTarget: readNullableString(record, 'capturedRouteTarget', 'CapturedRouteTarget'),
  };
}

const PRE_ROUTING_CARDS: Array<{
  key: PreRoutingKey;
  stage: string;
  badge: string;
  title: string;
  description: string;
  color: string;
}> = [
  { key: 'inbound', stage: 'START', badge: 'TEL', title: 'Inbound call', description: 'PSTN - WebRTC', color: '#16a34a' },
  { key: 'hours', stage: 'PRE-ROUTING', badge: 'CLK', title: 'Hours check', description: 'Open - after-hours', color: '#0ea5e9' },
  { key: 'disclosure', stage: 'PRE-ROUTING', badge: '!', title: 'Disclosure', description: 'Recording - legal', color: '#b91c1c' },
  // v12.10.17 (#1747, UI-PROTO-ID-CHECK-T123 v1.1 tab 1): pinned between the Disclosure and the Greeting (D22); OFF by default.
  { key: 'idCheck', stage: 'PRE-ROUTING', badge: 'ID', title: 'ID check', description: 'Contact book · who is calling', color: '#0f766e' },
  { key: 'greeting', stage: 'PRE-ROUTING', badge: 'MIC', title: 'Greeting', description: 'Welcome prompt', color: '#c2410c' },
  { key: 'language', stage: 'PRE-ROUTING', badge: 'LAN', title: 'Language detect', description: 'Auto-detect - language offer', color: '#8b5cf6' },
  { key: 'classify', stage: 'PRE-ROUTING', badge: 'CLS', title: 'Classify', description: 'Intent routing', color: '#ea580c' },
];

// v12.2.47.10 (#275-A): pre-routing stages render in the tenant's saved order (doc.preRouting.order — an array
// of card keys). Inbound (START) is always pinned first; any card missing from the saved order keeps a stable
// spot after the listed ones. Mirrors the server's ReconcilePreRoutingCardStates key handling so the designer,
// the preview, and the live engine (which sorts pre-routing cards by Order) all agree.
function preRoutingOrderedCards(doc: DesignerDocument): typeof PRE_ROUTING_CARDS {
  const saved = doc.preRouting?.order;
  if (!Array.isArray(saved)) return PRE_ROUTING_CARDS;
  const byKey = new Map(PRE_ROUTING_CARDS.map(c => [c.key as string, c] as const));
  const seen = new Set<string>();
  const ordered: typeof PRE_ROUTING_CARDS = [];
  for (const k of saved) {
    if (typeof k !== 'string') continue;
    const c = byKey.get(k);
    if (c && !seen.has(c.key)) { ordered.push(c); seen.add(c.key); }
  }
  for (const c of PRE_ROUTING_CARDS) if (!seen.has(c.key)) ordered.push(c);
  const inbound = ordered.filter(c => c.key === 'inbound');
  const rest = ordered.filter(c => c.key !== 'inbound');
  return pinIdCheck([...inbound, ...rest]);
}

// v12.10.17 (#1747 D22): the ID check always sits right before the Greeting - an order saved before 12.10.17 does not list
// it, and the engine pins it there too (WorkflowDesignerDocument.PinIdCheckBeforeGreeting), so the canvas never disagrees.
function pinIdCheck<T extends { key: PreRoutingKey }>(cards: T[]): T[] {
  const id = cards.find(c => c.key === 'idCheck');
  if (!id) return cards;
  const rest = cards.filter(c => c.key !== 'idCheck');
  const at = rest.findIndex(c => c.key === 'greeting');
  if (at < 0) return [...rest, id];
  return [...rest.slice(0, at), id, ...rest.slice(at)];
}

// Pre-routing card enabled state (Disclosure is off by default; everything else on).
function preRoutingEnabled(doc: DesignerDocument, key: PreRoutingKey): boolean {
  const entry = doc.preRouting?.[key] as { isEnabled?: boolean } | undefined;
  return entry?.isEnabled ?? (key === 'disclosure' || key === 'idCheck' ? false : true);   // v12.10.17 (#1747): ID check defaults OFF
}

// Normalize a possibly-legacy per-language text field into Record<lang,string>.
function asLangMap(v: Record<string, string> | string | undefined, lang: string): Record<string, string> {
  if (!v) return {};
  if (typeof v === 'string') return v ? { [lang]: v } : {};
  return { ...v };
}

// Resolve the disclosure blocks to render. Uses saved blocks when present; otherwise seeds the two
// standard announcements (Recording disclosure on, Legal notice off), migrating any legacy
// recordingText / legalText so nothing already configured is lost.
function disclosureBlocks(doc: DesignerDocument, lang: string): DisclosureBlock[] {
  const cfg = (doc.preRouting?.disclosure ?? {}) as DisclosureConfig;
  if (cfg.blocks && cfg.blocks.length) return cfg.blocks;
  const recording = asLangMap(cfg.recordingText, lang);
  const legal = asLangMap(cfg.legalText, lang);
  return [
    {
      id: 'recording',
      caption: 'Call recording disclosure',
      enabled: true,
      text: Object.keys(recording).length ? recording : { [lang]: 'This call may be recorded for quality and training purposes.' },
    },
    {
      id: 'legal',
      caption: 'Legal notice',
      enabled: Object.keys(legal).length > 0,
      text: legal,
    },
  ];
}

// Deterministic id for a freshly added disclosure block (no Date.now/random — stable across renders).
function nextDisclosureId(blocks: DisclosureBlock[]): string {
  let n = blocks.length + 1;
  while (blocks.some(b => b.id === `block-${n}`)) n += 1;
  return `block-${n}`;
}

function parseConfig(json: string): DesignerDocument {
  try {
    return normalizeDoc(JSON.parse(json) as DesignerDocument, true);   // v12.3.16: migrate on the LOAD path only
  } catch {
    return normalizeDoc({}, true);
  }
}

// v12.3.16: `migrateShared` runs the one-time #383 migration. It used to run inside every normalizeDoc, which
// meant on EVERY edit - idempotent, but it rebuilt sharedNodes constantly for no reason and made reasoning about
// #387 harder than it needed to be. It belongs on the load path only.
function normalizeDoc(input: DesignerDocument, migrateShared = false): DesignerDocument {
  const root = asRecord(input);
  const modalInput = asRecord(input.modal ?? readRaw(root, 'modal', 'Modal'));
  const preRoutingInput = asRecord(input.preRouting ?? readRaw(root, 'preRouting', 'PreRouting'));
  const rawLanguages = asArray(readRaw(modalInput, 'languages', 'Languages'));
  const languages = rawLanguages.length
    ? rawLanguages.map(normalizeLanguage)
    : [{ code: 'en', displayName: 'English', isEnabled: true }];
  const rawWorkflows = (input.workflows ?? asArray(readRaw(root, 'workflows', 'Workflows'))) as WorkflowLane[];
  const rawTerminal = readRaw(root, 'terminal', 'Terminal');
  const parsed: DesignerDocument = {
    schemaVersion: readString(root, 'schemaVersion', 'SchemaVersion', '11.4.1.0'),
    modal: {
      category: readString(modalInput, 'category', 'Category', 'healthcare'),
      templateKey: readString(modalInput, 'templateKey', 'TemplateKey', 'tenant-workflow'),
      displayName: readString(modalInput, 'displayName', 'DisplayName', 'Tenant workflow'),
      languages,
      tenantDefaultPolicy: readString(modalInput, 'tenantDefaultPolicy', 'TenantDefaultPolicy', 'one-active-workflow'),
    },
    preRouting: {
      label: readString(preRoutingInput, 'label', 'Label', 'Inbound call'),
      routingGoal: readString(preRoutingInput, 'routingGoal', 'RoutingGoal', 'Greet, detect language, classify intent, and route naturally.'),
      greeting: Object.keys(readPrompt(readRaw(preRoutingInput, 'greeting', 'Greeting'))).length
        ? readPrompt(readRaw(preRoutingInput, 'greeting', 'Greeting'))
        : { en: 'Thank you for calling {organization.name}. How may I help you today?' },
      fallbackMode: readString(preRoutingInput, 'fallbackMode', 'FallbackMode', 'clarify-then-keypad'),
      tokens: asArray(readRaw(preRoutingInput, 'tokens', 'Tokens')).filter((item): item is string => typeof item === 'string'),
      ...preRoutingInput,
    },
    workflows: rawWorkflows.map((workflow, index) => normalizeWorkflow(workflow, index)),
    // v12.2.23.0 (#149): merge the standard outcomes (incl. the new "thankyou") UNDER the saved values, so
    // every doc has Thank-You available while any tenant-edited message still wins.
    terminal: { ...DEFAULT_TERMINALS, ...(asRecord(rawTerminal) as Record<string, string>) },
    defaultTerminalKey: readNullableString(root, 'defaultTerminalKey', 'DefaultTerminalKey'),
    // v12.2.44.0 (#253): per-terminal action/wait/wrap-up config (round-trips as-is; engine reads camelCase).
    terminalConfig: asRecord(readRaw(root, 'terminalConfig', 'TerminalConfig')) as Record<string, TerminalConfig>,
    // v12.9.24 (#911): MUST be listed or normalizeDoc strips it and every machine text loses its mark (#294).
    machineFilled: asRecord(readRaw(root, 'machineFilled', 'MachineFilled')) as DesignerDocument['machineFilled'],
    // v12.3.2 (#238): explicit terminal order + the interceptor's on/off — MUST be listed here or normalizeDoc strips them.
    terminalOrder: asArray(readRaw(root, 'terminalOrder', 'TerminalOrder')).filter((k): k is string => typeof k === 'string'),
    // v12.4.0 (#398): `commands` MUST survive normalize or every phrase list is wiped on the first save - the
    // #294 trap that #312, #320 and #385 were each caught by. asRecord keeps the whole object, so the nested
    // per-language lists ride through untouched.
    interceptor: asRecord(readRaw(root, 'interceptor', 'Interceptor')) as InterceptorConfig,
    // v12.10.19 (#1907): MUST be listed or normalizeDoc strips it (#294)
    silenceRule: readRaw(root, 'silenceRule', 'SilenceRule') === undefined ? undefined : (asRecord(readRaw(root, 'silenceRule', 'SilenceRule')) as SilenceRule),
    // v12.10.21 (#1957): MUST be listed or normalizeDoc strips it (#294)
    readbacks: readRaw(root, 'readbacks', 'Readbacks') === undefined ? undefined : (asRecord(readRaw(root, 'readbacks', 'Readbacks')) as ReadbacksConfig),
    // v12.3.11 (#312): nodes every intent runs. MUST be listed here — normalizeDoc rebuilds the document
    // from this fixed field list on every save, so an unlisted field is silently stripped (#294).
    sharedNodes: asArray(readRaw(root, 'sharedNodes', 'SharedNodes')).map((n, i) => {
      const nn = normalizeNode(n, -1, -1, i);
      const pos = readString(asRecord(n), 'sharedPosition', 'SharedPosition', 'before');
      const swf = readString(asRecord(n), 'sharedWorkflowId', 'SharedWorkflowId', '');   // v12.3.15 (#383)
      // v12.3.12 (#320): carry the per-intent disable list through normalize, or it is stripped on save - the
      // #294 trap that #312 had to be rescued from.
      const off = asArray(readRaw(asRecord(n), 'disabledIntentIds', 'DisabledIntentIds'))
        .filter((x): x is string => typeof x === 'string');
      return { ...nn, sharedWorkflowId: swf || undefined, sharedPosition: (pos === 'after' ? 'after' : 'before') as 'before' | 'after', disabledIntentIds: off };
    }),
  };
  // v12.4.11 (#471/#473/#474): strip content no drawer can show, on load and on every save. Placed here
  // rather than at a call site because normalizeDoc is the one funnel every document passes through.
  return pruneUnreachableNodeContent(
    migrateShared ? materializeSharedRefs(splitLegacySharedNodes(parsed)) : parsed,
  );
}

/**
 * v12.4.0 (#385): give every shared node a REAL POSITION by placing a reference in each intent's node list.
 *
 * Tushar: "it needs a real position index. if other cards (non shared) have position index then shared needs to
 * have one as well." Once a shared node sits in intent.nodes as a reference, its position IS the array index -
 * the same mechanism every other card already uses - so Move earlier / Move later become the ordinary array
 * move, two shared nodes finally have a defined order, and a shared node can sit between two of the intent's
 * own nodes. The old sharedPosition could only say 'before' or 'after', which is why "Move later" sent his
 * Capture identity past Book slot instead of one card along.
 *
 * PLACEMENT MUST MATCH WHAT THE CALL DOES TODAY, exactly. 'before' -> index 0, 'after' -> the end. So the first
 * render after this migration shows the same order the engine has been running, and the first save writes that
 * same order down. Nothing moves on its own.
 *
 * A reference is inserted in EVERY intent of the owning caller type, including intents where the node is
 * switched off (#320) - "present but disabled" and "not here at all" are different things, and losing that
 * distinction would make a disabled node unrecoverable in the UI.
 *
 * Runs AFTER splitLegacySharedNodes, so every shared node already carries its owning caller type.
 * Idempotent: an intent that already references a shared node is left untouched.
 */
function materializeSharedRefs(doc: DesignerDocument): DesignerDocument {
  const shared = doc.sharedNodes ?? [];
  if (shared.length === 0) return doc;

  let touched = false;
  const workflows = (doc.workflows ?? []).map(w => {
    const mine = shared.filter(n => n.id && (!n.sharedWorkflowId || n.sharedWorkflowId === w.id));
    if (mine.length === 0) return w;

    const intents = (w.intents ?? []).map(intent => {
      const nodes = [...(intent.nodes ?? [])];
      const already = new Set(nodes.map(n => n.sharedNodeId).filter(Boolean) as string[]);

      const before = mine.filter(n => n.sharedPosition !== 'after' && !already.has(n.id!));
      const after = mine.filter(n => n.sharedPosition === 'after' && !already.has(n.id!));
      if (before.length === 0 && after.length === 0) return intent;

      touched = true;
      const ref = (n: WorkflowNode): WorkflowNode => ({ id: `ref-${n.id}`, sharedNodeId: n.id });
      return { ...intent, nodes: [...before.map(ref), ...nodes, ...after.map(ref)] };
    });
    return { ...w, intents };
  });

  return touched ? { ...doc, workflows } : doc;
}

/**
 * v12.3.15 (#383): give every legacy shared node an owning caller type.
 *
 * Before this, a shared node had no owner and ran in EVERY caller type - so Tushar's one shared node,
 * "Capture identity", was asking Pharmacy and Physician callers for the patient's full name. The fix scopes
 * sharing to one caller type, which leaves the question of where the existing ones go.
 *
 * HIS ANSWER, 2026-09-01: "i will manually delete it from there." So a legacy node is COPIED into every caller
 * type rather than assigned to a guess. Nothing changes on the first call after deploy - all three still run
 * it, exactly as today - and he deletes the copies he does not want, in the UI, seeing what he is doing.
 * Assigning it to one caller type by inference would have silently stopped two others capturing a name.
 *
 * Idempotent: after the split every node carries a sharedWorkflowId, so a re-parse finds nothing legacy.
 * The engine reads an unstamped node as "runs everywhere", so live behaviour is unchanged whether or not this
 * document is ever saved - there is no window where a call behaves differently from what the designer shows.
 */
function splitLegacySharedNodes(doc: DesignerDocument): DesignerDocument {
  const shared = doc.sharedNodes ?? [];
  if (!shared.some(n => !n.sharedWorkflowId)) return doc;          // nothing legacy - leave it alone
  const wfs = (doc.workflows ?? []).filter(w => w.id);
  if (wfs.length === 0) return doc;                                 // nowhere to put them

  const uid = (pfx: string) => `${pfx}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
  const out: WorkflowNode[] = [];
  for (const node of shared) {
    if (node.sharedWorkflowId) { out.push(node); continue; }
    wfs.forEach((w, i) => {
      const intentIds = new Set((w.intents ?? []).map(x => x.id).filter(Boolean) as string[]);
      out.push({
        ...JSON.parse(JSON.stringify(node)) as WorkflowNode,
        // The first copy keeps the original id so anything referring to it by id still resolves.
        id: i === 0 ? node.id : uid('node'),
        sharedWorkflowId: w.id,
        // A per-intent disable only means anything for intents this caller type actually has.
        disabledIntentIds: (node.disabledIntentIds ?? []).filter(id => intentIds.has(id)),
      });
    });
  }
  return { ...doc, sharedNodes: out };
}

function cloneDoc(doc: DesignerDocument): DesignerDocument {
  return JSON.parse(JSON.stringify(doc)) as DesignerDocument;
}

// ══ v12.9.22 (#885): STOP INVENTING A NAME FOR A LANGUAGE THAT DID NOT SEND ONE. ═══════════════════
//
// His report: *"look at tabs US En . En . this problem is everywhere"*. The tab read the code twice because
// THIS function manufactured a displayName out of the code - `fallbackDisplay = code.toUpperCase()` - so a
// regional row ("en-US") arrived at `langLabel` carrying the fake name "EN-US", and rendered "EN-US · EN".
//
// THAT MADE IT LOOK LIKE #864 REGRESSED, AND #864 IS CORRECT. #864 (12.9.21) deliberately inverted the
// precedence so the name the API sends outranks T2's own LANGUAGE_INFO table, because ARCHITECTURE §7 says
// enabling a language must be DATA, not code - otherwise a ninth provisioned language renders as a bare
// code until somebody edits a .tsx. That reasoning still holds and is untouched here.
//
// What #864 assumed, reasonably, is that a displayName which EXISTS is a real name. This function broke that
// assumption by fabricating one. The fix is to stop fabricating: a row with no name now carries no name, and
// `langLabel`'s fallback does the job it was left in place to do.
function normalizeLanguage(raw: unknown): { code: string; displayName: string; isEnabled: boolean } {
  if (typeof raw === 'string') {
    const code = raw.trim().toLowerCase() || 'en';
    return { code, displayName: '', isEnabled: true };
  }

  const record = asRecord(raw);
  const code = readString(record, 'code', 'Code', 'en').trim().toLowerCase() || 'en';
  return {
    code,
    displayName: readString(record, 'displayName', 'DisplayName', '').trim(),
    isEnabled: readBoolean(record, 'isEnabled', 'IsEnabled', true),
  };
}

function languageList(doc: DesignerDocument): Array<{ code: string; displayName: string; isEnabled: boolean }> {
  const raw = doc.modal?.languages;
  if (!raw?.length) return [{ code: 'en', displayName: 'English', isEnabled: true }];
  return raw.map(normalizeLanguage);
}

// v12.3.7 (#238-F): the tenant's default/primary language code (first configured), used as the auto-translate SOURCE.
function primaryLangCode(doc: DesignerDocument): string {
  return languageList(doc)[0]?.code ?? 'en';
}

// v12.2.16.0: the T4 catalog template may declare N languages, but a TENANT only ever shows the
// languages actually provisioned on its AI Agent (Settings → AI Agent → Languages & Voices). Filter
// the template's language set down to the tenant's provisioned ones so the workflow card tabs never
// show a language the tenant can't speak. Falls back to the full set if the AI-Agent list is missing.
function provisionedLanguages(
  all: Array<{ code: string; displayName: string; isEnabled: boolean }>,
  aiLangs: Array<{ code: string }> | undefined,
): Array<{ code: string; displayName: string; isEnabled: boolean }> {
  if (!aiLangs?.length) return all;
  const provisioned = new Set(aiLangs.map(l => canonLang(l.code)));
  const filtered = all.filter(l => provisioned.has(canonLang(l.code)));
  return filtered.length ? filtered : all;
}

function summarize(doc: DesignerDocument) {
  const workflows = doc.workflows ?? [];
  const intents = workflows.reduce((sum, workflow) => sum + (workflow.intents?.length ?? 0), 0);
  const nodes = workflows.reduce((sum, workflow) => (
    sum + (workflow.intents ?? []).reduce((inner, intent) => inner + (intent.nodes?.length ?? 0), 0)
  ), 0);
  const steps = workflows.reduce((sum, workflow) => (
    sum + (workflow.intents ?? []).reduce((intentSum, intent) => (
      intentSum + (intent.nodes ?? []).reduce((nodeSum, node) => nodeSum + nodeStepCount(node), 0)   // v12.4.12 (#478 sweep)
    ), 0)
  ), 0);
  return { workflows: workflows.length, intents, nodes, steps };
}

// v12.4.0 (#398/#399): THE ENGINE'S BUILT-IN PHRASES, mirrored so the panel can SHOW them.
//
// These were invisible before - "go back" and "start over" were hardcoded in DetectMeta and the question cues
// were buried in LooksLikeQuestion, so a tenant had no way to know what their agent already understood. They
// render violet (.icp-ph.plat) to mark them as ours; the moment a tenant edits a list it REPLACES these for
// that language, which is exactly what CommandPhrases() does on the engine side.
//
// v12.4.1 (#412): PER LANGUAGE, and the previous version of this comment was the defect report. It said
// "Shown here in English only - the engine carries the Spanish too", and that is exactly what a tenant saw:
// the same English chips on every tab. Tushar, verifying 12.4.0: "i swithced tab to spanish and i still see
// keywords in english." Reading that, a tenant concludes the agent understands no Spanish and types their own
// short list - which REPLACES the working built-ins for that language and makes the call worse.
//
// KEEP IN STEP WITH SnapshotCallInterpreter.SayAgainDefaults / GoBackDefaults / StartOverDefaults /
// QuestionCueDefaults. That sentence was here before and was not honoured in the same commit that wrote it,
// so it is now MECHANICAL: tools\Check-InterceptorDefaults.mjs compares the two files and fails the build.
// A comment asking a human to keep two copies in step is not a mechanism.
type LangPhrases = Record<string, string[]>;
const SAY_AGAIN_DEFAULTS: LangPhrases = {
  en: [
    'sorry', 'sorry what', 'what', 'what did you say', 'say that again', 'can you say that again',
    'can you repeat that', 'can you repeat', 'repeat that', 'repeat please', 'please repeat',
    'i didnt hear you', 'i did not hear you', 'i didnt catch that', 'i did not catch that',
    'pardon', 'pardon me', 'come again', 'one more time',
    // v12.4.2 (#424): added after 'could you repeat that' was committed as a YES at a Confirm read-back.
    'could you repeat that', 'could you repeat', 'would you repeat that', 'would you mind repeating that',
    'say again', 'run that by me again', 'what was that', 'sorry what was that', 'i missed that',
  ],
  es: ['perdon', 'como', 'que dijo', 'puede repetir', 'repita por favor', 'otra vez'],
};
const GO_BACK_DEFAULTS: LangPhrases = {
  en: ['go back', 'back up', 'back', 'previous', 'previous question', 'the question before', 'go back a step'],
  es: ['atras', 'regresar', 'volver', 'la anterior'],
};
const START_OVER_DEFAULTS: LangPhrases = {
  en: ['start over', 'start again', 'from the beginning', 'lets start over'],
  es: ['empezar de nuevo', 'desde el principio'],
};
const QUESTION_CUE_DEFAULTS: LangPhrases = {
  en: [
    'what', 'when', 'where', 'which', 'who', 'whose', 'how', 'why',
    'do you', 'does', 'are you', 'is there', 'can i', 'can you', 'could you', 'would you',
  ],
  es: ['que', 'cuando', 'donde', 'cual', 'quien', 'como', 'por que', 'puede', 'puedo', 'hay'],
};

// Mirrors SnapshotCallInterpreter.DefaultPhrases: an unconfigured language falls back to English rather than
// to nothing, so a tenant provisioned in a third language still sees what their agent actually understands.
function defaultPhrases(defaults: LangPhrases, language: string): string[] {
  const own = defaults[language];
  return own && own.length > 0 ? own : (defaults.en ?? []);
}

// v12.3.11 (#312): shared nodes get their own colour so they never read as one intent's own node.
export const SHARED_NODE_COLOR = '#0f766e';

function nodeColor(type?: string) {
  const normalized = (type ?? '').toLowerCase();
  if (normalized === 'identity') return HIERARCHY_COLORS.identity;
  if (normalized === 'connect') return HIERARCHY_COLORS.connect;
  if (normalized === 'confirm') return HIERARCHY_COLORS.confirm;
  if (normalized === 'textconfirm') return HIERARCHY_COLORS.textConfirm;   // v12.5.0 (#525)
  if (normalized === 'terminal') return HIERARCHY_COLORS.terminal;
  return HIERARCHY_COLORS.steps;
}

function badgeFor(value: string | undefined, fallback: string) {
  if (!value) return fallback;
  const words = value.split(/[\s-_]+/).filter(Boolean);
  if (words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return value.slice(0, 3).toUpperCase();
}

function cardTitleForPreRouting(doc: DesignerDocument, key: PreRoutingKey) {
  const card = PRE_ROUTING_CARDS.find(item => item.key === key)!;
  if (key === 'inbound') return doc.preRouting?.label || card.title;
  const custom = doc.preRouting?.[key];
  if (custom && typeof custom === 'object' && 'label' in custom) {
    const label = (custom as { label?: unknown }).label;
    if (typeof label === 'string' && label.trim()) return label;
  }
  return card.title;
}

function cardDescriptionForPreRouting(doc: DesignerDocument, key: PreRoutingKey) {
  const card = PRE_ROUTING_CARDS.find(item => item.key === key)!;
  if (key === 'greeting') {
    return 'Regular · ID matched · Repeat caller';   // v12.10.17 (#1776): the Greeting's three prompts
  }
  const custom = doc.preRouting?.[key];
  if (custom && typeof custom === 'object' && 'description' in custom) {
    const description = (custom as { description?: unknown }).description;
    if (typeof description === 'string' && description.trim()) return description;
  }
  return card.description;
}

function makeId(prefix: string) {
  return `${prefix}-${Date.now().toString(36)}`;
}

// v12.2.36.0 (#192): host-agnostic save controller. The shell (T2 SettingsPage hero / later T4 chrome)
// consumes this to render its own sticky "Save all changes" bar. Kept minimal so #118 (shared T2/T4
// designer) inherits it; the SAVE ACTION stays injected by the host-owned mutation here.
export interface WorkflowSnapshotState { anyDirty: boolean; saveAll: () => void; discardAll: () => void; drawerOpen?: boolean;   // v12.10.10.1 (#1428)
  /** v12.10.18 (#1866): one entry per changed part (each intent, the opening cards, shared cards, ...) - the bar counts these. */
  changes?: { id: string; title: string }[];
  /** v12.10.18 (#1866): a save is on its way - the bar's Save is disabled so a second click cannot send the old version. */
  saving?: boolean;
}

// v12.10.18 (#1866, Tushar 10/21): "bottom bar still showed 1 workflow change ... i had to click two times and then it gave this
// message workflow changed since you opened it". The bar counted DOM cards and the workflow page is one card, so 4 intents with a
// disabled Text card read "1 unsaved change". Count the changed PARTS of the document instead - each intent on its own.
export function workflowChanges(saved: DesignerDocument, draft: DesignerDocument): { id: string; title: string }[] {
  const out: { id: string; title: string }[] = [];
  const s = (x: unknown) => JSON.stringify(x ?? null);
  const savedLanes = saved.workflows ?? [];
  for (const lane of draft.workflows ?? []) {
    const before = savedLanes.find(l => l.id === lane.id);
    const intents = lane.intents ?? [];
    let laneCounted = false;
    for (const it of intents) {
      const prev = before?.intents?.find(x => x.id === it.id);
      if (s(prev) !== s(it)) out.push({ id: `wf-${lane.id}-${it.id}`, title: `${lane.name || 'Workflow'} › ${it.label || 'Intent'}` });
    }
    const removed = (before?.intents ?? []).filter(x => !intents.some(i => i.id === x.id));
    for (const r of removed) out.push({ id: `wf-${lane.id}-${r.id}-removed`, title: `${lane.name || 'Workflow'} › ${r.label || 'Intent'} (removed)` });
    // the lane's own settings (name, order ...) with its intents left out
    const { intents: _a, ...laneRest } = lane as WorkflowLane & { intents?: unknown };
    const { intents: _b, ...beforeRest } = (before ?? {}) as WorkflowLane & { intents?: unknown };
    if (!before || s(laneRest) !== s(beforeRest)) { out.push({ id: `wf-${lane.id}`, title: lane.name || 'Workflow' }); laneCounted = true; }
    void laneCounted;
  }
  for (const gone of savedLanes.filter(l => !(draft.workflows ?? []).some(x => x.id === l.id))) out.push({ id: `wf-${gone.id}-removed`, title: `${gone.name || 'Workflow'} (removed)` });
  const parts: [keyof DesignerDocument, string][] = [['preRouting', 'Opening cards'], ['sharedNodes', 'Shared cards'], ['interceptor', 'Interceptor'],
    ['terminalConfig', 'End cards'], ['terminal', 'End cards'], ['terminalOrder', 'End cards'], ['defaultTerminalKey', 'End cards'], ['modal', 'Workflow settings'], ['readbacks', 'Read-backs']];   // v12.10.21 (#1957): + Read-backs
  for (const [k, title] of parts) if (s(saved[k]) !== s(draft[k]) && !out.some(o => o.title === title)) out.push({ id: `wf-part-${String(k)}`, title });
  return out;
}

export default function WorkflowModalSnapshotPage({ onStateChange }: { onStateChange?: (s: WorkflowSnapshotState) => void } = {}) {
  const [draftDoc, setDraftDoc] = useState<DesignerDocument | null>(null);
  // v12.10.1 (#1086): Route to operator cannot be enabled from the ⋮ menu either while the Outside operator line is off.
  const { data: pageHandoffView } = useQuery<HandoffSettingsView>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<HandoffSettingsView>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  const [activeTab, setActiveTab] = useState<TabKey>('card');
  const [activeLanguage, setActiveLanguage] = useState('en');
  const [message, setMessage] = useState<string | null>(null);
  const [activeCard, setActiveCard] = useState<CardRef | null>(null);
  // v12.2.20.0 (PRE-FIX): the doc snapshot captured when a drawer opens, so "Cancel" can revert only
  // the edits made inside that drawer session (leaving any earlier unsaved draft intact).
  const drawerBaselineRef = useRef<DesignerDocument | null>(null);
  const [expandedWorkflowId, setExpandedWorkflowId] = useState<string | null>(null);
  const [expandedIntentId, setExpandedIntentId] = useState<string | null>(null);
  const [treeQuery, setTreeQuery] = useState('');
  const [simulateText, setSimulateText] = useState('I need to schedule an appointment');
  const [simulation, setSimulation] = useState<SimulationResult | null>(null);
  const [changeTemplateOpen, setChangeTemplateOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<number | null>(null);
  // v12.2.34.0 (#186): the card whose delete was requested (drives the type-to-confirm dialog).
  const [deleteTarget, setDeleteTarget] = useState<{ card: CardRef; name: string; childCount: number; childNoun: string } | null>(null);
  // v12.3.12 (#322): a drawer closed by clicking the backdrop used to discard its edits without a word.
  const [discardPrompt, setDiscardPrompt] = useState(false);
  // v12.3.12 (#320): which shared node is being switched off, and in which intent the author is standing.
  const [sharedToggle, setSharedToggle] = useState<{ nodeId: string; name: string; intentId: string; intentLabel: string;
    turningOff: boolean; intentCount: number; workflowLabel: string; consequence?: string } | null>(null);   // v12.3.14 (#370): M5 needs real counts; v12.3.15 (#383): scoped to a caller type
  const [copyTarget, setCopyTarget] = useState<{ card: Extract<CardRef, { kind: 'node' }>; label: string } | null>(null);

  const { data, isLoading, isError, error, refetch } = useQuery<TenantWorkflowSnapshot>({
    queryKey: ['t2-workflow-modal-snapshot'],
    queryFn: async () => normalizeSnapshot(await api.get<unknown>('/t2/workflow-modal')),
    retry: false,
  });

  const { data: templateOptions = [] } = useQuery<WorkflowTemplateOption[]>({
    queryKey: ['t2-workflow-modal-template-options'],
    queryFn: async () => {
      const result = await api.get<unknown>('/t2/workflow-modal/template-options');
      return asArray(result).map(normalizeTemplateOption);
    },
    // v12.10.7 (#1125): loaded up front in the tenant designer - the header says "vN available" when a newer Published
    // version of the same template exists. A template (T4) has no template to change.
    enabled: changeTemplateOpen || designerMode() === 'tenant',
  });
  const [addLanguageOpen, setAddLanguageOpen] = useState(false);   // v12.10.7 (#1125): T4 template mode; v12.10.26 (#2143): T2 too (AI Agent languages only)
  const [removeLanguage, setRemoveLanguage] = useState<{ code: string; name: string } | null>(null);   // v12.10.26 (#2143)
  // v12.10.7 (#1125): the newest Published version of THIS template newer than the tenant's - "vN available".
  const newerVersion = useMemo(() => {
    if (!data || designerMode() !== 'tenant') return null;
    const n = templateOptions.filter(o => o.templateKey === data.templateKey && o.templateVersion > data.templateVersion)
      .sort((a, b) => b.templateVersion - a.templateVersion)[0];
    return n ? { id: n.id, version: n.templateVersion } : null;
  }, [templateOptions, data]);

  // Tenant's provisioned AI-Agent languages (shared cache with PhoneActivationSection / AI Agent page).
  // Drives which language tabs the workflow card drawers show — see provisionedLanguages().
  const { data: aiAgentSettings } = useQuery<AiAgentTokenSettings>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<AiAgentTokenSettings>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });

  const doc = useMemo(() => normalizeDoc(draftDoc ?? parseConfig(data?.configJson ?? '{}')), [draftDoc, data?.configJson]);
  // v12.2.35.0 (#192): dirty = the working doc differs from the last saved snapshot. Drives the sticky
  // header's Save-enabled/highlight state and the "Unsaved changes" cue so Save is never a guess.
  const savedDoc = useMemo(() => normalizeDoc(parseConfig(data?.configJson ?? '{}')), [data?.configJson]);
  const isDirty = useMemo(() => JSON.stringify(doc) !== JSON.stringify(savedDoc), [doc, savedDoc]);
  const languages = languageList(doc);
  // The drawer tabs use only the tenant-provisioned languages; the template panel keeps the full set.
  const drawerLanguages = useMemo(
    () => provisionedLanguages(languages, aiAgentSettings?.languages),
    [languages, aiAgentSettings?.languages],
  );
  const summary = summarize(doc);
  // v12.10.26 (#2143): a language turned on in Settings › AI Agent but missing from the practice's workflow - offered by
  // "+ Add language" (T2), which adds it to the workflow so its tabs appear and the save auto-translates it. Picked over adding
  // it silently on load (that would make the page "unsaved" the moment it opens).
  const missingAgentLanguages = useMemo(() => {
    if (designerMode() !== 'tenant') return [] as Array<[string, string]>;
    const have = new Set(languages.map(l => canonLang(l.code)));
    const out: Array<[string, string]> = [];
    for (const l of aiAgentSettings?.languages ?? []) {
      const c = canonLang(l.code);
      if (!c || have.has(c) || out.some(([x]) => x === c)) continue;
      out.push([c, LANGUAGE_INFO[c]?.name ?? TEMPLATE_LANGUAGES.find(([x]) => x === c)?.[1] ?? c.toUpperCase()]);
    }
    return out;
  }, [languages, aiAgentSettings?.languages]);
  // v12.9.24 (#911): the document's publish-time translation record -> per-language sets of machine texts for the
  // Machine-translated badge, and the count of texts that could not be translated.
  const [translateFailed, setTranslateFailed] = useState<string[]>([]);   // v12.9.26 (#946)
  const { machineFilledTexts, machineFailed } = useMemo(() => {
    const sets: Record<string, Set<string>> = {};
    let failed = 0;
    const rec = ((doc as unknown as Record<string, unknown>).machineFilled ?? {}) as Record<string, { text?: string; failed?: boolean }>;
    for (const [key, mark] of Object.entries(rec)) {
      const lang = key.slice(key.lastIndexOf('|') + 1);
      if (mark?.failed) { failed++; continue; }
      if (mark?.text) (sets[lang] ??= new Set<string>()).add(mark.text.trim());
    }
    return { machineFilledTexts: sets, machineFailed: failed };
  }, [doc]);
  const selectedWorkflowId = expandedWorkflowId ?? doc.workflows?.[0]?.id ?? '';
  const selectedWorkflow = doc.workflows?.find(workflow => workflow.id === selectedWorkflowId) ?? doc.workflows?.[0];
  const selectedIntentId = expandedIntentId ?? selectedWorkflow?.intents?.[0]?.id ?? '';
  const selectedIntent = selectedWorkflow?.intents?.find(intent => intent.id === selectedIntentId) ?? selectedWorkflow?.intents?.[0];

  // v12.10.11.1 (#1486): "Open card ->" in Personalization › Edit category lands here with ?card=intent&wf=..&intent=.. -
  // that caller type and intent are selected and the intent drawer opens, once; the query is then cleared.
  const deepLinkDone = useRef(false);
  useEffect(() => {
    if (deepLinkDone.current || !data) return;
    deepLinkDone.current = true;
    try {
      const sp = new URLSearchParams(window.location.search);
      if (sp.get('card') !== 'intent') return;
      const wf = sp.get('wf') ?? '';
      const it = sp.get('intent') ?? '';
      if (doc.workflows?.find(w => w.id === wf)?.intents?.some(i => i.id === it)) {
        setExpandedWorkflowId(wf);
        setExpandedIntentId(it);
        setActiveCard({ kind: 'intent', workflowId: wf, intentId: it });
      }
      ['card', 'wf', 'intent'].forEach(k => sp.delete(k));
      const q = sp.toString();
      window.history.replaceState(window.history.state, '', window.location.pathname + (q ? `?${q}` : '') + window.location.hash);
    } catch { /* no deep link */ }
  }, [data, doc]);

  // v12.10.18 (#1866): the version our own last save returned; cleared when a fresh load is newer.
  const lastSavedAtRef = useRef<string | null>(null);
  useEffect(() => {
    if (data?.updatedAt && lastSavedAtRef.current && Date.parse(data.updatedAt) >= Date.parse(lastSavedAtRef.current)) lastSavedAtRef.current = null;
  }, [data?.updatedAt]);
  const saveMutation = useMutation({
    // v12.2.24.0 (#152): accept an optional doc override so a removal (which sets draftDoc in the same tick)
    // can be persisted immediately without waiting for a re-render to refresh the `doc` closure.
    mutationFn: (override?: DesignerDocument) => {
      // v12.4.16 (#504 follow-up): the one-way Confirm conversion happens HERE, not on load, and here
      // rather than in guardedSave so that every save route goes through it - the shell hero, the drawer's
      // Done, and the delete paths that call saveMutation directly.
      const target = migrateConfirmSuccessRoutes(override ?? doc);
      return api.put<{ saved: boolean; updatedAt: string; translation?: { filled: number; failed: number; stale: number; failureReason?: string | null; failedPaths?: string[] } | null }>(`/t2/workflow-modal/${data?.id}`, {
        templateName: target.modal?.displayName || data?.templateName || 'Tenant workflow template',
        configJson: JSON.stringify(target, null, 2),
        summaryJson: JSON.stringify(summarize(target)),
        // v12.10.16.1 (#1711): the version this page loaded - a newer stored workflow refuses the save (409) instead of being overwritten.
        // v12.10.18 (#1866): OUR OWN last save counts as loaded - the refetch may not have landed yet, and sending the pre-save
        // version made our second save look like someone else's change ("Workflow changed since you opened it").
        expectedUpdatedAt: lastSavedAtRef.current || data?.updatedAt || undefined,
      });
    },
    onSuccess: async (res) => {
      if (res?.updatedAt) lastSavedAtRef.current = res.updatedAt;   // v12.10.18 (#1866)
      // v12.9.24 (#911): publish and flag - the save always lands, and the message says what translation did.
      const t = (res as { translation?: { filled: number; failed: number; stale: number; failedPaths?: string[] } | null } | undefined)?.translation;
      // v12.9.26 (#946, his wording): 'Tenant workflow saved. N texts auto-translated.' - no 'marked ... for review'.
      // v12.10.27 (#2170, Tushar 10/31): "Workflow saved" as a toast, not an inline line ("wasn't it supposed to come as a toast message?").
      const savedWord = designerMode() === 'template' ? 'Template saved' : 'Workflow saved';
      setMessage(null);
      toast('success', savedWord, !t || (t.filled === 0 && t.failed === 0) ? undefined : `${t.filled} text${t.filled === 1 ? '' : 's'} auto-translated.`);
      // A text that could NOT be translated is named in the save result (card > field > language), with Retry - at
      // save time only, never a standing banner afterwards ('label not gonna help').
      setTranslateFailed(t?.failed ? (t.failedPaths ?? []) : []);
      // v12.3.16 (#386): clear the draft only AFTER the refetch has landed. Clearing it first drops `doc` back
      // to the STALE server copy for however long the round trip takes, which is why Tushar saved, switched to
      // Prescription and Results, and found the shared node missing until he refreshed the page. The data was
      // always correct; the screen was showing the pre-save document.
      try { await refetch(); } finally { setDraftDoc(null); }
    },
    // v12.10.10 (#1401): A FAILED SAVE IS NEVER SILENT. This mutation had no onError, so a 428 (Confirm it's you),
    // a 403 or a 500 left Done looking dead - the drawer simply stayed open. The api client now asks "Confirm it's
    // you" itself; what still fails is named here. Cancelling the confirm is the person's own "no" - no toast.
    onError: (err: unknown) => {
      if ((err as { name?: string } | null)?.name === 'ConfirmCancelledError') return;
      const st = (err as { status?: number } | null)?.status;
      // v12.10.16.1 (#1711): someone (or a script) changed the workflow after this page loaded - never overwrite it.
      if (st === 409) { toast('error', 'Workflow changed since you opened it', 'Reload the page to see the latest workflow, then make your change again. Nothing was saved.'); return; }
      const why = st === 403 ? 'Your user group does not allow changing the workflow.'
        : st === 428 ? "Confirm it's you was not completed."
        : st ? `The server answered ${st}.` : 'The server could not be reached.';
      toast('error', 'Could not save', `${why} Nothing was lost - your edits are still here. Try again.`);
    },
  });

  // ── v12.3.11 (#311): register workflow-defined tokens ────────────────────────────────────────
  // An author invents a token by typing it into a step's Stores box ({medication.pharmacy}). It already
  // WORKS on a live call — the engine writes whatever a step stores into the call's slots — but until now
  // nothing recorded that it exists, so it had no label, no type, and an integration had to parse the
  // workflow to discover it. On save we spot fields that are not in the vocabulary catalog and not yet
  // registered, and ASK before recording them (Tushar: "option 1 with confirmation prompt") — silent
  // registration would let a typo become a permanent field.
  const queryClient = useQueryClient();
  const { catalog: pageCatalog, customFields: registeredFields, lists: pageLists } = useVocabulary();
  const [pendingFields, setPendingFields] = useState<{ key: string; label: string; type: CustomField['type'] }[] | null>(null);
  const pendingSaveRef = useRef<{ override?: DesignerDocument; onSuccess?: () => void } | null>(null);
  // v12.4.16 (#505): the save-time half. "Saving a workflow that strands an enabled node warns FIRST" - so
  // this holds the save while the warning is on screen, and the save only runs if they choose to go ahead.
  const [strandedWarn, setStrandedWarn] = useState<StrandedReport[] | null>(null);
  const strandedSaveRef = useRef<{ override?: DesignerDocument; onSuccess?: () => void } | null>(null);
  const [templateBlanks, setTemplateBlanks] = useState<string[] | null>(null);   // v12.10.10 (#1408)
  const blankSaveRef = useRef<{ override?: DesignerDocument; onSuccess?: () => void } | null>(null);

  const registerFields = useMutation({
    mutationFn: (fields: Record<string, CustomField>) =>
      api.put('/t2/settings/organization/custom-fields', fields),
  });

  function unregisteredFrom(target: DesignerDocument): string[] {
    // v12.10.3 (BDR-016): a platform template registers no tenant fields - each tenant registers its own on its own save.
    if (designerMode() === 'template') return [];
    const catalogEntities = new Set((pageCatalog ?? []).map((e) => e.token.toLowerCase()));
    const known = new Set(Object.keys(registeredFields).map((k) => k.toLowerCase()));
    return collectSlots(target)
      .map((t) => canonToken(t))
      .filter((t) => {
        const d = t.indexOf('.');
        if (d <= 0) return false;                                   // bare keys are not entity.field
        if (catalogEntities.has(t.slice(0, d).toLowerCase())) return false;   // platform-managed already
        return !known.has(t.toLowerCase());
      })
      .filter((t, i, a) => a.indexOf(t) === i)
      .sort();
  }

  // v12.4.16 (#505): the stranded-card warning runs FIRST, in front of the new-field prompt, because it is
  // about whether the workflow means what they think it means - a question worth answering before naming
  // fields. Choosing "Save anyway" drops straight into proceedSave, so the field prompt still happens.
  function guardedSave(override?: DesignerDocument, onSuccess?: () => void, skipBlankCheck = false) {
    // v12.10.10 (#1408): a T4 template names every box it leaves without text (warn, Save anyway).
    // v12.10.10 (#1406 C1): an offer token on a field with no list tie is refused - the agent would offer nothing.
    const lc = listOfferChecks(override ?? doc, registeredFields, pageLists);
    if (lc.refuse.length > 0) { toast('error', 'Not saved - a list offer has no list', lc.refuse.join(' · ')); return; }
    if (!skipBlankCheck) {
      const blanks = [...(designerMode() === 'template' ? templateBlankBoxes(override ?? doc) : []), ...lc.warn];   // C2 / C3 warn
      if (blanks.length > 0) { blankSaveRef.current = { override, onSuccess }; setTemplateBlanks(blanks); return; }
    }
    const stranded = strandedInDocument(override ?? doc);
    if (stranded.length > 0) {
      strandedSaveRef.current = { override, onSuccess };
      setStrandedWarn(stranded);
      return;
    }
    proceedSave(override, onSuccess);
  }

  // Every save goes through here so a new field cannot slip in unregistered by another route.
  function proceedSave(override?: DesignerDocument, onSuccess?: () => void) {
    const target = override ?? doc;
    const fresh = unregisteredFrom(target);
    if (fresh.length === 0) { saveMutation.mutate(override, onSuccess ? { onSuccess } : undefined); return; }
    pendingSaveRef.current = { override, onSuccess };
    setPendingFields(fresh.map((key) => ({
      key,
      label: prettyField(key.slice(key.indexOf('.') + 1)),
      type: 'text' as CustomField['type'],
    })));
  }

  function confirmRegister() {
    const list = pendingFields ?? [];
    const payload: Record<string, CustomField> = {};
    for (const f of list) payload[f.key] = { label: f.label.trim() || f.key, type: f.type };
    const queued = pendingSaveRef.current;
    setPendingFields(null); pendingSaveRef.current = null;
    registerFields.mutate(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['t2-org-vocabulary'] });
        toast('success', list.length === 1 ? 'Field registered' : `${list.length} fields registered`,
          list.map((f) => f.label).join(', '));
        saveMutation.mutate(queued?.override, queued?.onSuccess ? { onSuccess: queued.onSuccess } : undefined);
      },
      onError: () => toast('error', 'Could not register the new field', 'The workflow was not saved — try again.'),
    });
  }

  const saveInFlightRef = useRef(false);
  saveInFlightRef.current = saveMutation.isPending;
  // v12.2.36.0 (#192): surface dirty + save/discard to the Settings shell so Workflow uses the same
  // sticky hero ("Save all changes" / "Discard draft") as every other section.
  useEffect(() => {
    onStateChange?.({
      anyDirty: isDirty,
      // v12.10.18 (#1866): a click while a save is on its way does nothing (it used to send the pre-save version -> 409).
      saveAll: () => { if (!saveInFlightRef.current) guardedSave(undefined); },
      discardAll: () => setDraftDoc(null),
      drawerOpen: !!activeCard,   // v12.10.10.1 (#1428): the shell hides its unsaved bar while a card drawer is open - drawer work saves on Done
      changes: isDirty ? workflowChanges(savedDoc, doc) : [],
      saving: saveMutation.isPending,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty, onStateChange, !!activeCard, doc, savedDoc, saveMutation.isPending]);

  const changeTemplateMutation = useMutation({
    mutationFn: async (mode: 'keep' | 'replace') => normalizeChangeTemplateResponse(await api.post<unknown>('/t2/workflow-modal/change-template', {
      templateId: selectedTemplateId,
      mode,   // v12.10.7 (#1125): Keep my changes, add what is new | Replace everything
    })),
    onSuccess: result => {
      setMessage(`${result.snapshot.categoryName} / ${result.snapshot.templateName} v${result.snapshot.templateVersion} copied into this tenant.`);
      setChangeTemplateOpen(false);
      setSelectedTemplateId(null);
      setDraftDoc(null);
      setActiveCard(null);
      refetch();
    },
  });

  const simulateMutation = useMutation({
    mutationFn: () => api.post<SimulationResult>(`/t2/workflow-modal/${data?.id}/simulate`, {
      utterance: simulateText,
      language: activeLanguage,
    }),
    onSuccess: setSimulation,
  });

  function updateDoc(mutator: (next: DesignerDocument) => void) {
    setDraftDoc(current => {
      const next = cloneDoc(current ?? doc);
      mutator(next);
      return normalizeDoc(next);
    });
    setMessage(null);
  }

  // v12.10.22 (#1984): a card's Move earlier / later and Copy to intent SAVE AT ONCE (the same save a drawer's Done makes). They used to
  // change only the screen - a user who moved a card and left lost the move, and nothing said so. The next document is built here
  // (not in the setState updater) so the save carries exactly what the screen shows.
  function updateDocAndSave(mutator: (next: DesignerDocument) => void) {
    const next = cloneDoc(draftDoc ?? doc);
    mutator(next);
    const n = normalizeDoc(next);
    setDraftDoc(n);
    setMessage(null);
    guardedSave(n);
  }

  // v12.2.20.0 (PRE-FIX): capture the baseline when a drawer opens (so Cancel can revert its edits),
  // and clear it when the drawer closes. Runs only on activeCard transitions; reads the doc at open.
  useEffect(() => {
    if (activeCard) {
      if (!drawerBaselineRef.current) drawerBaselineRef.current = cloneDoc(doc);
    } else {
      drawerBaselineRef.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCard]);

  // v12.9.21 (#865): the Inbound-call drawer EMBEDS Phone & Activation, which owns its own draft. Done used
  // to save only the workflow document, so the AI Agent toggle was discarded when the drawer closed - on a
  // drawer that also showed a "Save" button, which is how "Save then Done" worked and "Done" alone did not.
  // UI Principles v1.4 §12: one commit path per surface. The section no longer renders its own bar when
  // embedded, and Done commits it HERE, before the document write.
  const phoneRef = useRef<PhoneActivationHandle | null>(null);

  // "Done" — persist the whole doc (drawer edits included) so they survive navigating away, then close
  // once the save succeeds. This is the fix for the reported "data not saving" on Hours/Disclosure/etc.
  async function onDoneCard() {
    try {
      await phoneRef.current?.save();
    } catch {
      // Do NOT close on a failed write. Closing would look exactly like success and lose the toggle again,
      // which is the whole defect. The caller stays on the drawer with their edit intact.
      toast('error', 'Could not save', 'The phone and activation settings did not save. Nothing was closed - try again.');
      return;
    }
    guardedSave(undefined, () => setActiveCard(null));
  }

  // "Cancel" / x / backdrop — discard the edits made while the drawer was open by reverting the draft
  // to the snapshot captured at open, then close.
  // v12.3.12 (#322): has anything actually changed since this drawer opened? Compared against the baseline the
  // drawer captured at open, so closing an untouched drawer stays instant and only real work raises a prompt.
  function drawerHasEdits() {
    // v12.9.21 (#865): the embedded section's draft is real work too. Without this, closing the drawer on
    // a changed toggle discarded it with no prompt - #322's rule applied to only half the drawer.
    if (phoneRef.current?.isDirty()) return true;
    const baseline = drawerBaselineRef.current;
    if (!baseline) return false;
    try { return JSON.stringify(normalizeDoc(cloneDoc(baseline))) !== JSON.stringify(doc); }
    catch { return true; }   // if it cannot be compared, assume there IS work and ask
  }

  function revertDrawer() {
    const baseline = drawerBaselineRef.current;
    if (baseline) setDraftDoc(normalizeDoc(cloneDoc(baseline)));
    setActiveCard(null);
    setDiscardPrompt(false);
  }

  // "Cancel" / x / backdrop. v12.3.12 (#322): Tushar copied a step into Lab results, edited it, clicked outside
  // the drawer and lost the lot with no warning - "i think the moment if i click outside of slider, if the data
  // is added, it should ask for confirmation". Cancel and x are explicit and still discard immediately; an
  // accidental backdrop click asks.
  function onCancelCard(explicit = true) {
    if (!explicit && drawerHasEdits()) { setDiscardPrompt(true); return; }
    revertDrawer();
  }

  function addWorkflow() {
    const id = makeId('workflow');
    drawerBaselineRef.current = cloneDoc(doc);  // v12.2.34.0 (#184): baseline BEFORE the add, so Cancel removes an unconfirmed new card
    updateDoc(next => {
      next.workflows ??= [];
      next.workflows.push({ id, name: 'New workflow', description: '', intents: [] });
    });
    setExpandedWorkflowId(id);
    setExpandedIntentId(null);
    setActiveCard({ kind: 'workflow', workflowId: id });
  }

  function addIntent(workflowId: string) {
    const id = makeId('intent');
    drawerBaselineRef.current = cloneDoc(doc);  // v12.2.34.0 (#184): baseline BEFORE the add, so Cancel removes an unconfirmed new card
    updateDoc(next => {
      const workflow = next.workflows?.find(item => item.id === workflowId);
      if (!workflow) return;
      workflow.intents ??= [];
      // v12.10.23 (#2029): a new request goes in before Something else, which stays last.
      const fresh = { id, label: 'New intent', keywords: [], confidenceThreshold: 0.7, fallbackMode: 'clarify-then-keypad', nodes: [] };
      const seAt = workflow.intents.findIndex(i => isSomethingElseIntent(i));
      if (seAt >= 0) workflow.intents.splice(seAt, 0, fresh); else workflow.intents.push(fresh);
    });
    setExpandedWorkflowId(workflowId);
    setExpandedIntentId(id);
    setActiveCard({ kind: 'intent', workflowId, intentId: id });
  }

  function addNode(workflowId: string, intentId: string) {
    const id = makeId('node');
    drawerBaselineRef.current = cloneDoc(doc);  // v12.2.34.0 (#184): baseline BEFORE the add, so Cancel removes an unconfirmed new card
    updateDoc(next => {
      const intent = next.workflows?.find(item => item.id === workflowId)?.intents?.find(item => item.id === intentId);
      if (!intent) return;
      intent.nodes ??= [];
      intent.nodes.push({ id, type: 'Request', label: 'New node', description: '', retryMax: 2, fallbackMode: 'clarify-then-keypad', steps: [] });
    });
    setActiveCard({ kind: 'node', workflowId, intentId, nodeId: id });
  }

  // v12.4.16 (#516): which terminal closes a call that ran every card in this intent.
  //
  // Tushar, 2026-09-19: "tell me one thing how the system knows which terminal card to call after the reference
  // node." It did not - ResolveDefaultTerminal took the document and ignored it, always answering
  // thankyou-failure. This is the setting that answers the question, shown at the end of the sequence because
  // that is where it takes effect.
  function setEndTerminal(workflowId: string, intentId: string, key: string) {
    updateDoc(next => {
      const intent = next.workflows?.find(item => item.id === workflowId)?.intents?.find(item => item.id === intentId);
      if (!intent) return;
      intent.endTerminalKey = key || null;
    });
  }

  // v12.2.24.0 (#152): remove a node from its intent, persist, then close the drawer. We build the next doc
  // explicitly and hand it straight to the save (as an override) so we don't serialize the stale pre-removal doc.
  function removeNode(card: Extract<CardRef, { kind: 'node' }>) {
    const next = normalizeDoc(cloneDoc(doc));
    const intent = next.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId);
    if (intent) intent.nodes = (intent.nodes ?? []).filter(n => n.id !== card.nodeId);
    setDraftDoc(next);
    saveMutation.mutate(next, { onSuccess: () => setActiveCard(null) });   // v12.3.12 (#316): see removeCard

  }

  // v12.2.25.0 (#159b): reorder a node within its intent directly from the Card View (◀ / ▶ on the card).
  // A normal draft edit — persisted on the page's "Save" like every other canvas change.
  function reorderNode(workflowId: string, intentId: string, from: number, to: number) {
    updateDocAndSave(next => {   // v12.10.22 (#1984): saved at once
      const list = next.workflows?.find(w => w.id === workflowId)?.intents?.find(i => i.id === intentId)?.nodes;
      if (!list || from < 0 || to < 0 || from >= list.length || to >= list.length) return;
      const tmp = list[from]; list[from] = list[to]; list[to] = tmp;
    });
  }

  // v12.3.5: copy a node to another intent. Deep-copies the node with FRESH ids (node + steps + request-types +
  // their steps), remaps request-type read-backs, and appends it to the chosen intent. Original is untouched.
  // ── v12.3.11 (#312): share / unshare a node ────────────────────────────────────────────────────
  // "Copy to intent…" DUPLICATES a node — three copies of Capture identity that drift apart. Sharing
  // MOVES it to doc.sharedNodes, where every intent runs the one definition. Editing it from any intent
  // edits that definition, so a change lands everywhere at once.
  // v12.3.12 (#320): switch a shared node off (or back on) either in EVERY intent or only in the one being
  // viewed. "Every intent" is node.enabled; "this intent" adds/removes the intent id on disabledIntentIds. The
  // engine's EffectiveNodes() reads both, so the card and the call agree.
  function applySharedDisable(nodeId: string, intentId: string, scope: 'all' | 'this', turningOff: boolean) {
    updateDoc(next => {
      const node = (next.sharedNodes ?? []).find(n => n.id === nodeId);
      if (!node) return;
      if (scope === 'all') {
        node.enabled = !turningOff;
        if (!turningOff) node.disabledIntentIds = [];   // turning it back on everywhere clears the per-intent list
        return;
      }
      const off = new Set((node.disabledIntentIds ?? []).filter(Boolean));
      if (turningOff) { off.add(intentId); node.enabled = true; }
      else {
        // v12.3.13 (#358): Tushar: "i clicked on more actions on a shared card and clicked enabled, it asked what
        // option, i said only in appointment and then it just closed and you can see the node is still disabled."
        // Removing the intent from disabledIntentIds does nothing while node.enabled is false - the node is off
        // GLOBALLY and the per-intent list is never consulted. Turning it on "just here" therefore has to switch
        // the node on and switch it off in every OTHER intent.
        if (!node.enabled) {
          node.enabled = true;
          off.clear();
          for (const w of next.workflows ?? [])
            for (const i of w.intents ?? [])
              if (i.id && i.id !== intentId) off.add(i.id);
        }
        off.delete(intentId);
      }
      node.disabledIntentIds = Array.from(off);
    });
    setSharedToggle(null);
  }

  function shareNode(workflowId: string, intentId: string, nodeId: string) {
    let moved = '';
    updateDoc(next => {
      const intent = next.workflows?.find(w => w.id === workflowId)?.intents?.find(i => i.id === intentId);
      const idx = intent?.nodes?.findIndex(n => n.id === nodeId) ?? -1;
      if (!intent?.nodes || idx < 0) return;
      const [node] = intent.nodes.splice(idx, 1);
      moved = node.label || 'Node';
      // v12.4.0 (#385): the node keeps its PLACE. It is lifted out of the intent's list and a REFERENCE is put
      // back at the same index, so sharing no longer moves the card - which is what "it needs a real position
      // index" buys. sharedPosition is still written for one build only, so a snapshot saved by this build can
      // still be read by an engine that has not been deployed yet.
      node.sharedPosition = idx === 0 ? 'before' : 'after';
      const ref: WorkflowNode = { id: `ref-${node.id}`, sharedNodeId: node.id };
      intent.nodes.splice(idx, 0, ref);
      // Every OTHER intent of this caller type gets the reference too - at the same index where that fits, or
      // at the end. Placement starts identical everywhere and only diverges if he moves it in one intent.
      for (const other of (next.workflows?.find(w => w.id === workflowId)?.intents ?? [])) {
        if (other.id === intentId) continue;
        other.nodes ??= [];
        if (other.nodes.some(n => n.sharedNodeId === node.id)) continue;
        other.nodes.splice(Math.min(idx, other.nodes.length), 0, { id: `ref-${node.id}-${other.id}`, sharedNodeId: node.id });
      }
      // v12.3.15 (#383): remember WHICH CALLER TYPE this came from. #312 threw it away - which is why a node
      // shared from Patient ran on Pharmacy and Physician calls, and why that fact could never be recovered
      // afterwards. Tushar: "sharing intent should only for one workflow."
      node.sharedWorkflowId = workflowId;
      next.sharedNodes = [...(next.sharedNodes ?? []), node];
    });
    toast('success', 'Shared with this caller type', `"${moved}" now runs in every intent of this caller type. Other caller types are unaffected. Copies already sitting in other intents are left alone — remove them when you are ready.`);
  }

  function unshareNode(nodeId: string) {
    const target = (doc.sharedNodes ?? []).find(n => n.id === nodeId);
    const wfId = selectedWorkflowId; const inId = selectedIntentId;
    const inLabel = selectedIntent?.label || 'this intent';
    if (!target || !wfId || !inId) return;
    let landedFirst = false;
    let failed = false;
    updateDoc(next => {
      const i = (next.sharedNodes ?? []).findIndex(n => n.id === nodeId);
      if (i < 0) { failed = true; return; }
      // v12.3.16 (#384): RESOLVE THE DESTINATION BEFORE REMOVING ANYTHING. The old order spliced the node out
      // of sharedNodes first and only then re-added it behind `if (intent)` - so a missed lookup deleted it
      // silently, with no undo and no warning. It never fired in practice, but remove-before-place on a
      // destructive path is the wrong shape and it is what made Tushar's "it's gone from all three intents"
      // impossible to rule out for an hour.
      const intent = next.workflows?.find(w => w.id === wfId)?.intents?.find(x => x.id === inId);
      if (!intent) { failed = true; return; }
      const node = next.sharedNodes![i];
      // v12.3.16 (#384): HONOUR THE POSITION. `Capture identity` ran FIRST (sharedPosition 'before'); the old
      // code deleted that and appended, so one menu click moved identity capture to AFTER the confirmation -
      // the agent would read back the booking and then ask who is calling. Silently.
      // v12.4.0 (#385): the node goes back EXACTLY WHERE ITS REFERENCE WAS. #384 could only choose between
      // first and last because that was all sharedPosition could say; now the reference's index is the answer,
      // so un-sharing is position-preserving in the ordinary case rather than approximately right.
      const refIdx = (intent.nodes ?? []).findIndex(n => n.sharedNodeId === nodeId);
      const runsFirst = refIdx >= 0 ? refIdx === 0 : node.sharedPosition !== 'after';
      delete node.sharedPosition;
      delete node.sharedWorkflowId;   // v12.3.16 (#384): it is not shared any more - clear the 12.3.15 stamp
      delete node.sharedNodeId;       // it is content again, not a pointer
      intent.nodes ??= [];
      if (refIdx >= 0) intent.nodes.splice(refIdx, 1, node);
      else intent.nodes = runsFirst ? [node, ...intent.nodes] : [...intent.nodes, node];
      // Every other intent loses the reference - it is not shared any more.
      for (const w of (next.workflows ?? []))
        for (const other of (w.intents ?? []))
          if (other !== intent && other.nodes)
            other.nodes = other.nodes.filter(n => n.sharedNodeId !== nodeId);
      next.sharedNodes!.splice(i, 1);   // only now
      landedFirst = runsFirst;
    });
    if (failed) {
      // Loud, not silent. If we cannot say where it went, we do not move it.
      toast('error', 'Could not un-share', `"${target.label || 'Node'}" was left shared - the intent it would move into could not be resolved. Nothing was changed.`);
      return;
    }
    toast('warning', 'No longer shared',
      `"${target.label || 'Node'}" now runs only in ${inLabel}, as the ${landedFirst ? 'FIRST' : 'LAST'} node. Other intents no longer run it.`);
  }

  // v12.4.0 (#385): move a shared node ONE CARD, in THIS intent, like any other card.
  //
  // 12.3.16 shipped this as a two-position flip because sharedPosition only had two values, and Tushar found
  // the ceiling immediately: "if you click move later then it goes last instead of moving after next card.
  // move earlier moves to first position." Now the shared node is a reference inside the intent's own list, so
  // moving it is the same array swap that moves every other node - and the label finally means what it says.
  function moveSharedNode(nodeId: string, dir: 'up' | 'down') {
    const target = (doc.sharedNodes ?? []).find(n => n.id === nodeId);
    const wfId = selectedWorkflowId; const inId = selectedIntentId;
    if (!target || !wfId || !inId) return;
    let ok = false; let pos = 0; let total = 0;
    updateDocAndSave(next => {   // v12.10.22 (#1984): saved at once (and ok / pos / total are set before the toast below reads them)
      const intent = next.workflows?.find(w => w.id === wfId)?.intents?.find(x => x.id === inId);
      const nodes = intent?.nodes;
      if (!nodes) return;
      const i = nodes.findIndex(n => n.sharedNodeId === nodeId);
      const j = dir === 'up' ? i - 1 : i + 1;
      if (i < 0 || j < 0 || j >= nodes.length) return;      // already at the end it is being moved towards
      [nodes[i], nodes[j]] = [nodes[j], nodes[i]];
      ok = true; pos = j + 1; total = nodes.length;
    });
    if (!ok) return;
    toast('success', dir === 'up' ? 'Moved earlier' : 'Moved later',
      `"${target.label || 'Node'}" is now step ${pos} of ${total} in ${selectedIntent?.label || 'this intent'}. Its position in other intents is unchanged.`);
  }

  function requestCopyNode(card: Extract<CardRef, { kind: 'node' }>, label: string) { setCopyTarget({ card, label }); }
  function confirmCopyNode(destWorkflowId: string, destIntentId: string) {
    const src = copyTarget; if (!src) return;
    updateDocAndSave(next => {   // v12.10.22 (#1984): the copy lands in the target intent's SAVED workflow at once
      const source = next.workflows?.find(w => w.id === src.card.workflowId)?.intents?.find(i => i.id === src.card.intentId)?.nodes?.find(n => n.id === src.card.nodeId);
      const dest = next.workflows?.find(w => w.id === destWorkflowId)?.intents?.find(i => i.id === destIntentId);
      if (!source || !dest) return;
      const uid = (p: string) => `${p}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
      const clone = JSON.parse(JSON.stringify(source)) as WorkflowNode;
      clone.id = uid('node');
      // v12.10.22 (#1984): "(copy)" only when the target intent already has a card with this name
      clone.label = (dest.nodes ?? []).some(n => (n.label || '').trim().toLowerCase() === (clone.label || 'Node').trim().toLowerCase())
        ? (clone.label || 'Node') + ' (copy)' : (clone.label || 'Node');
      // v12.4.11 (#472): a branching node's flat steps are dead (#471) — copying them verbatim is how one
      // authoring accident on Process Request reached Medication Name and then Test Data. The copy's own ids
      // date it exactly: node + both dead steps all minted in a single millisecond, twice.
      // THIRD TIME THIS FUNCTION HAS LEARNED THE SAME LESSON: #360 taught it to drop read-backs belonging to
      // the source intent's types, #378 the node-level default read-back, and now this. Each time the fix was
      // applied to the field that was reported rather than to the idea behind it.
      if ((clone.requestTypes?.length ?? 0) > 0) clone.steps = [];
      (clone.steps ?? []).forEach(st => { st.id = uid('step'); });
      const idMap: Record<string, string> = {};
      (clone.requestTypes ?? []).forEach(rt => { const old = rt.id; rt.id = uid('rt'); if (old) idMap[old] = rt.id; (rt.steps ?? []).forEach(st => { st.id = uid('step'); }); });
      // v12.3.13 (#360): remap the read-backs this node's OWN request types own, and DROP the rest.
      // The old line only remapped when idMap had a match and left everything else untouched - and a CONFIRM node
      // has no requestTypes of its own (they live on the Request node), so idMap is empty and every read-back kept
      // the SOURCE intent's ids. That is exactly what the live snapshot showed: Prescription's "Confirm (copy)"
      // carrying Appointment's three request-type ids, and Prescription's own types having no read-back anywhere.
      // They cannot be remapped - the destination's types are DIFFERENT types, not renamed ones - so they go.
      clone.requestReadbacks = (clone.requestReadbacks ?? [])
        .filter(rb => rb.requestTypeId && idMap[rb.requestTypeId])
        .map(rb => ({ ...rb, requestTypeId: idMap[rb.requestTypeId!] }));
      // v12.3.14 (#378): the node-level DEFAULT read-back is written about ONE flow, so it does not survive a
      // copy into a different intent either. #360 dropped the per-type read-backs and left this one - and this
      // one is the sentence that reached Tushar's Refill caller: "Let me confirm - you'd like a new appointment
      // for John Smith. Sounds good?" on a prescription refill. His own note on #360 said it: "copy is possible
      // but text needs to be configured. you don't want to copy owner node's properties here."
      // Copying WITHIN the same intent keeps it - there the text is still about the flow it was written for.
      if (destIntentId !== src.card.intentId) clone.defaultReadback = {};
      dest.nodes ??= [];
      dest.nodes.push(clone);
    });
    setCopyTarget(null);
  }

  // v12.2.34.0 (#185): rename any card (workflow name / intent label / node label) from the ⋯ menu.
  function renameCard(card: CardRef, name: string) {
    const value = name.trim();
    if (!value) return;
    updateDoc(next => {
      if (card.kind === 'workflow') { const w = next.workflows?.find(x => x.id === card.workflowId); if (w) w.name = value; }
      else if (card.kind === 'intent') { const i = next.workflows?.find(x => x.id === card.workflowId)?.intents?.find(x => x.id === card.intentId); if (i) i.label = value; }
      else if (card.kind === 'node') { const n = next.workflows?.find(x => x.id === card.workflowId)?.intents?.find(x => x.id === card.intentId)?.nodes?.find(x => x.id === card.nodeId); if (n) n.label = value; }
      // v12.3.2 (#238): renaming a terminal sets its Name (the card title); the built-in Key never changes.
      else if (card.kind === 'terminal') { next.terminalConfig ??= {}; const c = next.terminalConfig[card.terminalKey] ?? {}; next.terminalConfig[card.terminalKey] = { ...c, name: value }; }
    });
  }

  // v12.2.47.7 (#271): toggle enabled on any workflow/intent/node card (engine skips disabled at runtime).
  function toggleCardEnabled(card: CardRef) {
    // v12.3.2 (#238): terminal + interceptor disable get a plain confirm (both reversible, so NOT type-to-confirm).
    if (card.kind === 'terminal') {
      // v12.3.3 (#238 . D-05): Thank You (Success)/(Failure) are the guaranteed safety net and can't be disabled.
      if (TERMINAL_LOCKED.has(card.terminalKey)) return;
      const on = doc.terminalConfig?.[card.terminalKey]?.enabled !== false;
      if (card.terminalKey === 'fallback') {   // v12.10.2 (#1097): it follows the Outside operator line - switched there
        toast('error', 'Route to operator follows the Outside operator line', 'It is on when that line has a number and is Verified - in AI Agent › Handoff › After hours.');   // v12.10.5
        return;
      }
      if (on && !window.confirm('Disable this terminal? Any call that would end here now falls back to Thank You (Failure), and its keywords stop routing — you can re-enable it anytime.')) return;
      updateDoc(next => { next.terminalConfig ??= {}; const c = next.terminalConfig[card.terminalKey] ?? {}; next.terminalConfig[card.terminalKey] = { ...c, enabled: !on }; });
      return;
    }
    if (card.kind === 'interceptor') {
      const on = doc.interceptor?.enabled !== false;
      if (on && !window.confirm('Turn the mid-call interceptor OFF? Terminal keywords (and, later, quick answers) stop working until you turn it back on.')) return;
      updateDoc(next => { next.interceptor = { ...(next.interceptor ?? {}), enabled: !on }; });
      return;
    }
    updateDoc(next => {
      if (card.kind === 'workflow') { const w = next.workflows?.find(x => x.id === card.workflowId); if (w) w.enabled = w.enabled === false ? true : false; }
      else if (card.kind === 'intent') { const i = next.workflows?.find(x => x.id === card.workflowId)?.intents?.find(x => x.id === card.intentId); if (i) i.enabled = i.enabled === false ? true : false; }
      else if (card.kind === 'node') { const n = next.workflows?.find(x => x.id === card.workflowId)?.intents?.find(x => x.id === card.intentId)?.nodes?.find(x => x.id === card.nodeId); if (n) n.enabled = n.enabled === false ? true : false; }
      // v12.2.47.9 (#275): pre-routing card Disable/Enable from its ⋮ menu (matches the SlideOver toggle semantics;
      // isEnabled default is true except disclosure=false). Inbound never reaches here (it has no ⋮ menu).
      else if (card.kind === 'preRouting') { next.preRouting ??= {}; const cur = preRoutingEnabled(next, card.key); (next.preRouting as Record<string, unknown>)[card.key] = { ...((next.preRouting as Record<string, unknown>)[card.key] as object | undefined), isEnabled: !cur }; }
    });
  }

  // v12.2.34.0 (#185): reorder workflows / intents (cosmetic — classify routes by keyword, not order).
  function reorderWorkflow(from: number, to: number) {
    updateDocAndSave(next => {   // v12.10.22 (#1984): every card Move earlier / later saves at once
      const list = next.workflows;
      if (!list || from < 0 || to < 0 || from >= list.length || to >= list.length) return;
      const tmp = list[from]; list[from] = list[to]; list[to] = tmp;
    });
  }
  function reorderIntent(workflowId: string, from: number, to: number) {
    updateDocAndSave(next => {   // v12.10.22 (#1984): every card Move earlier / later saves at once
      const list = next.workflows?.find(w => w.id === workflowId)?.intents;
      if (!list || from < 0 || to < 0 || from >= list.length || to >= list.length) return;
      if (isSomethingElseIntent(list[from]) || isSomethingElseIntent(list[to])) return;   // v12.10.23 (#2029): Something else stays last
      const tmp = list[from]; list[from] = list[to]; list[to] = tmp;
    });
  }
  // v12.3.2 (#238): move a terminal card one slot earlier/later. The DEFAULT_TERMINALS merge makes key order sticky,
  // so we persist an explicit doc.terminalOrder (cosmetic — routing is by key, not position).
  function reorderTerminal(fromKey: string, dir: -1 | 1) {
    updateDocAndSave(next => {   // v12.10.22 (#1984): every card Move earlier / later saves at once
      const cur = terminalOrderedKeys(next);
      const from = cur.indexOf(fromKey);
      const to = from + dir;
      if (from < 0 || to < 0 || to >= cur.length) return;
      const swapped = [...cur];
      [swapped[from], swapped[to]] = [swapped[to], swapped[from]];
      next.terminalOrder = swapped;
    });
  }
  // v12.2.47.10 (#275-A): move a pre-routing stage one slot earlier/later by writing doc.preRouting.order
  // (card keys). Inbound is pinned first; the hours-before-greeting invariant is preserved (the engine runs the
  // after-hours gate before the greeting), matching the server's defense-in-depth swap.
  function reorderPreRouting(fromKey: string, dir: -1 | 1) {
    updateDocAndSave(next => {   // v12.10.22 (#1984): every card Move earlier / later saves at once
      next.preRouting ??= {};
      // v12.10.17 (#1747): the ID check is pinned before the Greeting - moves are worked out without it, then it is put back.
      const cur = preRoutingOrderedCards(next).map(c => c.key as string).filter(k => k !== 'idCheck');
      if (fromKey === 'idCheck') return;
      const from = cur.indexOf(fromKey);
      const to = from + dir;
      if (from <= 0 || to <= 0 || to >= cur.length) return;   // never move Inbound or into slot 0
      const swapped = [...cur];
      [swapped[from], swapped[to]] = [swapped[to], swapped[from]];
      if (swapped.indexOf('hours') > swapped.indexOf('greeting')) return;   // keep Hours before Greeting
      const gi = swapped.indexOf('greeting');
      (next.preRouting as Record<string, unknown>).order = gi < 0 ? [...swapped, 'idCheck'] : [...swapped.slice(0, gi), 'idCheck', ...swapped.slice(gi)];
    });
  }

  // v12.2.34.0 (#186): open the delete dialog (type-to-confirm only when the card has children).
  function requestDelete(card: CardRef, name: string, childCount: number, childNoun: string) {
    setDeleteTarget({ card, name, childCount, childNoun });
  }
  function confirmDelete() {
    const target = deleteTarget;
    if (!target) return;
    const card = target.card;
    const next = normalizeDoc(cloneDoc(doc));
    if (card.kind === 'workflow') {
      next.workflows = (next.workflows ?? []).filter(w => w.id !== card.workflowId);
    } else if (card.kind === 'intent') {
      const w = next.workflows?.find(x => x.id === card.workflowId);
      if (w) w.intents = (w.intents ?? []).filter(i => i.id !== card.intentId || isSomethingElseIntent(i));   // v12.10.23 (#2029): never deleted
    } else if (card.kind === 'node') {
      const i = next.workflows?.find(x => x.id === card.workflowId)?.intents?.find(x => x.id === card.intentId);
      if (i) i.nodes = (i.nodes ?? []).filter(n => n.id !== card.nodeId);
    }
    setDraftDoc(next);
    // v12.3.12 (#316): saveMutation directly, NOT guardedSave. Tushar typed the node's name into the delete
    // confirmation and got the "Register a new field?" dialog instead of a deletion, and confirming it re-opened
    // the delete prompt from the start. A delete only ever REMOVES content, so it cannot introduce an
    // unregistered field and has no business running the registration scan.
    saveMutation.mutate(next, { onSuccess: () => { setDeleteTarget(null); setActiveCard(null); } });
  }

  if (isLoading) return <div className="tenant-workflow-loading">Loading workflow...</div>;
  if (isError || !data) {
    return (
      <div className="stack-4">
        <div className="tenant-workflow-page-head">
          <div>
            <h1>Workflow</h1>
            <p>How your calls are answered and routed.</p>{/* v12.10.10 (#1409) */}
          </div>
        </div>
        <Alert variant="warn">{(error as Error)?.message ?? 'No workflow template snapshot has been configured for this tenant.'}</Alert>
      </div>
    );
  }

  return (
    <MachineFilledContext.Provider value={machineFilledTexts}>
    <div className="tenant-workflow">
      {/* v12.2.36.0 (#192): Save/Discard moved to the shell "Save all changes" hero (like every other
          settings section); title/description come from the hero too. This slim bar keeps Preview runtime. */}
      {/* v12.10.7.1 (#1195): in T4 (template mode) Preview runtime lives in More actions only - not twice. */}
      {designerMode() !== 'template' && (
        <div className="tenant-workflow-actionbar">
          <button className="tenant-secondary" type="button" onClick={() => simulateMutation.mutate()}>
            Preview runtime
          </button>
        </div>
      )}

      {message && <Alert variant="success">{message}</Alert>}
      {/* v12.9.24 (#911): publish and flag - what could not be translated is said, not hidden. */}
      {/* v12.9.26 (#946): the standing 'could not be auto-translated' banner is GONE (machineFailed={machineFailed} kept for tracking only). */}
      {translateFailed.length > 0 && message && (
        <Alert variant="warn">
          {translateFailed.length} text{translateFailed.length === 1 ? '' : 's'} could not be translated and will be spoken in the primary language:
          <ul style={{ margin: '6px 0 6px 18px' }}>
            {translateFailed.map(p => <li key={p}>{describeDocPath(doc, p)}</li>)}
          </ul>
          <button type="button" className="tenant-secondary" disabled={saveMutation.isPending} onClick={() => saveMutation.mutate(undefined)}>Retry</button>
        </Alert>
      )}
      {saveMutation.isError && <Alert variant="error">{(saveMutation.error as Error)?.message ?? 'Save failed'}</Alert>}
      {changeTemplateMutation.isError && <Alert variant="error">{(changeTemplateMutation.error as Error)?.message ?? 'Template change failed'}</Alert>}

      <section className="tenant-workflow-shell">
        <TemplateIdentity
          data={data}
          doc={doc}
          languages={languages}
          onChangeTemplate={(id?: number) => {
            setSelectedTemplateId(id ?? data.platformTemplateId);
            setChangeTemplateOpen(true);
          }}
          newer={newerVersion}
          onAddLanguage={designerMode() === 'template' || missingAgentLanguages.length > 0 ? () => setAddLanguageOpen(true) : undefined}
          missingAgentLanguages={missingAgentLanguages}
          onRemoveLanguage={(code, name) => setRemoveLanguage({ code, name })}
        />

        <div className="tenant-workflow-tabs">
          <button className={activeTab === 'card' ? 'active' : ''} type="button" onClick={() => setActiveTab('card')}>Card View</button>
          <button className={activeTab === 'tree' ? 'active' : ''} type="button" onClick={() => setActiveTab('tree')}>Tree View</button>
          <button className={activeTab === 'tech' ? 'active' : ''} type="button" onClick={() => setActiveTab('tech')}>Tech View</button>
        </div>

        {activeTab === 'card' && (
          <CardView
            doc={doc}
            summary={summary}
            selectedWorkflow={selectedWorkflow}
            selectedIntent={selectedIntent}
            onOpen={setActiveCard}
            onSelectWorkflow={workflowId => {
              setExpandedWorkflowId(workflowId);
              setExpandedIntentId(null);
            }}
            onSelectIntent={(workflowId, intentId) => {
              setExpandedWorkflowId(workflowId);
              setExpandedIntentId(intentId);
            }}
            onAddWorkflow={addWorkflow}
            onAddIntent={addIntent}
            onAddNode={addNode}
            onReorderNode={reorderNode}
            onReorderWorkflow={reorderWorkflow}
            onReorderIntent={reorderIntent}
            onReorderPreRouting={reorderPreRouting}
            onReorderTerminal={reorderTerminal}
            onRenameCard={renameCard}
            onDeleteCard={requestDelete}
            onToggleCardEnabled={toggleCardEnabled}
            onCopyNode={requestCopyNode}
            onSetEndTerminal={setEndTerminal}
            onShareNode={shareNode}
            onUnshareNode={unshareNode}
            onMoveSharedNode={moveSharedNode}
        onToggleSharedNode={(nodeId, name, intentId, intentLabel, turningOff) => {
          // v12.3.14 (#370): M5 - "skip the modal entirely when the item is used in one place. No choice
          // exists, so do not ask." And the counts are COMPUTED; the standard is explicit that a guess is
          // worse than no number, so if we could not produce one we would fall back to plain buttons.
          const count = intentsUsingSharedNode(doc, selectedWorkflow?.id, nodeId);
          if (count <= 1) { applySharedDisable(nodeId, intentId, 'all', turningOff); return; }
          setSharedToggle({ nodeId, name, intentId, intentLabel, turningOff, intentCount: count,
            workflowLabel: selectedWorkflow?.name || 'caller type',
            consequence: turningOff ? sharedNodeConsequence(doc, nodeId, intentLabel) : undefined });
        }}
          />
        )}

        {activeTab === 'tree' && (
          <TreeView
            doc={doc}
            query={treeQuery}
            onQuery={setTreeQuery}
            onOpen={setActiveCard}
            onAddWorkflow={addWorkflow}
            onAddIntent={addIntent}
            onAddNode={addNode}
          />
        )}

        {activeTab === 'tech' && <TechView doc={doc} />}

        <RuntimePreview
          text={simulateText}
          onText={setSimulateText}
          onRun={() => simulateMutation.mutate()}
          running={simulateMutation.isPending}
          simulation={simulation}
        />
      </section>

      {activeCard && (
        <WorkflowDrawer
          card={activeCard}
          doc={doc}
          activeLanguage={drawerLanguages.some(l => l.code === activeLanguage) ? activeLanguage : (drawerLanguages[0]?.code ?? 'en')}
          languages={drawerLanguages}
          onLanguage={setActiveLanguage}
          onDone={onDoneCard}
          phoneRef={phoneRef}
          onCancel={onCancelCard}
          onRemoveNode={activeCard.kind === 'node' ? () => removeNode(activeCard) : undefined}
          saving={saveMutation.isPending}
          onUpdate={updateDoc}
          onToggleCardEnabled={toggleCardEnabled}
          onOpenCard={setActiveCard}
        />
      )}

      {copyTarget && (
        <CopyNodeDialog doc={doc} sourceLabel={copyTarget.label} onCancel={() => setCopyTarget(null)} onConfirm={confirmCopyNode} />
      )}

      {/* v12.4.16 (#505): AN ENABLED CARD THAT CANNOT BE REACHED, NAMED BEFORE THE SAVE LANDS.
          Not a block - a correct workflow can be mid-edit, and a warning that refuses the save would be
          fought rather than read. It names the card and the route that strands it, which is the whole of
          what was missing: at Harlem every signal available said yes while the card never ran. */}
      {templateBlanks && templateBlanks.length > 0 && (
        <div className="tenant-dialog-backdrop" onClick={() => { setTemplateBlanks(null); blankSaveRef.current = null; }}>
          <div className="tenant-dialog tenant-dialog-strand" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
            <h3>{templateBlanks.length === 1 ? 'One thing to check before saving' : `${templateBlanks.length} things to check before saving`}</h3>
            <p>{designerMode() === 'template'
              ? <>Every practice that uses this template sees an empty box as the <b>Template default</b> - give each one its wording. A list offer that offers nothing is listed too.</>
              : <>These list offers would not work as written. Saving is allowed.</>}</p>
            <ul className="tenant-strand-list">{templateBlanks.map(b => <li key={b}><b>{b}</b></li>)}</ul>
            <div className="tenant-dialog-actions">
              <button type="button" className="tenant-secondary" onClick={() => { setTemplateBlanks(null); blankSaveRef.current = null; }}>Go back and fix</button>
              <button type="button" className="tenant-primary" disabled={saveMutation.isPending}
                onClick={() => { const q = blankSaveRef.current; setTemplateBlanks(null); blankSaveRef.current = null; guardedSave(q?.override, q?.onSuccess, true); }}>
                Save anyway
              </button>
            </div>
          </div>
        </div>
      )}
      {strandedWarn && strandedWarn.length > 0 && (
        <div className="tenant-dialog-backdrop" onClick={() => { setStrandedWarn(null); strandedSaveRef.current = null; }}>
          <div className="tenant-dialog tenant-dialog-strand" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
            <h3>{strandedWarn.length === 1 ? 'One card can never be reached' : `${strandedWarn.length} cards can never be reached`}</h3>
            <p>
              {strandedWarn.length === 1 ? 'This card is switched on and configured, but no call can get to it' : 'These cards are switched on and configured, but no call can get to them'}
              &nbsp;&mdash; an earlier card ends the call first. Saving is allowed; the {strandedWarn.length === 1 ? 'card' : 'cards'} will simply never run.
            </p>
            <ul className="tenant-strand-list">
              {strandedWarn.map(x => (
                <li key={`${x.intentId}::${x.index}`}>
                  <b>{x.label}</b> <span className="tenant-strand-where">{x.workflowName} &rsaquo; {x.intentLabel} &middot; card {x.index + 1}</span>
                  <span className="tenant-strand-why">Stranded because {x.blocker}.</span>
                </li>
              ))}
            </ul>
            <div className="tenant-dialog-actions">
              <button type="button" className="tenant-secondary" onClick={() => { setStrandedWarn(null); strandedSaveRef.current = null; }}>Go back and fix it</button>
              <button type="button" className="tenant-primary" disabled={saveMutation.isPending}
                onClick={() => { const queued = strandedSaveRef.current; setStrandedWarn(null); strandedSaveRef.current = null; proceedSave(queued?.override, queued?.onSuccess); }}>
                Save anyway
              </button>
            </div>
          </div>
        </div>
      )}

      {pendingFields && pendingFields.length > 0 && (
        <div className="rq-scrim" onMouseDown={(e) => { if (e.target === e.currentTarget) { setPendingFields(null); pendingSaveRef.current = null; } }}>
          <div className="rq-cdlg rq-newfield" role="dialog" aria-modal="true" aria-label="Register new fields">
            <h3>{pendingFields.length === 1 ? 'Register a new field?' : `Register ${pendingFields.length} new fields?`}</h3>
            <p>
              This workflow captures {pendingFields.length === 1 ? 'a field' : 'fields'} we haven&rsquo;t seen before.
              Registering {pendingFields.length === 1 ? 'it' : 'them'} gives {pendingFields.length === 1 ? 'it a' : 'them'} name{pendingFields.length === 1 ? '' : 's'} the
              token picker can show, and lets integrations read the shape of your data. The token itself never changes.
            </p>
            <div className="rq-nf-list">
              {pendingFields.map((f, i) => (
                <div className="rq-nf-row" key={f.key}>
                  <code className="rq-nf-key">{'{' + f.key + '}'}</code>
                  <input className="rq-nf-label" value={f.label} aria-label={`Label for ${f.key}`}
                    onChange={(e) => setPendingFields((list) => (list ?? []).map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} />
                  <select className="rq-nf-type" value={f.type} aria-label={`Type for ${f.key}`}
                    onChange={(e) => setPendingFields((list) => (list ?? []).map((x, j) => (j === i ? { ...x, type: e.target.value as CustomField['type'] } : x)))}>
                    <option value="text">Text</option>
                    <option value="number">Number</option>
                    <option value="date">Date</option>
                    <option value="phone">Phone</option>
                  </select>
                </div>
              ))}
            </div>
            <p className="rq-nf-note">
              A <b>type</b> lets the AI check what it heard &mdash; days of supply should be a number, not &ldquo;thirty-ish&rdquo;.
            </p>
            <div className="rq-cfoot">
              <button type="button" className="rq-cbtn-cancel" onClick={() => { setPendingFields(null); pendingSaveRef.current = null; }}>Cancel</button>
              <button type="button" className="rq-cbtn-primary" disabled={registerFields.isPending} onClick={confirmRegister}>
                {registerFields.isPending ? 'Registering…' : 'Register and save'}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* v12.3.12 (#322): the drawer was closed by clicking outside it and there is unsaved work in there. */}
      {discardPrompt && (
        <div className="tenant-dialog-backdrop" onClick={() => setDiscardPrompt(false)}>
          <div className="tenant-dialog" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
            <h3>Keep your changes?</h3>
            <p>You have edits in this panel that have not been saved yet. Closing it without saving would discard them.</p>
            <div className="tenant-dialog-actions">
              <button type="button" className="tenant-secondary" onClick={() => setDiscardPrompt(false)}>Keep editing</button>
              <button type="button" className="tenant-secondary" onClick={revertDrawer}>Discard changes</button>
              <button type="button" className="tenant-primary" disabled={saveMutation.isPending}
                onClick={() => { setDiscardPrompt(false); guardedSave(undefined, () => setActiveCard(null)); }}>
                {saveMutation.isPending ? 'Saving…' : 'Save changes'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* v12.3.12 (#320): switching a shared node off - Tushar: "Per intent, it should ask disable for all
          intent or just the selected intent." Asked every time, because the two answers are not undoable in
          the same way: "every intent" also clears where it was individually switched off. */}
      {/* v12.3.14 (#370): rebuilt to the M5 "scope choice" standard
          (Documents\UI Principles\Dialogue Boxes\Modal_M5_Scope_Choice_v1_0.html).
          One action, two reaches - the caller of this dialog is not answering yes or no, they are choosing how
          far the change travels. So: the choices are ROWS, not footer buttons; the footer holds Cancel alone;
          options run narrowest first and the narrowest is pre-selected and focused, so Enter applies the smaller
          change; and each row carries a REAL count, computed here, never a guess.
          Breadcrumb order is TUSHAR'S, not the standard's: NAME on top as the caption, type as the small label
          beneath. He chose it over the standard's uppercase-key-above-value chip on 2026-09-01, and the standard
          files are being amended to match rather than the build. */}
      {sharedToggle && (
        <div className="tenant-dialog-backdrop" onClick={() => setSharedToggle(null)}>
          <div className="tenant-dialog tenant-dialog-m5" role="dialog" aria-modal="true"
               aria-labelledby="m5-title" onClick={e => e.stopPropagation()}
               onKeyDown={e => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); setSharedToggle(null); } }}>
            {/* v12.3.14.1: Tushar's smoke test of the M5 build, and three corrections to his own standard.
                (1) The title was "Where should Capture identity turn off?" - it wrapped to two lines and repeated
                a name the breadcrumb already carries one line down. It is a short caption now. The VERB is
                Disable/Enable because that is what the menu he clicked to get here says; only one place in T2
                said "Turn on/Turn off" and that is being brought into line in the same build.
                (2) The amber consequence block: "i think the yellow caption is very annoying. rather we should
                use our tooltip format" - so it moves into the standard three-section HelpTooltip.
                (3) "i think this is also not needed this node is shared, so the same settings run in more than
                one intent" - deleted. The badge says it and the tooltip explains it.
                This knowingly diverges from M5 acceptance line 13 (titles name the item) and from M5's Copy
                table. He is updating the standard to match; the divergence is the decision, not an oversight. */}
            <div className="tenant-dialog-head">
              <h3 id="m5-title">{sharedToggle.turningOff ? 'Disable' : 'Enable'} node</h3>
              <span className="tenant-help-scope"><HelpTooltip sections={[
                ['What it does', `This node is shared, so the same settings run in every ${sharedToggle.workflowLabel} intent. You are choosing how far this change travels - this intent only, or all of them. Other caller types are not affected.`],
                ['What happens', sharedToggle.consequence
                  ?? 'The node stops running in the intents you choose. Nothing else about the call changes.'],
                ['Example', `"Just here" leaves ${sharedToggle.name} running everywhere except ${sharedToggle.intentLabel}.`]]} /></span>
              <span className="tenant-badge-shared">Shared node</span>
            </div>
            <div className="tenant-dialog-idents">
              <div><b>{sharedToggle.intentLabel}</b><span>intent</span></div>
              <span className="tenant-dialog-sep" aria-hidden="true">&rsaquo;</span>
              <div><b>{sharedToggle.name}</b><span>node</span></div>
            </div>
            <div className="tenant-choice-rows">
              <button type="button" className="tenant-choice-row" autoFocus
                onClick={() => applySharedDisable(sharedToggle.nodeId, sharedToggle.intentId, 'this', sharedToggle.turningOff)}>
                <span className="tenant-choice-text">
                  <b>Just here</b>
                  <span>{sharedToggle.turningOff ? 'Disables' : 'Enables'} it in {sharedToggle.intentLabel} only.</span>
                </span>
                <span className="tenant-choice-count">1 intent</span>
              </button>
              <button type="button" className="tenant-choice-row"
                onClick={() => applySharedDisable(sharedToggle.nodeId, sharedToggle.intentId, 'all', sharedToggle.turningOff)}>
                <span className="tenant-choice-text">
                  <b>Everywhere</b>
                  {/* v12.3.15 (#383): 'every intent' now means every intent OF THIS CALLER TYPE. The old
                      wording was true of a model that was wrong, which is exactly why it read as a dummy
                      number to Tushar - it counted past the lane he was standing in. */}
                  <span>{sharedToggle.turningOff ? 'Disables' : 'Enables'} it in every {sharedToggle.workflowLabel} intent.</span>
                </span>
                <span className="tenant-choice-count">{sharedToggle.intentCount} {sharedToggle.intentCount === 1 ? 'intent' : 'intents'}</span>
              </button>
            </div>
            <div className="tenant-dialog-actions">
              <span className="tenant-dialog-esc">Esc to cancel</span>
              <button type="button" className="tenant-secondary" onClick={() => setSharedToggle(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {deleteTarget && (
        <DeleteCardDialog
          name={deleteTarget.name}
          kindLabel={deleteTarget.card.kind}
          childCount={deleteTarget.childCount}
          childNoun={deleteTarget.childNoun}
          saving={saveMutation.isPending}
          onCancel={() => setDeleteTarget(null)}
          onConfirm={confirmDelete}
        />
      )}

      {addLanguageOpen && (
        <AddLanguageDialog have={(doc.modal?.languages ?? []).map(l => canonLang(typeof l === 'string' ? l : l.code))}
          options={designerMode() === 'tenant' ? missingAgentLanguages : undefined}
          onClose={() => setAddLanguageOpen(false)}
          onAdd={(code) => {
            updateDoc(next => {
              const modal = (next.modal ??= {});
              const langs = [...(modal.languages ?? [])];
              if (!langs.some(l => canonLang(typeof l === 'string' ? l : l.code) === code)) langs.push({ code, displayName: '', isEnabled: true } as never);
              modal.languages = langs;
              next.preRouting ??= {};
              const ld = (next.preRouting.languageDetect ?? {}) as Record<string, unknown>;
              const sup = Array.isArray(ld.supportedLanguages) ? [...(ld.supportedLanguages as string[])] : [];
              if (!sup.includes(code)) sup.push(code);
              ld.supportedLanguages = sup;
              next.preRouting.languageDetect = ld;
            });
            setAddLanguageOpen(false);
          }} />
      )}

      {/* v12.10.26 (#2143): remove a non-primary language from the template / the practice's workflow - asks first. */}
      {removeLanguage && (
        <div className="tenant-dialog-backdrop" onClick={() => setRemoveLanguage(null)}>
          <section className="tenant-template-dialog" onClick={event => event.stopPropagation()} role="alertdialog" aria-label={`Remove ${removeLanguage.name}?`}>
            <header>
              <div><h2>Remove {removeLanguage.name}?</h2>
                <p>{designerMode() === 'template'
                  ? `Every card loses its ${removeLanguage.name} tab. Practices made from this template keep their own copy until they change template.`
                  : `Every card loses its ${removeLanguage.name} tab and calls stop offering ${removeLanguage.name}. Turn it off in Settings › AI Agent too if the practice no longer speaks it.`}
                  {' '}Save all changes to keep it.</p></div>
              <button type="button" onClick={() => setRemoveLanguage(null)}>x</button>
            </header>
            <footer>
              <button className="tenant-secondary" type="button" onClick={() => setRemoveLanguage(null)}>Cancel</button>
              <button className="tenant-primary" type="button" onClick={() => {
                const code = removeLanguage.code;
                updateDoc(next => {
                  const modal = (next.modal ??= {});
                  const langs = [...(modal.languages ?? [])];
                  // the primary (first) language is never removed
                  modal.languages = langs.filter((l, i) => i === 0 || canonLang(typeof l === 'string' ? l : l.code) !== code);
                  const ld = ((next.preRouting ??= {}).languageDetect ?? null) as Record<string, unknown> | null;
                  if (ld) {
                    if (Array.isArray(ld.supportedLanguages)) ld.supportedLanguages = (ld.supportedLanguages as string[]).filter(c => canonLang(c) !== code);
                    if (ld.offers && typeof ld.offers === 'object') {
                      const offers = { ...(ld.offers as Record<string, unknown>) };
                      Object.keys(offers).forEach(k => { if (canonLang(k) === code) delete offers[k]; });
                      ld.offers = offers;
                    }
                  }
                });
                setRemoveLanguage(null);
              }}>Remove language</button>
            </footer>
          </section>
        </div>
      )}

      {changeTemplateOpen && (
        <ChangeTemplateDialog
          currentId={data.platformTemplateId}
          selectedId={selectedTemplateId}
          templates={templateOptions}
          saving={changeTemplateMutation.isPending}
          onSelect={setSelectedTemplateId}
          onClose={() => {
            setChangeTemplateOpen(false);
            setSelectedTemplateId(null);
          }}
          onCopy={(mode) => changeTemplateMutation.mutate(mode)}
          currentVersion={data.templateVersion}
        />
      )}
    </div>
    </MachineFilledContext.Provider>
  );
}

// v12.10.10 (#1409, UI-PROTO-T19-TEMPLATE-HEADER v1.1, Tushar picked V1): ONE line - name, status pill, and on the right
// "Catalog X · Version vN" then Change template; the languages on a second line (first = PRIMARY). Facts read as text, not as
// input-looking boxes. No "vN available" pill and no update banner until the update mechanism exists (#1410, deferred by Tushar).
function TemplateIdentity({
  data,
  doc,
  languages,
  onChangeTemplate,
  onAddLanguage,
  onRemoveLanguage,
  missingAgentLanguages = [],
}: {
  data: TenantWorkflowSnapshot;
  doc: DesignerDocument;
  languages: Array<{ code: string; displayName: string; isEnabled: boolean }>;
  onChangeTemplate: (templateId?: number) => void;
  newer?: { id: number; version: number } | null;
  onAddLanguage?: () => void;
  onRemoveLanguage?: (code: string, name: string) => void;   // v12.10.26 (#2143)
  missingAgentLanguages?: Array<[string, string]>;           // v12.10.26 (#2143): AI Agent languages not in this workflow
}) {
  const enabled = languages.filter(l => l.isEnabled);
  const status = (data.status || '').trim();
  const active = /^active$/i.test(status);
  return (
    <section className="tenant-template-card tpl-v1">
      <div className="tpl-strip">
        <span className="tpl-nm">{doc.modal?.displayName || data.templateName}</span>
        {status && <span className={`tpl-pill${active ? ' tpl-act' : ''}`}>{status.charAt(0).toUpperCase() + status.slice(1)}</span>}
        <span className="tpl-right">
          <span className="tpl-cv">Catalog <b>{data.categoryName || doc.modal?.category || 'Workflow'}</b><span className="tpl-sep" aria-hidden="true">·</span>Version <b>v{data.templateVersion}</b></span>
          {/* v12.10.3 (BDR-016): a template has no template to change - only a tenant copy does. */}
          {designerMode() === 'tenant' && canChangeTemplate() && <button className="tenant-secondary small" type="button" onClick={() => onChangeTemplate()}>Change template</button>}   {/* v12.10.25 (#2103): Support visit only */}
          {/* v12.10.7 (#1125): in a T4 template, the spot where T2 shows Change template adds a language to the template. */}
          {/* v12.10.26 (#2143): T2 offers it only for AI Agent languages not yet in the workflow. */}
          {onAddLanguage && <button className="tenant-secondary small" type="button" onClick={onAddLanguage}>+ Add language</button>}
        </span>
      </div>
      <div className="tpl-row2">
        <span className="tpl-lbl">Languages</span>
        {enabled.map((language, i) => (
          <span key={language.code} className="tpl-lang">{langLabel(language)}{i === 0 && <small>PRIMARY</small>}
            {/* v12.10.26 (#2143): x removes a non-primary language (asks first); the primary cannot be removed. */}
            {i > 0 && onRemoveLanguage && languages[0]?.code !== language.code && (
              <button type="button" className="tpl-lang-x" aria-label={`Remove ${langLabel(language)}`} title={`Remove ${langLabel(language)} from this ${designerMode() === 'template' ? 'template' : 'workflow'}`}
                onClick={() => onRemoveLanguage(canonLang(language.code), langLabel(language))}
                style={{ marginLeft: 6, border: 0, background: 'none', cursor: 'pointer', color: '#64748b', fontSize: 13, lineHeight: 1, padding: 0 }}>×</button>
            )}
          </span>
        ))}
        {missingAgentLanguages.length > 0 && (
          <span className="tpl-lbl" style={{ marginLeft: 8, color: '#92400e' }}>
            {missingAgentLanguages.map(([, n]) => n).join(', ')} {missingAgentLanguages.length === 1 ? 'is' : 'are'} on in AI Agent but not in this workflow - + Add language
          </span>
        )}
      </div>
    </section>
  );
}


// v12.10.7 (#1125): + Add language in a T4 template - the languages a template can carry. The tenant's own languages
// (AI Agent) decide which tabs a tenant sees; a template may carry more.
const TEMPLATE_LANGUAGES: Array<[string, string]> = [['en', 'English'], ['es', 'Spanish'], ['fr', 'French'], ['de', 'German'], ['pt', 'Portuguese'],
  ['it', 'Italian'], ['zh', 'Chinese'], ['vi', 'Vietnamese'], ['ko', 'Korean'], ['ru', 'Russian'], ['ar', 'Arabic'], ['hi', 'Hindi'], ['gu', 'Gujarati'], ['tl', 'Tagalog'], ['pl', 'Polish'], ['ht', 'Haitian Creole']];
function AddLanguageDialog({ have, onClose, onAdd, options }: { have: string[]; onClose: () => void; onAdd: (code: string) => void; options?: Array<[string, string]> }) {
  // v12.10.26 (#2143): a practice (T2) is offered only its AI Agent languages that are not in the workflow yet.
  const free = (options ?? TEMPLATE_LANGUAGES).filter(([c]) => !have.includes(c));
  const [code, setCode] = useState(free[0]?.[0] ?? '');
  return (
    <div className="tenant-dialog-backdrop" onClick={onClose}>
      <section className="tenant-template-dialog" onClick={event => event.stopPropagation()} role="dialog" aria-label="Add language">
        <header>
          <div>{options
            ? <><h2>Add a language to this workflow</h2><p>Languages turned on in Settings › AI Agent that this workflow does not have yet. Every card gets a tab for it; Save all changes and its texts are auto-translated.</p></>
            : <><h2>Add a language to this template</h2><p>Every card gets a tab for it. Save all changes to keep it; tenants see it only when it is one of their AI Agent languages.</p></>}</div>
          <button type="button" onClick={onClose}>x</button>
        </header>
        {free.length === 0 ? <Alert variant="warn">{options ? 'Every AI Agent language is already in this workflow.' : 'Every language on the list is already in this template.'}</Alert> : (
          <label className="tenant-form-field"><span>Language</span>
            <select value={code} onChange={e => setCode(e.target.value)}>{free.map(([c, n]) => <option key={c} value={c}>{n} · {c.toUpperCase()}</option>)}</select>
          </label>
        )}
        <footer>
          <button className="tenant-secondary" type="button" onClick={onClose}>Cancel</button>
          <button className="tenant-primary" type="button" disabled={!code} onClick={() => onAdd(code)}>Add language</button>
        </footer>
      </section>
    </div>
  );
}

// v12.7.2 (#616): CardView reads the connections so a Connect card can say it points at nothing.
function CardView({
  doc,
  summary,
  selectedWorkflow,
  selectedIntent,
  onOpen,
  onSelectWorkflow,
  onSelectIntent,
  onAddWorkflow,
  onAddIntent,
  onAddNode,
  onReorderNode,
  onReorderWorkflow,
  onReorderIntent,
  onReorderPreRouting,
  onReorderTerminal,
  onRenameCard,
  onDeleteCard,
  onToggleCardEnabled,
  onCopyNode,
  onShareNode,
  onUnshareNode,
  onMoveSharedNode,
  onToggleSharedNode,
  onSetEndTerminal,
}: {
  doc: DesignerDocument;
  onSetEndTerminal: (workflowId: string, intentId: string, key: string) => void;   // v12.4.16 (#516)
  summary: { workflows: number; intents: number; nodes: number; steps: number };
  selectedWorkflow?: WorkflowLane;
  selectedIntent?: WorkflowIntent;
  onOpen: (card: CardRef) => void;
  onSelectWorkflow: (workflowId: string) => void;
  onSelectIntent: (workflowId: string, intentId: string) => void;
  onAddWorkflow: () => void;
  onAddIntent: (workflowId: string) => void;
  onAddNode: (workflowId: string, intentId: string) => void;
  // v12.2.25.0 (#159b): swap the node at `from` with the node at `to` within its intent's run order.
  onReorderNode: (workflowId: string, intentId: string, from: number, to: number) => void;
  onReorderWorkflow: (from: number, to: number) => void;
  onReorderIntent: (workflowId: string, from: number, to: number) => void;
  onReorderPreRouting: (fromKey: string, dir: -1 | 1) => void;
  onReorderTerminal: (fromKey: string, dir: -1 | 1) => void;
  onRenameCard: (card: CardRef, name: string) => void;
  onDeleteCard: (card: CardRef, name: string, childCount: number, childNoun: string) => void;
  onToggleCardEnabled: (card: CardRef) => void;
  onCopyNode: (card: Extract<CardRef, { kind: 'node' }>, label: string) => void;
  // v12.3.11 (#312)
  onShareNode: (workflowId: string, intentId: string, nodeId: string) => void;
  onUnshareNode: (nodeId: string) => void;
  onMoveSharedNode: (nodeId: string, dir: 'up' | 'down') => void;   // v12.4.0 (#385): one card, not a two-position flip
  onToggleSharedNode: (nodeId: string, name: string, intentId: string, intentLabel: string, turningOff: boolean) => void;   // v12.3.12 (#320)
}) {
  const offTerminals = useOffTerminals();   // v12.10.4 (#1119): Route to operator shows DISABLED while the Outside operator line is off
  // v12.7.2 (#616): so a Connect card whose connection was renamed or deleted says so on the card itself,
  // instead of only inside the drawer #487 put the warning in.
  const cardConnections = useConnectedSystems();
  // Inbound card meta reflects the number's real capabilities ("Phone · Text" / "Phone"), not the
  // old "PSTN · WebRTC" placeholder. Shares the AI-Agent query cache, so no extra fetch.
  const phoneHandles = usePhoneHandlesLabel();
  // v12.4.16 (#505): the enabled cards in THIS intent that no path reaches. Keyed by POSITION, not by node
  // id - a shared node appears once per reference, and two references to it can differ in reachability.
  const strandedHere = new Map(
    (selectedIntent ? strandedInIntent(doc, selectedWorkflow?.id, selectedIntent) : []).map(x => [x.index, x] as const));
  return (
    <div className="tenant-workflow-canvas">
      <FlowSection number={1} title="Pre-routing" caption="runs in order before the caller is classified" count={`${PRE_ROUTING_CARDS.length} stages`}>
        {/* v12.2.47.10 (#275-A): pre-routing stages render in the saved order and are reorderable via the ⋮ menu.
            Inbound (START) is pinned first; Move earlier is disabled on the first movable stage; the Hours→Greeting
            invariant is enforced so Greeting can never move above Hours. */}
        {preRoutingOrderedCards(doc).map((card, index, arr) => {
          const movable = card.key !== 'inbound' && card.key !== 'idCheck';   // v12.10.17 (#1747): the ID check is pinned before the Greeting
          // v12.10.17 (#1747): a neighbour move is judged across the pinned ID check (it travels with the Greeting).
          const prev = arr[index - 1]?.key === 'idCheck' ? arr[index - 2] : arr[index - 1];
          const nextCard = arr[index + 1]?.key === 'idCheck' ? arr[index + 2] : arr[index + 1];
          const canUp = movable && index > 1 && !!prev && prev.key !== 'inbound' && !(card.key === 'greeting' && prev?.key === 'hours');
          const canDown = movable && !!nextCard && !(card.key === 'hours' && nextCard?.key === 'greeting');
          return (
            <FlowCard
              key={card.key}
              kind={card.stage}
              badge={card.badge}
              title={cardTitleForPreRouting(doc, card.key)}
              description={card.key === 'inbound' ? phoneHandles : cardDescriptionForPreRouting(doc, card.key)}
              color={card.color}
              disabled={card.key !== 'inbound' && !preRoutingEnabled(doc, card.key)}
              onClick={() => onOpen({ kind: 'preRouting', key: card.key })}
              /* Every pre-routing card EXCEPT Inbound gets the ⋮ menu with Edit + Move earlier/later + Disable/Enable.
                 Delete is intentionally omitted (fixed built-in stages). Inbound = no menu (name edited in its drawer). */
              onEdit={card.key === 'inbound' ? undefined : () => onOpen({ kind: 'preRouting', key: card.key })}
              canMoveUp={canUp}
              canMoveDown={canDown}
              onMoveUp={movable ? () => onReorderPreRouting(card.key, -1) : undefined}
              onMoveDown={movable ? () => onReorderPreRouting(card.key, 1) : undefined}
              onToggleEnabled={card.key === 'inbound' ? undefined : () => onToggleCardEnabled({ kind: 'preRouting', key: card.key })}
            />
          );
        })}
      </FlowSection>

      <FlowSection number={2} title="Workflows" caption="parallel entry points - pick one" count={`${summary.workflows} workflows`} link="Classify routes the call to one workflow">
        {(doc.workflows ?? []).map((workflow, index, arr) => (
          <FlowCard
            key={workflow.id}
            kind="WORKFLOW"
            badge={badgeFor(workflow.name, 'WF')}
            title={workflow.name || 'Workflow'}
            description={`${workflow.intents?.length ?? 0} intents`}
            color={HIERARCHY_COLORS.workflow}
            selected={workflow.id === selectedWorkflow?.id}
            disabled={workflow.enabled === false}
            onClick={() => workflow.id && onSelectWorkflow(workflow.id)}
            canMoveUp={index > 0}
            canMoveDown={index < arr.length - 1}
            onMoveUp={() => onReorderWorkflow(index, index - 1)}
            onMoveDown={() => onReorderWorkflow(index, index + 1)}
            onEdit={() => { if (workflow.id) onOpen({ kind: 'workflow', workflowId: workflow.id }); }}
            onRename={name => { if (workflow.id) onRenameCard({ kind: 'workflow', workflowId: workflow.id }, name); }}
            onDelete={() => { if (workflow.id) onDeleteCard({ kind: 'workflow', workflowId: workflow.id }, workflow.name || 'Workflow', workflow.intents?.length ?? 0, 'intent'); }}
            onToggleEnabled={() => { if (workflow.id) onToggleCardEnabled({ kind: 'workflow', workflowId: workflow.id }); }}
          />
        ))}
        <AddCard label="Add workflow" onClick={onAddWorkflow} />
      </FlowSection>

      {selectedWorkflow && (
        <FlowSection number={3} title={selectedWorkflow.name || 'Workflow'} caption="its intents - pick one" count={`${selectedWorkflow.intents?.length ?? 0} intents`} link={<>Inside <b>{selectedWorkflow.name}</b> &middot; its intents</>}>
          {(selectedWorkflow.intents ?? []).map((intent, index, arr) => (
            <FlowCard
              key={intent.id}
              kind="INTENT"
              badge={badgeFor(intent.label, 'IN')}
              title={intent.label || 'Intent'}
              description={(() => { const rts = (intent.nodes ?? []).flatMap(n => n.requestTypes ?? []).filter(rt => rt.enabled !== false).map(rt => rt.name).filter(Boolean); return rts.length ? `Request types: ${rts.join(', ')}` : `${intent.nodes?.length ?? 0} nodes - ${(intent.keywords ?? []).slice(0, 3).join(', ')}`; })()}
              color={HIERARCHY_COLORS.intent}
              selected={intent.id === selectedIntent?.id}
              disabled={intent.enabled === false}
              onClick={() => selectedWorkflow.id && intent.id && onSelectIntent(selectedWorkflow.id, intent.id)}
              onEdit={() => { if (selectedWorkflow.id && intent.id) onOpen({ kind: 'intent', workflowId: selectedWorkflow.id, intentId: intent.id }); }}
              canMoveUp={index > 0 && !isSomethingElseIntent(intent)}   /* v12.10.23 (#2029): Something else stays last */
              canMoveDown={index < arr.length - 1 && !isSomethingElseIntent(intent) && !isSomethingElseIntent(arr[index + 1])}
              onMoveUp={() => selectedWorkflow.id && onReorderIntent(selectedWorkflow.id, index, index - 1)}
              onMoveDown={() => selectedWorkflow.id && onReorderIntent(selectedWorkflow.id, index, index + 1)}
              onRename={name => { if (selectedWorkflow.id && intent.id) onRenameCard({ kind: 'intent', workflowId: selectedWorkflow.id, intentId: intent.id }, name); }}
              onDelete={isSomethingElseIntent(intent) ? undefined : () => { if (selectedWorkflow.id && intent.id) onDeleteCard({ kind: 'intent', workflowId: selectedWorkflow.id, intentId: intent.id }, intent.label || 'Intent', intent.nodes?.length ?? 0, 'node'); }}
              onToggleEnabled={() => { if (selectedWorkflow.id && intent.id) onToggleCardEnabled({ kind: 'intent', workflowId: selectedWorkflow.id, intentId: intent.id }); }}
            />
          ))}
          <AddCard label="Add intent" onClick={() => selectedWorkflow.id && onAddIntent(selectedWorkflow.id)} />
        </FlowSection>
      )}

      {selectedWorkflow && selectedIntent && (
        <FlowSection number={4} title="Nodes" caption={`inside ${selectedIntent.label || 'intent'} - runs in order`} count={`${selectedIntent.nodes?.length ?? 0} nodes`} link={<>Inside <b>{selectedIntent.label}</b> &middot; its node sequence</>}>
          {/* v12.3.11 (#312): shared nodes run in EVERY intent, so they render here too — before or after this
              intent's own nodes, exactly as the call will run them. They are drawn in a distinct colour and say
              so on the card, because editing one changes every intent and deleting one removes it everywhere. */}
          {/* v12.4.0 (#385): ONE ORDERED WALK. This used to be three blocks - shared-before, the intent's own
              nodes, shared-after - because sharedPosition could only say 'before' or 'after'. A shared node is
              now a REFERENCE inside this list, so its position is its array index and there is one sequence to
              render, in the order the call actually runs. That also fixes #388 for free: the count badge above
              is this list's length, and the list is what is drawn. */}
          {(selectedIntent.nodes ?? []).map((node, index, arr) => {
            const shared = node.sharedNodeId
              ? sharedNodesFor(doc, selectedWorkflow?.id).find(n => n.id === node.sharedNodeId)
              : undefined;

            // A reference whose definition is gone (deleted, or owned by another caller type) renders nothing
            // rather than an empty card. EffectiveNodes skips it on a call for the same reason.
            if (node.sharedNodeId && !shared) return null;

            if (shared) {
              const offHere = shared.enabled === false || (shared.disabledIntentIds ?? []).includes(selectedIntent.id ?? '');
              return (
                <FlowCard
                  key={`shared-${shared.id}-${index}`}
                  kind="SHARED"
                  badge="ALL"
                  title={shared.label || 'Shared node'}
                  color={SHARED_NODE_COLOR}
                  /* v12.3.12 (#320): a shared node can be off EVERYWHERE (enabled:false) or off just here. */
                  disabled={offHere}
                  /* v12.4.0 (#385): it has a real position now, so it says the same thing every other card says
                     instead of the two-value "runs first" / "runs last" that could not describe where it is. */
                  orderLabel={`${index + 1}/${arr.length}`}
                  /* v12.3.16 (#383 copy): a shared node runs in every intent of ONE caller type. */
                  description={shared.enabled === false
                    ? `Off in every ${selectedWorkflow.name || 'caller type'} intent - ${nodeCardDescription(shared, doc, selectedWorkflow.id, selectedIntent.id, cardConnections)}`
                    : (shared.disabledIntentIds ?? []).includes(selectedIntent.id ?? '')
                      ? `Off in ${selectedIntent.label || 'this intent'} - runs in the others`
                      : `Runs in every ${selectedWorkflow.name || 'caller type'} intent - ${nodeCardDescription(shared, doc, selectedWorkflow.id, selectedIntent.id, cardConnections)}`}
                  onClick={() => shared.id && onOpen({ kind: 'sharedNode', nodeId: shared.id })}
                  onEdit={() => { if (shared.id) onOpen({ kind: 'sharedNode', nodeId: shared.id }); }}
                  onUnshare={() => shared.id && onUnshareNode(shared.id)}
                  /* v12.4.0 (#385): ordinary one-card moves, bounded by this intent's list like any other node.
                     12.3.16 could only flip before/after, so "Move later" jumped past every own node. */
                  canMoveUp={index > 0}
                  canMoveDown={index < arr.length - 1}
                  onMoveUp={() => shared.id && onMoveSharedNode(shared.id, 'up')}
                  onMoveDown={() => shared.id && onMoveSharedNode(shared.id, 'down')}
                  onToggleEnabled={() => shared.id && onToggleSharedNode(shared.id, shared.label || 'Shared node',
                    selectedIntent.id ?? '', selectedIntent.label || 'this intent', !offHere)}
                  warning={strandedHere.has(index) ? `Unreachable - ${strandedHere.get(index)!.blocker}, so this card never runs.` : undefined}
                />
              );
            }

            return (
              <FlowCard
                key={node.id}
                kind={(node.type || 'NODE').toUpperCase()}
                badge={badgeFor(node.type, 'ND')}
                title={node.label || 'Node'}
                description={nodeCardDescription(node, doc, selectedWorkflow.id, selectedIntent.id, cardConnections)}   /* v12.4.11 (#442); v12.7.2 (#616) */
                color={nodeColor(node.type)}
                disabled={node.enabled === false}
                orderLabel={`${index + 1}/${arr.length}`}
                canMoveUp={index > 0}
                canMoveDown={index < arr.length - 1}
                onMoveUp={() => selectedWorkflow.id && selectedIntent.id && onReorderNode(selectedWorkflow.id, selectedIntent.id, index, index - 1)}
                onMoveDown={() => selectedWorkflow.id && selectedIntent.id && onReorderNode(selectedWorkflow.id, selectedIntent.id, index, index + 1)}
                onClick={() => selectedWorkflow.id && selectedIntent.id && node.id && onOpen({ kind: 'node', workflowId: selectedWorkflow.id, intentId: selectedIntent.id, nodeId: node.id })}
                onEdit={() => { if (selectedWorkflow.id && selectedIntent.id && node.id) onOpen({ kind: 'node', workflowId: selectedWorkflow.id, intentId: selectedIntent.id, nodeId: node.id }); }}
                onRename={name => { if (selectedWorkflow.id && selectedIntent.id && node.id) onRenameCard({ kind: 'node', workflowId: selectedWorkflow.id, intentId: selectedIntent.id, nodeId: node.id }, name); }}
                onDelete={() => { if (selectedWorkflow.id && selectedIntent.id && node.id) onDeleteCard({ kind: 'node', workflowId: selectedWorkflow.id, intentId: selectedIntent.id, nodeId: node.id }, node.label || 'Node', nodeStepCount(node), 'step'); /* v12.4.12 (#478): the card's count, not node.steps */ }}
                onToggleEnabled={() => { if (selectedWorkflow.id && selectedIntent.id && node.id) onToggleCardEnabled({ kind: 'node', workflowId: selectedWorkflow.id, intentId: selectedIntent.id, nodeId: node.id }); }}
                onCopy={() => { if (selectedWorkflow.id && selectedIntent.id && node.id) onCopyNode({ kind: 'node', workflowId: selectedWorkflow.id, intentId: selectedIntent.id, nodeId: node.id }, node.label || 'Node'); }}
                onShare={() => { if (selectedWorkflow.id && selectedIntent.id && node.id) onShareNode(selectedWorkflow.id, selectedIntent.id, node.id); }}
                warning={strandedHere.has(index) ? `Unreachable - ${strandedHere.get(index)!.blocker}, so this card never runs.` : undefined}
              />
            );
          })}
          <AddCard label="Add node" onClick={() => selectedWorkflow.id && selectedIntent.id && onAddNode(selectedWorkflow.id, selectedIntent.id)} />
          {/* v12.4.16 (#516): the end of the sequence, shown where it happens. NOT a node - no ordinal, no
              enable toggle, no reorder, no delete - so the "N nodes" count stays honest. */}
          <EndOfSequenceCard
            doc={doc}
            value={selectedIntent.endTerminalKey ?? ''}
            onChange={key => { if (selectedWorkflow.id && selectedIntent.id) onSetEndTerminal(selectedWorkflow.id, selectedIntent.id, key); }} />
        </FlowSection>
      )}

      {/* v12.3.1 (#238): the global mid-call interceptor — stage 5. It reads the terminal cards' keywords and
          (Slice 2) answers off-script questions from the Knowledge Base. One card; global like Pre-routing. */}
      <FlowSection number={5} title="Interceptor" caption="mid-call - runs on every caller turn" count="1 stage" link="Handles digressions before the call reaches a terminal">
        <FlowCard
          kind="INTERCEPTOR"
          badge="ICP"
          title="Mid-call handling"
          description="Answers questions, hands off, and switches - on any turn"
          color="#6d28d9"
          disabled={doc.interceptor?.enabled === false}
          onClick={() => onOpen({ kind: 'interceptor' })}
          onEdit={() => onOpen({ kind: 'interceptor' })}
          onToggleEnabled={() => onToggleCardEnabled({ kind: 'interceptor' })}
        />
      </FlowSection>

      {/* v12.9.26 (#969): lane 7 sits AFTER Terminal in the file but reads as its own lane; see below. */}
      <FlowSection number={6} title="Terminal" caption="final outcomes" count={`${terminalOrderedKeys(doc).length} terminal cards`} link="Every path resolves to one terminal outcome">
        {/* v12.3.2 (#238): terminals render in the saved order and get the ⋮ menu (Edit/Rename/Disable/Move) — no Delete
            (built-ins are always re-merged, so they're disable-only). Edit opens the drawer where Name = rename. */}
        {terminalOrderedKeys(doc).map((key, index, arr) => {
          const value = (doc.terminal ?? DEFAULT_TERMINALS)[key] ?? '';
          const tcfg = doc.terminalConfig?.[key];
          return (
          <FlowCard
            key={key}
            kind="TERMINAL"
            badge={badgeFor(key, 'END')}
            title={(tcfg?.name && tcfg.name.trim()) || TERMINAL_LABELS[key] || key}
            description={(tcfg?.description && tcfg.description.trim()) || TERMINAL_DESCRIPTIONS[key] || value}
            color={HIERARCHY_COLORS.terminal}
            disabled={tcfg?.enabled === false || !!offTerminals[key]}
            canMoveUp={index > 0}
            canMoveDown={index < arr.length - 1}
            onMoveUp={() => onReorderTerminal(key, -1)}
            onMoveDown={() => onReorderTerminal(key, 1)}
            onClick={() => onOpen({ kind: 'terminal', terminalKey: key })}
            onEdit={() => onOpen({ kind: 'terminal', terminalKey: key })}
            onRename={name => onRenameCard({ kind: 'terminal', terminalKey: key }, name)}
            onToggleEnabled={TERMINAL_LOCKED.has(key) ? undefined : () => onToggleCardEnabled({ kind: 'terminal', terminalKey: key })}
          />
          );
        })}
      </FlowSection>

      {/* v12.9.26 (#969): LANE 7 - PHRASES. Every tenant-editable line the agent speaks, grouped by call stage, in
          every language the organization runs. Moved here from Personalization > Agent phrases (same stored values). */}
      <FlowSection number={7} title="Phrases" caption="every line the agent speaks" count="2 cards" link="Reword any line the caller hears - blank keeps the platform line">
        <FlowCard
          kind="PHRASES"
          badge="TXT"
          title="Agent phrases"
          description="Clarify, confirm, connect, wrap-up and goodbye lines - per language"
          color="#0f766e"
          onClick={() => onOpen({ kind: 'phrases' })}
          onEdit={() => onOpen({ kind: 'phrases' })}
        />
        {/* v12.10.21 (#1957, UI-PROTO-READBACKS v1.4 tab 3): the second card of lane 7 - every read-back in one place. */}
        <ReadbacksFlowCard doc={doc} onOpen={() => onOpen({ kind: 'readbacks' })} />
      </FlowSection>
    </div>
  );
}

function FlowSection({
  number,
  title,
  caption,
  count,
  link,
  children,
}: {
  number: number;
  title: string;
  caption: string;
  count: string;
  link?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section className="tenant-flow-section">
      <div className="tenant-flow-rail">
        <span className="tenant-flow-number">{number}</span>
      </div>
      <div className="tenant-flow-content">
        {link && <p className="tenant-flow-link">{link}</p>}
        <div className="tenant-flow-section-head">
          <strong>{title}</strong>
          <small>{caption}</small>
          <em>{count}</em>
        </div>
        <div className="tenant-flow-row">{children}</div>
      </div>
    </section>
  );
}

function FlowCard({
  kind,
  badge,
  title,
  description,
  color,
  selected,
  disabled,
  warning,
  action,
  onAction,
  onClick,
  onMoveUp,
  onMoveDown,
  canMoveUp,
  canMoveDown,
  orderLabel,
  onEdit,
  onRename,
  onDelete,
  onToggleEnabled,
  onCopy,
  onShare,
  onUnshare,
}: {
  kind: string;
  badge: string;
  title: string;
  description: string;
  color: string;
  selected?: boolean;
  disabled?: boolean;
  // v12.4.16 (#505): this card is UNREACHABLE - an earlier card ends every branch before the call gets here.
  // It is not a style flag: it is set only by strandedInIntent, and only for a card that is switched ON.
  warning?: string;
  action?: string;
  onAction?: () => void;
  onClick: () => void;
  // v12.2.25.0 (#159b): reorder controls, now surfaced through the card ⋯ menu (v12.2.34.0 #185/#187).
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
  orderLabel?: string;
  // v12.2.34.0 (#185): inline rename + delete via the card ⋯ menu.
  // v12.2.46.0 (#259): ⋯ Edit opens the full editor drawer (intents) instead of inline rename.
  onEdit?: () => void;
  onRename?: (name: string) => void;
  onDelete?: () => void;
  // v12.2.47.5 (#270): Disable/Enable from the card menu (node cards only for now).
  onToggleEnabled?: () => void;
  // v12.3.11 (#312): promote a node to shared (runs in every intent) / demote it back to this intent only.
  onShare?: () => void;
  onUnshare?: () => void;
  onCopy?: () => void;   // v12.3.5: copy this card to another intent (node cards)
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [renaming, setRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState(title);
  const hasMenu = Boolean(onEdit || onRename || onDelete || onMoveUp || onMoveDown || onToggleEnabled || onCopy);
  const stop = (event: React.SyntheticEvent) => event.stopPropagation();
  // v12.2.35.0 (#190): the menu is PORTALED to <body> with a computed fixed position, so a hovered card's
  // transform can no longer clip it or turn a fixed scrim card-relative (the old flicker + multi-open bug).
  const menuBtnRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [menuPos, setMenuPos] = useState<{ top: number; left: number } | null>(null);
  function toggleMenu() {
    if (menuOpen) { setMenuOpen(false); return; }
    const r = menuBtnRef.current?.getBoundingClientRect();
    if (r) { const width = 160; let left = r.right - width; if (left < 8) left = 8; setMenuPos({ top: r.bottom + 6, left }); }
    setMenuOpen(true);
  }
  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    const onDown = (event: PointerEvent) => {
      const t = event.target as Node;
      if (menuRef.current?.contains(t) || menuBtnRef.current?.contains(t)) return;
      setMenuOpen(false);
    };
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('keydown', onKey);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      document.removeEventListener('pointerdown', onDown, true);
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [menuOpen]);
  function commitRename() {
    const value = renameValue.trim();
    if (value && value !== title) onRename?.(value);
    setRenaming(false);
  }
  return (
    <article
      className={`tenant-flow-card ${selected ? 'selected' : ''}${disabled ? ' is-disabled' : ''}${warning ? ' is-unreachable' : ''}`}
      data-kind={kind}
      style={{ '--card-color': color } as React.CSSProperties}
      onClick={renaming ? undefined : onClick}
      role="button"
      tabIndex={0}
      onKeyDown={event => {
        if (!renaming && (event.key === 'Enter' || event.key === ' ')) onClick();
      }}
    >
      {/* v12.2.34.0 (#185/#187): top-right controls — "+" add-child (if any) and the ⋯ actions menu.
          The old inline ◀/▶ reorder row (which overlapped the badge/label header) is gone; reorder now
          lives in the ⋯ menu, and node run-order shows as a small badge in the kind row. */}
      <div className="tenant-flow-card-controls" onClick={stop}>
        {action && (
          <button className="tenant-flow-card-action" type="button" aria-label={action}
            onClick={event => { event.stopPropagation(); onAction?.(); }}>{action}</button>
        )}
        {hasMenu && (
          <button ref={menuBtnRef} className="tenant-flow-card-menu-btn" type="button" aria-label="More actions" aria-haspopup="menu"
            onClick={event => { event.stopPropagation(); toggleMenu(); }}>&#8942;</button>
        )}
      </div>
      {menuOpen && menuPos && createPortal(
        <div ref={menuRef} className="tenant-flow-card-menu" role="menu"
          style={{ position: 'fixed', top: menuPos.top, left: menuPos.left }} onClick={stop}>
          {/* v12.2.47.9 (#275-B): restore the leading icon on each menu item (dropped in #270). */}
          {(onEdit || onRename) && (
            <button type="button" className="tenant-flow-card-menu-item"
              onClick={event => { event.stopPropagation(); setMenuOpen(false); if (onEdit) { onEdit(); } else { setRenameValue(title); setRenaming(true); } }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">✎</span>Edit</button>
          )}
          {onCopy && (
            <button type="button" className="tenant-flow-card-menu-item"
              onClick={event => { event.stopPropagation(); setMenuOpen(false); onCopy?.(); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">⧉</span>Copy to intent…</button>
          )}
          {/* v12.3.11 (#312): "Copy to intent…" duplicates; this SHARES — one definition every intent runs. */}
          {onShare && (
            <button type="button" className="tenant-flow-card-menu-item"
              onClick={event => { event.stopPropagation(); setMenuOpen(false); onShare?.(); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">⇄</span>Share with all intents…</button>
          )}
          {onUnshare && (
            <button type="button" className="tenant-flow-card-menu-item"
              onClick={event => { event.stopPropagation(); setMenuOpen(false); onUnshare?.(); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">⇤</span>Stop sharing</button>
          )}
          {onMoveUp && (
            <button type="button" className="tenant-flow-card-menu-item" disabled={!canMoveUp}
              onClick={event => { event.stopPropagation(); onMoveUp?.(); setMenuOpen(false); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">←</span>Move earlier</button>
          )}
          {onMoveDown && (
            <button type="button" className="tenant-flow-card-menu-item" disabled={!canMoveDown}
              onClick={event => { event.stopPropagation(); onMoveDown?.(); setMenuOpen(false); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">→</span>Move later</button>
          )}
          {onToggleEnabled && (
            <button type="button" className="tenant-flow-card-menu-item"
              onClick={event => { event.stopPropagation(); setMenuOpen(false); onToggleEnabled?.(); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">{disabled ? '✓' : '⊘'}</span>{disabled ? 'Enable' : 'Disable'}</button>
          )}
          {onDelete && (
            <>
              <div className="tenant-flow-card-menu-sep" />
              <button type="button" className="tenant-flow-card-menu-item is-danger"
                onClick={event => { event.stopPropagation(); setMenuOpen(false); onDelete?.(); }}><span className="tenant-flow-card-menu-ic" aria-hidden="true">🗑</span>Delete</button>
            </>
          )}
        </div>,
        document.body
      )}
      <div className="tenant-flow-card-kind">
        <span>{badge}</span>
        <strong>{kind}</strong>
        {orderLabel && <em className="tenant-flow-card-orderbadge">{orderLabel}</em>}
      </div>
      {renaming ? (
        <input
          className="tenant-flow-card-rename"
          autoFocus
          value={renameValue}
          onClick={stop}
          onMouseDown={stop}
          onChange={event => setRenameValue(event.target.value)}
          onBlur={commitRename}
          onKeyDown={event => {
            event.stopPropagation();
            if (event.key === 'Enter') commitRename();
            else if (event.key === 'Escape') { setRenameValue(title); setRenaming(false); }
          }}
        />
      ) : (
        <h3>{title}</h3>
      )}
      <p>{description}</p>
      {/* v12.4.16 (#505): THE WARNING LIVES ON THE CARD THAT CANNOT RUN. "Enabled" says this card is switched
          on and "3 step(s)" says it is configured; neither says the call will ever arrive. This one line is
          the difference, and it names the route that strands it so the fix is one click away. */}
      {warning && (
        <p className="tenant-flow-card-warn"><span aria-hidden="true">&#9888;</span>{warning}</p>
      )}
      {disabled && <span className="tenant-flow-card-off-br">Disabled</span>}
    </article>
  );
}

function AddCard({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button className="tenant-add-card" type="button" onClick={onClick}>
      + {label}
    </button>
  );
}

// v12.4.16 (#516): WHERE A CALL ENDS WHEN IT RAN EVERY CARD.
//
// Tushar asked the question that found this: "tell me one thing how the system knows which terminal card to
// call after the reference node." It did not. ResolveDefaultTerminal took the document and ignored it, always
// returning thankyou-FAILURE, so a completed booking closed on "I'm sorry we couldn't finish your request just
// now". It was invisible only because the legacy Confirm terminal route (retired in #504) ended those calls
// before the sequence could run out.
//
// DELIBERATELY NOT A NODE. No ordinal badge, no Enabled toggle, no drag, no delete, no kebab - the node count
// chip keeps showing the real number of cards. It is a terminus marker that happens to be editable, and it is
// inline rather than behind a drawer because one field does not earn a drawer.
//
// NO REACHABILITY NOTE HERE. An earlier terminal route is a perfectly correct workflow - Tushar: "if a node
// routes to a terminal earlier, then that is a correct workflow" - so the only thing worth flagging is an
// earlier route that strands an ENABLED node, and that warning belongs on the stranded card (#505).
function EndOfSequenceCard({ doc, value, onChange }: {
  doc: DesignerDocument; value: string; onChange: (key: string) => void;
}) {
  const offTerminals = useOffTerminals();   // v12.10.4 (#1119)
  const terminals = Object.keys(doc.terminal ?? DEFAULT_TERMINALS);
  return (
    <div className="tenant-endseq-card">
      <div className="tenant-endseq-head">
        <span className="tenant-endseq-chip">END</span>
        <span className="tenant-endseq-title">End of sequence</span>
      </div>
      <label className="tenant-endseq-label" htmlFor="endseq-terminal">When every card is done &rarr; go to</label>
      <select
        id="endseq-terminal"
        className="tenant-endseq-select"
        value={value}
        onChange={event => onChange(event.target.value)}
      >
        <option value="">Thank You (Success)</option>
        {terminals.filter(k => k !== 'thankyou').map(k => (
          <option key={k} value={k} disabled={!!offTerminals[k]}>{TERMINAL_LABELS[k] ?? k}{offTerminals[k] ? ` (${offTerminals[k]})` : ''}</option>
        ))}
      </select>
      <p className="tenant-endseq-note">Reached when the last card finishes and nothing has routed the call away.</p>
    </div>
  );
}

function TreeView({
  doc,
  query,
  onQuery,
  onOpen,
  onAddWorkflow,
  onAddIntent,
  onAddNode,
}: {
  doc: DesignerDocument;
  query: string;
  onQuery: (value: string) => void;
  onOpen: (card: CardRef) => void;
  onAddWorkflow: () => void;
  onAddIntent: (workflowId: string) => void;
  onAddNode: (workflowId: string, intentId: string) => void;
}) {
  const needle = query.trim().toLowerCase();
  const visible = (value: string | undefined) => !needle || (value ?? '').toLowerCase().includes(needle);
  // v12.7.2 (#616): the sequence view says it too - the same argument #505 made for Unreachable, and the
  // same badge channel. A node that cannot reach its connected system is as broken as one nothing reaches.
  const treeConnections = useConnectedSystems();
  // v12.4.16 (#505): the sequence view says it too - acceptance is "on its own card AND in the sequence
  // view". Keyed by intent + position, the same pair the rows below are drawn from.
  const strandedRows = new Map(strandedInDocument(doc).map(x => [`${x.intentId}::${x.index}`, x] as const));

  return (
    <section className="tenant-tree-view">
      <input value={query} onChange={event => onQuery(event.target.value)} placeholder="Search workflows, nodes, steps..." />
      <div className="tenant-tree-group">
        <div className="tenant-tree-title">
          <strong>Pre-routing</strong>
        </div>
        {PRE_ROUTING_CARDS.filter(card => visible(card.title) || visible(cardDescriptionForPreRouting(doc, card.key))).map(card => (
          <button key={card.key} className="tenant-tree-row" style={{ '--row-color': card.color } as React.CSSProperties} type="button" onClick={() => onOpen({ kind: 'preRouting', key: card.key })}>
            <span className="tenant-tree-badge" style={{ background: card.color }}>{card.badge}</span>
            <strong>{cardTitleForPreRouting(doc, card.key)}</strong>
            <small>{cardDescriptionForPreRouting(doc, card.key)}</small>
          </button>
        ))}
      </div>

      <div className="tenant-tree-group">
        <div className="tenant-tree-title">
          <strong>Workflows</strong>
          <button type="button" onClick={onAddWorkflow}>+ workflow</button>
        </div>
        {(doc.workflows ?? []).map(workflow => (
          <div key={workflow.id} className="tenant-tree-branch">
            <button className="tenant-tree-row workflow" style={{ '--row-color': HIERARCHY_COLORS.workflow } as React.CSSProperties} type="button" onClick={() => workflow.id && onOpen({ kind: 'workflow', workflowId: workflow.id })}>
              <span className="tenant-tree-badge" style={{ background: HIERARCHY_COLORS.workflow }}>{badgeFor(workflow.name, 'WF')}</span>
              <strong>{workflow.name}</strong>
              <small>{workflow.intents?.length ?? 0} intents</small>
            </button>
            <button className="tenant-tree-add" type="button" onClick={() => workflow.id && onAddIntent(workflow.id)}>+ intent</button>
            {(workflow.intents ?? []).map(intent => (
              <div key={intent.id} className="tenant-tree-branch level-2">
                <button className="tenant-tree-row intent" style={{ '--row-color': HIERARCHY_COLORS.intent } as React.CSSProperties} type="button" onClick={() => workflow.id && intent.id && onOpen({ kind: 'intent', workflowId: workflow.id, intentId: intent.id })}>
                  <span className="tenant-tree-badge" style={{ background: HIERARCHY_COLORS.intent }}>{badgeFor(intent.label, 'IN')}</span>
                  <strong>{intent.label}</strong>
                  <small>{intent.nodes?.length ?? 0} nodes</small>
                </button>
                <button className="tenant-tree-add" type="button" onClick={() => workflow.id && intent.id && onAddNode(workflow.id, intent.id)}>+ node</button>
                {(intent.nodes ?? []).map((node, nodeIndex) => {
                  const stranded = strandedRows.get(`${intent.id ?? ''}::${nodeIndex}`);
                  return (
                  <div key={node.id} className="tenant-tree-branch level-3">
                    <button className={`tenant-tree-row node${stranded ? ' is-unreachable' : ''}`} style={{ '--row-color': nodeColor(node.type) } as React.CSSProperties} type="button" onClick={() => workflow.id && intent.id && node.id && onOpen({ kind: 'node', workflowId: workflow.id, intentId: intent.id, nodeId: node.id })}>
                      <span className="tenant-tree-badge" style={{ background: nodeColor(node.type) }}>{badgeFor(node.type, 'ND')}</span>
                      <strong>{node.label}</strong>
                      <small>{nodeStepCount(node)} steps</small>{/* v12.4.12 (#478 sweep) */}
                      {node.integration && <span className="tenant-tree-int">{node.integration.provider} &middot; {node.integration.operation}</span>}
                      {/* v12.4.16 (#505): unreachable, said in the sequence view too. */}
                      {stranded && <span className="tenant-tree-warn" title={`Unreachable - ${stranded.blocker}.`}>&#9888; Unreachable</span>}
                      {/* v12.7.2 (#616): the connected system this card names is gone. Distinct from Unreachable:
                          the call DOES arrive here, and then the action fails at 0ms with nothing sent. */}
                      {node.integration && connectionIsMissing(node.integration, treeConnections) && (
                        <span className="tenant-tree-warn"
                              title={`"${node.integration.provider || 'This connection'}" is not a configured connected system - open the card and pick one that exists.`}>&#9888; No connection</span>
                      )}
                    </button>
                    {(node.steps ?? []).map(step => (
                      <button key={step.id} className="tenant-tree-row step level-4" style={{ '--row-color': HIERARCHY_COLORS.steps } as React.CSSProperties} type="button" onClick={() => workflow.id && intent.id && node.id && step.id && onOpen({ kind: 'step', workflowId: workflow.id, intentId: intent.id, nodeId: node.id, stepId: step.id })}>
                        <span className="tenant-tree-badge muted">STEP</span>
                        <strong>{step.label}</strong>
                        <small>{step.stores ?? step.kind}</small>
                      </button>
                    ))}
                  </div>
                  );
                })}
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

function TechView({ doc }: { doc: DesignerDocument }) {
  const json = useMemo(() => JSON.stringify(doc, null, 2), [doc]);
  const [copied, setCopied] = useState(false);
  const copy = () => {
    const done = () => { setCopied(true); window.setTimeout(() => setCopied(false), 1500); };
    if (navigator.clipboard?.writeText) { navigator.clipboard.writeText(json).then(done).catch(() => {}); }
    else { try { const ta = document.createElement('textarea'); ta.value = json; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); done(); } catch { /* no-op */ } }
  };
  const download = () => {
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'tenant-workflow-snapshot.json';
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  };
  return (
    <section className="tenant-tech-view">
      <div className="tenant-tech-head">
        <div>
          <strong>Active workflow JSON</strong>
          <p>This is the persisted snapshot that the runtime will use.</p>
        </div>
        <div className="tenant-tech-actions">
          <button type="button" className="tenant-secondary" onClick={copy}>{copied ? 'Copied ✓' : 'Copy'}</button>
          <button type="button" className="tenant-secondary" onClick={download}>Download</button>
        </div>
      </div>
      <pre>{json}</pre>
    </section>
  );
}

function RuntimePreview({
  text,
  onText,
  onRun,
  running,
  simulation,
}: {
  text: string;
  onText: (value: string) => void;
  onRun: () => void;
  running: boolean;
  simulation: SimulationResult | null;
}) {
  return (
    <section className="tenant-runtime-preview">
      <div>
        <strong>Runtime simulator</strong>
        <p>Try a caller phrase against this workflow snapshot.</p>
      </div>
      <div className="tenant-runtime-controls">
        <input value={text} onChange={event => onText(event.target.value)} />
        <button className="tenant-secondary" type="button" onClick={onRun} disabled={running}>{running ? 'Running...' : 'Preview runtime'}</button>
      </div>
      {simulation && (
        <div className="tenant-runtime-result">
          <strong>{simulation.status === 'classified' ? `${simulation.workflow} / ${simulation.intent}` : 'Fallback needed'}</strong>
          <span>{simulation.message}</span>
          {simulation.path.slice(0, 4).map(node => (
            <small key={`${node.nodeId}-${node.nodeType}`}>{node.nodeType}: {node.label}</small>
          ))}
        </div>
      )}
    </section>
  );
}

function DeleteCardDialog({ name, kindLabel, childCount, childNoun, saving, onCancel, onConfirm }: {
  name: string;
  kindLabel: string;
  childCount: number;
  childNoun: string;
  saving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const requiresType = childCount > 0;
  const [text, setText] = useState('');
  const matched = text.trim() === name.trim();
  const canDelete = !requiresType || matched;
  const childLabel = `${childCount} ${childNoun}${childCount === 1 ? '' : 's'}`;
  return (
    <div className="tenant-dialog-backdrop" onClick={saving ? undefined : onCancel}>
      <div className="tenant-delete-dialog" onClick={event => event.stopPropagation()}>
        <div className="tenant-delete-head">
          <span className="tenant-delete-warn">!</span>
          <div>
            <h3>Delete &ldquo;{name}&rdquo;?</h3>
            {requiresType ? (
              <p>This removes it <b>and its {childLabel}</b> and everything inside. This can&rsquo;t be undone.</p>
            ) : (
              <p>This {kindLabel} is empty. This can&rsquo;t be undone.</p>
            )}
          </div>
        </div>
        {requiresType && (
          <div className="tenant-delete-confirm">
            <label>Type <b>{name}</b> to confirm</label>
            <input autoFocus value={text} placeholder={name} className={matched ? 'is-ok' : ''}
              onChange={event => setText(event.target.value)} />
          </div>
        )}
        <div className="tenant-delete-actions">
          <button type="button" className="tenant-secondary" onClick={onCancel} disabled={saving}>Cancel</button>
          <button type="button" className="tenant-delete-danger" onClick={onConfirm} disabled={!canDelete || saving}>
            {saving ? 'Deleting...' : `Delete ${kindLabel}`}
          </button>
        </div>
      </div>
    </div>
  );
}

function WorkflowDrawer({
  card,
  doc,
  activeLanguage,
  languages,
  onLanguage,
  onDone,
  onCancel,
  onRemoveNode,
  saving,
  onUpdate,
  onToggleCardEnabled,
  onOpenCard,
  phoneRef,
}: {
  card: CardRef;
  doc: DesignerDocument;
  activeLanguage: string;
  languages: Array<{ code: string; displayName: string; isEnabled: boolean }>;
  onLanguage: (code: string) => void;
  onDone: () => void;
  // v12.9.21 (#865): the drawer's Done must commit the embedded Phone & Activation section, which owns its
  // own draft. The ref lives in the parent because that is where onDone is defined; it is threaded rather
  // than duplicated so there is exactly one commit path. UI Principles v1.4 §12.
  phoneRef: React.MutableRefObject<PhoneActivationHandle | null>;
  // v12.3.12 (#322): explicit=false means the close was a backdrop click, which asks before discarding edits.
  onCancel: (explicit?: boolean) => void;
  onRemoveNode?: () => void;
  saving: boolean;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
  onToggleCardEnabled?: (card: CardRef) => void;   // v12.3.3 (#238 . 238-k)
  // v12.4.0 (#400): jump straight from one editor to another. The interceptor's keyword summary is a MIRROR of
  // data owned by the terminal cards, so each row has to be able to take you to the card that owns it - a
  // read-only list that tells you to go and find stage 6 yourself is the thing Tushar objected to.
  onOpenCard?: (card: CardRef) => void;
}) {
  // Hook must run before any early return (rules of hooks). Shares the AI-Agent query cache.
  const phoneHandles = usePhoneHandlesLabel();
  // v12.10.1 (#1086): the Outside operator line decides whether Route to operator can be enabled.
  const { data: handoffView } = useQuery<HandoffSettingsView>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<HandoffSettingsView>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  // v12.2.34.0 (#184): only close on a backdrop click that STARTED on the backdrop (a text-selection drag
  // ending on the backdrop must NOT close/discard the drawer).
  const backdropMouseDown = useRef(false);
  const context = findCardContext(doc, card);
  if (!context) return null;

  const isInbound = card.kind === 'preRouting' && card.key === 'inbound';
  const isGreeting = card.kind === 'preRouting' && card.key === 'greeting';
  const isIdCheck = card.kind === 'preRouting' && card.key === 'idCheck';   // v12.10.17 (#1747)
  // v12.2.23.0 (#145): node cards can now be enabled/disabled too (park a node until it's ready).
  const nodeForCard = (card.kind === 'node' || card.kind === 'sharedNode') ? findNode(doc, card) : null;
  const cardEnabled = card.kind === 'preRouting'
    ? preRoutingEnabled(doc, card.key)
    : card.kind === 'node' ? (nodeForCard?.enabled ?? true)
    : card.kind === 'terminal' ? (card.terminalKey === 'fallback' ? operatorLineOn(handoffView) : doc.terminalConfig?.[card.terminalKey]?.enabled !== false)   // v12.3.3 (#238 . 238-k); v12.10.2 (#1097): Route to operator follows the Outside operator line
    : card.kind === 'interceptor' ? (doc.interceptor?.enabled !== false)                        // v12.3.3 (#238 . 238-k)
    : card.kind === 'readbacks' ? (doc.readbacks?.enabled !== false)                            // v12.10.21 (#1957): the master switch
    : true;
  // v12.3.3 (#238 . D-05): the terminal switch is live except for the two locked safety-net terminals.
  // v12.10.1 (#1086): Route to operator cannot be switched ON while the Outside operator line is off (it can be switched off).
  const operatorBlocked = card.kind === 'terminal' && card.terminalKey === 'fallback';   // v12.10.2 (#1097): no switch of its own - it follows the line
  const canToggleEnabled = (card.kind === 'preRouting' && card.key !== 'inbound')
    || card.kind === 'node'
    || (card.kind === 'terminal' && !TERMINAL_LOCKED.has(card.terminalKey) && !operatorBlocked)
    || card.kind === 'interceptor'
    || card.kind === 'readbacks';   // v12.10.21 (#1957): the Read-backs master switch is the drawer's Enabled switch (prototype v1.4)
  // Language tabs appear only where content is language-specific (Disclosure, Greeting). Universal
  // cards (Inbound, Hours, Language detect, Classify) drop them. Non pre-routing cards are unchanged.
  const langTabKeys: PreRoutingKey[] = ['disclosure', 'greeting'];
  // v12.2.47.9 (#276-U2): EVERY node editor now renders its own EN/ES rail BELOW the main section (like the Request
  // node already did), so suppress the drawer-header language strip for ALL node kinds — not just Request.
  // v12.3.6 (#238 Card Layout Standard v1.0): the drawer-header strip now renders ONLY for the pure per-language
  // pre-routing cards (Greeting / Disclosure). Terminal + Step render their OWN inline strip between the two boxes;
  // Workflow + Intent have no per-language content so they get no strip at all.
  // ══ v12.9.22 (#883 / BDR-015 R2): THE HEADER STRIP RETIRES. ═══════════════════════════════════════
  // The 12.3.6 decision moved the language strip out of the drawer header and INTO each editor. It reached
  // the Node, Step and Terminal editors and stopped - which is why Identity (a Node editor) looked right to
  // him and Disclosure did not. Now that Hours, Disclosure and Greeting carry their own, a header strip
  // would be a SECOND control for the same state on the same screen. His rule: "it has to be universal".
  // v12.10.7 (#937): the dead header strip (showLanguageTabs = false) and its .tenant-drawer-languages markup are deleted.
  // Inbound and Greeting are ALWAYS-ON entry points (no Enabled toggle): Inbound IS the entry point;
  // Greeting can't be disabled or the call goes silent. The Interceptor is a global always-on layer, so no toggle
  // either. Every other card gets the header switch.
  // v12.3.3 (#238 . 238-k): terminal + interceptor keep the header Enabled toggle AND the ⋮-menu Disable (both confirm, same field).
  // v12.3.3 (#238 . 238-k): terminal + interceptor get the drawer Enabled switch back.
  // v12.9.27 (#1042): the Phrases lane is not a card that can be turned off - no Enabled switch on its drawer.
  const showMaster = !isInbound && !isGreeting && card.kind !== 'phrases';
  const subtitle = isInbound ? phoneHandles : context.subtitle;

  return (
    <div
      className="tenant-workflow-drawer-backdrop"
      onMouseDown={event => { backdropMouseDown.current = event.target === event.currentTarget; }}
      onClick={event => { if (!saving && backdropMouseDown.current && event.target === event.currentTarget) onCancel(false); }}>   {/* v12.3.12 (#322): backdrop = accidental, ask first */}
      <aside className="tenant-workflow-drawer" onClick={event => event.stopPropagation()}>
        {/* v12.2.16.0: Enabled toggle stays in the right cluster with its caption, separated from the
            close button by a divider so they read as distinct controls (fixes the earlier floating-X). */}
        <header style={{ '--drawer-color': context.color } as React.CSSProperties}>
          <div className="tenant-drawer-headmain">
            <h2>{context.title}</h2>
            <p>{subtitle}</p>
          </div>
          <div className="tenant-drawer-headtools">
            {showMaster && (
              <>
                <label className={`tenant-head-switch${cardEnabled ? '' : ' is-off'}`} title={operatorBlocked ? (cardEnabled ? 'On - the Outside operator line is set and Verified (AI Agent › Handoff).' : 'Off - type the Outside operator line and Verify it in AI Agent › Handoff to turn this card on.') : isIdCheck ? (cardEnabled ? 'Enabled - the contact book is checked on every call, before the first word' : 'Disabled - calls run exactly as on 10/15: no lookup, no question, the Regular greeting') : card.kind === 'readbacks' ? (cardEnabled ? 'Enabled - a doubtful answer is read back when its field is switched on below' : 'Off - nothing the caller said is spoken back') : cardEnabled ? 'Enabled — this step runs on every call' : 'Disabled — this step is skipped on every call'}>
                  <b>{cardEnabled ? 'Enabled' : 'Disabled'}</b>
                  <span className="tenant-head-track">
                    <input type="checkbox" checked={cardEnabled} disabled={!canToggleEnabled} onChange={event => {
                      const value = event.target.checked;
                      // v12.3.3 (#238 . 238-k/D-07): terminal + interceptor route through the confirm-guarded handler
                      // (same as the ⋮ menu), so both paths prompt and write the same enabled field.
                      if (card.kind === 'terminal' || card.kind === 'interceptor') { onToggleCardEnabled?.(card); return; }
                      onUpdate(next => {
                        if (card.kind === 'preRouting') {
                          next.preRouting ??= {};
                          (next.preRouting as Record<string, unknown>)[card.key] = { ...(next.preRouting[card.key] as object | undefined), isEnabled: value };
                        } else if (card.kind === 'node') {
                          const target = findNode(next, card);   // v12.2.23.0 (#145): persist node enable/disable
                          if (target) target.enabled = value;
                        } else if (card.kind === 'readbacks') {
                          next.readbacks = { ...(next.readbacks ?? {}), enabled: value };   // v12.10.21 (#1957): doc.readbacks.enabled
                        }
                      });
                    }} />
                    <i />
                  </span>
                </label>
                <span className="tenant-head-divider" aria-hidden="true" />
              </>
            )}
            <button type="button" className="tenant-drawer-close" onClick={() => onCancel(true)} disabled={saving}>x</button>
          </div>
        </header>
        {/* v12.10.5 (#1129): the held switch says why, with the way to fix it. */}
        {operatorBlocked && !cardEnabled && (
          <div className="tenant-field-note" style={{ margin: '10px 20px 0', color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 7, padding: '6px 10px' }}>
            {operatorWhy(handoffView)} <a href={HANDOFF_SETTINGS_PATH}>AI Agent › Handoff › After hours</a>.
          </div>
        )}


        <OpenCardContext.Provider value={onOpenCard ?? null}>{/* v12.10.21 (#1957): the step pointer line opens the Read-backs card */}
        <div className="tenant-drawer-content">
          {isInbound && (
            <PhoneActivationSection ref={phoneRef} embedded />
          )}
          {card.kind === 'preRouting' && !isInbound && (
            <PreRoutingEditor cardKey={card.key} doc={doc} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />
          )}
          {card.kind === 'workflow' && (
            <WorkflowEditor card={card} doc={doc} onUpdate={onUpdate} language={activeLanguage} languages={languages} onLanguage={onLanguage} />
          )}
          {card.kind === 'intent' && (
            <IntentEditor card={card} doc={doc} onUpdate={onUpdate} language={activeLanguage} languages={languages} onLanguage={onLanguage} />
          )}
          {/* v12.3.11 (#312): a shared node uses the SAME editor — findNode resolves it, so edits apply everywhere. */}
          {card.kind === 'sharedNode' && (
            <NodeEditor card={card} doc={doc} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />
          )}
          {card.kind === 'node' && (nodeForCard?.type === 'Request' ? (
            <RequestNodeEditor card={card} doc={doc} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />
          ) : (
            <NodeEditor card={card} doc={doc} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} onRemove={onRemoveNode} />
          ))}
          {card.kind === 'step' && (
            <StepEditor card={card} doc={doc} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />
          )}
          {card.kind === 'terminal' && (
            <TerminalEditor card={card} doc={doc} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />
          )}
          {card.kind === 'interceptor' && (
            <InterceptorEditor doc={doc} language={activeLanguage} languages={languages}
              onLanguage={onLanguage} onUpdate={onUpdate} onOpen={onOpenCard} />
          )}
          {card.kind === 'phrases' && (
            <PhrasesEditor language={activeLanguage} languages={languages} onLanguage={onLanguage} />
          )}
          {card.kind === 'readbacks' && (
            <ReadbacksEditor doc={doc} focus={card.focus} language={activeLanguage} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />
          )}
        </div>
        </OpenCardContext.Provider>

        <footer>
          <span>{saving ? 'Saving…' : isIdCheck ? 'Ready · Off = calls run exactly as on 10/15' : 'Ready'}</span>
          <button className="tenant-secondary" type="button" onClick={() => onCancel(true)} disabled={saving}>Cancel</button>
          <button className="tenant-primary" type="button" onClick={onDone} disabled={saving}>{saving ? 'Saving…' : 'Done'}</button>
        </footer>
      </aside>
    </div>
  );
}

// Per-card bespoke editors. The prototype's one-size-fits-all layout is gone — each pre-routing card
// now renders exactly the controls that make sense for it (Inbound is handled upstream by
// PhoneActivationSection and never reaches here).
function PreRoutingEditor({
  cardKey,
  doc,
  language,
  languages,
  onLanguage,
  onUpdate,
}: {
  cardKey: PreRoutingKey;
  doc: DesignerDocument;
  language: string;
  // v12.9.22 (#883 / BDR-015 R2): the strip belongs INSIDE each editor, so each editor needs the set and
  // the setter. Step/Terminal/Node editors have had them since 12.3.6; the pre-routing cards never did.
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const card = PRE_ROUTING_CARDS.find(item => item.key === cardKey)!;
  if (cardKey === 'hours') return <HoursEditor doc={doc} language={language} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} card={card} />;
  if (cardKey === 'disclosure') return <DisclosureEditor doc={doc} language={language} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />;
  if (cardKey === 'idCheck') return <IdCheckEditor doc={doc} language={language} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} />;   // v12.10.17 (#1747)
  if (cardKey === 'greeting') return <GreetingEditor doc={doc} language={language} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} card={card} />;
  if (cardKey === 'language') return <LanguageDetectEditor doc={doc} language={language} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} card={card} />;
  if (cardKey === 'classify') return <ClassifyEditor doc={doc} language={language} languages={languages} onLanguage={onLanguage} onUpdate={onUpdate} card={card} />;
  return <GenericPreRoutingEditor cardKey={cardKey} doc={doc} onUpdate={onUpdate} card={card} />;
}

type PreCard = { title: string; description: string };

// Name + Purpose sit side by side on every card. Name shows on the flow card; Purpose is the short
// "what this card is for" line.
function NamePurposeRow({ cardKey, doc, card, onUpdate }: {
  cardKey: PreRoutingKey; doc: DesignerDocument; card: PreCard;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const custom = doc.preRouting?.[cardKey] as { label?: string; description?: string } | undefined;
  const patchField = (field: 'label' | 'description', value: string) => onUpdate(next => {
    next.preRouting ??= {};
    next.preRouting[cardKey] = { ...(next.preRouting[cardKey] as object | undefined), [field]: value };
  });
  return (
    <div className="tenant-field-row">
      <TextField label="Name" help={[['What it does', 'The internal name for this card, shown on the workflow canvas. A label for you and your team — never spoken to the caller.'], ['When it fires', 'Used only in the builder to identify the card; it has no effect on the live call.'], ['Example', 'Rename the greeting card to “Welcome + hours note” so you can spot it on the canvas at a glance.']]} value={custom?.label ?? card.title} onChange={value => patchField('label', value)} />
      <TextField label="Purpose" help={[['What it does', 'An optional internal note describing what this card is for. Not spoken to the caller.'], ['When it fires', 'Shown only in the builder; it never affects the call flow.'], ['Example', 'Note “Plays the HIPAA recording notice” so a teammate knows why the card exists.']]} value={custom?.description ?? card.description} onChange={value => patchField('description', value)} />
    </div>
  );
}

// CARD 2 — Hours check. Name/Purpose, after-hours routing, and an On-fail that is locked to
// Voicemail (the only recovery style that means anything for an hours gate; never blank).
function HoursEditor({ doc, language, languages, onLanguage, onUpdate, card }: {
  doc: DesignerDocument; card: PreCard; language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const tok = useTokenSource(doc);   // v12.4.1 (#405)

  const hours = (doc.preRouting?.hours ?? {}) as { afterHoursRouting?: string; onFail?: string; afterHoursMessage?: string | Record<string, string> };
  // v12.9.22 (#883): the closed message is per language now. A tenant who has never opened this card still
  // has the single 12.3.6 string; it is read as the PRIMARY language's text and is not rewritten until they
  // actually edit something, so nothing changes under anyone by merely opening the screen.
  const ahmRaw = hours.afterHoursMessage;
  const ahmMap: Record<string, string> = typeof ahmRaw === 'string'
    ? (ahmRaw ? { [primaryLangCode(doc)]: ahmRaw } : {})
    : (ahmRaw ?? {});
  const ahmText = ahmMap[language] ?? '';
  const cl = useCardLines();   // v12.10.10 (#1408)
  return (
    <>
    <div className="tenant-drawer-section">
      <SectionTitle title="Hours check settings" help={[
        ['What it does', 'Routes the call the moment it arrives based on whether the office is open or closed, using your configured business hours + holidays.'],
        ['When it fires', 'At the very start of every call, before the greeting. It can only ever fall back to Voicemail (clarify-then-keypad / re-ask / operator do nothing here), so On fail stays locked to Voicemail.'],
        ['Example', 'A call at 9pm on a weekday is outside hours → the hours check routes it straight to after-hours handling (e.g. voicemail) instead of the normal agent flow.'],
      ]} />
      <NamePurposeRow cardKey="hours" doc={doc} card={card} onUpdate={onUpdate} />
      <SelectField
        label="After-hours routing"
        help={[['What it does', 'Chooses where a call goes when it arrives OUTSIDE business hours — take a voicemail, run the AI agent anyway, or hand off to a number.'], ['When it fires', 'Only when the hours check finds the office closed (outside your configured hours/holidays).'], ['Example', 'Set to Voicemail → after-hours callers hear the closed message and leave a message instead of reaching the agent.']]}
        value={hours.afterHoursRouting ?? 'voicemail'}
        options={['voicemail', 'ai_agent', 'handover']}
        labels={{ voicemail: 'Voicemail', ai_agent: 'AI Agent', handover: 'Handover' }}
        onChange={value => onUpdate(next => {
          next.preRouting ??= {};
          const h = (next.preRouting.hours ?? {}) as Record<string, unknown>;
          h.afterHoursRouting = value;
          next.preRouting.hours = h;
        })}
      />
      <SelectField
        label="On fail"
        help={[['What it does', 'The fallback for an hours check. An hours check can only ever fall back to voicemail, so this is locked to Voicemail.'], ['When it fires', 'If the hours check itself cannot route the call.'], ['Example', 'Always Voicemail — clarify-then-keypad, re-ask and operator do nothing for an hours check.']]}
        value="voicemail"
        options={['voicemail']}
        labels={{ voicemail: 'Voicemail' }}
        onChange={() => onUpdate(next => {
          next.preRouting ??= {};
          const h = (next.preRouting.hours ?? {}) as Record<string, unknown>;
          h.onFail = 'voicemail';
          next.preRouting.hours = h;
        })}
      />
    </div>

    {/* v12.10.7 (#937, §37): the rail sits BELOW the settings box and above the per-language After-hours message - the
        12.9.22 comment said so and the strip still rendered first. */}
    <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />
    {/* v12.3.6 (#238-C): dedicated after-hours message, spoken once before the closed call drops to voicemail.
        Default language only - the caller has not chosen a language yet at the hours check. */}
    <div className="tenant-drawer-section">
      <SectionTitle title="After-hours message" note="spoken before voicemail" help={[['What it does', 'The line a caller hears when they reach you OUTSIDE business hours, played once before they are sent to voicemail.'], ['When it fires', 'Only when the hours check finds the office closed and after-hours routing is Voicemail.'], ['Example', '"Thank you for calling. Our office is closed right now - please leave a message and we will call you back."']]} />
      <div className="tenant-form-field">
        {/* v12.10.10 (#1408): the 'Closed message' caption is gone; blank = the template default, spoken and shown as written text. */}
        <PromptEditor value={ahmText} rows={3} language={language} groups={tok.groups} known={tok.known}
          platformDefault={cl('hours.closedMessage', language)} translateSourceDefault={cl('hours.closedMessage', primaryLangCode(doc))}
          translateSource={ahmMap[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
          onChange={value => onUpdate(next => {
            next.preRouting ??= {};
            const h = (next.preRouting.hours ?? {}) as Record<string, unknown>;
            const prev = h.afterHoursMessage;
            // Migrate the legacy string onto the primary language the first time anything is edited.
            const map: Record<string, string> = typeof prev === 'string'
              ? (prev ? { [primaryLangCode(next)]: prev } : {})
              : ({ ...(prev as Record<string, string> ?? {}) });
            if (value) map[language] = value; else delete map[language];
            h.afterHoursMessage = map;
            next.preRouting.hours = h;
          })} />
        <small className="tenant-field-note">Played once when a call arrives outside business hours, before the caller is sent to voicemail. Written per language; the call speaks whichever language is set as <strong>Primary</strong> in Organization settings, because the caller&rsquo;s own language is not detected until classify.</small>
      </div>
    </div>
    </>
  );
}

// CARD 3 — Disclosure. A repeatable list of spoken announcements. Each block is read aloud in order
// at the start of the call (announcement, not a question), then the agent moves on. Language-specific.
function DisclosureEditor({ doc, language, languages, onLanguage, onUpdate }: {
  doc: DesignerDocument; language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const tok = useTokenSource(doc);   // v12.4.1 (#405)
  const blocks = disclosureBlocks(doc, language);
  // Every mutation writes the FULL resolved block list back (so the seeded defaults persist on first
  // edit) under preRouting.disclosure.blocks, preserving the isEnabled flag set by the master toggle.
  const commit = (mutate: (arr: DisclosureBlock[]) => DisclosureBlock[]) => onUpdate(next => {
    next.preRouting ??= {};
    const current = disclosureBlocks(next, language).map(b => ({ ...b, text: { ...b.text } }));
    const prev = (next.preRouting.disclosure ?? {}) as DisclosureConfig;
    next.preRouting.disclosure = { ...prev, blocks: mutate(current) };
  });
  return (
    <>
      {/* v12.10.7 (#937, §37): no settings box on this card, so the rail comes first - the position was right, the
          retired strip's format was not. */}
      <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />
    <div className="tenant-drawer-section">
      <SectionTitle title="Disclosure announcements" note={`Spoken to every caller · ${language.toUpperCase()}`} help={[
        ['What it does', 'Announcements read aloud, in order, at the very start of every call — they are statements, not questions, so the caller is not asked to respond.'],
        ['When it fires', 'Right after the hours check and before the greeting. Turn a block off to skip it; add as many as you need with “+ Add disclosure”.'],
        ['Example', 'A recording-consent line — “This call may be recorded for quality and care coordination” — plays first, then the agent greets the caller.'],
      ]} />
      <div className="tenant-disclosure-list">
        {blocks.map((block, index) => (
          <DisclosureBlockCard
            key={block.id}
            block={block}
            language={language}
            tok={tok}
            sourceText={block.text[primaryLangCode(doc)] ?? ''}
            sourceLang={primaryLangCode(doc)}
            onCaption={value => commit(arr => { arr[index] = { ...arr[index], caption: value }; return arr; })}
            onToggle={value => commit(arr => { arr[index] = { ...arr[index], enabled: value }; return arr; })}
            onText={value => commit(arr => { arr[index] = { ...arr[index], text: { ...arr[index].text, [language]: value } }; return arr; })}
            onRemove={() => commit(arr => arr.filter((_, i) => i !== index))}
          />
        ))}
      </div>
      <button type="button" className="tenant-add-block" onClick={() => commit(arr => [...arr, { id: nextDisclosureId(arr), caption: 'New disclosure', enabled: true, text: {} }])}>
        + Add disclosure
      </button>
    </div>
    </>
  );
}

function DisclosureBlockCard({ block, language, tok, sourceText, sourceLang, onCaption, onToggle, onText, onRemove }: {
  block: DisclosureBlock;
  language: string;
  tok: { groups: TokenGroup[]; known: string[] };   // v12.4.1 (#405)
  sourceText?: string;
  sourceLang?: string;
  onCaption: (value: string) => void;
  onToggle: (value: boolean) => void;
  onText: (value: string) => void;
  onRemove: () => void;
}) {
  const text = block.text[language] ?? '';
  return (
    <div className={`tenant-disclosure-block${block.enabled ? '' : ' is-off'}`}>
      <div className="tenant-disclosure-head">
        <input className="tenant-disclosure-caption" value={block.caption} onChange={event => onCaption(event.target.value)} placeholder="Caption" />
        <label className="tenant-mini-switch">
          <input type="checkbox" checked={block.enabled} onChange={event => onToggle(event.target.checked)} />
          <span />
        </label>
        <button type="button" className="tenant-disclosure-remove" onClick={onRemove} aria-label="Remove disclosure">×</button>
      </div>
      {/* Shared prompt component: grouped Insert-token panel + persistent PREVIEW with a ▶ Play button. */}
      <PromptEditor value={text} onChange={onText} silentWhenBlank blankNote="Blank = this announcement is skipped." rows={2} language={language} groups={tok.groups} known={tok.known} translateSource={sourceText} translateSourceLang={sourceLang} />
    </div>
  );
}

// ══ v12.10.17 (T123 #1747, UI-PROTO-ID-CHECK-T123 v1.1 tab 2 - LOCKED): THE ID CHECK CARD ═══════════════════════════════════
// Designer JSON: preRouting.idCheck = { isEnabled, verifiedAfter, skipExternalId, prompts: { verified:{lang}, shared:{lang}, afterNo:{lang} } }.
// v12.10.21 (#1917, contract C1): verifiedAfter 0..10 (0 = every contact on the phone counts as verified; template default 3);
// skipExternalId absent = ON (a contact with an External ID counts as verified on its first call); match fields shown read-only.
// The engine reads it in WorkflowDesignerDocument.ReconcileIdCheck. A blank prompt = the platform line (idcheck.*), shown as
// written text in its box. Source 2 (the practice system API) is FUTURE (#1774) and cannot be switched on.
interface IdCheckConfig {
  isEnabled?: boolean;
  label?: string;
  description?: string;
  verifiedAfter?: number;
  skipExternalId?: boolean;   // v12.10.21 (#1917): absent = true (template default ON)
  prompts?: { verified?: Record<string, string>; shared?: Record<string, string>; afterNo?: Record<string, string> };
}
// {contact.*} resolves only on this card's question, so only this card offers it (PromptEditor.catalogGroups leaves it out).
const CONTACT_TOKEN_GROUP: TokenGroup = { label: 'Contact', tokens: ['contact.firstName', 'contact.lastName', 'contact.name'] };
const ID_CHECK_VERIFIED_DEFAULT = 3;

function IdCheckEditor({ doc, language, languages, onLanguage, onUpdate }: {
  doc: DesignerDocument; language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const tok = useTokenSource(doc);
  const groups = useMemo(() => [CONTACT_TOKEN_GROUP, ...tok.groups], [tok.groups]);
  const known = useMemo(() => [...CONTACT_TOKEN_GROUP.tokens, ...tok.known], [tok.known]);
  const cl = useCardLines();
  const ic = (doc.preRouting?.idCheck ?? {}) as IdCheckConfig;
  const primary = primaryLangCode(doc);
  const patch = (mutate: (obj: IdCheckConfig) => void) => onUpdate(next => {
    next.preRouting ??= {};
    const obj = { ...((next.preRouting.idCheck ?? {}) as IdCheckConfig) };
    obj.prompts = { ...(obj.prompts ?? {}) };
    mutate(obj);
    next.preRouting.idCheck = obj;
  });
  const setPrompt = (which: 'verified' | 'shared' | 'afterNo', value: string) => patch(obj => {
    const map = { ...((obj.prompts?.[which] ?? {}) as Record<string, string>) };
    if (value) map[language] = value; else delete map[language];
    obj.prompts = { ...(obj.prompts ?? {}), [which]: map };
  });
  // v12.10.21 (#1917): 0 is a real value now (0..10) - only an absent / out-of-range value falls back to the template default.
  const n = typeof ic.verifiedAfter === 'number' && ic.verifiedAfter >= 0 && ic.verifiedAfter <= 10 ? Math.round(ic.verifiedAfter) : ID_CHECK_VERIFIED_DEFAULT;
  const skipExternalId = ic.skipExternalId !== false;   // v12.10.21 (#1917): template default ON
  const lines: { which: 'verified' | 'shared' | 'afterNo'; caption: string; note: string }[] = [
    { which: 'verified', caption: 'One contact on this phone, verified',
      note: 'Yes → contact linked, name + date of birth confirmed (not asked again in Identity, still read back at Confirm) → Greeting “ID matched”. No → the line below, once.' },
    { which: 'shared', caption: 'Shared phone, or not yet verified',
      note: 'The answer is matched to the contacts on this phone only. Match → linked → Greeting “ID matched”. No match → Greeting “Regular”, nothing filled.' },
    { which: 'afterNo', caption: 'After a “no”', note: 'Asked once, then the Greeting either way.' },
  ];
  return (
    <>
      <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />
      <div className="tenant-drawer-section">
        <SectionTitle title="Where the match comes from" note="All languages" help={[
          ['What it does', 'Looks the caller’s phone number up before the first word, in the order below. A source only runs when the ones above it found nothing.'],
          ['When it fires', 'At the start of the call - silent, the caller hears ringing. Hard limit 1 second, then "not found" and the call goes on as today.'],
          ['Example', '(908) 555-0133 is on two contacts - Mario Lopez and Maria Lopez - so the shared-phone line is used.'],
        ]} />
        <div className="tenant-disclosure-list">
          <div className="tenant-disclosure-block">
            <div className="tenant-disclosure-head">
              <input className="tenant-disclosure-caption" value="1 · Contact book (phone number)" readOnly />
              <label className="tenant-mini-switch" title="The contact book is the source this build uses"><input type="checkbox" checked disabled readOnly /><span /></label>
            </div>
            <small className="tenant-field-note">Matches only the contacts on the caller's phone number - Phone 1 to 4. No search by name or date of birth.</small>{/* v12.10.21 (#1917): Phone 1-4 (D6) */}
          </div>
          <div className="tenant-disclosure-block is-off">
            <div className="tenant-disclosure-head">
              <input className="tenant-disclosure-caption" value="2 · Practice system (API)" readOnly />
              <span className="tenant-future-tag">FUTURE</span>
              <label className="tenant-mini-switch" title="Not available yet (#1774)"><input type="checkbox" disabled /><span /></label>
            </div>
            <small className="tenant-field-note">Asked only when the contact book finds nothing. Not available yet (#1774).</small>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 12, fontSize: 14, alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            Verified after
            <select className="settings-input" value={String(n)} style={{ width: 64, padding: '6px 8px' }}
              onChange={event => patch(obj => { obj.verifiedAfter = Number(event.target.value); })}>
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => <option key={v} value={String(v)}>{v}</option>)}{/* v12.10.21 (#1917): 0 allowed */}
            </select>
            confirmed calls from that phone
          </label>
          <span className="tenant-field-note">Time limit: 1 second (fixed)</span>
        </div>
        <small className="tenant-field-note" style={{ display: 'block', marginTop: 4 }}>
          {n === 0 ? '0 = every contact on the phone counts as verified.' : `Template default: ${ID_CHECK_VERIFIED_DEFAULT}. 0 = every contact on the phone counts as verified.`}
        </small>
        {/* v12.10.21 (#1917, contract C1): Skip verification for contacts with External ID - template default ON. */}
        <div className="tenant-disclosure-list" style={{ marginTop: 10 }}>
          <div className="tenant-disclosure-block">
            <div className="tenant-disclosure-head">
              <input className="tenant-disclosure-caption" value="Skip verification for contacts with External ID" readOnly />
              <label className="tenant-mini-switch" title={skipExternalId ? 'On - a contact with an External ID counts as verified on its first call' : 'Off - a contact with an External ID needs the confirmed calls above like any other'}>
                <input type="checkbox" checked={skipExternalId} onChange={event => { const v = event.target.checked; patch(obj => { obj.skipExternalId = v; }); }} /><span />
              </label>
            </div>
            <small className="tenant-field-note">On: a contact with an External ID (imported from the practice system) counts as verified on its first call. Template default: On.</small>
          </div>
          {/* v12.10.21 (#1917): the match fields - configuration with a visible template default, read-only in this build. */}
          <div className="tenant-disclosure-block">
            <div className="tenant-disclosure-head">
              <input className="tenant-disclosure-caption" value="Match fields" readOnly />
              <span className="rb-defbadge">Template default</span>
            </div>
            <div style={{ fontSize: 13.5 }}><b>Primary:</b> calling phone (Phone 1-4) · <b>Secondary:</b> date of birth</div>
            <small className="tenant-field-note">Read-only in this build - editing the match fields comes later.</small>
          </div>
        </div>
      </div>
      <div className="tenant-drawer-section">
        <SectionTitle title="What the caller hears" note={`Language-specific · ${language.toUpperCase()}`} help={[
          ['What it does', 'One question, picked by what the lookup found. The recording notice stays on the Disclosure card.'],
          ['When it fires', 'After the Disclosure, before the Greeting. A "yes" links the contact and fills its name and date of birth as confirmed - Identity does not ask them again; the Confirm step still reads them back.'],
          ['Example', 'Am I speaking with Maria?'],
        ]} />
        <div className="tenant-disclosure-list">
          {lines.map(l => (
            <div className="tenant-disclosure-block" key={l.which}>
              <div className="tenant-disclosure-head">
                <input className="tenant-disclosure-caption" value={l.caption} readOnly />
                <label className="tenant-mini-switch" title="Always used when the lookup finds this case"><input type="checkbox" checked disabled readOnly /><span /></label>
              </div>
              <small className="tenant-field-note" style={{ display: 'block', margin: '0 0 6px' }}>{l.note}</small>
              <PromptEditor value={ic.prompts?.[l.which]?.[language] ?? ''} rows={2} language={language} groups={groups} known={known}
                onChange={value => setPrompt(l.which, value)}
                platformDefault={cl('idcheck.' + l.which, language)} translateSourceDefault={cl('idcheck.' + l.which, primary)}
                translateSource={ic.prompts?.[l.which]?.[primary] ?? ''} translateSourceLang={primary} />
            </div>
          ))}
          <div className="tenant-disclosure-block">
            <div className="tenant-disclosure-head"><input className="tenant-disclosure-caption" value="Not found" readOnly /></div>
            <small className="tenant-field-note">Nothing is said - straight to the Greeting “Regular”.</small>
          </div>
        </div>
        <small className="tenant-field-note" style={{ display: 'block', marginTop: 8 }}>
          Language: the contact's preferred language when it has one (the invite “Puede responder en español” is left out for that call); otherwise the organization's primary language. Listening uses the Greeting's multi-language listener.
        </small>
      </div>
    </>
  );
}

// Greeting — the first thing the caller hears. Language-specific prompt via the shared PromptEditor.
// v12.10.17 (#1776, UI-PROTO-ID-CHECK-T123 v1.1 tabs 3/4): THREE prompts - Regular (preRouting.greeting, today's text and
// the one used when the ID check found no one), ID matched and Repeat caller (preRouting.greetingVariants). A blank variant
// = Regular on the call. With the ID check off the ID matched prompt shows switched off with "ID check is off".
function GreetingEditor({ doc, language, languages, onLanguage, onUpdate }: {
  doc: DesignerDocument; language: string; card: PreCard;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const tok = useTokenSource(doc);   // v12.4.1 (#405)
  const text = doc.preRouting?.greeting?.[language] ?? '';
  const cl = useCardLines();   // v12.10.10 (#1408): the engine's greeting.default is the Template default
  const variants = (doc.preRouting?.greetingVariants ?? {}) as { idMatched?: Record<string, string>; repeatCaller?: Record<string, string> };
  const idOn = preRoutingEnabled(doc, 'idCheck');
  const primary = primaryLangCode(doc);
  const setVariant = (which: 'idMatched' | 'repeatCaller', value: string) => onUpdate(next => {
    next.preRouting ??= {};
    const gv = { ...((next.preRouting.greetingVariants ?? {}) as Record<string, Record<string, string>>) };
    const map = { ...(gv[which] ?? {}) };
    if (value) map[language] = value; else delete map[language];
    gv[which] = map;
    next.preRouting.greetingVariants = gv;
  });
  return (
    <>
      {/* v12.10.7 (#937, §37): no settings box on this card, so the rail comes first - the position was right, the
          retired strip's format was not. */}
      <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />
    <div className="tenant-drawer-section">
      <SectionTitle title="Greetings" note={`Language-specific · ${language.toUpperCase()}`} help={[
        ['What it does', 'One greeting is spoken, picked by what happened before it.'],
        ['When it fires', 'Right after the ID check (or the Disclosure when ID check is off).'],
        ['Example', 'A caller who just confirmed “yes, this is Maria” hears “Thank you. How may I help you today?”'],
      ]} />
      <div className="tenant-disclosure-list">
        <div className="tenant-disclosure-block">
          <div className="tenant-disclosure-head">
            <input className="tenant-disclosure-caption" value="Regular" readOnly />
            <label className="tenant-mini-switch" title="Always used when no other greeting applies"><input type="checkbox" checked disabled readOnly /><span /></label>
          </div>
          <small className="tenant-field-note" style={{ display: 'block', margin: '0 0 6px' }}>Every call today - and when the ID check found no one, or the caller was not on this phone.</small>
          <PromptEditor value={text} onChange={value => onUpdate(next => { next.preRouting ??= {}; next.preRouting.greeting ??= {}; next.preRouting.greeting[language] = value; })} platformDefault={cl('greeting.default', language)} translateSourceDefault={cl('greeting.default', primary)} rows={3} language={language} groups={tok.groups} known={tok.known} translateSource={doc.preRouting?.greeting?.[primary] ?? ''} translateSourceLang={primary} />
        </div>
        <div className={`tenant-disclosure-block${idOn ? '' : ' is-off'}`}>
          <div className="tenant-disclosure-head">
            <input className="tenant-disclosure-caption" value="ID matched" readOnly />
            <label className="tenant-mini-switch" title={idOn ? 'Used after the ID check confirmed who is calling' : 'ID check is off'}><input type="checkbox" checked={idOn} disabled readOnly /><span /></label>
          </div>
          <small className="tenant-field-note" style={{ display: 'block', margin: '0 0 6px' }}>
            {idOn ? 'After the ID check confirmed who is calling. No name here - the ID check already said it.' : <><b>ID check is off</b> - turn it on to use this greeting.</>}
          </small>
          <PromptEditor value={variants.idMatched?.[language] ?? ''} onChange={value => setVariant('idMatched', value)} rows={2} language={language}
            groups={tok.groups} known={tok.known} silentWhenBlank blankNote="Blank = the Regular greeting is used."
            translateSource={variants.idMatched?.[primary] ?? ''} translateSourceLang={primary} />
        </div>
        <div className="tenant-disclosure-block">
          <div className="tenant-disclosure-head">
            <input className="tenant-disclosure-caption" value="Repeat caller" readOnly />
            <label className="tenant-mini-switch" title="Used for a repeat caller when it has text"><input type="checkbox" checked disabled readOnly /><span /></label>
          </div>
          <small className="tenant-field-note" style={{ display: 'block', margin: '0 0 6px' }}>The same number called again within the repeat-caller window (Settings › Personalization › Repeat callers). Replaces “skip the opening”.</small>
          <PromptEditor value={variants.repeatCaller?.[language] ?? ''} onChange={value => setVariant('repeatCaller', value)} rows={2} language={language}
            groups={tok.groups} known={tok.known} silentWhenBlank blankNote="Blank = the Regular greeting is used (the opening is still skipped)."
            translateSource={variants.repeatCaller?.[primary] ?? ''} translateSourceLang={primary} />
        </div>
      </div>
    </div>
    </>
  );
}

// Language detect — universal card (NO language tabs): the manual fallback is always English and the
// languages it detects among come from the tenant's AI Agent. Detect mode + a customizable confidence
// threshold; below it the language counts as "not detected" and the single English fallback prompt plays.
function LanguageDetectEditor({ doc, language, languages, onLanguage, onUpdate, card }: {
  doc: DesignerDocument; card: PreCard; language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const tok = useTokenSource(doc);   // v12.4.1 (#405)
  const ld = (doc.preRouting?.languageDetect ?? {}) as { detectMode?: string; threshold?: number; repeatFrequency?: number; askCap?: number; waitSeconds?: number; manualPrompt?: Record<string, string>;
    // v12.9.24 (#910): the language offer. reask = the PRIMARY language's question; offers = per other language.
    reask?: Record<string, string>; offers?: Record<string, { announce?: boolean; invite?: string; nameLine?: string; confirm?: string }> };
  const primary = primaryLangCode(doc);
  const isPrimary = language === primary;
  // v12.9.26 (#932): the stored displayName can be EMPTY (the #904 pass emptied it) - fall back to the canonical name,
  // as the tab strip does, never to a blank ('OFFER' / 'Announce').
  const langName = (code: string) => { const l = languages.find(x => x.code === code); return (l?.displayName ?? '').trim() || langLabel(l ?? { code, displayName: '' }) || code.toUpperCase(); };
  // v12.9.26 (#933): the platform line each empty box falls back to, read from the engine's rows (CardLines).
  const { data: orgLines } = useQuery<{ cardLines?: Record<string, Record<string, string>> }>({
    queryKey: ['t2-org-vocabulary'], queryFn: () => api.get('/t2/settings/organization'), staleTime: 60_000 });
  const cardLine = (key: string) => orgLines?.cardLines?.[key]?.[language] ?? '';
  const offer = ld.offers?.[language] ?? {};
  const patchOffer = (mutate: (o: { announce?: boolean; invite?: string; nameLine?: string; confirm?: string }) => void) => patchLD(obj => {
    const offers = { ...((obj.offers ?? {}) as Record<string, { announce?: boolean; invite?: string; nameLine?: string; confirm?: string }>) };
    const o = { ...(offers[language] ?? {}) };
    mutate(o);
    offers[language] = o;
    obj.offers = offers;
  });
  const patchLD = (mutate: (obj: Record<string, unknown>) => void) => onUpdate(next => {
    next.preRouting ??= {};
    const obj = (next.preRouting.languageDetect ?? {}) as Record<string, unknown>;
    mutate(obj);
    next.preRouting.languageDetect = obj;
  });
  return (
    <>
    <div className="tenant-drawer-section">
      <SectionTitle title="Detection" help={[
        ['What it does', 'Identifies the caller’s language from your provisioned languages, then continues the call in it.'],
        ['When it fires', 'At the first turn after the greeting, before classification. Below the confidence threshold it counts as “not detected”: with a language announced, the agent plays the re-ask question and the language-name lines once; otherwise it re-asks up to the repeat frequency, then continues on its best guess.'],
        ['Example', 'A caller answering in Spanish is detected as ES and the rest of the call runs in Spanish.'],
      ]} />
      {/* ══ v12.9.23 (#883 / BDR-015 R2): HIS DECISION NAMED FIVE CARDS, NOT THREE. ═══════════════════
          "hours check, disclosure, greeting, language detect, classfiy will all have language tabs and
           whatever default language is selected, it will use that language accordingly until classify" */}
      <NamePurposeRow cardKey="language" doc={doc} card={card} onUpdate={onUpdate} />
      {/* v12.9.26 (#928): 'Detect mode' removed - no engine code reads detectMode. The stored value is left as is. */}
      <div className="tenant-field-row">
        <SelectField
          label="Confidence threshold"
          help={[['What it does', 'Sets how sure auto-detect must be to accept a language. Below this, the language counts as “not detected”.'], ['When it fires', 'On each detection attempt, before the call continues in the chosen language.'], ['Example', 'At 0.80 (strict), a borderline “um, hola?” scores too low → not detected → the agent re-asks or plays the manual prompt.']]}
          value={String(ld.threshold ?? 0.6)}
          options={thresholdOptions(ld.threshold)}
          labels={thresholdLabels(ld.threshold)}
          onChange={value => patchLD(obj => { obj.threshold = Number(value); })}
        />
        <SelectField
          label="Ask cap"
          help={[['What it does', 'How many times the caller is asked in total before the agent continues on its best guess of the language. Ask cap 2 = the caller is asked twice in total. A silent wait (Wait for response) counts as one ask.'], ['When it fires', 'Each time detection fails (silence or below-threshold). This is also the silence budget right after the greeting.'], ['Example', 'Ask cap 2 \u2192 asked, then once more, then the call continues in the language it thinks most likely.']]}
          value={String(ld.askCap ?? ((ld.repeatFrequency ?? 1) + 1))}
          options={ASK_CAP_OPTIONS}
          labels={ASK_CAP_LABELS}
          onChange={value => patchLD(obj => { obj.askCap = Number(value); obj.repeatFrequency = Number(value) - 1; })}
        />
      </div>
      {/* v12.2.20.0 (#136): how long to listen for the caller after the greeting before treating it as
          silence and playing the manual fallback prompt. */}
      <SelectField
        label="Wait for response"
        help={[['What it does', 'Sets how long the agent listens after the greeting before treating it as silence.'], ['When it fires', 'The first listen after the greeting. The caller\u2019s answer is used for both language and reason for calling.'], ['Not added together', 'Each listen has ONE wait. This one and Classify\u2019s never add up (#954).'], ['Example', 'At 6 seconds, if the caller says nothing for 6s the agent plays the re-ask question (and, with a language announced, its language-name line).']]}
        value={String(ld.waitSeconds ?? 6)}
        options={['3', '5', '6', '8', '10', '15']}
        labels={{ '3': '3 seconds', '5': '5 seconds', '6': '6 seconds · default', '8': '8 seconds', '10': '10 seconds', '15': '15 seconds' }}
        onChange={value => patchLD(obj => { obj.waitSeconds = Number(value); })}
      />
      <p className="tenant-field-note">After the greeting, the agent listens this long for the caller to speak.</p>
    </div>
    {/* v12.10.7 (#937 / #947, §37): the settings box closes above, the rail follows, and one line says what each tab holds -
        the primary tab and the other tabs carry different things, so the card must not look like two different cards. */}
    <LanguageRail languages={languages} active={language} onLanguage={onLanguage}
      note={`${langName(primary)} (primary) tab: the re-ask question. Every other language tab: how that language is offered to the caller. Every tab: its switch line.`} />
    <div className="tenant-drawer-section">
      {/* ══ v12.9.24 (#910): THE LANGUAGE OFFER REPLACES THE MANUAL FALLBACK PROMPT. ══════════════════════
          His design, 2026-09-29: the Greeting card keeps only the greeting. This card carries, on the PRIMARY
          language's tab, the re-ask question; on every OTHER language's tab, an Announce switch (off by default)
          and two short lines spoken in that language's own voice. The old "I can help in English and Spanish.
          Which language would you prefer?" prompt no longer plays - the engine retired it in the same build. */}
      {isPrimary ? (
        <>
          <SectionTitle title="Re-ask question" note={`${language.toUpperCase()} · primary`} help={[
            ['What it does', 'The question the agent asks again when the caller stays silent after the greeting, or is not understood.'],
            ['When it fires', 'On silence after the greeting, and once when the first answer is not understood. With a language announced, each announced language’s name line follows it, in that language’s voice.'],
            ['Example', 'Silence → “What is the reason for your call today?” … “Para continuar en español, diga español.” Not understood → the same, with “Sorry, I didn’t catch that.” in front.'],
            ['Empty', 'Leave empty to use the platform line: “What is the reason for your call today?”'],
          ]} />
          <PromptEditor
            value={ld.reask?.[language] ?? ''}
            onChange={value => patchLD(obj => { const r = { ...((obj.reask ?? {}) as Record<string, string>) }; r[language] = value; obj.reask = r; })}
            platformDefault={cardLine('language.reask')}
            rows={2}
            language={language}
            groups={tok.groups} known={tok.known}
          />
        </>
      ) : (
        <>
          <SectionTitle title={`Offer ${langName(language)}`} note={`${language.toUpperCase()} · spoken in the ${langName(language)} voice`}
            action={(
              <label className="tenant-title-switch">
                <span className="tenant-mini-switch">
                  <input type="checkbox" checked={offer.announce === true} onChange={event => patchOffer(o => { o.announce = event.target.checked; })} />
                  <span />
                </span>
                Announce {langName(language)}
              </label>
            )}
            help={[
            ['What it does', `Tells callers they can use ${langName(language)}, and gives them a word the ${langName(primary)} recognizer can hear. The call listens in ${langName(primary)} until the language is known, so a caller who just speaks ${langName(language)} can be mis-heard.`],
            ['When it fires', 'Only when Announce is on. The invite line plays right after the greeting; the language-name line plays after the re-ask question on silence and when the first answer is not understood.'],
            ['Default', 'Off. Turn it on for each language you want offered.'],
          ]} />
          {offer.announce !== true && <p className="tenant-field-note">Announce is off: {langName(language)} is not offered on calls. Callers who speak it are still detected.</p>}
          {offer.announce === true ? (
            <>
              <SectionTitle title="Invite line" note="spoken after the greeting, every call" help={[
                ['What it does', 'One short sentence in this language, right after the greeting.'],
                ['When it fires', 'Every call, after the greeting, while Announce is on. A caller who starts talking over it is still heard.'],
                ['Empty', 'Leave empty to use the platform line for this language - it shows in the box.'],
              ]} />
              <PromptEditor
                value={offer.invite ?? ''}
                onChange={value => patchOffer(o => { o.invite = value; })}
                platformDefault={cardLine('language.invite')}
                rows={1}
                language={language}
                groups={tok.groups} known={tok.known}
              />
              <SectionTitle title="Language-name line" note="spoken after the re-ask question" help={[
                ['What it does', 'Tells the caller the one word to say to switch - the language’s own name, which the recognizer hears in either language.'],
                ['When it fires', 'After the re-ask question on silence, and once when the first answer is not understood.'],
                ['Empty', 'Leave empty to use the platform line for this language - it shows in the box.'],
              ]} />
              <PromptEditor
                value={offer.nameLine ?? ''}
                onChange={value => patchOffer(o => { o.nameLine = value; })}
                platformDefault={cardLine('language.nameLine')}
                rows={1}
                language={language}
                groups={tok.groups} known={tok.known}
              />
            </>
          ) : null}
          {/* v12.10.5.1 (#1148, Tushar 10/3): asked in this language before the call switches to it on detection alone -
              a short / name-only answer ("María López."). Yes switches; anything else stays. Its UI home is here. */}
          <SectionTitle title="Confirm switch question" note={`spoken in the ${langName(language)} voice`} help={[
            ['What it does', `Asked before the call moves to ${langName(language)} when the only evidence is a short answer that sounds like it (a name, one or two words). Yes switches; anything else stays in ${langName(primary)}.`],
            ['When it fires', `Only on a short answer with no "${langName(language)}" said and no full ${langName(language)} sentence - those switch straight away.`],
            ['Empty', 'Leave empty to use the platform line for this language - it shows in the box.'],
          ]} />
          <PromptEditor
            value={offer.confirm ?? ''}
            onChange={value => patchOffer(o => { o.confirm = value; })}
            platformDefault={cardLine('language.confirmSwitch')}
            rows={1}
            language={language}
            groups={tok.groups} known={tok.known}
          />
        </>
      )}
      {/* v12.9.27 (#1044, LOCKED): the Switch line - on EVERY language tab, Announce or not. The one place it is edited. */}
      <SwitchLineSection language={language} langName={langName(language)} />
    </div>
    </>
  );
}

// ══ v12.9.27 (#1044, UI-LOCK-12.9.27 LOCKED 2026-10-01): THE SWITCH LINE, EDITED HERE. ══════════════════════
// His choice: "keep switch line option here as well as in the language detect card mainly for editing text, preview in
// ai agent is easier" -> AI Agent shows it read-only with Play; THIS is where the words change. Same storage as before
// (agentPhrases["language.switch"]), saved on its own - it is a tenant phrase, not part of the workflow document - so
// calls are unaffected until it is saved, and Save on the workflow does not touch it.
function SwitchLineSection({ language, langName }: { language: string; langName: string }) {
  const qc = useQueryClient();
  const { data } = useQuery<{ languages?: { code: string; voice: string; switchLine?: string | null; switchLineDefault?: string | null }[] }>({
    queryKey: ['t2-ai-agent'], queryFn: () => api.get('/t2/settings/ai-agent'), staleTime: 30_000 });
  const row = (data?.languages ?? []).find(l => canonLang(l.code) === canonLang(language));
  const saved = (row?.switchLine ?? '').trim();
  const platform = (row?.switchLineDefault ?? '').trim();
  const [text, setText] = useState(saved);
  useEffect(() => { setText(saved); }, [saved, language]);
  const dirty = text.trim() !== saved;
  const save = useMutation({
    mutationFn: () => api.put('/t2/settings/ai-agent/switch-line', { language, text: text.trim() }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['t2-ai-agent'] }); toast('success', 'Switch line saved', `${langName}: ${text.trim() || 'the platform line'}.`); },
    onError: () => toast('error', 'Could not save the switch line', 'Nothing was changed - try again.'),
  });
  async function play() {
    const line = text.trim() || platform;
    if (!line || !row?.voice) { toast('error', 'Nothing to play', 'Choose a voice for this language under AI Agent first.'); return; }
    try {
      const res = await api.post<{ audioUrl: string | null }>('/t2/settings/ai-agent/voice-preview', { language, voiceId: row.voice, sample: line });
      if (res.audioUrl) await new Audio(res.audioUrl).play();
      else toast('error', 'Preview failed', 'The voice service did not return audio.');
    } catch { toast('error', 'Preview failed', 'The voice service did not respond.'); }
  }
  return (
    <>
      <SectionTitle title="Switch line" note={`${language.toUpperCase()} · spoken in the ${langName} voice`} help={[
        ['What it does', 'The first words this voice says when a call changes into this language AND the caller hears a different voice as a result. One short line, no name.'],
        ['When it fires', 'Only when the voice actually changes. Shown on every language tab, whether Announce is on or not.'],
        ['Example', 'English voice → Spanish voice: “Continuemos en español.” then the next question.'],
        ['Empty', 'The platform line is shown until you change it (Template default).'],
      ]} />
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button type="button" className="tenant-secondary" onClick={play} title={`Play in the ${langName} voice`} aria-label={`Play the ${langName} switch line`}>&#9654;</button>
        {/* v12.10.10.1 (#1417): the platform line is shown as written text, never a grey placeholder; typing it back = blank. */}
        <input className="rq-in" style={{ flex: 1 }} value={text || platform}
          aria-label={`Switch line in ${langName}`} onChange={e => setText(e.target.value.trim() === (platform ?? '').trim() ? '' : e.target.value)} maxLength={300} />
        <button type="button" className="tenant-primary" disabled={!dirty || save.isPending} onClick={() => save.mutate()}>
          {save.isPending ? 'Saving…' : 'Save'}
        </button>
      </div>
      <p className="tenant-field-note">{!text.trim() && <><span className="rq-defnote">Template default</span>{' '}</>}Saved on its own - not with the workflow. AI Agent › Languages &amp; voices shows it with a Play button.</p>
    </>
  );
}

// Generic fallback editor for any pre-routing card without a bespoke editor. Name/Purpose + the shared
// on-fail recovery selector. (All six canonical cards now have bespoke editors; this stays as a net.)
function GenericPreRoutingEditor({ cardKey, doc, onUpdate, card }: {
  cardKey: PreRoutingKey; doc: DesignerDocument; card: PreCard;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  return (
    <div className="tenant-drawer-section">
      <SectionTitle title={`${card.title} settings`} />
      <NamePurposeRow cardKey={cardKey} doc={doc} card={card} onUpdate={onUpdate} />
      <SelectField label="On fail" help={[['What it does', 'What the agent does when it can’t determine the caller’s need after the re-asks — clarify then offer the keypad, re-ask once, hand to an operator, or take a voicemail.'], ['When it fires', 'After classification (or language detection) fails to clear the confidence threshold within the re-asks.'], ['Example', '“Clarify then keypad” → the agent says it didn’t catch that and offers “press 1 for…”.']]} value={doc.preRouting?.fallbackMode ?? 'clarify-then-keypad'} options={FALLBACK_OPTIONS} onChange={value => onUpdate(next => { next.preRouting ??= {}; next.preRouting.fallbackMode = value; })} />
    </div>
  );
}

// A tag/chip editor for a list of keywords. Chips are removable; typing + Enter or comma commits;
// Backspace on an empty field pops the last chip. Blur commits a pending draft. Dedupes case-insensitively.
function KeywordTags({ label, value, onChange, placeholder, help }: {
  label?: string; value: string[]; onChange: (next: string[]) => void; placeholder?: string; help?: HelpSection[];
}) {
  const [draft, setDraft] = useState('');
  const commit = (raw: string) => {
    const parts = raw.split(',').map(s => s.trim()).filter(Boolean);
    if (parts.length === 0) { setDraft(''); return; }
    const merged = [...value];
    for (const p of parts) if (!merged.some(k => k.toLowerCase() === p.toLowerCase())) merged.push(p);
    onChange(merged);
    setDraft('');
  };
  return (
    <label className="tenant-kw">
      {label ? <span className="tenant-kw-label">{label}{help && <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={help} /></span>}</span> : null}
      <div className="tenant-kw-box">
        {value.map((kw, i) => (
          <span className="tenant-kw-chip" key={`${kw}-${i}`}>
            {kw}
            <button type="button" aria-label={`Remove ${kw}`} onClick={() => onChange(value.filter((_, j) => j !== i))}>×</button>
          </span>
        ))}
        <input
          className="tenant-kw-input"
          value={draft}
          placeholder={value.length === 0 ? (placeholder ?? 'Add keyword…') : ''}
          onChange={event => setDraft(event.target.value)}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ',') { event.preventDefault(); commit(draft); }
            else if (event.key === 'Backspace' && draft === '' && value.length > 0) onChange(value.slice(0, -1));
          }}
          onBlur={() => { if (draft.trim()) commit(draft); }}
        />
      </div>
    </label>
  );
}

// CARD 6 — Classify. The routing brain: reads the caller's first sentence and jumps straight to the
// matching caller type (workflow) + intent so the agent doesn't re-ask what the caller already said.
// The keyword library grounds that match — every caller type and every intent can carry keyword tags.
// Confidence threshold + repeat frequency drive the shared confidence → repeat → fallback engine.
function ClassifyEditor({ doc, language, languages, onLanguage, onUpdate, card }: {
  doc: DesignerDocument; card: PreCard; language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const tok = useTokenSource(doc);   // v12.4.1 (#405)
  const workflows = doc.workflows ?? [];
  const cls = (doc.preRouting?.classify ?? {}) as { threshold?: number; repeatFrequency?: number; askCap?: number; waitSeconds?: number; aiMode?: string; catchAll?: string };
  const patchCls = (mutate: (obj: Record<string, unknown>) => void) => onUpdate(next => {
    next.preRouting ??= {};
    const obj = (next.preRouting.classify ?? {}) as Record<string, unknown>;
    mutate(obj);
    next.preRouting.classify = obj;
  });
  // ══ v12.9.23 (#903): KEYWORDS PER LANGUAGE. ════════════════════════════════════════════════════════
  // A Spanish caller says "cita", not "appointment". The seeded library already mixes both into ONE flat
  // list, which works for matching and is a trap for the tenant: #412's report was his own words on the
  // interceptor phrases - "i swithced tab to spanish and i still see keywords in english" - and a tenant
  // tidying a list they half-recognise deletes the words that make the other language work.
  //
  // THE PRIMARY LANGUAGE KEEPS WRITING THE FLAT LIST. That is what makes this safe: nothing migrates, the
  // engine's fallback is that same list, and a tenant who never opens a second tab sees no change at all.
  const kwPrimary = primaryLangCode(doc);
  const kwRead = (o?: { keywords?: string[]; keywordsByLang?: Record<string, string[]> }) =>
    (language === kwPrimary ? o?.keywords : o?.keywordsByLang?.[language]) ?? [];
  const kwWrite = (o: { keywords?: string[]; keywordsByLang?: Record<string, string[]> }, kws: string[]) => {
    if (language === kwPrimary) { o.keywords = kws; return; }
    o.keywordsByLang = { ...(o.keywordsByLang ?? {}), [language]: kws };
  };
  const setWorkflowKeywords = (wfId: string, kws: string[]) => onUpdate(next => {
    const w = next.workflows?.find(item => item.id === wfId);
    if (w) kwWrite(w, kws);
  });
  const setIntentKeywords = (wfId: string, itId: string, kws: string[]) => onUpdate(next => {
    const it = next.workflows?.find(item => item.id === wfId)?.intents?.find(i => i.id === itId);
    if (it) kwWrite(it, kws);
  });
  // v12.2.36.0 (#196): remove a caller type (workflow) or an intent from the keyword library. Empty
  // caller types delete immediately; ones with intents/keywords ask for an inline confirm first.
  const [confirmRemoveWf, setConfirmRemoveWf] = useState<string | null>(null);
  const removeWorkflow = (wfId: string) => onUpdate(next => {
    if (next.workflows) next.workflows = next.workflows.filter(w => w.id !== wfId);
  });
  const removeIntent = (wfId: string, itId: string) => onUpdate(next => {
    const w = next.workflows?.find(item => item.id === wfId);
    if (w?.intents) w.intents = w.intents.filter(i => i.id !== itId || isSomethingElseIntent(i));   // v12.10.23 (#2029): never deleted
  });
  // v12.2.19.0 (WF-KEYPAD): keypad menu (digit -> caller type). Shown when Classify is disabled (primary IVR) or the
  // on-fail is a keypad mode. Stored at preRouting.classify.keypad = { prompt:{en}, options:[{digit,workflowId}] }.
  type KeypadShape = { prompt?: Record<string, string>; options: { digit: string; workflowId: string }[] };
  const KEYPAD_DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
  const clsKeypad = ((doc.preRouting?.classify ?? {}) as { keypad?: Partial<KeypadShape> }).keypad ?? {};
  const kpOptions = clsKeypad.options ?? [];
  const kpPrompt = clsKeypad.prompt?.[language] ?? '';   // v12.9.23 (#883)
  // v12.10.10 (#1408): what the engine speaks when this box is blank - BuildKeypadPrompt, rebuilt here from the same
  // platform rows (menu.keypad.choose / option / repeat) and the caller-type names in this language. Shown as written text.
  const cl = useCardLines();
  const kpAuto = (() => {
    const choose = cl('menu.keypad.choose', language), opt = cl('menu.keypad.option', language), rep = cl('menu.keypad.repeat', language);
    if (!choose && !opt) return '';
    let out = choose;
    for (const o of (clsKeypad.options ?? [])) {
      const wf = (doc.workflows ?? []).find(w => (w.id ?? '').toLowerCase() === (o.workflowId ?? '').toLowerCase());
      if (!wf || wf.enabled === false) continue;
      const nm = (wf.nameByLang?.[language] ?? '').trim() || wf.name || o.workflowId;
      out += opt.replace('{0}', nm).replace('{1}', o.digit);
    }
    return (out + rep).trim();
  })();
  const classifyOff = !preRoutingEnabled(doc, 'classify');
  const showKeypad = classifyOff || /keypad/i.test(doc.preRouting?.fallbackMode ?? '');
  const patchKeypad = (mutate: (kp: KeypadShape) => void) => onUpdate(next => {
    next.preRouting ??= {};
    const c = (next.preRouting.classify ?? {}) as Record<string, unknown>;
    const kp = (c.keypad ?? {}) as KeypadShape;
    kp.options = kp.options ?? [];
    mutate(kp);
    c.keypad = kp;
    next.preRouting.classify = c;
  });
  return (
    <>
    <div className="tenant-drawer-section">
      {/* v12.9.24 (#921): the language strip MOVED below the header block - Name, Purpose, Wait for response,
          Repeat frequency, Process data and Confidence threshold are not per-language. His point, 2026-09-29:
          "the language bar comes after the header block". */}
      <SectionTitle title="Classification" help={[
        ['What it does', 'Reads the caller’s first sentence and routes straight to the matching caller type + intent — so the agent skips redundant questions when the caller already said why they’re calling.'],
        ['When it fires', 'On the first turn after the greeting. If the best match scores below the confidence threshold, the agent re-asks up to the repeat frequency, then runs the on-fail fallback.'],
        ['Example', '“I need to refill my prescription” classifies as Pharmacy / Refill request and jumps the caller straight into that flow.'],
      ]} />
      <NamePurposeRow cardKey="classify" doc={doc} card={card} onUpdate={onUpdate} />

      {/* ══ v12.9.11 (#759): THE FIELD ORDER AND THE LABEL ARE HIS. ═════════════════════════════════════
          Tushar, on 39-0071: *"Reading the caller's first sentence - too big and confusing. we need some
          sorter version like Process? let's fix classify card a little bit. below name and purpose line we
          can have wait for response and next to it repeat frequency. Process Data (reading the caller's
          first) and then in same line confidence threshold."*

          So: Name/Purpose, then Wait for response + Repeat frequency, then Process data + Confidence
          threshold. The long sentence that was the LABEL is now the first line of the help tip, which is
          where an explanation belongs - a label is a name, not a description.

          RAISED ON 39-0071, AGREED, AND THEN NOT CUT IN 12.9.10. It is one of the two items behind his
          scope complaint (*"you keep on letting me guess what is build and what is not"*), which is why it
          leads this release's T2 work rather than trailing it.

          ON THE THIRD OPTION he asked about - *"what we had before just the intent processing?"* - there has
          been no capture-nothing mode since 12.3.13. The pre-fill runs in BOTH modes, and re-adding a third
          would re-enable #357, the defect that began this whole arc. Local already makes no model call, so a
          third option would not buy latency either. TWO OPTIONS, NOT THREE. */}
      <div className="tenant-field-row">
        <SelectField
          label="Wait for response"
          help={[['What it does', 'How long the agent listens for the caller\u2019s reason before treating it as silence and re-asking / falling back.'], ['When it fires', 'Classify\u2019s own re-asks only (after \u201csorry, I didn\u2019t catch that\u201d and after a Knowledge Base answer). Also the first listen when Language detect is off.'], ['Not added together', 'Each listen has ONE wait. This one and Language detect\u2019s never add up (#954).'], ['Example', 'At 6 seconds, if the caller says nothing for 6s the agent re-asks, then offers the keypad menu.'],
            // v12.9.24 (#921): the loose note under this row moved here - and its \u escapes now render, because
            // this is a JS string. In JSX TEXT they printed literally (the #859 class).
            ['If nothing is said', 'The agent re-asks, then offers the keypad menu (\u201cpress 1 for\u2026\u201d) when one is configured below.']]}
          value={String(cls.waitSeconds ?? 6)}
          options={['3', '5', '6', '8', '10', '15']}
          labels={{ '3': '3 seconds', '5': '5 seconds', '6': '6 seconds \u00b7 default', '8': '8 seconds', '10': '10 seconds', '15': '15 seconds' }}
          onChange={value => patchCls(obj => { obj.waitSeconds = Number(value); })}
        />
        <SelectField
          label="Ask cap"
          help={[['What it does', 'How many times the caller is asked for their reason in total before the on-fail action runs. Ask cap 2 = the caller is asked twice in total. A silent wait (Wait for response) counts as one ask.'], ['When it fires', 'Each time classification fails (silence or below threshold). Also the silence budget after the greeting when Language detect is off.'], ['Example', 'Ask cap 2 \u2192 asked, then once more; if that still doesn\u2019t match, it clarifies then offers the keypad.'], ['Fixed safety stop', 'Knowledge Base answers given from this card stop after 2, whatever this number says.']]}
          value={String(cls.askCap ?? ((cls.repeatFrequency ?? 1) + 1))}
          options={ASK_CAP_OPTIONS}
          labels={ASK_CAP_LABELS}
          onChange={value => patchCls(obj => { obj.askCap = Number(value); obj.repeatFrequency = Number(value) - 1; })}
        />
      </div>

      {/* v12.9.0 (#694): HOW THIS CARD THINKS. Local = keyword match first, then a router that returns only a
          route. AI = one grounded call that routes AND picks up anything the caller already said - their name,
          a date, a ZIP - so the agent never asks for something it was just told.
          v12.9.11 (#781): and in LOCAL mode a labelled opening sentence now yields a name and a date of birth
          too, deterministically - so the gap between the two modes is narrower than this help text implies on
          a caller who introduces themselves. */}
      <div className="tenant-field-row">
        {/* ══ v12.10.22 (#2033, UI-PROTO-CLASSIFY-AI-SWITCH-T174 v1.0 APPROVED 10/27): the "Process data" dropdown is replaced by the
            "AI processing" switch - no mode to pick. Stored in the same field (aiMode: on = "ai", off = "local"), so UMG (AI) is On after
            the deploy with no change. ══ */}
        <div className="tenant-form-field cls-ai-row">
          <span>AI processing<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
            ['What it does', 'Keywords always route the call. With AI processing on, the AI is used only when it is needed.'],
            ['When the AI runs', '(1) The keywords cannot place the opening - the AI routes the call and fills the details the caller gave. (2) The keywords placed it but the caller also gave details (a date or time, a provider, a name, numbers) - one AI call fills those fields only; it never changes the route.'],
            ['When it does not', 'A plain request (\u201cI\u2019d like to schedule an appointment\u201d), or details already loaded from the contact after the ID check - no AI call.'],
            ['Off', 'Keywords only; when they cannot place the opening, the On-fail fallback below.'],
            ['Call path', 'Every AI answer is written to the call path: what was asked and what came back.'],
          ]} /></span></span>
          <span className="cls-ai-sw">
            <button type="button" role="switch" aria-checked={cls.aiMode === 'ai'} aria-label="AI processing"
              className={'rq-sw' + (cls.aiMode === 'ai' ? ' on' : '')}
              onClick={() => patchCls(obj => { obj.aiMode = cls.aiMode === 'ai' ? 'local' : 'ai'; })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
            <span className="cls-ai-state">{cls.aiMode === 'ai' ? 'On' : 'Off'}</span>
          </span>
        </div>
        {/* v12.10.15 (#1644, FINAL 10/13): where a call goes when the reason can't be worked out after the re-asks. */}
        {(() => {
          const opts = [''];
          const labels: Record<string, string> = { '': 'Very-low-confidence action (Settings \u203a Call handling)' };
          for (const w of workflows) {
            if (w.enabled === false) continue;
            for (const it of (w.intents ?? [])) {
              if ((it as { enabled?: boolean }).enabled === false) continue;
              const v = `${w.id}/${it.id}`;
              opts.push(v);
              labels[v] = `${w.name || 'Caller type'} \u203a ${it.label || 'Request'}`;
            }
          }
          const cur = cls.catchAll ?? '';
          if (cur && !opts.includes(cur)) { opts.push(cur); labels[cur] = 'A request that no longer exists - pick again'; }
          return (
            <SelectField
              label="If the reason can't be worked out"
              help={[
                ['What it does', 'After the re-asks, the call carries on in the request you pick here - the caller is identified, says what they need in their own words, and gets a reference number - instead of going to the Very-low-confidence action.'],
                ['When it fires', 'Only when the agent still cannot tell what the caller wants after the clarify re-asks (and the keypad menu, if that is the On fail).'],
                ['Example', 'Patient \u203a General request. Leave it on the first choice to keep using Settings \u203a Call handling \u203a Very-low-confidence action.'],
              ]}
              value={cur}
              options={opts}
              labels={labels}
              onChange={value => patchCls(obj => { if (value) obj.catchAll = value; else delete obj.catchAll; })}
            />
          );
        })()}
        <SelectField
          label="Confidence threshold"
          help={[['What it does', 'How sure the classifier must be to route the caller to a caller type/intent. Below this counts as no match.'], ['When it fires', 'On each classification attempt, right after the caller states their reason.'], ['Example', 'At 0.50 (lenient) a vague \u201cuh, my meds?\u201d still routes to Pharmacy; at 0.80 it would fall to the on-fail path.']]}
          value={String(cls.threshold ?? 0.6)}
          options={thresholdOptions(cls.threshold)}
          labels={thresholdLabels(cls.threshold)}
          onChange={value => patchCls(obj => { obj.threshold = Number(value); })}
        />
      </div>
    </div>
    {/* v12.10.7 (#937, T2 UI Principles §37): settings box -> rail -> per-language content. When nothing matches and the
        keypad's key mapping are not per-language, so they moved up into the settings box; the keypad's SPOKEN prompt stays
        below the rail with the other per-language lines. */}
    <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />
    <div className="tenant-drawer-section">
      {/* v12.9.26 (#966): Classify's own re-ask line, per language, showing what will actually play. It edits the SAME
          stored value as Workflow > Phrases > 'Clarify' - one source, two places to reach it. */}
      <SectionTitle title="Re-ask line" help={[
        ['What it does', 'What the agent says when it did not understand why the caller is calling, before asking again.'],
        ['When it fires', 'On Classify\u2019s own re-asks - after \u201csorry, I didn\u2019t catch that\u201d.'],
        ['Same line, two places', 'This is the Clarify line in Workflow \u203a Phrases. Editing either changes both.']]} />
      <PhrasesEditor language={language} languages={languages} onLanguage={onLanguage} onlyKeys={['clarify']} compact />
      {/* v12.10.19 (#1890 #1911): how the answer to the Re-ask line is read now */}
      <p className="tenant-field-note">The answer to this line is read as the caller type: &ldquo;patient&rdquo; &rarr; Patient, a pharmacy / doctor&rsquo;s-office word &rarr; that caller type, a bare &ldquo;office&rdquo; &rarr; the keypad menu of the other caller types. A word several caller types share (in their keywords) asks only those caller types (Workflow &rsaquo; Phrases &rsaquo; classify.callerTypeShared).</p>
      {/* v12.10.23 (#2028, LOCKED 10/29): the Silent caller moved to Settings › Call Handling › Conversation flow. */}
      <p className="tenant-field-note">Silent caller is set in Settings &rsaquo; Call Handling &rsaquo; Conversation flow.</p>
      {/* ══ v12.10.23 (#2012 #2028, UI-PROTO-MENUS-T174 v1.5 LOCKED): When nothing matches comes after the Re-ask line (step 1). On fail keeps
          its four choices; Offer keypad (the default) = step 2, the Keypad menu - ONE collapsed row like the Interceptor rows, holding the
          spoken keypad prompt and the keys → caller type list. ══ */}
      <SectionTitle title="When nothing matches" help={[
        ['What it does', 'Sets what the agent does when no caller type clears the confidence threshold after the re-asks — clarify then offer the keypad, re-ask once, hand to an operator, or take a voicemail.'],
        ['When it fires', 'After classification exhausts its re-asks without a confident match.'],
        ['Example', '“Clarify then keypad” → the agent says it didn’t catch that and offers “press 1 for Patient, 2 for Pharmacy…”.'],
      ]} />
      <SelectField label="On fail" help={[['What it does', 'What the agent does when it can’t determine the caller’s need after the re-asks — clarify then offer the keypad, re-ask once, hand to an operator, or take a voicemail.'], ['When it fires', 'After classification (or language detection) fails to clear the confidence threshold within the re-asks.'], ['Example', '“Clarify then keypad” → the agent says it didn’t catch that and offers “press 1 for…”.']]} value={doc.preRouting?.fallbackMode ?? 'clarify-then-keypad'} options={FALLBACK_OPTIONS} labels={FALLBACK_LABELS} onChange={value => onUpdate(next => { next.preRouting ??= {}; next.preRouting.fallbackMode = value; })} />
      {showKeypad && (
        <IcpCard icon="#" title="Keypad menu" chip="Menu" chipKind="new"
          description={classifyOff
            ? 'Classify is off: the keypad menu is how callers reach a caller type. Menu keys and short menus: Settings › Call Handling › Keypad menus.'
            : 'Only when the re-ask (Re-ask line) did not get them to a caller type: the keypad prompt. Menu keys and short menus: Settings › Call Handling › Keypad menus.'}
          fires={classifyOff ? 'classify off · the first menu' : 'classify · after the re-ask'}
          help={[
            ['What it does', 'Lets callers press a key to reach a caller type. Used when Classify is disabled (primary routing) or as the Offer keypad on-fail.'],
            ['When it fires', 'When Classify is off, or after the Re-ask line did not get the caller to a caller type and On fail is Offer keypad.'],
            ['Example', 'Keys 1→Patient, 2→Pharmacy, 3→Physician; leave the prompt blank to auto-build “For Patient, say Patient or press 1…”.'],
            ['Menu keys', 'Repeat, main menu and a person (and short menus) are set once in Settings › Call Handling › Keypad menus.'],
          ]}
          enabled disabledToggle>
          <div className="icp-fld">
            <div className="lab">Keypad prompt (spoken) &middot; {language.toUpperCase()}</div>
            <PromptEditor value={kpPrompt} onChange={value => patchKeypad(kp => { kp.prompt = kp.prompt ?? {}; kp.prompt[language] = value; })} platformDefault={kpAuto} rows={2} language={language} translateSource={clsKeypad.prompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)} groups={tok.groups} known={tok.known} />
          </div>
          <div className="icp-fld">
            <div className="lab">Keys &rarr; caller type</div>
          {kpOptions.length === 0
            ? <div className="tenant-kw-empty">No keys mapped yet — add one below.</div>
            : kpOptions.map((opt, idx) => (
              <div key={idx} style={{ display: 'flex', gap: 10, alignItems: 'flex-end', marginBottom: 8 }}>
                <div style={{ width: 96 }}>
                  <SelectField label="Key" help={[['What it does', 'The phone-keypad digit the caller presses to choose this caller type.'], ['When it fires', 'When the keypad menu plays (Classify disabled, or the clarify-then-keypad on-fail).'], ['Example', 'Key 1 → Patient: pressing 1 routes the caller to the Patient workflow.']]} value={opt.digit || '1'} options={KEYPAD_DIGITS} onChange={value => patchKeypad(kp => { kp.options[idx] = { ...kp.options[idx], digit: value }; })} />
                </div>
                <div style={{ flex: 1 }}>
                  <SelectField label="Caller type" help={[['What it does', 'The caller type (workflow) the caller reaches when they press this key.'], ['When it fires', 'On a keypad selection.'], ['Example', 'Key 2 mapped to Pharmacy → pressing 2 routes the caller into the Pharmacy workflow.']]} value={opt.workflowId || (workflows[0]?.id ?? '')} options={workflows.map(w => w.id ?? '')} labels={Object.fromEntries(workflows.map(w => [w.id ?? '', w.name || (w.id ?? '')] as [string, string]))} onChange={value => patchKeypad(kp => { kp.options[idx] = { ...kp.options[idx], workflowId: value }; })} />
                </div>
                <button type="button" style={{ height: 34, padding: '0 12px', border: '1px solid #e2e8f0', borderRadius: 8, background: '#fff', color: '#b91c1c', cursor: 'pointer' }} onClick={() => patchKeypad(kp => { kp.options.splice(idx, 1); })}>Remove</button>
              </div>
            ))}
          <button type="button" disabled={workflows.length === 0} style={{ marginTop: 4, height: 34, padding: '0 14px', border: '1px dashed #cbd5e1', borderRadius: 8, background: '#f8fafc', color: '#ea580c', fontWeight: 600, cursor: workflows.length === 0 ? 'default' : 'pointer' }} onClick={() => patchKeypad(kp => { const used = new Set(kp.options.map(o => o.digit)); const next = KEYPAD_DIGITS.find(x => !used.has(x)) ?? '1'; kp.options.push({ digit: next, workflowId: workflows[0]?.id ?? '' }); })}>+ Add key</button>
            <p className="icp-note">Menu keys (repeat, main menu, a person) are added from Settings &rsaquo; Call Handling &rsaquo; Keypad menus - no need to map them here.</p>
          </div>
        </IcpCard>
      )}
      <SectionTitle title="Keyword library" note={`${workflows.length} caller ${workflows.length === 1 ? 'type' : 'types'}`} help={[
        ['What it does', 'Holds the keyword phrases that route callers to each caller type + intent. A keyword hit routes instantly, skipping the classifier LLM.'],
        ['When it fires', 'On classification, before the LLM — a clear keyword match wins immediately.'],
        ['Example', 'Tag Pharmacy with “refill, prescription, medication” so “I need a refill” routes straight to Pharmacy.'],
        ['Intents', 'Within a caller type, intents are the specific asks. Their keywords sharpen the routing to the exact node chain.'],
        ['How matching works', 'Keywords are hints, not hard rules — the classifier weighs them together with the AI model’s own understanding of the sentence.'],
      ]} />
      {workflows.length === 0 ? (
        <div className="tenant-kw-empty">No caller types defined yet. Add workflows on the canvas, then tag them with keywords here.</div>
      ) : (
        <div className="tenant-kw-lib">
          {workflows.map(wf => {
            const intents = wf.intents ?? [];
            return (
              <div className="tenant-kw-wf" key={wf.id ?? wf.name}>
                <div className="tenant-kw-wf-head">
                  <span className="tenant-kw-wf-name">{wf.name || 'Caller type'}</span>
                  <span className="tenant-kw-wf-count">{intents.length} intent{intents.length === 1 ? '' : 's'}</span>
                  {confirmRemoveWf === (wf.id ?? '') ? (
                    <span className="tenant-kw-wf-confirm">
                      Remove{intents.length ? ` caller type + ${intents.length} intent${intents.length === 1 ? '' : 's'}` : ''}?
                      <button type="button" className="tenant-kw-wf-del" onClick={() => { removeWorkflow(wf.id ?? ''); setConfirmRemoveWf(null); }}>Remove</button>
                      <button type="button" className="tenant-kw-wf-cancel" onClick={() => setConfirmRemoveWf(null)}>Cancel</button>
                    </span>
                  ) : (
                    <button type="button" className="tenant-kw-wf-remove" title="Remove caller type"
                      onClick={() => {
                        const empty = intents.length === 0 && (wf.keywords ?? []).length === 0;
                        if (empty) removeWorkflow(wf.id ?? ''); else setConfirmRemoveWf(wf.id ?? '');
                      }}>×</button>
                  )}
                </div>
                <KeywordTags
                  label="Caller-type keywords"
                  help={[['What it does', 'Phrases that route a caller into THIS caller type (before choosing an intent). A keyword hit routes instantly, skipping the LLM.'], ['When it fires', 'On classification — matched against the caller’s first sentence.'], ['Example', 'Tag Pharmacy with “refill, prescription, pharmacy” so “I’m calling about my prescription” routes to Pharmacy.']]}
                  value={kwRead(wf)}
                  onChange={kws => setWorkflowKeywords(wf.id ?? '', kws)}
                  placeholder={language === kwPrimary ? 'e.g. appointment, book, schedule' : 'keywords in this language'}
                />
                {intents.length > 0 && (
                  <div className="tenant-kw-intents">
                    {intents.map(it => (
                      <div className="tenant-kw-intent" key={it.id ?? it.label}>
                        <div className="tenant-kw-intent-head">
                          <span className="tenant-kw-intent-name">{it.label || 'Intent'}<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Keywords that route a caller to THIS intent within the caller type. A hit picks the intent directly, skipping the classifier LLM.'], ['When it fires', 'On classification, after the caller type is chosen — matched against what the caller says.'], ['Example', 'Add “cancel, can’t make it” to Cancel Appointment so “I need to cancel” lands on that intent.']]} /></span></span>
                          {!isSomethingElseIntent(it) && (   /* v12.10.23 (#2029): Something else is never deleted */
                          <button type="button" className="tenant-kw-intent-remove" title="Remove intent"
                            onClick={() => removeIntent(wf.id ?? '', it.id ?? '')}>×</button>)}
                        </div>
                        <KeywordTags
                          value={kwRead(it)}
                          onChange={kws => setIntentKeywords(wf.id ?? '', it.id ?? '', kws)}
                          placeholder={language === kwPrimary ? 'keywords for this intent' : 'keywords in this language'}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

    </div>
    </>
  );
}

// ══ v12.10.23 (#2029): THE CALLER TYPE'S CATCH-ALL. The same test as the engine (SnapshotCallInterpreter.IsSomethingElse):
// the label 'Something else' / 'Other' / 'Otro' / 'Otra cosa' / 'Algo más', or the id 'something-else'. Always last, never deleted.
function isSomethingElseIntent(i?: { id?: string; label?: string } | null): boolean {
  if (!i) return false;
  const l = (i.label ?? '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  return /^(something else|other|otro|otra cosa|algo mas)\b/.test(l) || (i.id ?? '').toLowerCase() === 'something-else';
}

// v12.10.23 (#2028 #2029): the request menu lines (PlatformPhrases menu.intent.*) - served as cardLines; these are only the
// fallback while that list loads. Kept identical to the engine's EN / ES rows.
const MENU_LINE_DEFAULTS: Record<string, Record<string, string>> = {
  'menu.intent.reask': { en: 'Are you calling about {0}?', es: '¿Llama por {0}?' },
  'menu.intent.somethingElse': { en: 'something else', es: 'algo más' },
  'menu.intent.or': { en: 'or', es: 'o' },
  'menu.intent.opener': { en: 'What can I help you with? ', es: '¿En qué puedo ayudarle? ' },
  'menu.intent.sayOrPress': { en: 'Say {0}, or press {1}. ', es: 'Diga {0}, o presione {1}. ' },
  'menu.intent.sayIt': { en: 'You can say {0}. ', es: 'Usted puede decir {0}.' },
  'menu.intent.anythingElse': { en: 'For anything else, press {0}. ', es: 'Para cualquier otra cosa, presione {0}. ' },
};
type CardLine = (key: string, lang: string) => string;
function menuLine(cl: CardLine, key: string, lang: string): string {
  return cl(key, lang) || MENU_LINE_DEFAULTS[key]?.[canonLang(lang)] || MENU_LINE_DEFAULTS[key]?.en || '';
}
const fmtLine = (t: string, a: string, b = '') => t.replace('{0}', a).replace('{1}', b);
function requestLabel(i: WorkflowIntent, lang: string): string {
  return (i.labelByLang?.[lang] ?? '').trim() || i.label || i.id || '';
}
/** Step 1 when the caller type is known and the request is not (BuildRequestReask): the first three requests + something else. */
function requestReaskDefault(wf: WorkflowLane, lang: string, cl: CardLine): string {
  const names = (wf.intents ?? []).filter(i => i.enabled !== false && !isSomethingElseIntent(i)).slice(0, 3).map(i => requestLabel(i, lang));
  names.push(menuLine(cl, 'menu.intent.somethingElse', lang));
  const or = menuLine(cl, 'menu.intent.or', lang);
  const joined = names.length === 1 ? names[0]
    : names.length === 2 ? `${names[0]} ${or} ${names[1]}`
    : `${names.slice(0, -1).join(', ')}, ${or} ${names[names.length - 1]}`;
  return fmtLine(menuLine(cl, 'menu.intent.reask', lang), joined);
}
/** Step 2 (BuildRequestMenu) without the menu keys: say-or-press for the first `max` requests, then "for anything else". */
function requestMenuDefault(wf: WorkflowLane, lang: string, cl: CardLine, max = 3): string {
  const live = (wf.intents ?? []).filter(i => i.enabled !== false);
  const se = live.find(i => isSomethingElseIntent(i));
  let out = menuLine(cl, 'menu.intent.opener', lang);
  for (const i of live.filter(x => !isSomethingElseIntent(x)).slice(0, max)) {
    const key = (i.key ?? '').trim();
    out += key ? fmtLine(menuLine(cl, 'menu.intent.sayOrPress', lang), requestLabel(i, lang), key)
               : fmtLine(menuLine(cl, 'menu.intent.sayIt', lang), requestLabel(i, lang)).trimEnd() + ' ';
  }
  if (se && (se.key ?? '').trim()) out += fmtLine(menuLine(cl, 'menu.intent.anythingElse', lang), (se.key ?? '').trim());
  else if (se) out += fmtLine(menuLine(cl, 'menu.intent.sayIt', lang), requestLabel(se, lang)).trimEnd() + ' ';
  return out.trim();
}

// v12.2.20.0 (#139): auto-computed workflow "purpose" from its intent labels. Kept in sync into
// workflow.description on every structural edit so downstream (previews, backlog) reads a real value.
function computePurpose(intents: Array<{ label?: string }> | undefined): string {
  const names = (intents ?? []).map(i => (i.label || '').trim()).filter(Boolean);
  if (names.length === 0) return '';
  if (names.length === 1) return `Handles ${names[0]}.`;
  if (names.length === 2) return `Handles ${names[0]} and ${names[1]}.`;
  return `Handles ${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}.`;
}

function WorkflowEditor({ card, doc, onUpdate, language, languages, onLanguage }: { card: Extract<CardRef, { kind: 'workflow' }>; doc: DesignerDocument; onUpdate: (mutator: (next: DesignerDocument) => void) => void;
  language?: string; languages?: { code: string; displayName: string }[]; onLanguage?: (code: string) => void }) {
  const tok = useTokenSource(doc);   // v12.10.23 (#2028): hooks before the early return
  const cl = useCardLines();
  const workflow = doc.workflows?.find(item => item.id === card.workflowId);
  if (!workflow) return null;
  const intents = workflow.intents ?? [];
  const totalWorkflows = doc.workflows?.length ?? 0;
  const autoPurpose = computePurpose(intents);

  // v12.2.20.0 (#139/#140): editing an EXISTING caller type now supports rename + full child management
  // (add / remove / reorder intents). Purpose is auto-derived from the intents (no manual free-text). At
  // least one intent per caller type and at least one caller type overall are enforced (delete disabled).
  const rename = (value: string) => onUpdate(next => {
    const t = next.workflows?.find(i => i.id === card.workflowId);
    if (t) { t.name = value; t.description = computePurpose(t.intents); }
  });
  const addIntentHere = () => onUpdate(next => {
    const t = next.workflows?.find(i => i.id === card.workflowId);
    if (!t) return;
    t.intents ??= [];
    // v12.10.23 (#2029): a new request goes in before Something else, which stays last.
    const fresh = { id: makeId('intent'), label: 'New intent', keywords: [], confidenceThreshold: 0.7, fallbackMode: 'clarify-then-keypad', nodes: [] };
    const seAt = t.intents.findIndex(i => isSomethingElseIntent(i));
    if (seAt >= 0) t.intents.splice(seAt, 0, fresh); else t.intents.push(fresh);
    t.description = computePurpose(t.intents);
  });
  const removeIntent = (intentId: string) => onUpdate(next => {
    const t = next.workflows?.find(i => i.id === card.workflowId);
    if (!t?.intents || t.intents.length <= 1) return; // guard: keep >= 1 intent
    if (isSomethingElseIntent(t.intents.find(i => i.id === intentId))) return;   // v12.10.23 (#2029): never deleted
    t.intents = t.intents.filter(i => i.id !== intentId);
    t.description = computePurpose(t.intents);
  });

  // v12.7.3 (#646): one digit, and only a digit. 0 is reserved by the keypad menu to repeat, so it is not
  // offered here; an empty value clears the key rather than storing "". A duplicate is not blocked in the
  // input - the warning below says which ones collide, because silently refusing a keystroke is worse than
  // showing the tenant what they have done.
  const setIntentKey = (intentId: string, raw: string) => {
    const digit = (raw ?? '').replace(/[^1-9]/g, '').slice(-1);
    onUpdate(next => {
      const wf = next.workflows?.find(w => w.id === card.workflowId);
      const target = wf?.intents?.find(i => i.id === intentId);
      if (target) target.key = digit || undefined;
    });
  };

  const moveIntent = (intentId: string, dir: -1 | 1) => onUpdate(next => {
    const t = next.workflows?.find(i => i.id === card.workflowId);
    if (!t?.intents) return;
    const idx = t.intents.findIndex(i => i.id === intentId);
    const j = idx + dir;
    if (idx < 0 || j < 0 || j >= t.intents.length) return;
    if (isSomethingElseIntent(t.intents[idx]) || isSomethingElseIntent(t.intents[j])) return;   // v12.10.23 (#2029): Something else stays last
    [t.intents[idx], t.intents[j]] = [t.intents[j], t.intents[idx]];
  });
  const deleteWorkflow = () => onUpdate(next => {
    if (!next.workflows || next.workflows.length <= 1) return; // guard: keep >= 1 caller type
    next.workflows = next.workflows.filter(i => i.id !== card.workflowId);
  });

  const rowBtn: React.CSSProperties = { height: 30, width: 30, border: '1px solid #e2e8f0', borderRadius: 7, background: '#fff', cursor: 'pointer', color: '#475569' };
  return (
    <>
    <div className="tenant-drawer-section">
      <SectionTitle title="Caller type" note="Parallel entry point" help={[
        ['What it does', 'A caller type is one reason-bucket a caller can land in (its own workflow). Rename it, and add or reorder the intents it contains below.'],
        ['When it fires', 'Classification (or the keypad menu) routes each caller into exactly one caller type; its Purpose is auto-derived from the intents inside.'],
        ['Example', 'A “Pharmacy” caller type holds the Refill request intent; callers about refills route here.'],
      ]} />
      <TextField label="Name" help={[['What it does', 'The caller type’s name — the reason-bucket a caller lands in (e.g. Patient, Pharmacy). Shown on the canvas and used to auto-build the keypad menu.'], ['When it fires', 'In the builder, and spoken as the option label when a keypad menu is auto-built.'], ['Example', 'Rename a workflow to “Insurance” and the keypad menu can say “press 3 for Insurance”.']]} value={workflow.name ?? ''} onChange={rename} />
      <div className="tenant-form-field">
        <label>Purpose <span className="aa-hint">— auto from intents</span></label>
        <p className="tenant-auto-purpose">{autoPurpose || 'No intents yet — add at least one below.'}</p>
      </div>

      <SectionTitle title="Intents" note={`${intents.length} · at least one required`} help={[
        ['What it does', 'The specific reasons within this caller type. Add, remove or reorder them here; open an intent from the canvas to edit its keywords and steps.'],
        ['When it fires', 'After the caller is routed to this caller type, classification picks the matching intent to run.'],
        ['Example', 'The Patient caller type holds Make Appointment, Cancel Appointment and Change Appointment intents.'],
      ]} />
      {intents.length === 0
        ? <div className="tenant-kw-empty">No intents yet — add one below.</div>
        : intents.map((it, idx) => { const se = isSomethingElseIntent(it); const nextSe = isSomethingElseIntent(intents[idx + 1]); return (
          <div key={it.id ?? idx} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
            <span style={{ flex: 1, fontSize: 13.5, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.label || 'Intent'}</span>
            {/* v12.10.23 (#2029, UI-PROTO-MENUS-T174 v1.5): the caller type's catch-all - always last, never deleted (it can be disabled / renamed). */}
            {se && <span style={{ marginLeft: 8, fontSize: 10.5, fontWeight: 800, borderRadius: 5, padding: '1px 6px', background: '#eef2ff', color: '#4338ca', whiteSpace: 'nowrap' }}>ALWAYS LAST &middot; CANNOT BE DELETED</span>}
            {/* ── v12.7.3 (#646): THE KEY THAT REACHES **THIS** INTENT. ──────────────────────────────────
                Tushar: *"where is the key for workflow intent?"* Pressing 1 for Patient dropped him straight
                into Appointment and started asking for a name, because RouteByDigit took the FIRST enabled
                intent unconditionally - four of his five Patient intents could not be reached by keypad at all.
                A caller type's digit now selects the CALLER TYPE; this selects the intent within it.
                It sits exactly where he boxed it: between the intent name and its reorder / delete controls.
                Blank is valid and is the default - the intent is then reachable by voice only, which is what
                every intent was before this field existed. */}
            <input
              value={it.key ?? ''}
              onChange={e => setIntentKey(it.id ?? '', e.target.value)}
              maxLength={1}
              inputMode="numeric"
              placeholder="key"
              title="The keypad digit that reaches this intent. Leave blank for voice only."
              aria-label={`Keypad key for ${it.label || 'intent'}`}
              style={{ width: 34, height: 28, textAlign: 'center', fontSize: 13, fontWeight: 600,
                       border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff', color: '#0f172a',
                       padding: 0, marginRight: 2 }} />
            <button type="button" title="Move up" style={{ ...rowBtn, opacity: se ? 0.35 : idx === 0 ? 0.4 : 1 }} disabled={se || idx === 0} onClick={() => moveIntent(it.id ?? '', -1)}>↑</button>
            <button type="button" title="Move down" style={{ ...rowBtn, opacity: se ? 0.35 : (idx === intents.length - 1 || nextSe) ? 0.4 : 1 }} disabled={se || nextSe || idx === intents.length - 1} onClick={() => moveIntent(it.id ?? '', 1)}>↓</button>
            <button type="button" title={intents.length <= 1 ? 'At least one intent is required' : 'Remove intent'} style={{ ...rowBtn, color: '#b91c1c', opacity: intents.length <= 1 ? 0.4 : 1, visibility: se ? 'hidden' : 'visible' }} disabled={se || intents.length <= 1} onClick={() => removeIntent(it.id ?? '')}>×</button>
          </div>
        ); })}
      <button type="button" style={{ marginTop: 4, height: 34, padding: '0 14px', border: '1px dashed #cbd5e1', borderRadius: 8, background: '#f8fafc', color: '#ea580c', fontWeight: 600, cursor: 'pointer' }} onClick={addIntentHere}>+ Add intent</button>

      <div style={{ marginTop: 18, paddingTop: 12, borderTop: '1px solid #f1f5f9' }}>
        <button type="button" disabled={totalWorkflows <= 1} title={totalWorkflows <= 1 ? 'At least one caller type is required' : 'Delete this caller type'}
          style={{ height: 34, padding: '0 14px', border: '1px solid #fecaca', borderRadius: 8, background: totalWorkflows <= 1 ? '#f8fafc' : '#fff', color: '#b91c1c', fontWeight: 600, cursor: totalWorkflows <= 1 ? 'default' : 'pointer', opacity: totalWorkflows <= 1 ? 0.5 : 1 }}
          onClick={deleteWorkflow}>Delete caller type</button>
        {totalWorkflows <= 1 && <p className="tenant-field-note">This is the only caller type — at least one is required, so it can’t be deleted.</p>}
      </div>
    </div>
    <SpokenNameRail doc={doc} what="caller type" name={workflow.name ?? ''} byLang={workflow.nameByLang} language={language} languages={languages} onLanguage={onLanguage}
      onChange={(lang, value) => onUpdate(next => { const t = next.workflows?.find(w => w.id === card.workflowId); if (t) { t.nameByLang = { ...(t.nameByLang ?? {}) }; if (value) t.nameByLang[lang] = value; else delete t.nameByLang[lang]; } })} />
    {/* ══ v12.10.23 (#2028 #2029, UI-PROTO-MENUS-T174 v1.5 LOCKED): this caller type's own menu, per language (the rail above).
        Step 1 the Re-ask line (blank = the first three requests + Something else); step 2 the Keypad menu - ONE collapsed row like the
        Interceptor rows, holding an optional wording override (blank = built from the requests). Stored as requestReask / requestMenuPrompt. ══ */}
    {(() => {
      const primary = primaryLangCode(doc);
      const lang = language || primary;
      const realCount = intents.filter(i => i.enabled !== false && !isSomethingElseIntent(i)).length;
      const reaskDefault = requestReaskDefault(workflow, lang, cl);
      const menuDefault = requestMenuDefault(workflow, lang, cl);
      const patchLang = (field: 'requestReask' | 'requestMenuPrompt', value: string) => onUpdate(next => {
        const t = next.workflows?.find(w => w.id === card.workflowId);
        if (!t) return;
        const map = { ...(t[field] ?? {}) };
        if (value.trim()) map[lang] = value; else delete map[lang];
        t[field] = Object.keys(map).length ? map : undefined;
      });
      return (
        <div className="tenant-drawer-section">
          <SectionTitle title="Re-ask line" note={`per language · ${lang.toUpperCase()}`} help={[
            ['What it does', 'What the agent asks when the caller is in this caller type but did not say a request it can place - step 1, words only, no keys.'],
            ['When it fires', 'After the caller’s words did not match a request of this caller type.'],
            ['Template default', 'The first three requests + Something else: “Are you calling about A, B, C, or something else?”. Write your own to override it.'],
          ]} />
          <PromptEditor value={workflow.requestReask?.[lang] ?? ''} onChange={value => patchLang('requestReask', value)} platformDefault={reaskDefault} rows={2} language={lang}
            translateSource={workflow.requestReask?.[primary] ?? ''} translateSourceLang={primary} translateSourceDefault={requestReaskDefault(workflow, primary, cl)} groups={tok.groups} known={tok.known} />
          <IcpCard icon="#" title="Keypad menu" chip="Menu" chipKind="new"
            description={realCount > 1
              ? 'When the re-ask did not get the caller to a request: say-or-press for the first three requests (short menus), then Something else. Menu keys: Settings › Call Handling › Keypad menus.'
              : 'One request + Something else: no keypad menu - a miss on the re-ask goes to Something else.'}
            fires="request · after the re-ask"
            help={[
              ['What it does', 'Step 2 - the keypad menu for this caller type’s requests: “Say {request}, or press {key}.”, then “For anything else, press {key}.” and the menu keys.'],
              ['When it fires', 'Only when the Re-ask line did not get the caller to a request, and the caller type has more than one request.'],
              ['Keys', 'Each request’s key is set on its row above; repeat, main menu and a person come from Settings › Call Handling › Keypad menus.'],
            ]}
            enabled={realCount > 1} disabledToggle>
            <div className="icp-fld">
              <div className="lab">Keypad menu wording &middot; {lang.toUpperCase()} &middot; optional</div>
              <PromptEditor value={workflow.requestMenuPrompt?.[lang] ?? ''} onChange={value => patchLang('requestMenuPrompt', value)} platformDefault={menuDefault} rows={3} language={lang}
                translateSource={workflow.requestMenuPrompt?.[primary] ?? ''} translateSourceLang={primary} translateSourceDefault={requestMenuDefault(workflow, primary, cl)} groups={tok.groups} known={tok.known} />
              <p className="icp-note">Template default: &ldquo;{menuDefault}&rdquo; + the menu keys from Settings &rsaquo; Call Handling &rsaquo; Keypad menus (repeat 0, main menu *, a person 9 while handoff is on). With short menus on, only the first three requests are read; the others still work when said or pressed.</p>
            </div>
          </IcpCard>
        </div>
      );
    })()}
    </>
  );
}

function IntentEditor({ card, doc, onUpdate, language, languages, onLanguage }: { card: Extract<CardRef, { kind: 'intent' }>; doc: DesignerDocument; onUpdate: (mutator: (next: DesignerDocument) => void) => void;
  language?: string; languages?: { code: string; displayName: string }[]; onLanguage?: (code: string) => void }) {
  const parentWf = doc.workflows?.find(item => item.id === card.workflowId);
  const intent = parentWf?.intents?.find(item => item.id === card.intentId);
  if (!intent) return null;
  const siblingCount = parentWf?.intents?.length ?? 0;
  // v12.2.20.0 (#140): removing this intent is blocked when it's the workflow's last one (>=1 required).
  const removeSelf = () => onUpdate(next => {
    const wf = next.workflows?.find(i => i.id === card.workflowId);
    if (!wf?.intents || wf.intents.length <= 1) return;
    if (isSomethingElseIntent(wf.intents.find(i => i.id === card.intentId))) return;   // v12.10.23 (#2029)
    wf.intents = wf.intents.filter(i => i.id !== card.intentId);
    wf.description = computePurpose(wf.intents);
  });
  return (
    <>
    <div className="tenant-drawer-section">
      <SectionTitle title="Intent" note="Classifier target" help={[['What it does', 'Configures one intent — a specific reason within a caller type (e.g. Make Appointment). Set its keywords, confidence and on-fail here; its nodes/steps are edited from the canvas.'], ['When it fires', 'When the classifier routes a caller in this caller type to this intent.'], ['Example', 'The Make Appointment intent’s keywords catch “book a visit” and run its capture → confirm → book nodes.']]} />
      <TextField label="Name" help={[['What it does', 'The intent’s label — a specific reason within a caller type (e.g. Make Appointment, Refill request).'], ['When it fires', 'Used by the classifier as the routing target and shown as the message category on the workspace card.'], ['Example', 'An intent “Make Appointment” routes booking calls and tags those messages with the Appointment category.']]} value={intent.label ?? ''} onChange={value => onUpdate(next => {
        const wf = next.workflows?.find(item => item.id === card.workflowId);
        const target = wf?.intents?.find(item => item.id === card.intentId);
        if (target) { target.label = value; if (wf) wf.description = computePurpose(wf.intents); }
      })} />
      {/* ══ v12.10.22 (#2011, prototype v1.0 LOCKED 10/26): Category - its own (default, as today) or an existing category: another
          intent's, so two intents that mean the same are one Personalization row and one filter chip. Only intents that are their own
          category are offered (one level); an intent other intents already file under keeps its own. ══ */}
      {(() => {
        const myId = intent.id ?? '';
        const filedHere = (doc.workflows ?? []).flatMap(w => (w.intents ?? []).filter(i => i.id !== myId && (i.category ?? '') === myId).map(i => `${w.name || 'Caller type'} \u203a ${i.label || 'Intent'}`));
        const opts: { v: string; l: string }[] = [{ v: '', l: `Its own - \u201c${intent.label || 'this intent'}\u201d` }];
        for (const w of doc.workflows ?? [])
          for (const i of w.intents ?? []) {
            if (!i.id || i.id === myId || (i.category ?? '').trim()) continue;
            const users = (doc.workflows ?? []).flatMap(w2 => (w2.intents ?? []).filter(x => x.id !== i.id && x.id !== myId && (x.category ?? '') === i.id).map(() => w2.name || 'Caller type'));
            opts.push({ v: i.id, l: `${i.label || i.id} (${w.name || 'Caller type'}${users.length ? `, also used by ${Array.from(new Set(users)).join(', ')}` : ''})` });
          }
        const cur = (intent.category ?? '').trim();
        return (
          <label className="tenant-form-field">
            <span>Category<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
              ['What it does', 'The category calls that take this intent are filed under - the pill on the message and its filter chip.'],
              ['Its own', 'This intent card is its own category (as before).'],
              ['An existing category', 'Pick another intent\u2019s category when the two mean the same - e.g. Physician \u203a Referral / orders files under Patient\u2019s Orders & referrals. One row in Personalization \u203a Categories, one filter chip; the caller type still tells patient from office, and the message still names this exact intent.'],
              ['Old messages', 'Keep what they were stored with - nothing is re-tagged.'],
            ]} /></span></span>
            <select value={cur} disabled={filedHere.length > 0 && !cur}
              onChange={e => onUpdate(next => { const t = next.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId); if (t) t.category = e.target.value || undefined; })}>
              {opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
            </select>
            {filedHere.length > 0 && <span className="tenant-field-note" style={{ margin: '4px 0 0' }}>Also the category of {filedHere.join(', ')} - it stays its own.</span>}
          </label>
        );
      })()}
      <label className="tenant-form-field">
        <span>Keywords<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Phrases that route a caller to this intent when the keyword classifier runs. Add a phrase and press Enter or comma.'], ['When it fires', 'On classification a keyword hit routes straight here, skipping the LLM.'], ['Example', 'appointment, book, schedule routes booking calls to this intent.']]} /></span></span>
        <KeywordChips value={intent.keywords ?? []} onChange={next2 => onUpdate(next => { const target = next.workflows?.find(item => item.id === card.workflowId)?.intents?.find(item => item.id === card.intentId); if (target) target.keywords = next2; })} />
      </label>
      {/* v12.10.17 (#1723 T120 follow-up): the "Files under" picker (#1486) is RETIRED per Tushar 10/16 - the message category is
          this intent card itself (BDR-018 D10/D12). An old snapshot's filesUnder is left in the JSON, untouched. */}
      <TextField label="Confidence threshold" help={[['What it does', 'How sure the classifier must be to pick THIS intent within its caller type.'], ['When it fires', 'When scoring the caller’s reason against this intent.'], ['Example', 'A higher threshold (0.8) means only a clear “I need to reschedule” routes to Reschedule; borderline phrasing falls through.']]} value={String(intent.confidenceThreshold ?? 0.7)} onChange={value => onUpdate(next => {
        const target = next.workflows?.find(item => item.id === card.workflowId)?.intents?.find(item => item.id === card.intentId);
        if (target) target.confidenceThreshold = Number(value) || 0.7;
      })} />
      <SelectField label="On fail" help={[['What it does', 'What happens when the caller matches this caller type but no specific intent clears its threshold.'], ['When it fires', 'After intent classification fails within this caller type.'], ['Example', '“Clarify then keypad” → the agent asks the caller to restate what they need, then offers keypad options.']]} value={intent.fallbackMode ?? 'clarify-then-keypad'} options={FALLBACK_OPTIONS} onChange={value => onUpdate(next => {
        const target = next.workflows?.find(item => item.id === card.workflowId)?.intents?.find(item => item.id === card.intentId);
        if (target) target.fallbackMode = value;
      })} />
      {isSomethingElseIntent(intent) ? (
        /* v12.10.23 (#2029): Something else is the caller type's catch-all - never removed. */
        <p className="tenant-field-note" style={{ marginTop: 18 }}>Something else is this caller type&rsquo;s catch-all - always last; it can be disabled or renamed, never removed.</p>
      ) : (
      <div style={{ marginTop: 18, paddingTop: 12, borderTop: '1px solid #f1f5f9' }}>
        <button type="button" disabled={siblingCount <= 1} title={siblingCount <= 1 ? 'At least one intent is required' : 'Remove this intent'}
          style={{ height: 34, padding: '0 14px', border: '1px solid #fecaca', borderRadius: 8, background: siblingCount <= 1 ? '#f8fafc' : '#fff', color: '#b91c1c', fontWeight: 600, cursor: siblingCount <= 1 ? 'default' : 'pointer', opacity: siblingCount <= 1 ? 0.5 : 1 }}
          onClick={removeSelf}>Remove intent</button>
        {siblingCount <= 1 && <p className="tenant-field-note">This is the only intent in its caller type — at least one is required, so it can’t be removed.</p>}
      </div>
      )}
    </div>
    <SpokenNameRail doc={doc} what="intent" name={intent.label ?? ''} byLang={intent.labelByLang} language={language} languages={languages} onLanguage={onLanguage}
      onChange={(lang, value) => onUpdate(next => { const t = next.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId); if (t) { t.labelByLang = { ...(t.labelByLang ?? {}) }; if (value) t.labelByLang[lang] = value; else delete t.labelByLang[lang]; } })} />
    </>
  );
}

// v12.10.17 (#1723 T120 follow-up): FilesUnderField (#1486, UI-PROTO-T56 v1.25 screen "files") removed - retired per Tushar 10/16.

// v12.2.47.0 (Request-node): add/edit a request type (Name + optional Keywords + Enabled). Keywords are grounding
// hints only - the classifier derives the type from meaning, so they are never required.
function RequestTypeSettingsPopup({ rt, onSave, onCancel }: {
  rt: WorkflowRequestType | null;
  onSave: (name: string, keywords: string[], enabled: boolean) => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState(rt?.name ?? '');
  const [keywords, setKeywords] = useState((rt?.keywords ?? []).join(', '));
  const [enabled, setEnabled] = useState(rt?.enabled !== false);
  const save = () => {
    const nm = name.trim();
    if (!nm) return;
    const kw = keywords.split(',').map(k => k.trim()).filter(Boolean);
    onSave(nm, kw, enabled);
  };
  return (
    <div className="tenant-rt-popup">
      <div className="tenant-rt-popup-title">{rt ? 'Edit request type' : 'Add request type'}</div>
      <label className="tenant-rt-popup-field">
        <span>Name</span>
        <input autoFocus value={name} placeholder="e.g. Change appointment" onChange={e => setName(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') save(); else if (e.key === 'Escape') onCancel(); }} />
      </label>
      <label className="tenant-rt-popup-field">
        <span>Keywords <small>(optional)</small></span>
        <input value={keywords} placeholder="words the caller might say, separated by commas (optional)" onChange={e => setKeywords(e.target.value)} />
      </label>
      <p className="tenant-field-note">Keywords are optional hints — the assistant understands natural phrasing without them. Separate with commas.</p>
      {rt && (
        <label className="tenant-rt-popup-toggle">
          <input type="checkbox" checked={enabled} onChange={e => setEnabled(e.target.checked)} /> Enabled
        </label>
      )}
      <div className="tenant-rt-popup-actions">
        <button type="button" className="tenant-rt-popup-cancel" onClick={onCancel}>Cancel</button>
        <button type="button" className="tenant-rt-popup-save" onClick={save}>{rt ? 'Save' : 'Add'}</button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// v12.2.47.5 (#269): Request-node drawer rebuilt to SPEC_request_node_v1_3 / reference v1.8.
// Centered confirm dialog (shared destructive-action pattern, §3.8) — focus lands on Cancel.
function ConfirmDialog({ title, body, consequence, confirmWord, onCancel, onConfirm }: {
  title: string; body: string; consequence?: JSX.Element | null; confirmWord?: string | null; onCancel: () => void; onConfirm: () => void;
}) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  // v12.3.9 (#238-D): destructive deletes inside the drawer (a step, a request type) now ask the author to TYPE
  // the name back before Delete enables - the same gate the card-level delete has used since #186. When no
  // confirmWord is supplied the dialog behaves exactly as before (plain Cancel / Delete).
  const typeRef = useRef<HTMLInputElement>(null);
  const [typed, setTyped] = useState('');
  const needsType = !!(confirmWord && confirmWord.trim());
  const matched = typed.trim().toLowerCase() === (confirmWord ?? '').trim().toLowerCase();
  const canDelete = !needsType || matched;
  useEffect(() => { if (needsType) typeRef.current?.focus(); else cancelRef.current?.focus(); }, [needsType]);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.preventDefault(); onCancel(); } };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onCancel]);
  return (
    <div className="rq-scrim rq" onMouseDown={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="rq-cdlg" role="alertdialog" aria-modal="true" aria-label={title}>
        <h3>{title}</h3>
        <p>{body}</p>
        {consequence != null && <div className="rq-conseq">{consequence}</div>}
        {needsType && (
          <div className="tenant-delete-confirm">
            <label htmlFor="rq-ctype-input">Type <b>{confirmWord}</b> to confirm</label>
            <input id="rq-ctype-input" ref={typeRef} value={typed} placeholder={confirmWord ?? ''} autoComplete="off"
              className={matched ? 'is-ok' : ''} onChange={e => setTyped(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter' && canDelete) { e.preventDefault(); onConfirm(); } }} />
          </div>
        )}
        <div className="rq-cfoot">
          <button ref={cancelRef} type="button" className="rq-cbtn-cancel" onClick={onCancel}>Cancel</button>
          <button type="button" className="rq-cbtn-danger" onClick={onConfirm} disabled={!canDelete}>Delete</button>
        </div>
      </div>
    </div>
  );
}

// v12.3.9 (#238-D): confirmWord = the text the author must type back before Delete enables (null = no gate).
type RqConfirm = { title: string; body: string; consequence: JSX.Element | null; confirmWord?: string | null; run: () => void };

/** v12.10.15 (#1643): the fields a set of steps stores, as their labels. */
function askTogetherFields(steps: WorkflowStep[], vocabLabels: Parameters<typeof tokenLabel>[1], vocabCustom: Parameters<typeof tokenLabel>[2]): string[] {
  const keys = steps.filter(st => st.enabled !== false).flatMap(st => (st.stores ?? '').split(/[,;\n]+/).map(k => canonStoreKey(k).trim()).filter(Boolean));
  return [...new Set(keys)].map(k => tokenLabel(k, vocabLabels, vocabCustom) ?? prettyField(k.split('.').pop() ?? k));
}

// ══ v12.10.16 (#1676): SWITCHING ASK TOGETHER ON FILLS THE COMBINED QUESTION (still editable). ══════════════════════════════
// Identity name + date of birth + ZIP gets the platform sentence UMG runs (EN + ES, Santos-reviewed with the 12.10.15 defaults).
// Any other set of fields gets an English sentence built from the field names; Spanish stays blank (= the steps ask one by one in
// Spanish) until someone who reads Spanish writes it - a machine-built Spanish list would need genders we do not hold here.
const ASK_TOGETHER_IDENTITY: Record<string, string> = {
  en: 'May I have the patient\u2019s full name, date of birth, and ZIP code?',
  es: '\u00bfMe puede dar el nombre completo, la fecha de nacimiento y el c\u00f3digo postal del paciente?',
};
function defaultAskTogether(fields: string[], identity: boolean): Record<string, string> {
  const low = fields.map(f => f.trim()).filter(Boolean);
  const norm = low.map(f => f.toLowerCase());
  const isNameDobZip = identity && norm.some(f => f.includes('name')) && norm.some(f => f.includes('birth') || f === 'dob') && norm.some(f => f.includes('zip'));
  if (isNameDobZip) return { ...ASK_TOGETHER_IDENTITY };
  if (low.length < 2) return {};
  const words = low.map(f => (/^[A-Z]{2,}/.test(f) ? f : f.charAt(0).toLowerCase() + f.slice(1)));
  const list = words.length === 2 ? `${words[0]} and ${words[1]}` : `${words.slice(0, -1).join(', ')}, and ${words[words.length - 1]}`;
  return { en: `${identity ? 'May I have the patient\u2019s' : 'May I have the'} ${list}?` };
}

// ══ v12.10.15 (#1643, UI-PROTO-IDENTITY-ASK-TOGETHER-B1 v1.3 + UI-PROTO-REQUEST-ASK-TOGETHER-B1 v1.3 LOCKED) ══════════════════
// Ask together, between the language tabs and Steps: the switch, the combined question in the tab language, and the fields the
// answer is read for. A node / type with no steps cannot switch it on. Help text lives in the ? tooltip (S123).
function AskTogetherBlock({ on, prompt, language, fields, noSteps, scopeLabel, onChange }: {
  on: boolean; prompt: Record<string, string> | undefined; language: string; fields: string[]; noSteps: boolean; scopeLabel: string;
  onChange: (patch: { askTogether?: boolean; askTogetherPrompt?: Record<string, string> }) => void;
}) {
  const text = prompt?.[language] ?? '';
  return (
    <div className={`rq-asktog${on ? ' is-on' : ''}`}>
      <div className="rq-asktog-head">
        <span className="lb">Ask together <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
          ['What it does', `One question for every field ${scopeLabel} collects. The answer is read once and each field goes to its step; the step checks it - a confident answer is not read back, an unsure one is read back by its own step.`],
          ['If something is missing', 'Only the missing field is asked, with the short line \u201cAnd the date of birth?\u201d - never the step\u2019s full question again. The step\u2019s re-ask line is used only when an answer was misheard.'],
          ['Question budget', 'The combined question counts as one question.'],
          ['Example', '\u201cMay I have the patient\u2019s full name, date of birth, and ZIP code?\u201d'],
        ]} /></span></span>
        <button type="button" role="switch" aria-checked={on} aria-label="Ask together" disabled={noSteps && !on}
          title={noSteps ? 'Add a step first' : undefined}
          className={'rq-sw' + (on ? ' on' : '')} onClick={() => {
            // v12.10.16 (#1676): switching ON fills the combined question in every language whose box is empty
            if (on) { onChange({ askTogether: false }); return; }
            const def = defaultAskTogether(fields, scopeLabel.includes('Identity'));
            const filled: Record<string, string> = { ...(prompt ?? {}) };
            let changed = false;
            for (const [lng, line] of Object.entries(def)) if (!(filled[lng] ?? '').trim()) { filled[lng] = line; changed = true; }
            onChange(changed ? { askTogether: true, askTogetherPrompt: filled } : { askTogether: true });
          }}><span className="rq-sw-thumb" aria-hidden="true" /></button>
      </div>
      {on && (
        <>
          <label className="tenant-form-field">
            <span>Combined question <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'What the agent asks, in this tab\u2019s language. Blank = the steps ask one by one in this language.']]} /></span></span>
            <textarea rows={2} value={text}
              onChange={e => onChange({ askTogetherPrompt: { ...(prompt ?? {}), [language]: e.target.value } })} />
          </label>
          <div className="rq-asktog-fields">
            <span className="rq-ladtog-txt">Fields read from the answer</span>
            {fields.length === 0 ? <span className="tenant-field-note">No fields yet - pick what each step stores.</span>
              : fields.map(f => <span key={f} className="rq-ladchip on">{f}</span>)}
          </div>
        </>
      )}
    </div>
  );
}

function RequestNodeEditor({ card, doc, language, languages, onLanguage, onUpdate }: {
  card: Extract<CardRef, { kind: 'node' }>;
  doc: DesignerDocument;
  language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const offTerminals = useOffTerminals();   // v12.10.4 (#1119)
  // v12.3.10.1 (#303): one served catalog, for the picker AND the unresolved-token check.
  const { catalog: vocabCatalog, vocab: vocabLabels, customFields: vocabCustom, lists: vocabLists } = useVocabulary();
  const confDefaults = useConfidenceDefaults();   // v12.10.21 (#1957): the field type's Confidence default, from configuration
  const node = findNode(doc, card);
  const { data: aiAgent } = useQuery<AiAgentTokenSettings>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<AiAgentTokenSettings>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  const identifiers: IdRow[] = [];   // v12.10.8 (#1190): Identity extraction is gone - Vocabulary is the only source
  const requestTypes = node?.requestTypes ?? [];
  const [rtSel, setRtSel] = useState(0);
  const [rtMenuFor, setRtMenuFor] = useState<string | null>(null);
  const [renamingRt, setRenamingRt] = useState<string | null>(null);
  const [stepMenuFor, setStepMenuFor] = useState<string | null>(null);
  const [confirm, setConfirm] = useState<RqConfirm | null>(null);
  const lastFocus = useRef<Element | null>(null);

  const rtIndex = Math.min(rtSel, Math.max(0, requestTypes.length - 1));
  const activeRt = requestTypes[rtIndex];
  // v12.10.22 (#1994): Move earlier / later inside the card - applied (and saved) with the drawer's Done, like every other edit here.
  const moveRt = (id: string, by: -1 | 1) => onUpdate(next => {
    const t = findNode(next, card);
    const arr = t?.requestTypes;
    if (!arr) return;
    const at = arr.findIndex(r => r.id === id);
    const to = at + by;
    if (at < 0 || to < 0 || to >= arr.length) return;
    const [m] = arr.splice(at, 1);
    arr.splice(to, 0, m);
  });
  // v12.9.26 (#988): on a language tab the chips read THAT language's name (nameByLang, filled at publish #911), and
  // Rename edits that language's name only - the primary name stays the stable key (BDR-001 v1.1).
  const rtPrimary = primaryLangCode(doc);
  const rtName = (rt: WorkflowRequestType) => (language === rtPrimary ? rt.name : (rt.nameByLang?.[language] || rt.name)) || 'Untitled';
  const renameRt = (rt: WorkflowRequestType, v: string) => {
    if (language === rtPrimary) patchRt(rt.id!, { name: v });
    else patchRt(rt.id!, { nameByLang: { ...(rt.nameByLang ?? {}), [language]: v } });
  };
  const steps = activeRt?.steps ?? [];

  const openConfirm = (c: RqConfirm) => { lastFocus.current = document.activeElement; setConfirm(c); };
  const closeConfirm = () => { setConfirm(null); const el = lastFocus.current as HTMLElement | null; if (el && el.focus) el.focus(); };

  const patchRt = (id: string, patch: Partial<WorkflowRequestType>) => onUpdate(next => {
    const rt = findNode(next, card)?.requestTypes?.find(r => r.id === id); if (rt) Object.assign(rt, patch);
  });
  const addRequestType = () => onUpdate(next => {
    const t = findNode(next, card); if (!t) return;
    t.requestTypes ??= [];
    const id = makeId('rt');
    const rt: WorkflowRequestType = { id, name: 'New request type', keywords: [], enabled: true, steps: [] };
    // v12.4.11 (#471): the FIRST type adopts whatever flat steps the node already had, so nothing vanishes
    // at the moment the node starts branching. Later types get an empty list, as they always did.
    if (t.requestTypes.length === 0) absorbFlatStepsIntoRequestType(t, rt);
    t.requestTypes.push(rt);
  });
  const rtStepsTarget = (next: DesignerDocument): WorkflowStep[] | undefined => {
    const t = findNode(next, card); if (!t) return undefined;
    t.requestTypes ??= [];
    const rt = t.requestTypes[rtIndex]; if (!rt) return undefined;
    rt.steps ??= []; return rt.steps;
  };

  if (!node) return null;

  const readyCount = requestTypes.filter(r => r.enabled !== false && (r.steps ?? []).some(s => s.enabled !== false)).length;
  const fieldUpdate = (fn: (t: NonNullable<ReturnType<typeof findNode>>) => void) => onUpdate(next => { const t = findNode(next, card); if (t) fn(t); });
  const langList = languages.length ? languages : [{ code: 'en', displayName: 'English' }];
  const activeOff = activeRt?.enabled === false;
  const intentNodes = doc.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId)?.nodes ?? [];

  const RQ_HELP_RT: HelpSection[] = [
    ['What it does', 'Splits this node into separate request types (for example Schedule, Change, Cancel). The caller is routed to the matching type, and each type runs its own steps.'],
    ['When it fires', 'When the call reaches this Request node — the agent detects which request the caller wants and follows that type.'],
    ['Example', 'A Change type asks for the original date, then the new date; a Cancel type confirms and cancels.'],
  ];
  const RQ_HELP_STEPS: HelpSection[] = [
    ['What it does', 'The ordered conversational turns for the selected request type — each asks a question and stores the answer.'],
    ['When it fires', 'In order, once this request type is chosen on a live call.'],
    ['Example', 'Step 1 captures the appointment date/time; Step 2 captures the reason.'],
  ];
  const FLD_NAME: HelpSection[] = [['What it does', 'The internal name for this node, shown on the canvas and in routing dropdowns. A label for your team - never spoken to the caller.'], ['When it fires', 'Builder only; it has no effect on the live call.'], ['Example', 'Naming a node Process Request makes it easy to find on the canvas.']];
  const FLD_TYPE: HelpSection[] = [['What it does', 'Chooses the node behavior. Request branches by request type; each type runs its own steps.'], ['When it fires', 'Applies to the whole node - it decides which prompts and routing appear here.'], ['Example', 'Set Type to Request to configure Schedule / Change / Cancel with their own steps.']];
  // v12.7.1: TWO CORRECTIONS, both of the same kind - the control said something the engine does not do.
  //   #574 (shipped 12.6.2) made the cap mean ASKS, the first one counted. This text still described the old
  //        off-by-one ("asks once then re-asks up to twice more" = three asks for a cap of 2).
  //   #578 the out-of-hours refusal spends a SEPARATE budget - ClosedReaskMax, a private constant - that no
  //        screen has ever pointed at. Whether it should become this cap or a control of its own is Tushar's
  //        decision and is still open; what is not defensible is a caller hearing a re-ask counted by a number
  //        that exists only in the source. So it is disclosed here, exactly as it behaves.
  // v12.9.26 (#967, his words: "the problem is word retry which adds confusion"): ONE number per card, 'Ask cap'.
  const FLD_RETRY: HelpSection[] = [['What it does', 'How many times the agent ASKS on this node in total - the first ask counts. Ask cap 2 = the caller is asked twice in total. A silent wait (Wait for response) counts as one ask.'], ['When it fires', 'Each turn the caller is silent, unclear, or gives a value that cannot be read as the field\u2019s type. At the cap, an \u201cIf not captured\u201d switch takes over if one is on; otherwise the miss is recorded and the call carries on.'], ['Example', 'Ask cap 2: asked, then asked once more, then the next step.'], ['Fixed safety stops', 'Two separate budgets of 2 are not governed by this number: a time outside your opening hours is refused and re-asked up to 2 times (the value was understood - the practice is closed then), and a field the step does not hold is re-asked up to 2 times.']];
  const FLD_DESC: HelpSection[] = [['What it does', 'A short internal note about this node. Not spoken to the caller.'], ['When it fires', 'Shown only in the builder.'], ['Example', 'Skip for existing patients - handled by the lookup node above.']];

  return (
    <div className="tenant-drawer-section rq">
      <div className="rq-nodecard">
        <div className="rq-band">
          <span className="lb">Request node</span>
          <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={RQ_HELP_RT} /></span>
          <span className="hint">Applies to every request type below</span>
        </div>
        <div className="rq-nodebody">
          <div className="rq-g2">
            <TextField label="Name" help={FLD_NAME} value={node.label ?? ''} onChange={v => fieldUpdate(t => { t.label = v; })} />
            <SelectField label="Type" help={FLD_TYPE} value={node.type ?? 'Request'} options={nodeTypeOptions(node.type ?? 'Request')} onChange={v => fieldUpdate(t => { applyNodeTypeChange(t, v); })} />{/* v12.4.11 (#471); v12.4.12 (#477): braced - a bare JSX comment rendered as text */}
            <TextField label="Ask cap" help={FLD_RETRY} value={String(node.retryMax ?? 2)} onChange={v => fieldUpdate(t => { t.retryMax = Number(v) || 0; })} />
            {/* ── v12.7.3 (#643): TWO CONTROLS LEAVE THIS CARD, AND NEITHER EVER DID ANYTHING HERE. ──────
                "On fail" offered four options and the engine reads FallbackMode only for a PreRouting card -
                on a NODE all four produced an identical call, so the card was asking the tenant to choose
                between four spellings of the same behavior.

                "Unable to capture" routed the node's `fail` outcome, and with nothing configured that resolved
                to a hardcoded "thankyou-failure": a caller who could not be understood on ONE field heard
                "I'm sorry we couldn't finish your request just now" and reached nobody.

                Tushar, 2026-09-23: *"it breaks the concept of AI assistant. we can not keep on running to
                voicemail or handover if we can't capture one field. the proper workflow is making a call at
                confirm node, otherwise let it keep going."* A failed capture now records the miss and CONTINUES.

                The stored values are NOT deleted from the document - an existing snapshot keeps them and they
                are simply unread, so nothing breaks and nothing needs migrating. What is removed is the
                pretence that setting them changes a call. */}
            <TextField label="Description" help={FLD_DESC} placeholder="Optional internal note" value={node.description ?? ''} onChange={v => fieldUpdate(t => { t.description = v; })} />
          </div>
        </div>{/* rq-nodebody */}
      </div>{/* rq-nodecard — v12.3.9 (#238-E): the identity box now holds the identity FIELDS ONLY and closes
           BEFORE "Request types", per Card Layout Standard v1.0 (identity box → request types → language strip
           → per-language content). Until 12.3.8 the box wrapped the request-type chips too. */}

      {/* v12.2.47.9 (#276-U1) / v12.3.9 (#238-E): request types are a SIBLING of the identity box; the selected
          type's rail + steps then run frameless below. */}
      <div className="rq-rtwrap">
        <div className="rq-rthead">
          <span className="t">Request types</span>
          <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={RQ_HELP_RT} /></span>
          <span className="acts">
            <span className="cnt">{readyCount} of {requestTypes.length} ready</span>
            <button type="button" className="rq-btn2" onClick={() => { addRequestType(); setRtSel(requestTypes.length); setRenamingRt('__last'); }}>+ Add request type</button>
          </span>
        </div>

        <div className="rq-chips">
          {requestTypes.map((rt, i) => {
            const off = rt.enabled === false;
            const count = rt.steps?.length ?? 0;
            const isRenaming = renamingRt === rt.id || (renamingRt === '__last' && i === requestTypes.length - 1);
            return (
              <div key={rt.id} className={'rq-chip' + (i === rtIndex ? ' sel' : '') + (off ? ' off' : '') + (!off && count === 0 ? ' empty' : '')}
                role="button" tabIndex={0} title={count + ' steps'} aria-selected={i === rtIndex}
                onClick={e => { if ((e.target as HTMLElement).closest('.kb')) return; setRtSel(i); setRtMenuFor(null); }}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setRtSel(i); } }}>
                {isRenaming ? (
                  <input className="rq-in" autoFocus defaultValue={rtName(rt) === 'Untitled' ? '' : rtName(rt)} style={{ height: 28, width: 150 }}
                    onClick={e => e.stopPropagation()}
                    onBlur={e => { const v = e.target.value.trim(); if (v) renameRt(rt, v); setRenamingRt(null); }}
                    onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter') { const v = (e.target as HTMLInputElement).value.trim(); if (v) renameRt(rt, v); setRenamingRt(null); } else if (e.key === 'Escape') { setRenamingRt(null); } }} />
                ) : (
                  <>
                    <span className="nm" title={language === rtPrimary ? undefined : `${langLabel({ code: rtPrimary, displayName: '' })}: ${rt.name || 'Untitled'}`}>{rtName(rt)}</span>
                    <span className="n">{off ? 'Off' : count}</span>
                    <span className="kb" onClick={e => { e.stopPropagation(); setRtMenuFor(rtMenuFor === rt.id ? null : (rt.id ?? null)); }}>⋮</span>
                  </>
                )}
                {rtMenuFor === rt.id && (
                  <div className="rq-rtmenu" style={{ top: '100%', left: 0, marginTop: 6 }}>
                    <button type="button" onClick={e => { e.stopPropagation(); setRtMenuFor(null); setRenamingRt(rt.id ?? null); }}>Rename</button>
                    <button type="button" onClick={e => { e.stopPropagation(); patchRt(rt.id!, { enabled: off ? true : false }); setRtMenuFor(null); }}>{off ? 'Enable' : 'Disable'}</button>
                    {/* v12.10.22 (#1994): request types can be reordered - the order is what the "which one?" question lists when no keyword matches */}
                    <button type="button" disabled={i === 0} onClick={e => { e.stopPropagation(); setRtMenuFor(null); moveRt(rt.id!, -1); setRtSel(i - 1); }}>Move earlier</button>
                    <button type="button" disabled={i === requestTypes.length - 1} onClick={e => { e.stopPropagation(); setRtMenuFor(null); moveRt(rt.id!, 1); setRtSel(i + 1); }}>Move later</button>
                    <div className="sep" />
                    <button type="button" className="danger" onClick={e => {
                      e.stopPropagation(); setRtMenuFor(null);
                      const n = count;
                      openConfirm({
                        title: 'Delete “' + (rt.name || 'Untitled') + '”?',
                        body: 'This request type and everything inside it will be removed from this node. It is applied when you choose Done.',
                        consequence: n === 0 ? null : <span><b>{n === 1 ? '1 step' : n + ' steps'}</b> will be deleted with it.</span>,
                        confirmWord: rt.name || 'Untitled',
                        run: () => {
                          onUpdate(next => { const t = findNode(next, card); if (t?.requestTypes) t.requestTypes = t.requestTypes.filter(r => r.id !== rt.id); });
                          setRtSel(0);
                          toast('success', 'Request type deleted', '\u201c' + (rt.name || 'Untitled') + '\u201d was removed. Choose Done to apply.');
                        },
                      });
                    }}>Delete</button>
                  </div>
                )}
              </div>
            );
          })}
          {requestTypes.length === 0 && <span className="tenant-field-note">No request types yet — add one (e.g. Schedule, Change, Cancel).</span>}
        </div>
      </div>
      {requestTypes.length > 0 && (
        <>
          <div className="rq-divider" />
              <div className="rq-scope">
                <LanguageRail languages={langList} active={language} onLanguage={onLanguage} />

                {activeOff && (
                  <div className="rq-offnote">This request type is turned off. The AI will not use it.</div>
                )}

                {activeRt && (
                  <AskTogetherBlock on={activeRt.askTogether === true} prompt={activeRt.askTogetherPrompt} language={language}
                    fields={askTogetherFields(steps, vocabLabels, vocabCustom)} noSteps={steps.length === 0} scopeLabel="this request type"
                    onChange={patch => patchRt(activeRt.id!, patch)} />
                )}

                {/* ══ v12.10.22 (#1985, LOCKED 10/27): this request type's keywords, per language (the stored requestTypes[].keywords /
                    keywordsByLang). With two or more types on a card, the caller's words are matched to these before "which one?" is asked. ══ */}
                {activeRt && (() => {
                  const prim = primaryLangCode(doc);
                  const kws = (language === prim ? activeRt.keywords : activeRt.keywordsByLang?.[language]) ?? [];
                  return (
                    <div className="rq-asktog rq-rtkw">
                      <KeywordTags label={`Keywords · ${langLabel({ code: language, displayName: '' })}`} value={kws}
                        placeholder="words the caller says for this request type - Enter or comma"
                        help={[
                          ['What it does', 'When a card has two or more request types, the caller\u2019s words are matched to these keywords (and the type\u2019s name words) to pick the type. No match -> the caller is asked which one.'],
                          ['Per language', 'Each language has its own list - switch the language above. The primary language is the main list.'],
                          ['Example', 'Records fax / status: fax, faxed, did you send, status, didn\u2019t receive, resend'],
                        ]}
                        onChange={next => onUpdate(d => {
                          const t = findNode(d, card)?.requestTypes?.find(r => r.id === activeRt.id);
                          if (!t) return;
                          if (language === prim) t.keywords = next;
                          else t.keywordsByLang = { ...(t.keywordsByLang ?? {}), [language]: next };
                        })} />
                    </div>
                  );
                })()}

                {/* v12.10.22 (#1986, Tushar 10/26 + 10/27): the "Next step for staff" box is removed - typed fixed lines per request type do not
                    work; the Next step comes from the AI (What the caller needs), with the built-in lines as the Local fallback. A saved nextStep
                    stays in the workflow untouched (round-trips) but nothing reads it. */}

                <div className="rq-stepshead">
                  <span className="lb">Steps <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={RQ_HELP_STEPS} /></span></span>
                  <button type="button" className="rq-btn1" onClick={() => onUpdate(next => { const arr = rtStepsTarget(next); if (arr) { if (arr.length === 0) { const rtN = findNode(next, card)?.requestTypes?.find(r => r.id === activeRt?.id); if (rtN && rtN.askTogether === undefined) rtN.askTogether = true; /* v12.10.15 (#1643 S127): ON for a new type once its first step is added */ } arr.push({ id: makeId('step'), kind: 'speak', label: 'New step', prompt: { [language]: '' }, fallbackMode: 'clarify-then-keypad', enabled: true }); } })}>+ Add step</button>
                </div>

                {steps.length === 0 && <p className="tenant-field-note">No steps yet. Use “+ Add step” to add a spoken turn.</p>}

                {steps.map((step, index) => {
                  const stepCount = steps.length;
                  const off = step.enabled === false;
                  const conf = step.confidenceThreshold;
                  const confErr = conf != null && (isNaN(conf) || conf < 0 || conf > 1);
                  const nameId = 'rq-step-name-' + step.id;
                  return (
                    <div key={step.id} className={'rq-stepcard' + (off ? ' disabled' : '')}>
                      <div className="rq-sgrid">
                        <div>
                          {/* v12.2.47.10 (#276-R1): step column tooltips in the standard 3-section format. */}
                          <span className="lab">Step {index + 1} <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Names this conversational step and sets its order — steps run top to bottom within the request type.'], ['When it fires', 'In order, once this request type is chosen on a live call.'], ['Example', 'Step 1 captures the date/time, Step 2 the reason. Use the ⋮ menu to reorder, disable, or delete a step.']]} /></span>{off && <span className="dbadge">Disabled</span>}</span>
                          <input id={nameId} className="rq-in" value={step.label ?? ''} placeholder="Name this step"
                            onChange={e => { const v = e.target.value; onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (t) t.label = v; }); }} />
                        </div>
                        {/* v12.9.1 (#708): "Cleanup" belongs on the header row - it describes how this step
                            READS an answer, next to how sure it has to be. Tushar's placement; it also keeps
                            the shared prompt-editor toolbar (which already carries Auto-translate) untouched. */}
                        <div>
                          <StepCleanupSelect
                            compact
                            value={step.cleanup}
                            fieldType={stepFieldType(step.stores, vocabCatalog, vocabCustom)}
                            disabled={off}
                            onChange={v => onUpdate(next => {
                              const t = rtStepsTarget(next)?.find(s2 => s2.id === step.id);
                              if (t) t.cleanup = v;
                            })} />
                        </div>
                        <div>
                          <span className="lab plain">Confidence <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'How sure the recognizer must be of a captured value (0–1). The score comes from the phone carrier, not from us.'], ['When it fires', 'On every capture at this step. On a NAME, a score at or above this is accepted outright; below it the value is checked before it is kept, and a score under the platform floor is not kept at all — the agent asks again and then offers spelling. On every other field the value is kept and marked on the call record for a person to check.'], ['Example', 'A name left blank uses 0.60 — chosen from 161 real calls, where every correct name scored 0.745 or better and every mis-heard one 0.563 or worse. A ZIP, phone, date or date of birth has NO bar: its shape is the check, because on those fields the score does not track whether the value is right — in the same 161 calls the 31 clean five-digit ZIPs never scored above 0.356 while the only three ZIP turns above 0.80 were nonsense.']]} /></span></span>
                          {/* v12.9.1 (#707): a stepper, not a free-text box - Tushar: "You left only typing
                              what happened to up and down arrow to select values?" Empty still means inherit,
                              and the placeholder names the default THIS field type actually gets. */}
                          <input className={'rq-in rq-conf' + (confErr ? ' err' : '')} type="number" step={0.05} min={0} max={1}
                            placeholder={confidencePlaceholderFor(stepFieldType(step.stores, vocabCatalog, vocabCustom), stepCapturesAPersonName(step.stores), confDefaults, confidencePlaceholder(stepFieldType(step.stores, vocabCatalog, vocabCustom)))}   /* v12.10.21 (#1957) */
                            value={conf ?? ''} onChange={e => { const v = e.target.value; onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (t) t.confidenceThreshold = v === '' ? null : Number(v); }); }} />
                          {confErr && <div className="rq-inerr">Enter a value from 0.00 to 1.00.</div>}
                        </div>
                        <div style={{ position: 'relative' }}>
                          <button type="button" className="rq-kebab" aria-expanded={stepMenuFor === step.id} title="Step actions" onClick={() => setStepMenuFor(stepMenuFor === step.id ? null : (step.id ?? null))}>⋮</button>
                          {stepMenuFor === step.id && (
                            <div className="rq-stepmenu">
                              {/* v12.2.47.10 (#275-B): leading icons on the step ⋮ menu, matching the card menu. */}
                              <button type="button" onClick={() => { setStepMenuFor(null); const el = document.getElementById(nameId) as HTMLInputElement | null; el?.focus(); }}><span className="rq-menu-ic" aria-hidden="true">✎</span>Edit</button>
                              <button type="button" disabled={index === 0} onClick={() => { setStepMenuFor(null); onUpdate(next => { const arr = rtStepsTarget(next); if (!arr || index <= 0) return; const tmp = arr[index - 1]; arr[index - 1] = arr[index]; arr[index] = tmp; }); }}><span className="rq-menu-ic" aria-hidden="true">↑</span>Move up</button>
                              <button type="button" disabled={index >= stepCount - 1} onClick={() => { setStepMenuFor(null); onUpdate(next => { const arr = rtStepsTarget(next); if (!arr || index >= arr.length - 1) return; const tmp = arr[index + 1]; arr[index + 1] = arr[index]; arr[index] = tmp; }); }}><span className="rq-menu-ic" aria-hidden="true">↓</span>Move down</button>
                              <button type="button" onClick={() => { setStepMenuFor(null); onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (t) t.enabled = t.enabled === false ? true : false; }); }}><span className="rq-menu-ic" aria-hidden="true">{off ? '✓' : '⊘'}</span>{off ? 'Enable' : 'Disable'}</button>
                              <div className="sep" />
                              <button type="button" className="danger" onClick={() => {
                                setStepMenuFor(null);
                                const emptyName = !(step.label ?? '').trim();
                                const emptyStores = !(step.stores ?? '').trim();
                                const emptyPrompt = Object.values(step.prompt ?? {}).every(v => !(v ?? '').trim());
                                const doDelete = () => {
                                  onUpdate(next => { const arr = rtStepsTarget(next); if (!arr) return; const idx = arr.findIndex(s => s.id === step.id); if (idx >= 0) arr.splice(idx, 1); });
                                  // The empty-step path deletes with NO dialog, so without this the row just
                                  // vanishes and the author cannot tell a delete from a misclick (238d2-empty).
                                  toast('success', 'Step deleted', 'Step ' + (index + 1) + ' was removed. Choose Done to apply.');
                                };
                                if (emptyName && emptyStores && emptyPrompt) { doDelete(); return; }
                                openConfirm({
                                  title: 'Delete Step ' + (index + 1) + '?',
                                  body: 'The prompt wording for every language, and the fields this step stores, will be removed. It is applied when you choose Done.',
                                  consequence: null,
                                  confirmWord: (step.label ?? '').trim() || ('Step ' + (index + 1)),
                                  run: doDelete,
                                });
                              }}><span className="rq-menu-ic" aria-hidden="true">🗑</span>Delete</button>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="rq-sbody">
                        {/* v12.9.6 (#748): a DIV, not a LABEL. A <label> forwards a click anywhere inside it to its first
                              labelable descendant - and that is the Optional <button> below, which sits
                              before StoresField in DOM order. So clicking the card's Stores area silently
                              flipped Optional, and on call 39-0069 an Identity step marked Optional by
                              accident skipped the surname in silence. Tushar: "if you click anywhere on
                              name step card then the optional gets selected and it is very hard to
                              notice." The element was only ever used for layout; the CSS targets it by
                              class, never as `label`. */}
                        <div className="tenant-node-step-key-field tenant-stores-row">
                          {/* v12.2.47.9 (#276-R3): Optional is now a toggle SWITCH sitting to the right of the STORES label line. */}
                          <span className="rq-storeshead">
                            <span className="rq-storeslab">Stores <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Sets the slot key(s) this step saves the answer into (e.g. subject.name). Separate multiple keys with commas.'], ['When it fires', 'Each time the caller answers this step.'], ['Example', 'subject.firstName, subject.lastName splits “Jane Doe” into two slots.']]} /></span></span>
                            <span className="rq-optsw" title="Optional — the step continues even if the caller doesn’t answer">
                              <span className="rq-optsw-txt">Optional</span>
                              <button type="button" role="switch" aria-checked={step.optional === true} className={'rq-sw' + (step.optional === true ? ' on' : '')}
                                onClick={() => onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (t) t.optional = !(t.optional === true); })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
                            </span>
                          </span>
                          <StoresField value={step.stores ?? ''} suggestions={storeKeySuggestions(doc, identifiers, vocabCustom)}
                            placeholder="(optional) — a field to capture, e.g. Appointment › Date"
                            onChange={v => onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (t) t.stores = v || null; })} />
                        </div>
                        <small className="tenant-field-note tenant-stores-hint">Type a field name and press Enter, Tab or comma to add it - several fields capture from one answer.{!(step.stores ?? '').trim() && <><br /><b>Nothing is captured from this step.</b> The answer is heard but not stored, and no {'{token}'} is created for it.</>}</small>
                        <PromptEditor value={step.prompt?.[language] ?? ''} rows={2} language={language} translateSource={step.prompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                          silentWhenBlank
                          groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                          onChange={v => onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (!t) return; t.prompt ??= {}; t.prompt[language] = v; })} />
                        {/* ── v12.9.0 (#696): EVERY FIELD, AND ABOVE "IF NOT CAPTURED". ──────────────────
                            Tushar, 2026-09-24: *"#3 - retry text should go before not captured not in the end.
                            Also why it is only for split ask and not for name, zip etc.. It can be for every
                            field."* Both halves. It sits with the QUESTION because it is what the agent says
                            when the answer to that question could not be used - the ladder below is what
                            happens after the asking has finished. And it is offered on every step, because a
                            tenant's own sentence is theirs whatever the Split ask switch is doing. */}
                        <RetryLine
                          value={step.rungPrompts?.retry?.[language]}
                          platformDefault={reaskPlatformDefault(stepFieldType(step.stores, vocabCatalog, vocabCustom), /birth|dob/i.test(step.stores ?? ''), (step.stores ?? '').split(/[,;\n]+/).filter(Boolean).length, language)}
                          disabled={off}
                          onChange={v => onUpdate(next => {
                            const t = rtStepsTarget(next)?.find(s2 => s2.id === step.id);
                            if (!t) return;
                            t.rungPrompts ??= {};
                            t.rungPrompts.retry ??= {};
                            if (v === null) delete t.rungPrompts.retry[language];
                            else t.rungPrompts.retry[language] = v;
                          })} />
                        {/* ── v12.7.3 (#647/#640): "IF NOT CAPTURED" - THE ESCALATION LADDER. ─────────────
                            Below the question, because it is what happens AFTER the question has failed.
                            Which switches appear is decided by the field type (his instruction), and every
                            switch that is on contributes chips whose sentence is editable per language -
                            otherwise turning one on would ship a hardcoded English literal, which is the very
                            thing #640 exists to end. */}
                        {/* v12.10.21 (#1957, LOCKED 10/25): the #1928 block is gone - ONE pointer line to the Read-backs card */}
                        <ReadbackPointer doc={doc} stores={step.stores} />
                        <LadderBlock
                          value={{ askToSpell: step.askToSpell, splitAsk: step.splitAsk, dtmf: step.dtmf, keypadNoKey: step.keypadNoKey, rungPrompts: step.rungPrompts, rungDefaults: step.rungDefaults /* v12.9.5 (#738) */ }}
                          fieldType={stepFieldType(step.stores, vocabCatalog, vocabCustom)}
                          isBirthdate={/birth|dob/i.test(step.stores ?? '')}
                          storedKeys={(step.stores ?? '').split(/[,;\n]+/).map(k => canonStoreKey(k).trim()).filter(Boolean)}
                          labelOf={(k) => tokenLabel(k, vocabLabels, vocabCustom) ?? prettyField(k.split('.').pop() ?? k)}
                          language={language}
                          disabled={off}
                          groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                          known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                          onChange={patch => onUpdate(next => {
                            const t = rtStepsTarget(next)?.find(s2 => s2.id === step.id);
                            if (!t) return;
                            if (patch.askToSpell !== undefined) t.askToSpell = patch.askToSpell;
                            if (patch.splitAsk   !== undefined) t.splitAsk   = patch.splitAsk;
                            if (patch.dtmf       !== undefined) t.dtmf       = patch.dtmf;
                    if (patch.keypadNoKey !== undefined) t.keypadNoKey = patch.keypadNoKey;   // v12.10.15 (#1641)
                            if (patch.rungPrompts !== undefined) t.rungPrompts = patch.rungPrompts;
                          })} />
                        {step.optional && (
                        <div className="rq-optwrap">
                          <span className="rq-optnote">Optional — the step continues even if the caller doesn’t answer.</span>
                            <label className="rq-optroute"><span>If captured → go to</span>
                              <select className="rq-in" value={step.capturedRouteKind === 'node' ? ('node:' + (step.capturedRouteTarget ?? '')) : step.capturedRouteKind === 'terminal' ? ('terminal:' + (step.capturedRouteTarget ?? '')) : 'continue'}
                                onChange={e => { const val = e.target.value; onUpdate(next => { const t = rtStepsTarget(next)?.find(s => s.id === step.id); if (!t) return; if (val === 'continue') { t.capturedRouteKind = 'continue'; t.capturedRouteTarget = null; } else { const ci = val.indexOf(':'); t.capturedRouteKind = val.slice(0, ci); t.capturedRouteTarget = val.slice(ci + 1); } }); }}>
                                <option value="continue">Continue to next step</option>
                                {intentNodes.filter(n => n.id !== node.id).map(n => <option key={n.id} value={'node:' + n.id}>Node: {routeNodeLabel(doc, card.workflowId, n)}</option>)}
                                {Object.keys(doc.terminal ?? DEFAULT_TERMINALS).map(k => <option key={k} value={'terminal:' + k} disabled={!!offTerminals[k]}>End: {TERMINAL_LABELS[k] ?? k}{offTerminals[k] ? ` (${offTerminals[k]})` : ''}</option>)}
                              </select>
                            </label>
                        </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
        </>
          )}
      {confirm && (
        <ConfirmDialog title={confirm.title} body={confirm.body} consequence={confirm.consequence} confirmWord={confirm.confirmWord ?? null}
          onCancel={closeConfirm} onConfirm={() => { confirm.run(); closeConfirm(); }} />
      )}
    </div>
  );
}

// v12.4.13 (#487): the shape the Connect node picker needs from Settings > Integrations.
// The options for one of the two pickers: a blank, everything configured, and - when the node already holds a
// value that matches nothing - that value, kept and labelled, never silently dropped.
function pickerOptions(configured: string[], current: string): { options: string[]; labels: Record<string, string> } {
  const known = configured.filter(v => v.trim().length > 0);
  const stray = current.trim().length > 0 && !known.some(k => k.toLowerCase() === current.trim().toLowerCase());
  return {
    options: ['', ...known, ...(stray ? [current] : [])],
    labels: { '': 'Not set', ...(stray ? { [current]: `${current} — not configured` } : {}) },
  };
}

function NodeEditor({ card, doc, language, languages, onLanguage, onUpdate, onRemove }: { card: Extract<CardRef, { kind: 'node' | 'sharedNode' }>; doc: DesignerDocument; language: string; languages: { code: string; displayName: string }[]; onLanguage: (code: string) => void; onUpdate: (mutator: (next: DesignerDocument) => void) => void; onRemove?: () => void }) {
  const offTerminals = useOffTerminals();   // v12.10.4 (#1119)
  const cbLine = useCardLines();   // v12.10.15 (#1663): the Callback card's platform lines, shown as written text (above every early return)
  // v12.4.13 (#487): a Connect node PICKS a configured connection and one of its actions. Same query key as the
  // Integrations screen, so react-query serves one copy. Tushar, 2026-09-18, pointing at a node aimed at
  // 'ehr-athena' / 'get-slots' - neither of which exists in Settings > Integrations: "we should enable the
  // support for workflow cards to select what's been configured."
  // v12.7.2 (#616): was this component's own copy of the query; now the shared hook, so the card, the tree
  // and this drawer can never disagree about which connections exist.
  const connections = useConnectedSystems();
  // v12.3.10.1 (#303): one served catalog, for the picker AND the unresolved-token check.
  const { catalog: vocabCatalog, vocab: vocabLabels, customFields: vocabCustom, lists: vocabLists } = useVocabulary();
  const confDefaults = useConfidenceDefaults();   // v12.10.21 (#1957): the field type's Confidence default, from configuration
  const node = findNode(doc, card);
  // v12.2.23.0 (#147): Identity nodes add steps by picking a configured Identity-extraction field.
  const { data: aiAgent } = useQuery<AiAgentTokenSettings>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<AiAgentTokenSettings>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  const identifiers: IdRow[] = [];   // v12.10.8 (#1190): Identity extraction is gone - Vocabulary is the only source
  const isIdentity = (node?.type ?? '') === 'Identity';
  // ── v12.2.47.0 (Request-node): a Request node branches by request type; each type owns its steps ──
  const isRequest = (node?.type ?? '') === 'Request';
  const requestTypes = node?.requestTypes ?? [];
  // v12.2.47.8 (#274): Confirm node auto-discovers the intent's Request-node types for per-type read-backs.
  const isConfirm = (node?.type ?? '') === 'Confirm';
  const [confirmRtSel, setConfirmRtSel] = useState(0);
  // A shared node is not inside an intent, so these intent-scoped lookups simply yield nothing for it.
  const cardWf = card.kind === 'node' ? card.workflowId : undefined;
  const cardIn = card.kind === 'node' ? card.intentId : undefined;
  const confirmReqTypes = isConfirm ? (doc.workflows?.find(w => w.id === cardWf)?.intents?.find(i => i.id === cardIn)?.nodes?.find(n => (n.type ?? '') === 'Request' && (n.requestTypes?.length ?? 0) > 0)?.requestTypes ?? []) : [];
  const confirmActive = confirmReqTypes[Math.min(confirmRtSel, Math.max(0, confirmReqTypes.length - 1))];
  // v12.3.14 (#376): the suggestion offered for the node-level Default. When the node branches by request type
  // there is no single flow to suggest for, so we offer nothing rather than a sentence about one arbitrary type -
  // suggesting the Appointment wording on a Prescription node is how this whole class of bug started.
  const defaultReadbackSuggestion = confirmReqTypes.length === 0 ? suggestDefaultReadback(doc, cardWf, cardIn) : '';
  const [rtSel, setRtSel] = useState(0);
  const [rtMenuFor, setRtMenuFor] = useState<string | null>(null);
  const [rtEditing, setRtEditing] = useState<string | null>(null);   // request type id, or '__new'
  const [stepMenuFor, setStepMenuFor] = useState<string | null>(null);   // v12.2.47.1 (#260): per-step ⋯ menu open state
  // v12.2.47.10 (#276-U4): confirm-dialog machinery + intent-node list, mirrored from RequestNodeEditor so the
  // Identity/Steps step cards share the exact rq-stepcard delete-confirm and optional-route behavior.
  const [confirm, setConfirm] = useState<RqConfirm | null>(null);
  const lastFocus = useRef<Element | null>(null);
  const openConfirm = (c: RqConfirm) => { lastFocus.current = document.activeElement; setConfirm(c); };
  const closeConfirm = () => { setConfirm(null); const el = lastFocus.current as HTMLElement | null; if (el && el.focus) el.focus(); };
  const intentNodes = doc.workflows?.find(w => w.id === cardWf)?.intents?.find(i => i.id === cardIn)?.nodes ?? [];
  const rtIndex = Math.min(rtSel, Math.max(0, requestTypes.length - 1));
  const activeRt = isRequest ? requestTypes[rtIndex] : undefined;
  const steps = isRequest ? (activeRt?.steps ?? []) : (node?.steps ?? []);
  // The steps array to mutate on `next` — the active request type's steps for a Request node, else the flat node steps.
  const stepsTarget = (next: DesignerDocument): WorkflowStep[] | undefined => {
    const t = findNode(next, card);
    if (!t) return undefined;
    if ((t.type ?? '') === 'Request') {
      t.requestTypes ??= [];
      const rt = t.requestTypes[rtIndex];
      if (!rt) return undefined;
      rt.steps ??= [];
      return rt.steps;
    }
    t.steps ??= [];
    return t.steps;
  };
  // v12.3.16 (#387): resolve the step a rendered row refers to. Index first - it is what the row was built
  // from and survives any id rewriting in normalizeDoc - with the id as a sanity check, and an id lookup as the
  // fallback if the array shifted under us.
  const stepAt = (next: DesignerDocument, index: number, id?: string): WorkflowStep | undefined => {
    const arr = stepsTarget(next);
    if (!arr) return undefined;
    const byIndex = arr[index];
    if (byIndex && (!id || !byIndex.id || byIndex.id === id)) return byIndex;
    return arr.find(s => s.id === id) ?? byIndex;
  };
  const addRequestType = (name: string, keywords: string[]) => onUpdate(next => {
    const t = findNode(next, card); if (!t) return;
    t.requestTypes ??= [];
    const rt: WorkflowRequestType = { id: makeId('rt'), name, keywords, enabled: true, steps: [] };
    // v12.4.11 (#471): same adoption as the other entry point — BOTH paths create a first request type, and
    // fixing only the one that happened to be reported is how #442 came back in the first place.
    if (t.requestTypes.length === 0) absorbFlatStepsIntoRequestType(t, rt);
    t.requestTypes.push(rt);
  });
  const updateRequestType = (id: string, patch: Partial<WorkflowRequestType>) => onUpdate(next => {
    const rt = findNode(next, card)?.requestTypes?.find(r => r.id === id); if (rt) Object.assign(rt, patch);
  });
  const deleteRequestType = (id: string) => onUpdate(next => {
    const t = findNode(next, card); if (t?.requestTypes) t.requestTypes = t.requestTypes.filter(r => r.id !== id);
  });
  // v12.4.3 (#429): compare canonically, so a step already storing `patient.dob` is not offered again as
  // `subject.dob` - one field, one entry, whatever spelling the existing document happens to carry.
  const usedStores = new Set((node?.steps ?? []).map(s => canonStoreKey(s.stores ?? '').toLowerCase()).filter(Boolean));
  const addIdentityStep = (storeKey: string, promptKey: string, label: string) => onUpdate(next => {
    const target = findNode(next, card);
    if (!target) return;
    target.steps ??= [];
    target.steps.push({ id: makeId('step'), kind: 'capture', label, stores: storeKey, prompt: { [language]: identSeedPrompt(promptKey, label, language) }, fallbackMode: 'clarify-then-keypad' });
  });
  if (!node) return null;
  // v12.2.47.9 (#276-U1/U2/U3/L): unified node-card shell + EN/ES rail moved below the main section.
  const nodeLangList = (languages && languages.length) ? languages : [{ code: 'en', displayName: 'English' }];
  const isConfirmNode = (node.type ?? '') === 'Confirm';
  // v12.4.16 (#503): a Connect node now carries a per-language line of its own (spoken when its action
  // could not be completed), so it joins the node types that render the EN/ES rail.
  // v12.5.0 (#525): a TextConfirm card is nothing BUT per-language wording - three texts of it - so it joins
  // the rail too.
  const isTextConfirm = (node.type ?? '') === 'TextConfirm';
  const isAnnounce = (node.type ?? '') === 'Announce';   // v12.10.1 (#1085)
  const isCallback = (node.type ?? '') === 'Callback';   // v12.10.15 (#1663)
  const hasLangContent = node.type === 'Identity' || node.type === 'Steps' || isConfirmNode || node.type === 'Connect' || isTextConfirm || isAnnounce || isCallback;
  return (
    <div className="tenant-drawer-section rq">
      <div className="rq-nodecard">
        <div className="rq-band">
          <span className="lb">{node.type ?? 'Node'} node</span>
          <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Configures one node in the intent’s flow — its type, Ask cap, routing, and (below the divider) its per-language wording.'], ['When it fires', 'When the call reaches this node in the intent’s node sequence.'], ['Example', 'An Identity node captures name + DOB; a Confirm node reads them back; a Connect node books the slot.']]} /></span>
          {/* v12.5.0 (#525): a text card has no steps, so it must not claim to apply to any. */}
          <span className="hint">{isAnnounce ? 'Applies to this announcement' : isConfirmNode ? 'Applies to this confirmation' : isTextConfirm ? 'Applies to the text offer and the message it sends' : 'Applies to this node and its steps'}</span>
        </div>
        <div className="rq-nodebody">
          {/* v12.2.47.9 (#276-U1): one 2-col field grid — Name / Type / Retry / On fail / Description [+ Unable to capture]. */}
          <div className="rq-g2">
            <TextField label="Name" help={[['What it does', 'Sets the internal name for this node, shown on the canvas and in routing dropdowns. A label for you and your team — never spoken to the caller.'], ['When it fires', 'Used only in the builder. It appears on the node tile so you can tell nodes apart and pick them as route targets; it has no effect during a live call.'], ['Example', 'Naming a node “Verify DOB” makes it easy to spot on the canvas and choose as a route target, while the caller only hears the step’s spoken prompt.']]} value={node.label ?? ''} onChange={value => onUpdate(next => {
          const target = findNode(next, card);
          if (target) target.label = value;
        })} />
        <SelectField label="Type" help={[['What it does', 'Chooses the node’s behavior: Identity and Steps capture information, Request branches by request type, Confirm reads it back for verification, Connect calls an integration, and TextConfirm offers to text the caller their reference number. Ending the call is handled by this node’s outcome routing to a terminal, not a separate node type.'], ['When it fires', 'Applies to the whole node — it decides which prompts and routing options appear here and how the engine runs this step during the call.'], ['Example', 'Set Type to Confirm and the node reads captured details back (“I have Jane Doe, born May 3rd — is that right?”); route an outcome to a terminal to end the call.']]} value={node.type ?? 'Steps'} options={nodeTypeOptions(node.type ?? 'Steps')} onChange={value => onUpdate(next => {
          const target = findNode(next, card);
          if (target) applyNodeTypeChange(target, value);   // v12.4.11 (#471): both type-change sites, not just the reported one
        })} />
            {/* v12.4.14 (#85c): a Connect node never speaks to the caller, so a retry cap and an on-fail re-ask
                are meaningless on it - Tushar, 2026-09-19: "i think on fail will not be applicable - this is silent
                node and patient will not be asked anything." Retrying the SYSTEM and what the caller hears when it
                cannot be reached are one tenant-wide policy, in Settings > Integrations > Failure policy, which the
                engine now reads (12.4.14 #85b). The stored values are left untouched, just not offered here. */}
            {/* v12.5.0 (#525): a TextConfirm card asks ONE yes/no question and takes the first answer -
                the engine sends only on an unambiguous yes and treats silence or an unclear reply as no,
                so there is nothing to re-ask and no on-fail path. Same judgement as #85c made for Connect:
                a control that cannot affect this node does not belong on it. Stored values are untouched. */}
            {node.type !== 'Connect' && !isAnnounce && (<>{/* v12.10.15 (#1660): the Text card follows its Ask cap too */}
            <TextField label="Ask cap" help={[['What it does', 'How many times the caller is asked in total on this card, the first ask included. Ask cap 2 = the caller is asked twice in total. A silent wait (Wait for response) counts as one ask.'], ['When it fires', 'Each turn where the caller is silent or the answer can\u2019t be understood. On a Confirm card, each correction round and each read-back repeated after a question counts against it too.'], ['Example', 'Ask cap 2: the caller is asked twice in total. After that, if the step has an \u201cIf not captured\u201d switch on, the agent tries that different way; otherwise it keeps whatever it heard, records the miss and carries on \u2014 it never ends the call over one field.']]} value={String(node.retryMax ?? 2)} onChange={value => onUpdate(next => {
          const target = findNode(next, card);
          if (target) target.retryMax = Number(value) || 0;
        })} />
        {isIdentity && (
          <TextField label="Question budget" help={[['What it does', 'The most identity questions one call is asked on this card - name, date of birth, ZIP, spelling and re-asks all count; Ask together counts as one. When it is reached, the agent keeps what it has, flags the rest for staff and moves on.'], ['When it applies', 'Only while Interceptor \u203a Call intent verification is on (Listen only writes what it would have done).'], ['Example', '6 (the default).']]}
            value={String(node?.questionBudget ?? 6)} onChange={value => onUpdate(next => { const t = findNode(next, card); if (t) t.questionBudget = Math.max(1, Number(value) || 6); })} />
        )}
        {/* v12.7.3 (#643): "On fail" REMOVED here for the same reason as on the Request node card - the engine
            reads FallbackMode only for a PreRouting card, so on a NODE all four options produce an identical
            call. Verification found this SECOND copy after the first was removed; a control deleted on one
            editor and left on another is the same defect wearing a different hat. Stored values are untouched. */}
            </>)}
            <div style={isAnnounce ? { gridColumn: '1 / -1' } : undefined}>{/* v12.10.2 (#1095): full width where nothing sits beside it */}
            <TextField label="Description" placeholder="Optional internal note" help={[['What it does', 'Holds a short internal note about this node — why it exists or anything a teammate should know. Not spoken to the caller.'], ['When it fires', 'Shown only in the builder when this node is open. It never affects the call flow or what the caller hears.'], ['Example', 'Add “Skip for existing patients — handled by the lookup node above” so the next person editing the workflow understands the intent.']]} value={node.description ?? ''} onChange={value => onUpdate(next => {
        const target = findNode(next, card);
        if (target) target.description = value;
      })} />
            </div>
            {/* v12.7.3 (#643): "Unable to capture" REMOVED - it routed the node's `fail` outcome, which with
                nothing configured resolved to a hardcoded "thankyou-failure", so a caller who could not be
                understood on ONE field heard an apology and reached nobody. A failed capture now records the
                miss and CONTINUES, so there is no fail outcome left for this control to route. His words:
                *"it breaks the concept of AI assistant. we can not keep on running to voicemail or handover if
                we can't capture one field."* Stored values stay in the document, simply unread. */}
          </div>{/* rq-g2 */}
      {/* v12.4.13 (#487): two PICKERS, not two free-text boxes. Until now a Connect node held two typed strings
          that nothing validated, so a node could point at a system that does not exist and only a live call would
          say so. The connection comes first, then that connection's own actions. A value already stored that
          matches nothing configured is KEPT and shown as "not configured" - a prompt to fix, never a silent
          deletion of someone's work. */}
      {node.type === 'Connect' && (() => {
        const provider = node.integration?.provider ?? '';
        const operation = node.integration?.operation ?? '';
        const chosen = connections.find(c => c.name.toLowerCase() === provider.trim().toLowerCase());
        const prov = pickerOptions(connections.map(c => c.name), provider);
        const ops = pickerOptions((chosen?.actions ?? []).map(a => (a.name ?? '').trim()).filter(Boolean), operation);
        const opKnown = !!chosen && (chosen.actions ?? []).some(a => (a.name ?? '').trim().toLowerCase() === operation.trim().toLowerCase());
        return (
          <>
            <div className="tenant-two-col">
              <SelectField label="Integration" help={[['What it does', 'Which connected system this node calls. The list is your Settings › Integrations connections — REST and FHIR, the two types that define actions.'], ['When it fires', 'When the call reaches this Connect node and the integration runs.'], ['Example', 'Pick “PMWeb Appointment API”, then choose one of its actions beside it.']]}
                value={provider} options={prov.options} labels={prov.labels}
                onChange={value => onUpdate(next => {
                  const target = findNode(next, card);
                  // Changing the connection clears an action that belonged to the old one.
                  // v12.7.2 (#616): the id is written WITH the name, in one assignment, so the two can never
                  // be saved out of step. A value kept because it matches nothing configured (#487's "stray")
                  // gets no id - there is no connection to take one from, and inventing one would be worse
                  // than the name it already has.
                  const picked = connections.find(c => c.name === value);
                  if (target) target.integration = {
                    ...(target.integration ?? {}),
                    providerId: picked ? Number(picked.id) || null : null,
                    provider: value,
                    operation: '',
                  };
                })} />
              <SelectField label="Action" help={[['What it does', 'Which of that connection’s actions runs here — the actions you defined on it in Settings › Integrations.'], ['When it fires', 'When this Connect node executes.'], ['Example', '“saveExternalAppointment” books the chosen time on the connection beside it.']]}
                value={operation} options={ops.options} labels={ops.labels}
                onChange={value => onUpdate(next => {
                  const target = findNode(next, card);
                  if (target) target.integration = { ...(target.integration ?? {}), operation: value };
                })} />
            </div>
            {connections.length === 0 && (
              <p className="tenant-field-note">No REST or FHIR connections are configured yet — add one in Settings › Integrations and it will appear here.</p>
            )}
            {provider.trim() !== '' && !chosen && (
              <p className="tenant-field-note">&#9888; “{provider}” is not a configured connection. It has been kept, but this node cannot run until you pick one that exists.</p>
            )}
            {chosen && operation.trim() !== '' && !opKnown && (
              <p className="tenant-field-note">&#9888; “{operation}” is not an action on {chosen.name}. Pick one of its actions, or add that action to the connection.</p>
            )}
            {/* v12.4.14 (#85c): said once, where the missing fields were. */}
            <p className="tenant-field-note">This node runs silently — it asks the caller nothing, so it has no retry cap or on-fail re-ask. How many times the SYSTEM is retried, what the caller hears while it fails, and where the call goes are set in Settings › Integrations › Failure policy; the timeout is under Settings › Reliability.</p>
          </>
        );
      })()}
      {node.type === 'Terminal' && (
        // v12.2.23.0 (#149): a Terminal node routes to one of the call outcomes — incl. the new "Thank You".
        <>
          <SelectField label="Outcome" help={[['What it does', 'Chooses which end-state this Terminal node hangs up with — e.g. End call, Voicemail, Handoff, Thank you.'], ['When it fires', 'When the call reaches this Terminal node.'], ['Example', 'Set to Thank you → the agent speaks the closing line, then ends the call.']]} value={node.terminalKey ?? 'end-call'}
            off={offTerminals}
            options={Object.keys(doc.terminal ?? DEFAULT_TERMINALS)}
            labels={Object.fromEntries(Object.keys(doc.terminal ?? DEFAULT_TERMINALS).map(k => [k, TERMINAL_LABELS[k] ?? k] as [string, string]))}
            onChange={value => onUpdate(next => { const target = findNode(next, card); if (target) target.terminalKey = value; })} />
          {node.terminalKey === 'thankyou' && (
            <p className="tenant-field-note">The Thank-You message is edited on the “Thank you” terminal card. Insert captured values with tokens (e.g. {'{patient.name}'}) to read them back before hanging up.</p>
          )}
        </>
      )}
      {/* v12.2.47.9 (#276): Confirm ROUTING is node-level (language-independent) and stays in the card. The per-language
          read-back + Default + correction move BELOW the rail (rendered in the scope). */}
      {isConfirmNode && (
        <>
          {/* v12.4.16 (#504 follow-up): THIS CONTROL NOW MEANS WHAT ITS LABEL SAYS.
              It wrote `node.terminalKey`, and after #504 retired ApplyNodeOutcome's legacy fallback - agreed
              with Tushar, correct, and staying - nothing read that field on a Confirm card. The dropdown was
              dead: a tenant could pick Thank You and the call would walk straight past it. It writes the
              explicit `success` outcome the engine actually reads, through the SAME setOutcomeRoute /
              ROUTE_CONTINUE mechanism the Connect node's error route uses (#503) - one mechanism, not two.
              An un-migrated node still DISPLAYS its legacy value (confirmSuccessValue), so nothing looks
              blank; picking anything, or simply saving, converts it. */}
          <SelectField label="On confirm → go to" help={[['What it does', 'Where the call goes after the caller CONFIRMS the read-back — continue to the next card, or end the call at a terminal.'], ['When it fires', 'On an affirmative confirmation at this Confirm node.'], ['Example', 'Keep “Continue to next node” so Book slot runs after “yes”; set a terminal only if the call should end here — any card after this one would then never run.']]}
            value={confirmSuccessValue(node)}
            off={offTerminals}
            options={[ROUTE_CONTINUE, ...Object.keys(doc.terminal ?? DEFAULT_TERMINALS)]}
            labels={{ [ROUTE_CONTINUE]: 'Continue to next node', ...Object.fromEntries(Object.keys(doc.terminal ?? DEFAULT_TERMINALS).map(k => [k, TERMINAL_LABELS[k] ?? k] as [string, string])) }}
            onChange={value => onUpdate(next => {
              const target = findNode(next, card);
              if (!target) return;
              target.outcomes = setOutcomeRoute(target.outcomes, 'success', value);
              target.terminalKey = null;   // the legacy field goes the moment the explicit route exists
            })} />
          <p className="tenant-field-note">After the caller confirms, end the call at this terminal &mdash; or keep &ldquo;Continue to next node&rdquo; to proceed. Thank-You speaks a closing line, then hangs up. <b>Choosing a terminal ends the call here</b>, so any card after this one is marked unreachable.</p>
          {/* ══ v12.9.25 (#965): HIS DECISIONS, 2026-09-30. "Use default fallback" is GONE - it meant Handoff-or-
              voicemail and nobody could tell which ("all these time, i was not aware of how it kept on going to
              hand over"). The choices are a card AHEAD of this one (never Confirm itself or a card before it)
              or a terminal. Nothing chosen = the NEXT card, and the default is shown WITH that card's name. The
              engine speaks the card's "can't be confirmed" line (below the rail) before routing. */}
          {(() => {
            const intentNodes = card.kind === 'node'
              ? (doc.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId)?.nodes ?? [])
              : [];
            const here = intentNodes.findIndex(n => n.id === node.id);
            const ahead = here >= 0 ? intentNodes.slice(here + 1).filter(n => n.enabled !== false) : [];
            const behind = here >= 0 ? intentNodes.slice(0, here + 1).map(n => n.id) : [];
            const oc = node.outcomes?.find(o => o.key === 'exhausted');
            const current = !oc ? '' : oc.routeKind === 'card' ? 'card:' + (oc.routeTarget ?? '') : (oc.routeTarget ?? '');
            const terminals = Object.keys(doc.terminal ?? DEFAULT_TERMINALS);
            const failureLabel = TERMINAL_LABELS['thankyou-failure'] ?? 'Thank You (Failure)';
            const nodeName = (n: { label?: string; type?: string }) => (n.label && n.label.trim()) || n.type || 'card';
            const defaultLabel = ahead.length > 0 ? `Default · next card: ${nodeName(ahead[0])}` : `Default · ${failureLabel} (Confirm is the last card)`;
            const pointsBack = oc?.routeKind === 'card' && behind.includes(oc.routeTarget ?? '');
            const effect = !oc
              ? (ahead.length > 0 ? `Skips to ${nodeName(ahead[0])} - the call carries on from there.` : `Ends the call at ${failureLabel}.`)
              : oc.routeKind === 'card'
                ? (pointsBack ? '' : `Skips to ${nodeName(intentNodes.find(n => n.id === oc.routeTarget) ?? {})} - every card between is not run.`)
                : `Ends the call at ${TERMINAL_LABELS[oc.routeTarget ?? ''] ?? oc.routeTarget}.`;
            return (
              <>
                <SelectField label="If it can’t be confirmed (Ask cap used up) → go to" help={[['What it does', 'Where the call goes when the caller cannot confirm the read-back - no answer after asking twice, or the Ask cap is used up. First the card’s “can’t be confirmed” line is spoken (below the language tabs), then the call goes here, and the request is flagged “Not confirmed by caller”.'], ['When it fires', 'After the Confirm card’s Ask cap is used up, or after silence to the read-back and to the one re-ask.'], ['Example', 'Skip to “Reference and Text” so an unconfirmed booking is NOT posted to the practice system, but the caller still gets a reference number and the request reaches staff in Messages, flagged.']]}
                  value={current}
                  off={offTerminals}
                  options={['', ...ahead.map(n => 'card:' + n.id), ...terminals]}
                  labels={{
                    '': defaultLabel,
                    ...Object.fromEntries(ahead.map(n => ['card:' + n.id, `Skip to: ${nodeName(n)}`] as [string, string])),
                    ...Object.fromEntries(terminals.map(k => [k, TERMINAL_LABELS[k] ?? k] as [string, string])),
                  }}
                  onChange={value => onUpdate(next => {
                    const t = findNode(next, card); if (!t) return;
                    const rest = (t.outcomes ?? []).filter(o => o.key !== 'exhausted');
                    if (value.startsWith('card:')) t.outcomes = [...rest, { key: 'exhausted', routeKind: 'card', routeTarget: value.slice(5) }];
                    else t.outcomes = setOutcomeTerminal(t.outcomes, 'exhausted', value);
                  })} />
                {pointsBack
                  ? <p className="tenant-field-note">&#9888; The saved route points at a card BEFORE this one, which is not allowed - calls use the default ({defaultLabel.replace('Default · ', '')}) until you pick again.</p>
                  : <p className="tenant-field-note">{effect}</p>}
                {/* v12.9.26 (#985, UI-LOCK-12.9.26 v1.3 LOCKED): skip the read-back when the caller already confirmed every
                    field it would read back. ON by default; the minimum greys out when the switch is off. */}
                {(() => {
                  const skipOn = node.skipReadbackWhenConfirmed !== false;
                  const minN = node.skipReadbackMinFields ?? 3;
                  return (
                    <div className="tenant-form-field rq-skiprb">
                      <span className="rq-optsw" style={{ justifyContent: 'space-between', width: '100%' }}>
                        <span>Skip the read-back when already confirmed <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                          ['What it does', 'If the caller already confirmed every detail this read-back would say, and nothing changed since, the call goes straight on. It still counts as confirmed by the caller.'],
                          ['When it fires', 'At this Confirm card, when every field it reads back was confirmed earlier in the call (the grouped question, a step’s own check, or a read-back of a doubtful value).'],
                          ['Example', 'The caller gave name, date and time in the first sentence and said yes to the grouped question → no second read-back.']]} /></span></span>
                        <button type="button" role="switch" aria-checked={skipOn} className={'rq-sw' + (skipOn ? ' on' : '')}
                          onClick={() => onUpdate(next => { const t = findNode(next, card); if (t) t.skipReadbackWhenConfirmed = !(t.skipReadbackWhenConfirmed !== false); })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
                      </span>
                      <span className={'rq-skiprb-n' + (skipOn ? '' : ' is-off')}>
                        Skip only when at least{' '}
                        <input type="number" min={1} max={20} value={minN} disabled={!skipOn} aria-label="Minimum confirmed fields"
                          onChange={e => { const v = Math.max(1, Math.min(20, Math.round(Number(e.target.value) || 1))); onUpdate(next => { const t = findNode(next, card); if (t) t.skipReadbackMinFields = v; }); }} />
                        {' '}fields are already confirmed
                      </span>
                    </div>
                  );
                })()}
              </>
            );
          })()}
        </>
      )}
      {node.type === 'Connect' && (
        <>
          {/* v12.4.16 (#503): CONTINUE is now a choice, not only terminals. Tushar, 2026-09-19: "the api
              connectivity is a failure but the call itself is not a failure" — a booking that could not be made
              still wants to hand the caller a reference number from the cards AFTER this one and close properly. */}
          <SelectField label="If the action can’t be completed → go to" help={[['What it does', 'Where the call goes when this node’s action fails — the system could not be reached, timed out, or answered with a failure (its result field did not come back as a success value).'], ['When it fires', 'After the retries in Settings › Integrations › Failure policy are used up. Leave it blank and the call follows that block’s Caller fallback instead.'], ['Example', 'Choose “Continue to next node” so the caller still gets their reference number and a proper goodbye — the booking failed, the call did not.']]}
            value={outcomeRouteValue(node.outcomes, 'error')}
            off={offTerminals}
            options={['', ROUTE_CONTINUE, ...Object.keys(doc.terminal ?? DEFAULT_TERMINALS)]}
            labels={{ '': 'Use the Failure policy setting', [ROUTE_CONTINUE]: 'Continue to next node', ...Object.fromEntries(Object.keys(doc.terminal ?? DEFAULT_TERMINALS).map(k => [k, TERMINAL_LABELS[k] ?? k] as [string, string])) }}
            onChange={value => onUpdate(next => { const t = findNode(next, card); if (t) t.outcomes = setOutcomeRoute(t.outcomes, 'error', value); })} />
          {/* v12.4.14 (#85c): the old note described a stub and a default terminal that no longer exists - the generic
              Default terminal went in 12.2.44, and 12.4.14 wired the node for real. This is the route the engine
              actually takes: this terminal if one is set, otherwise the tenant's Caller fallback. */}
          <p className="tenant-field-note">Choose <strong>Continue to next node</strong> and the call carries on down the sequence &mdash; the cards after this one still run, so the caller gets whatever they would have got anyway. Set a terminal instead and a failed action goes straight to it. Left blank, the call follows the <em>Caller fallback</em> in Settings › Integrations › Failure policy.</p>
        </>
      )}
        </div>{/* rq-nodebody */}
      </div>{/* rq-nodecard — wraps the main section (fields + node-level routing) only */}
      {/* v12.2.47.9 (#276-U2/U3/L): frameless per-language content below a single divider — EN/ES rail, then the
          Confirm read-back (per type + Default + correction) OR (for Identity/Steps) the node's Steps. */}
      {hasLangContent && (
        <>
          <div className="rq-divider" />
          <div className="rq-scope">
            <LanguageRail languages={nodeLangList} active={language} onLanguage={onLanguage} />
            {isConfirmNode && (
              <>
                {confirmReqTypes.length > 0 && (
                  <div className="rq" style={{ marginBottom: 12 }}>
                    <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                      <span className="t">Read-back per request type</span>
                      <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Write the confirmation read-back for each request type. The agent speaks the one matching the caller request; values fill from captured tokens.'], ['When it fires', 'At this Confirm node, using the request type chosen earlier in the flow.'], ['Example', 'Change reads old and new date/time; Cancel reads the appointment being cancelled.']]} /></span>
                    </div>
                    <div className="rq-chips">
                      {confirmReqTypes.map((rt, i) => (
                        <div key={rt.id} className={'rq-chip' + (i === confirmRtSel ? ' sel' : '')} role="button" tabIndex={0}
                          onClick={() => setConfirmRtSel(i)} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setConfirmRtSel(i); } }}>
                          <span className="nm">{(language !== primaryLangCode(doc) && rt.nameByLang?.[language]) || rt.name || 'Untitled'}</span>
                        </div>
                      ))}
                    </div>
                    {/* v12.3.13 (#361): the suggestion is a PLACEHOLDER, not the value. It used to be passed as
                        `value`, so it sat in the textarea looking exactly like saved content - Tushar reasonably
                        believed he had configured the Refill read-back, and the string appeared ZERO times in the
                        saved snapshot. The screen said the agent would say something the agent had never been told.
                        Now an unsaved suggestion is visibly a suggestion, and "Use this wording" saves it. */}
                    {confirmActive && (
                      <PromptEditor value={node.requestReadbacks?.find(rb => rb.requestTypeId === confirmActive.id)?.prompt?.[language] ?? ''} rows={2} language={language} translateSource={node.requestReadbacks?.find(rb => rb.requestTypeId === confirmActive.id)?.prompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                        platformDefault={language === primaryLangCode(doc) ? suggestReadback(confirmActive) : ''}
                        blankNote="Blank = a read-back is built from the fields this request captured."
                        groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                        onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.requestReadbacks ??= []; let rb = t.requestReadbacks.find(x => x.requestTypeId === confirmActive.id); if (!rb) { rb = { requestTypeId: confirmActive.id!, prompt: {} }; t.requestReadbacks.push(rb); } rb.prompt ??= {}; rb.prompt[language] = v; })} />
                    )}
                    {confirmActive && !(node.requestReadbacks?.find(rb => rb.requestTypeId === confirmActive.id)?.prompt?.[language] ?? '').trim() && suggestReadback(confirmActive) && (
                      <p className="tenant-field-note tenant-suggested-note">
                        <b>Nothing saved for this type yet.</b> The greyed line above is a suggestion built from the
                        fields it captures — the agent will not say it until you save it.
                        <button type="button" className="tenant-linkish" onClick={() => onUpdate(next => {
                          const t = findNode(next, card); if (!t) return;
                          t.requestReadbacks ??= [];
                          let rb = t.requestReadbacks.find(x => x.requestTypeId === confirmActive.id);
                          if (!rb) { rb = { requestTypeId: confirmActive.id!, prompt: {} }; t.requestReadbacks.push(rb); }
                          rb.prompt ??= {}; rb.prompt[language] = suggestReadback(confirmActive);
                        })}>Use this wording</button>
                      </p>
                    )}
                    <p className="tenant-field-note">Types are auto-discovered from the Request node.</p>
                  </div>
                )}
                {/* v12.3.14 (#376): THE DEFAULT READ-BACK HAS NEVER HAD AN EDITOR.
                    It has been parsed, saved, and (since 12.3.13) SPOKEN - with no way for a tenant to see it,
                    let alone change it. Tushar's Refill caller heard "Let me confirm - you'd like a new
                    appointment for John Smith. Sounds good?" That sentence is not in the codebase; it is this
                    field on his Prescription Confirm node, migrated from a legacy step-1 prompt written when the
                    node only ever handled appointments. Invisible text that drives live calls is the same defect
                    as #361, one level up: the screen did not say what the agent would say.
                    Same placeholder treatment as the per-type editor - an unsaved suggestion looks like a
                    suggestion, and only "Use this wording" makes it real. */}
                {/* v12.4.0 (#396): THREE STATES, not one block shown always.
                    Tushar: "why are we showing even if that is not gonna work when the request type... can't we
                    just tweak UI to show only what is applicable to that step?" He is right, and the worst case
                    was one he did not name: with request types present and this field EMPTY there was no warning
                    at all - just a normal-looking editor with a placeholder, inviting you to write a line the
                    agent can never say. Same failure as #361 and #376: the screen implying the agent will say
                    something it never will.
                    It is NOT simply hidden when it has text. #376 exists because invisible text was driving live
                    calls - his Refill caller heard a sentence that was in no source file, it was this field. And
                    request types are AUTO-DISCOVERED from the Request node, so this flips between live and dead
                    without anyone touching the Confirm node: hide populated text and it becomes live speech
                    nobody can see. Hence read-only + warned + clearable. */}
                {confirmReqTypes.length === 0 ? (
                  <div className="rq" style={{ marginBottom: 12 }}>
                    <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                      <span className="t">Read-back</span>
                      <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                        ['What it does', 'The confirmation the agent reads back on this node. Values fill from captured tokens.'],
                        ['When it fires', 'At this Confirm node, every time - this intent has no request types to split by.'],
                        ['Example', '“Just to confirm — {subject.name}, {request.date} at {request.time}. Is that right?”']]} /></span>
                    </div>
                    <PromptEditor value={node.defaultReadback?.[language] ?? ''} rows={2} language={language}
                      translateSource={node.defaultReadback?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                      platformDefault={language === primaryLangCode(doc) ? defaultReadbackSuggestion : ''}
                      blankNote="Blank = a read-back is built from the fields this node captured."
                      groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                      onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.defaultReadback = { ...(t.defaultReadback ?? {}), [language]: v }; })} />
                    {!(node.defaultReadback?.[language] ?? '').trim() && defaultReadbackSuggestion && (
                      <p className="tenant-field-note tenant-suggested-note">
                        <b>Nothing saved here yet.</b> The greyed line above is a suggestion — the agent will not say
                        it until you save it.
                        <button type="button" className="tenant-linkish" onClick={() => onUpdate(next => {
                          const t = findNode(next, card); if (!t) return;
                          t.defaultReadback = { ...(t.defaultReadback ?? {}), [language]: defaultReadbackSuggestion };
                        })}>Use this wording</button>
                      </p>
                    )}
                  </div>
                ) : (node.defaultReadback?.[language] ?? '').trim() ? (
                  <div className="rq" style={{ marginBottom: 12 }}>
                    <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                      <span className="t">Unused read-back</span>
                    </div>
                    <p className="tenant-field-note tenant-suggested-note" style={{ marginTop: 0 }}>
                      <b>This is not spoken on this intent.</b> This node is split by request type, so a type with
                      no read-back of its own is composed from the fields it captured rather than falling back to
                      this line — a default written for one flow cannot describe another. It is kept here so nothing
                      invisible can drive a call; give each type its own wording above, or clear it.
                    </p>
                    <div className="tenant-auto-purpose" style={{ opacity: .75 }}>{node.defaultReadback?.[language]}</div>
                    <button type="button" className="tenant-linkish" onClick={() => onUpdate(next => {
                      const t = findNode(next, card); if (!t) return;
                      t.defaultReadback = { ...(t.defaultReadback ?? {}), [language]: '' };
                    })}>Clear it</button>
                  </div>
                ) : null}

                <TextField label="If the caller says it’s wrong, ask" placeholder=""
                  help={[['What it does', 'Sets what the agent says when the caller rejects the read-back but did not include the correction. If they DO say the fix in the same breath, it’s applied automatically and this prompt is skipped. Leave blank to use the built-in prompt.'], ['When it fires', 'Only on a Confirm node, right after the caller says the details are wrong without stating the right value.'], ['Example', 'Caller says “No, that’s not right” with no correction → the agent asks your prompt. Built-in: “Sorry about that. Please tell me what isn’t correct, and what it should be.”']]}
                  value={(node.correctionPrompt?.[language] ?? '') || (CONFIRM_BUILTIN.correction?.[language] ?? CONFIRM_BUILTIN.correction?.en ?? '')}
                  onChange={value => onUpdate(next => { const target = findNode(next, card); if (target) target.correctionPrompt = { ...(target.correctionPrompt ?? {}), [language]: value.trim() === (CONFIRM_BUILTIN.correction?.[language] ?? CONFIRM_BUILTIN.correction?.en ?? '').trim() ? '' : value }; })} />
                {/* v12.10.10.1 (#1418): the built-in line is shown as written text (never a grey placeholder) with the badge. */}
                {!(node.correctionPrompt?.[language] ?? '').trim() && <p className="tenant-field-note"><span className="rq-defnote">Template default</span> Change the words to use your own.</p>}
                {/* v12.9.25 (#965 AC6): the line before the "can't be confirmed" route. His decision: only this
                    sentence - no "staff will get back to you", because the route that follows speaks for itself. */}
                <TextField label="If it can’t be confirmed, say" placeholder=""
                  help={[['What it does', 'The line the caller hears when the read-back cannot be confirmed, just before the call goes where “If it can’t be confirmed → go to” says. Leave blank to use the built-in line.'], ['When it fires', 'When the Confirm card’s Ask cap is used up, or the caller stays silent after the read-back and the one re-ask.'], ['Example', '“Sorry, I am having trouble collecting the correct information.” then Skip to: Reference and Text.']]}
                  value={(node.cantConfirmPrompt?.[language] ?? '') || (CONFIRM_BUILTIN.cantConfirm?.[language] ?? CONFIRM_BUILTIN.cantConfirm?.en ?? '')}
                  onChange={value => onUpdate(next => { const target = findNode(next, card); if (target) target.cantConfirmPrompt = { ...(target.cantConfirmPrompt ?? {}), [language]: value.trim() === (CONFIRM_BUILTIN.cantConfirm?.[language] ?? CONFIRM_BUILTIN.cantConfirm?.en ?? '').trim() ? '' : value }; })} />
                {!(node.cantConfirmPrompt?.[language] ?? '').trim() && <p className="tenant-field-note"><span className="rq-defnote">Template default</span> Change the words to use your own.</p>}
              </>
            )}

            {/* v12.4.16 (#503/#508): THE CONNECT NODE'S OWN LINE WHEN ITS ACTION COULD NOT BE COMPLETED.
                Tushar, 2026-09-19: "we need one additional language wise prompt which can say in case of error -
                We are having difficulties, We have recorded your details and staff will call you back."
                It replaces the hard-coded default, which is what closes #508: on call #38-0007 the caller heard
                the built-in "I've noted your request and our staff will follow up" AND the voicemail route's
                "Sorry, we are having trouble completing your request" one second apart - one saying it was
                handled, the next saying it was not. One authored line replaces both. */}
            {/* ══ v12.9.11 (#778): THREE OUTCOMES, THREE PROMPTS - Success / Failure / No Connection. ══
                His design: *"le't add pill No Connection, Success, Failure. i wanted to keep it one promot so
                make it easy which serves all three purposes ... nah, i think separate pills will allow to
                define proper message to caller."* He considered one prompt with a skip switch and rejected it.

                WHY THIS FIXES 39-0074 RATHER THAN PATCHING IT. The caller heard *"Status for booking your
                appointment: with message."* - the node had a success path and an error path and no path for
                "the system never answered", so the error prompt spoke its own scaffolding around tokens that
                could not exist. The third box IS the missing state.

                AND THE No Connection BOX HAS NO TOKEN PICKER, which is his addition and the part that matters:
                with no tokens there is nothing to resolve to nothing. The engine speaks it verbatim. */}
            {node.type === 'Connect' && (
              <div className="rq" style={{ marginBottom: 12 }}>
                <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                  <span className="t">When it succeeds, say</span>
                  <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                    ['What it does', 'What the agent says when this node\u2019s action completed successfully.'],
                    ['When it fires', 'Once, immediately after the action succeeds, before the call continues.'],
                    ['Example', '\u201cYou\u2019re booked. Your reference is {external.reference}.\u201d Leave it blank to say nothing \u2014 which is what every build before 12.9.11 did.']]} /></span>
                </div>
                <PromptEditor value={node.successPrompt?.[language] ?? ''} rows={2} language={language}
                  translateSource={node.successPrompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                  silentWhenBlank
                  groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                  onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.successPrompt = { ...(t.successPrompt ?? {}), [language]: v }; })} />
                <p className="tenant-field-note">Optional. Blank means nothing extra is said &mdash; the behavior of every build before this one.</p>

                <div className="rq-rthead">
                  <span className="t">If it answers and refuses, say</span>
                  <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                    ['What it does', 'What the agent says when this node\u2019s action could not be completed \u2014 the system could not be reached, timed out, or answered with a failure.'],
                    ['When it fires', 'Once, immediately before the call follows the route you chose above. Leave it blank to say nothing and just route.'],
                    ['Example', '\u201cWe are having difficulties. We have recorded your details and our staff will call you back.\u201d Pair it with \u201cContinue to next node\u201d so the caller still gets their reference number.']]} /></span>
                </div>
                <PromptEditor value={node.errorPrompt?.[language] ?? ''} rows={2} language={language}
                  translateSource={node.errorPrompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                  silentWhenBlank blankNote="Blank = the connection's own failure line is spoken if it has one; otherwise nothing is said."
                  groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                  onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.errorPrompt = { ...(t.errorPrompt ?? {}), [language]: v }; })} />
                <p className="tenant-field-note">Optional. Blank means the call routes without a word &mdash; useful when the route itself speaks, such as voicemail. Use tokens here freely: the system answered, so its values exist.</p>

                <div className="rq-rthead">
                  <span className="t">If it never answers, say</span>
                  <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                    ['What it does', 'What the agent says when the other system could not be reached at all \u2014 it timed out or never responded.'],
                    ['When it fires', 'Instead of the refusal line above, whenever nothing came back.'],
                    ['No tokens, on purpose', 'There is no response, so no {token} could have a value. This box offers none \u2014 and the agent speaks whatever you write here exactly as written. That is what stops a half-finished sentence like \u201cStatus for booking your appointment: with message.\u201d reaching a caller.'],
                    ['Example', '\u201cWe are having difficulties. We have recorded your details and our staff will call you back.\u201d']]} /></span>
                </div>
                {/* NO groups / NO known -> the picker is absent, which is his rule: *"the No Connection pill
                    should have no token picker at all. keep it universal."* */}
                <PromptEditor value={node.noConnectionPrompt?.[language] ?? ''} rows={2} language={language} noTokens
                  translateSource={node.noConnectionPrompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                  silentWhenBlank blankNote="Blank = the connection's own failure line is spoken if it has one; otherwise nothing is said."
                  onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.noConnectionPrompt = { ...(t.noConnectionPrompt ?? {}), [language]: v }; })} />
                <p className="tenant-field-note">One universal sentence, no tokens. Blank falls back to the connection&rsquo;s own failure line, then to silence &mdash; never to the refusal line above, whose tokens cannot resolve when nothing answered.</p>
              </div>
            )}

            {/* ── v12.5.0 (#525): THE TEXT CONFIRMATION CARD'S THREE TEXTS ────────────────────────────────
                Tushar, 2026-09-19: "if it is a cellphone, then can send confirmaiton message along with giving
                the reference number." Three separate fields because they are three separate decisions: what the
                agent ASKS, what the message CONTAINS, and whether anything is said afterwards. Every one of them
                is blank-means-nothing, and each note below says which nothing it means - a field whose emptiness
                silently changes what a caller experiences has to say so on the screen (#361/#376/#396). */}
            {/* ══ v12.10.15 (#1663, FINAL 10/13): THE CALLBACK CARD - two lines per language, the field it stores, the mobile switch. ══ */}
            {isCallback && (
              <>
                <div className="rq" style={{ marginBottom: 12 }}>
                  <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                    <span className="t">Ask the caller</span>
                    <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                      ['What it does', 'Asks whether to call back at the number they are calling from. The number is never read out - the line is the same on every call. Yes = the caller ID is stored; a number (spoken or keyed) = that number is stored; \u201ca different one\u201d = the next line is asked.'],
                      ['When it fires', 'Once per call, where the card sits (after Process Request, before Confirm). A caller with no caller ID is asked the next line straight away.'],
                      ['Blank', 'Blank = the platform line.']]} /></span>
                  </div>
                  <PromptEditor value={node.callbackQuestion?.[language] ?? ''} rows={2} language={language}
                    translateSource={node.callbackQuestion?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                    platformDefault={cbLine('callback.question', language)}
                    groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.callbackQuestion = { ...(t.callbackQuestion ?? {}), [language]: v }; })} />
                </div>
                <div className="rq" style={{ marginBottom: 12 }}>
                  <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                    <span className="t">Ask for the number</span>
                    <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Asked when the caller wants a different number, or has no caller ID. The keypad works too.'], ['Blank', 'Blank = the platform line.']]} /></span>
                  </div>
                  <PromptEditor value={node.callbackAskNumber?.[language] ?? ''} rows={2} language={language}
                    translateSource={node.callbackAskNumber?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                    platformDefault={cbLine('callback.askNumber', language)}
                    groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.callbackAskNumber = { ...(t.callbackAskNumber ?? {}), [language]: v }; })} />
                </div>
                <div className="rq-g2" style={{ marginBottom: 12 }}>
                  <TextField label="Store" help={[['What it does', 'The field the callback number is stored in. Blank = Caller \u203a Callback number (caller.callback).']]}
                    value={(node.callbackStore ?? '').trim() || 'caller.callback'} /* v12.10.16 (#1675): blank shows (and is) Caller › Callback number */
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (t) t.callbackStore = v.trim() || null; })} />
                  <label className="tenant-form-field">
                    <span>Skip when the caller is on a mobile <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'On: a caller on a mobile is not asked - the mobile number is stored as the callback number. Off (default): everyone is asked.']]} /></span></span>
                    <button type="button" role="switch" aria-checked={node.callbackSkipOnMobile === true} className={'rq-sw' + (node.callbackSkipOnMobile ? ' on' : '')}
                      onClick={() => onUpdate(next => { const t = findNode(next, card); if (t) t.callbackSkipOnMobile = !(t.callbackSkipOnMobile === true); })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
                  </label>
                </div>
              </>
            )}

            {isTextConfirm && (
              <>
                <div className="rq" style={{ marginBottom: 12 }}>
                  <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                    <span className="t">Ask the caller</span>
                    <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                      ['What it does', 'The line the agent speaks to ASK whether the caller wants the confirmation by text. Nothing is ever sent without a yes — the permission is recorded on the call, which is what makes the text theirs to refuse.'],
                      ['When it fires', 'When the call reaches this card AND the caller is ringing from a mobile. On a landline, a toll-free or office line, or when the line type could not be determined, the card is skipped in silence and the call carries on exactly as it would have.'],
                      ['Example', '“I can text you the confirmation. Would you like that?”']]} /></span>
                  </div>
                  <PromptEditor value={node.textOffer?.[language] ?? ''} rows={2} language={language}
                    translateSource={node.textOffer?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                    silentWhenBlank blankNote="Blank = no text is offered."
                    groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.textOffer = { ...(t.textOffer ?? {}), [language]: v }; })} />
                  <p className="tenant-field-note"><b>Leave this blank and the card does nothing at all</b> &mdash; no question is asked and no text is sent. The caller is only asked when they are calling from a <b>mobile</b>; a landline, a toll-free number, or a number whose type we could not determine, and the call walks past this card without a word. <b>Only a clear &ldquo;yes&rdquo; sends the text</b> &mdash; silence, &ldquo;um&rdquo;, or anything unclear is taken as no. Either way the call continues to the next card.</p>
                </div>

                {/* v12.10.15 (#1660, LOCKED S148): the card's own Re-ask line, in the same format as a step's re-ask. */}
                <div className="rq" style={{ marginBottom: 12 }}>
                  <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                    <span className="t">Re-ask</span>
                    <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                      ['What it does', 'What the agent says when the caller says nothing, or gives an answer that is not a clear yes or no, after the offer.'],
                      ['When it fires', 'Only while the card\u2019s Ask cap allows it: Ask cap 1 = no re-ask (no text, the call moves on); Ask cap 2 = the offer and one re-ask.'],
                      ['Blank', 'Blank = the agent says the offer again.'],
                      ['Example', '\u201cWould you like me to text you the reference number?\u201d']]} /></span>
                  </div>
                  <PromptEditor value={node.textReask?.[language] ?? ''} rows={2} language={language}
                    translateSource={node.textReask?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                    silentWhenBlank blankNote="Blank = the offer is said again."
                    previewWhenBlank={/* v12.10.16 (#1674): the preview shows the offer that will be said again */ node.textOffer?.[language] ?? ''}
                    groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.textReask = { ...(t.textReask ?? {}), [language]: v }; })} />
                </div>

                <div className="rq" style={{ marginBottom: 12 }}>
                  <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                    <span className="t">The text message</span>
                    <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                      ['What it does', 'The body of the SMS, sent to the number the caller is calling from, from your own practice number. Written per language and with the same tokens as every other prompt.'],
                      ['When it fires', 'Only after the caller has said yes to the question above. Leave it blank and nothing is sent even then — the call path records that the caller accepted a message that was never written.'],
                      ['Example', '“{organization.name}: your reference number is {request.referenceNumber}.”']]} /></span>
                  </div>
                  <PromptEditor value={node.textMessage?.[language] ?? ''} rows={3} language={language}
                    translateSource={node.textMessage?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                    silentWhenBlank blankNote="Blank = no text is sent."
                    groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.textMessage = { ...(t.textMessage ?? {}), [language]: v }; })} />
                  {/* v12.9.28 (#1057): our own short link instead of the long form address */}
                  <div style={{ marginTop: 10 }}>
                    <TextField label="Feedback form address" help={[['What it does', 'Your feedback form (for example a Google Form "pre-filled link"). Put {request.feedbackLink} in the message above and the text carries a short link of ours that opens this form with the call number already filled in.'], ['When it fires', 'When the caller taps the link in the text. A call number we cannot find opens the form without it.'], ['Example', 'https://docs.google.com/forms/d/e/…/viewform?usp=pp_url&entry.123456= - the call number is added at the end, or where you write {ref}.']]}
                      value={node.feedbackFormUrl ?? ''} placeholder="https://docs.google.com/forms/…&entry.123456="
                      onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.feedbackFormUrl = v.trim() || undefined; })} />
                  </div>
                  <p className="tenant-field-note"><b>Blank means nothing is sent</b>, even if the caller says yes. <b>A text message is not encrypted</b>, and it sits on the phone for anyone who picks it up &mdash; which is why this ships with the practice name and the reference number and nothing else. Adding the date, the time, the provider or the reason for the visit puts patient information on an unencrypted channel: a decision worth making deliberately, and yours to make.</p>
                </div>

                <div className="rq" style={{ marginBottom: 12 }}>
                  <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                    <span className="t">After it is sent, say</span>
                    <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                      ['What it does', 'An optional line the agent speaks once the message has actually been accepted for delivery. Leave it blank and the agent says nothing.'],
                      ['When it fires', 'Only after a successful send. A send that fails is never announced to the caller — they already have their reference number, and telling them a text failed adds worry and no information; it is recorded in the call path for your staff instead.'],
                      ['Example', '“It is on its way.”']]} /></span>
                  </div>
                  <PromptEditor value={node.textSent?.[language] ?? ''} rows={2} language={language}
                    translateSource={node.textSent?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                    silentWhenBlank
                    groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                    onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.textSent = { ...(t.textSent ?? {}), [language]: v }; })} />
                  <p className="tenant-field-note">Optional, and blank is the default &mdash; the call simply moves on to the next card. Delivery is <b>not</b> confirmed here: the carrier has accepted the message, which is not the same as the phone having received it.</p>
                </div>
              </>
            )}

      {/* v12.10.1 (#1085): the Announce card's line, per language */}
      {isAnnounce && (
        <div className="rq" style={{ marginBottom: 12 }}>
          <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
            <span className="t">Announce</span>
            <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
              ['What it does', 'The one line this card says. Tokens read captured values; nothing is asked.'],
              ['When it fires', 'When the call reaches this card. Cleared - the template line comes back and is spoken.'],
              ['Example', 'Let me give you the reference number for this call: {request.referenceNumber}.']]} /></span>
          </div>
          <PromptEditor value={node.announceText?.[language] ?? ''} rows={2} language={language}
            translateSource={node.announceText?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
            placeholder="Let me give you the reference number for this call: {request.referenceNumber}."   /* grey-ok: PromptEditor ignores placeholder; platformDefault is shown */
            platformDefault={ANNOUNCE_DEFAULTS[language] ?? ANNOUNCE_DEFAULTS.en}
            groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
            onChange={v => onUpdate(next => { const t = findNode(next, card); if (!t) return; t.announceText = { ...(t.announceText ?? {}), [language]: v }; })} />
          {/* v12.10.2 (#1094): the Announce card's settings - BELOW the line, in one row (his review 10/2). */}
          {(
            <div className="rq-g2" style={{ gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', alignItems: 'end', marginTop: 10 }}>
              <label className="tenant-form-field tenant-inline-switch">
                <label className="tenant-mini-switch">
                  <input type="checkbox" checked={node.announceWait !== false} onChange={event => onUpdate(next => { const t = findNode(next, card); if (t) t.announceWait = event.target.checked; })} />
                  <span />
                </label>
                <span>Wait for the caller<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'After the line, listen a few seconds so the caller can ask to hear it again.'], ['When it fires', 'Right after the line is spoken. "Repeat", "say that again" or "what was the number?" says it again; OK, thanks, yes or silence moves on.'], ['Example', 'On for a reference number. Off for a line that needs no reply - it is spoken and the call goes straight on.']]} /></span></span>
              </label>
              <SelectField label="Then go to" help={[['What it does', 'Where the call goes after this card.'], ['When it fires', 'When the caller has heard the line (and answered, or stayed silent).'], ['Example', 'Continue to next node - the Text card after the reference.']]}
                value={node.announceThen ?? 'next'} options={['next', 'thankyou', 'handoff']}
                labels={{ next: 'Continue to next node', thankyou: TERMINAL_LABELS.thankyou, handoff: TERMINAL_LABELS.handoff }}
                onChange={value => onUpdate(next => { const t = findNode(next, card); if (t) t.announceThen = value === 'next' ? undefined : value; })} />
              <TextField label="Listen for (seconds)" help={[['What it does', 'How long to listen after the line.'], ['When it fires', 'Only with Wait for the caller on.'], ['Example', '3']]}
                value={String(node.announceListenSeconds ?? 3)} onChange={value => onUpdate(next => { const t = findNode(next, card); if (t) t.announceListenSeconds = Math.max(1, Math.min(10, Number(value) || 3)); })} />
              <TextField label="Ask cap" help={[['What it does', 'How many times in total the line may be said on this card, the first time included - like Ask cap on the other cards.'], ['When it fires', 'Only with Wait for the caller on: each "repeat" / "say that again" says it once more, up to this cap.'], ['Example', 'Ask cap 3: said once, then up to two more times if the caller asks.']]}
                value={String((node.announceRepeatMax ?? 2) + 1)} onChange={value => onUpdate(next => { const t = findNode(next, card); if (t) t.announceRepeatMax = Math.max(0, Math.min(5, (Number(value) || 1) - 1)); })} />
            </div>
          )}
        </div>
      )}

      {node.type !== 'Confirm' && !isTextConfirm && !isAnnounce && !isCallback /* v12.10.16 (#1675): the Callback card uses no steps */ && (
      <div className="tenant-node-step-list">
        {isRequest && (
          <div className="tenant-rt-block">
            <div className="tenant-rt-head">
              <strong>Request types <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Splits this node into separate request types (for example Make, Change, Cancel). The caller is routed to the matching type, and each type runs its own steps.'], ['When it fires', 'When the call reaches this Request node - the agent detects which request the caller wants and follows that type.'], ['Example', 'A Change type asks for the original date, then the new date; a Cancel type confirms and cancels.']]} /></span></strong>
              <span className="tenant-rt-count">{requestTypes.filter(r => r.enabled !== false && (r.steps?.length ?? 0) > 0).length} of {requestTypes.length}</span>
              <button type="button" className="tenant-rt-add" onClick={() => setRtEditing('__new')}>+ Add request type</button>
            </div>
            <div className="tenant-rt-chips">
              {requestTypes.map((rt, i) => {
                const off = rt.enabled === false;
                const count = rt.steps?.length ?? 0;
                return (
                  <div key={rt.id} className={`tenant-rt-chip${i === rtIndex ? ' sel' : ''}${off ? ' off' : ''}${!off && count === 0 ? ' empty' : ''}`}>
                    <button type="button" className="tenant-rt-chip-main" onClick={() => { setRtSel(i); setRtMenuFor(null); }}>
                      <span className="tenant-rt-chip-nm">{rt.name || 'Untitled'}</span>
                      <span className="tenant-rt-chip-n">{off ? 'Off' : count}</span>
                    </button>
                    <button type="button" className="tenant-rt-chip-dot" title="More" onClick={() => setRtMenuFor(rtMenuFor === rt.id ? null : (rt.id ?? null))}>⋮</button>
                    {rtMenuFor === rt.id && (
                      <div className="tenant-rt-menu">
                        <button type="button" onClick={() => { setRtEditing(rt.id ?? null); setRtMenuFor(null); }}>Edit</button>
                        <button type="button" onClick={() => { updateRequestType(rt.id!, { enabled: off ? true : false }); setRtMenuFor(null); }}>{off ? 'Enable' : 'Disable'}</button>   {/* v12.3.14.1: Tushar - "let's keep enable / disable everywhere for now." This was the only place in T2 that said Turn on/Turn off. */}
                        <button type="button" className="tenant-rt-menu-del" onClick={() => { deleteRequestType(rt.id!); setRtMenuFor(null); setRtSel(0); }}>Delete</button>
                      </div>
                    )}
                  </div>
                );
              })}
              {requestTypes.length === 0 && <span className="tenant-field-note">No request types yet — add one (e.g. Make, Change, Cancel).</span>}
            </div>
            {rtEditing !== null && (
              <RequestTypeSettingsPopup
                rt={rtEditing === '__new' ? null : (requestTypes.find(r => r.id === rtEditing) ?? null)}
                onSave={(name, keywords, enabled) => {
                  if (rtEditing === '__new') addRequestType(name, keywords);
                  else updateRequestType(rtEditing, { name, keywords, enabled });
                  setRtEditing(null);
                }}
                onCancel={() => setRtEditing(null)} />
            )}
          </div>
        )}
        {isIdentity && node && (
          <AskTogetherBlock on={node.askTogether === true} prompt={node.askTogetherPrompt} language={language}
            fields={askTogetherFields(steps, vocabLabels, vocabCustom)} noSteps={steps.length === 0} scopeLabel="this Identity card"
            onChange={patch => onUpdate(next => { const t = findNode(next, card); if (!t) return; if (patch.askTogether !== undefined) t.askTogether = patch.askTogether; if (patch.askTogetherPrompt !== undefined) t.askTogetherPrompt = patch.askTogetherPrompt; })} />
        )}
        {/* v12.2.47.10 (#276-U4): Identity/Steps step head unified to the rq-stepshead style (label + tooltip + add). */}
        <div className="rq-stepshead">
          <span className="lb">Steps <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', isIdentity ? 'The identity fields this node captures, in order — each asks for a value and stores it.' : 'The ordered conversational turns for this node — each asks a question and stores the answer.'], ['When it fires', 'In order, once the call reaches this node.'], ['Example', isIdentity ? 'Step 1 captures the patient name; Step 2 the date of birth.' : 'Step 1 captures the reason for calling; Step 2 a callback number.']]} /></span></span>
          {isIdentity ? (
            // v12.10.8 (#1190, Tushar 10/5): the "+ Add identity field..." dropdown is gone with Identity extraction - "we use
            // only token now to say what to store". A new identity step is a capture step; its Stores box names the token.
            <button type="button" className="rq-btn1" onClick={() => onUpdate(next => {
              const target = findNode(next, card);
              if (!target) return;
              target.steps ??= [];
              if (target.steps.length === 0 && target.askTogether === undefined) target.askTogether = true;   // v12.10.15 (#1643 S127): a new Identity
              target.steps.push({ id: makeId('step'), kind: 'capture', label: 'New step', stores: '', prompt: { [language]: '' }, fallbackMode: 'clarify-then-keypad', enabled: true });
            })}>+ Add step</button>
          ) : (
            <button type="button" className="rq-btn1" onClick={() => onUpdate(next => {
              const arr = stepsTarget(next);
              if (!arr) return;
              const target = findNode(next, card);
              // v12.2.38.0 (#174): a Confirm node's FIRST step is seeded with the recommended read-back.
              const seedConfirm = (target?.type ?? '') === 'Confirm' && arr.length === 0;
              arr.push({ id: makeId('step'), kind: 'speak', label: seedConfirm ? 'Read-back' : 'New step', prompt: { [language]: seedConfirm ? CONFIRM_READBACK_DEFAULT : '' }, fallbackMode: 'clarify-then-keypad', enabled: true });
            })}>+ Add step</button>
          )}
        </div>
        {steps.length === 0 && (
          <p className="tenant-field-note">No steps yet. {isIdentity ? 'Use “+ Add step”, then choose the field it stores in Stores.' : 'Use “+ Add step” to add a spoken/asked turn.'}</p>
        )}
        {/* v12.2.47.10 (#276-U4): Identity/Steps step cards unified to the Request node's rq-stepcard layout
            (rq-sgrid Step / Confidence / Unsure / kebab + rq-sbody Stores row with Optional toggle). */}
        {steps.map((step, index) => {
          const stepCount = steps.length;
          const off = step.enabled === false;
          const conf = step.confidenceThreshold;
          const confErr = conf != null && (isNaN(conf) || conf < 0 || conf > 1);
          const nameId = 'nd-step-name-' + step.id;
          return (
            <div key={step.id} className={'rq-stepcard' + (off ? ' disabled' : '')}>
              <div className="rq-sgrid">
                <div>
                  <span className="lab">Step {index + 1} <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Names this step and sets its order — steps run top to bottom within this node.'], ['When it fires', 'In order, once the call reaches this node.'], ['Example', 'Step 1 captures the value, Step 2 the reason. Use the ⋮ menu to reorder, disable, or delete a step.']]} /></span>{off && <span className="dbadge">Disabled</span>}</span>
                  <input id={nameId} className="rq-in" value={step.label ?? ''} placeholder="Name this step"
                    onChange={e => { const v = e.target.value; onUpdate(next => { const t = stepAt(next, index, step.id); if (t) t.label = v; }); }} />
                </div>
                {/* v12.9.1 (#708): the SECOND render site - both, always. */}
                <div>
                  <StepCleanupSelect
                    compact
                    value={step.cleanup}
                    fieldType={stepFieldType(step.stores, vocabCatalog, vocabCustom)}
                    disabled={off}
                    onChange={v => onUpdate(next => {
                      const t = stepAt(next, index, step.id);
                      if (t) t.cleanup = v;
                    })} />
                </div>
                <div>
                  <span className="lab plain">Confidence <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'How sure the recognizer must be of a captured value (0–1). The score comes from the phone carrier, not from us.'], ['When it fires', 'On every capture at this step. On a NAME, a score at or above this is accepted outright; below it the value is checked before it is kept, and a score under the platform floor is not kept at all — the agent asks again and then offers spelling. On every other field the value is kept and marked on the call record for a person to check.'], ['Example', 'A name left blank uses 0.60 — chosen from 161 real calls, where every correct name scored 0.745 or better and every mis-heard one 0.563 or worse. Other fields use 0.80.']]} /></span></span>
                  {/* v12.9.1 (#707): the SECOND render site - both, always. */}
                  <input className={'rq-in rq-conf' + (confErr ? ' err' : '')} type="number" step={0.05} min={0} max={1}
                    placeholder={confidencePlaceholderFor(stepFieldType(step.stores, vocabCatalog, vocabCustom), stepCapturesAPersonName(step.stores), confDefaults, 'default · ' + (stepFieldType(step.stores, vocabCatalog, vocabCustom) === 'name' ? '0.60' : '0.80'))}   /* grey-ok: a confidence number, not a spoken line; v12.10.21 (#1957) from configuration when served */
                    value={conf ?? ''} onChange={e => { const v = e.target.value; onUpdate(next => { const t = stepAt(next, index, step.id); if (t) t.confidenceThreshold = v === '' ? null : Number(v); }); }} />
                  {confErr && <div className="rq-inerr">Enter a value from 0.00 to 1.00.</div>}
                </div>
                <div style={{ position: 'relative' }}>
                  <button type="button" className="rq-kebab" aria-expanded={stepMenuFor === step.id} title="Step actions" onClick={() => setStepMenuFor(stepMenuFor === step.id ? null : (step.id ?? null))}>⋮</button>
                  {stepMenuFor === step.id && (
                    <div className="rq-stepmenu">
                      {/* v12.2.47.10 (#275-B): leading icons on the step ⋮ menu, matching the Request node. */}
                      <button type="button" onClick={() => { setStepMenuFor(null); const el = document.getElementById(nameId) as HTMLInputElement | null; el?.focus(); }}><span className="rq-menu-ic" aria-hidden="true">✎</span>Edit</button>
                      <button type="button" disabled={index === 0} onClick={() => { setStepMenuFor(null); onUpdate(next => { const arr = stepsTarget(next); if (!arr || index <= 0) return; const tmp = arr[index - 1]; arr[index - 1] = arr[index]; arr[index] = tmp; }); }}><span className="rq-menu-ic" aria-hidden="true">↑</span>Move up</button>
                      <button type="button" disabled={index >= stepCount - 1} onClick={() => { setStepMenuFor(null); onUpdate(next => { const arr = stepsTarget(next); if (!arr || index >= arr.length - 1) return; const tmp = arr[index + 1]; arr[index + 1] = arr[index]; arr[index] = tmp; }); }}><span className="rq-menu-ic" aria-hidden="true">↓</span>Move down</button>
                      {/* v12.3.16 (#387): act on the step at THE INDEX THIS ROW WAS RENDERED FROM, not a re-find
                          by id. Tushar could not re-enable a disabled step inside a shared node: the menu said
                          Enable, the click did nothing, no console error. Re-finding by id searches a freshly
                          NORMALISED array - if an id does not survive that rebuild identically the find misses and
                          the mutation silently does nothing, which is exactly the symptom. The row was rendered
                          from steps[index]; mutating stepsTarget(next)[index] is the same element by construction.
                          I could not isolate the id mismatch by reading the code; this removes the class of failure
                          rather than the instance. */}
                      <button type="button" onClick={() => { setStepMenuFor(null); onUpdate(next => { const t = stepAt(next, index, step.id); if (t) t.enabled = t.enabled === false ? true : false; }); }}><span className="rq-menu-ic" aria-hidden="true">{off ? '✓' : '⊘'}</span>{off ? 'Enable' : 'Disable'}</button>
                      <div className="sep" />
                      <button type="button" className="danger" onClick={() => {
                        setStepMenuFor(null);
                        const emptyName = !(step.label ?? '').trim();
                        const emptyStores = !(step.stores ?? '').trim();
                        const emptyPrompt = Object.values(step.prompt ?? {}).every(v => !(v ?? '').trim());
                        const doDelete = () => onUpdate(next => { const arr = stepsTarget(next); if (!arr) return; const idx = arr.findIndex(s => s.id === step.id); if (idx >= 0) arr.splice(idx, 1); });
                        if (emptyName && emptyStores && emptyPrompt) { doDelete(); return; }
                        openConfirm({
                          title: 'Delete Step ' + (index + 1) + '?',
                          body: 'The prompt wording for every language, and the fields this step stores, will be removed. It is applied when you choose Done.',
                          consequence: null,
                          confirmWord: (step.label ?? '').trim() || ('Step ' + (index + 1)),
                          run: doDelete,
                        });
                      }}><span className="rq-menu-ic" aria-hidden="true">🗑</span>Delete</button>
                    </div>
                  )}
                </div>
              </div>
              <div className="rq-sbody">
                {/* v12.9.6 (#748): a DIV, not a LABEL. A <label> forwards a click anywhere inside it to its first
                              labelable descendant - and that is the Optional <button> below, which sits
                              before StoresField in DOM order. So clicking the card's Stores area silently
                              flipped Optional, and on call 39-0069 an Identity step marked Optional by
                              accident skipped the surname in silence. Tushar: "if you click anywhere on
                              name step card then the optional gets selected and it is very hard to
                              notice." The element was only ever used for layout; the CSS targets it by
                              class, never as `label`. */}
                <div className="tenant-node-step-key-field tenant-stores-row">
                  {/* v12.2.47.10 (#276-U4): Optional toggle SWITCH to the right of the STORES label line (matches Request). */}
                  <span className="rq-storeshead">
                    <span className="rq-storeslab">Stores <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Sets the slot key(s) this step saves the answer into (e.g. subject.name). Separate multiple keys with commas.'], ['When it fires', 'Each time the caller answers this step.'], ['Example', 'subject.firstName, subject.lastName splits “Jane Doe” into two slots.']]} /></span></span>
                    <span className="rq-optsw" title="Optional — the step continues even if the caller doesn’t answer">
                      <span className="rq-optsw-txt">Optional</span>
                      <button type="button" role="switch" aria-checked={step.optional === true} className={'rq-sw' + (step.optional === true ? ' on' : '')}
                        onClick={() => onUpdate(next => { const t = stepAt(next, index, step.id); if (t) t.optional = !(t.optional === true); })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
                    </span>
                  </span>
                  <StoresField value={step.stores ?? ''} suggestions={storeKeySuggestions(doc, identifiers, vocabCustom)}
                    placeholder={isIdentity ? 'Add a field to capture…' : '(optional) — a field to capture, e.g. Appointment › Date'}
                    onChange={v => onUpdate(next => { const t = stepAt(next, index, step.id); if (t) t.stores = v || null; })} />
                </div>
                <small className="tenant-field-note tenant-stores-hint">Type a field name and press Enter, Tab or comma to add it - several fields capture from one answer.{!(step.stores ?? '').trim() && <><br /><b>Nothing is captured from this step.</b> The answer is heard but not stored, and no {'{token}'} is created for it.</>}</small>
                <PromptEditor value={step.prompt?.[language] ?? ''} rows={2} language={language} translateSource={step.prompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
                  silentWhenBlank
                  groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                  onChange={v => onUpdate(next => { const t = stepAt(next, index, step.id); if (!t) return; t.prompt ??= {}; t.prompt[language] = v; })} />
                {/* v12.9.0 (#696): the SECOND render site - every field, above "If not captured". */}
                <RetryLine
                  value={step.rungPrompts?.retry?.[language]}
                  platformDefault={reaskPlatformDefault(stepFieldType(step.stores, vocabCatalog, vocabCustom), /birth|dob/i.test(step.stores ?? ''), (step.stores ?? '').split(/[,;\n]+/).filter(Boolean).length, language)}
                  disabled={off}
                  onChange={v => onUpdate(next => {
                    const t = stepAt(next, index, step.id);
                    if (!t) return;
                    t.rungPrompts ??= {};
                    t.rungPrompts.retry ??= {};
                    if (v === null) delete t.rungPrompts.retry[language];
                    else t.rungPrompts.retry[language] = v;
                  })} />
                {/* ── v12.7.3 (#647/#640): "IF NOT CAPTURED" ON **THIS** CARD TOO. ───────────────────────────
                    THE IDENTITY NODE HAS ITS OWN STEP RENDERER. 12.7.3 shipped the ladder on the Request node's
                    card and not on this one, so the identity steps - the Name, Date of birth and ZIP steps the
                    whole release was FOR - had no switches at all. Tushar found it on the live screen within
                    minutes of the deploy.
                    It is the third time in one release that a control was changed on one editor and left on the
                    other (see #643's two copies of "On fail" / "Unable to capture"). The lesson is not "check
                    this file again": a grep that asks "is <LadderBlock> present?" answers yes on one site and
                    says nothing about coverage. Ask how many step renderers exist, then confirm each one. */}
                {/* v12.10.21 (#1957, LOCKED 10/25): the #1928 block is gone - ONE pointer line to the Read-backs card */}
                <ReadbackPointer doc={doc} stores={step.stores} />
                <LadderBlock
                  value={{ askToSpell: step.askToSpell, splitAsk: step.splitAsk, dtmf: step.dtmf, keypadNoKey: step.keypadNoKey, rungPrompts: step.rungPrompts, rungDefaults: step.rungDefaults /* v12.9.5 (#738) */ }}
                  fieldType={stepFieldType(step.stores, vocabCatalog, vocabCustom)}
                  isBirthdate={/birth|dob/i.test(step.stores ?? '')}
                  storedKeys={(step.stores ?? '').split(/[,;\n]+/).map(k => canonStoreKey(k).trim()).filter(Boolean)}
                  labelOf={(k) => tokenLabel(k, vocabLabels, vocabCustom) ?? prettyField(k.split('.').pop() ?? k)}
                  language={language}
                  disabled={off}
                  groups={availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                  known={availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
                  onChange={patch => onUpdate(next => {
                    const t = stepAt(next, index, step.id);
                    if (!t) return;
                    if (patch.askToSpell !== undefined) t.askToSpell = patch.askToSpell;
                    if (patch.splitAsk   !== undefined) t.splitAsk   = patch.splitAsk;
                    if (patch.dtmf       !== undefined) t.dtmf       = patch.dtmf;
                    if (patch.keypadNoKey !== undefined) t.keypadNoKey = patch.keypadNoKey;   // v12.10.15 (#1641)
                    if (patch.rungPrompts !== undefined) t.rungPrompts = patch.rungPrompts;
                  })} />
                {step.optional && (
                <div className="rq-optwrap">
                  <span className="rq-optnote">Optional — the step continues even if the caller doesn’t answer.</span>
                    <label className="rq-optroute"><span>If captured → go to</span>
                      <select className="rq-in" value={step.capturedRouteKind === 'node' ? ('node:' + (step.capturedRouteTarget ?? '')) : step.capturedRouteKind === 'terminal' ? ('terminal:' + (step.capturedRouteTarget ?? '')) : 'continue'}
                        onChange={e => { const val = e.target.value; onUpdate(next => { const t = stepsTarget(next)?.find(s => s.id === step.id); if (!t) return; if (val === 'continue') { t.capturedRouteKind = 'continue'; t.capturedRouteTarget = null; } else { const ci = val.indexOf(':'); t.capturedRouteKind = val.slice(0, ci); t.capturedRouteTarget = val.slice(ci + 1); } }); }}>
                        <option value="continue">Continue to next step</option>
                        {intentNodes.filter(n => n.id !== node.id).map(n => <option key={n.id} value={'node:' + n.id}>Node: {routeNodeLabel(doc, cardWf, n)}</option>)}
                        {Object.keys(doc.terminal ?? DEFAULT_TERMINALS).map(k => <option key={k} value={'terminal:' + k} disabled={!!offTerminals[k]}>End: {TERMINAL_LABELS[k] ?? k}{offTerminals[k] ? ` (${offTerminals[k]})` : ''}</option>)}
                      </select>
                    </label>
                </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      )}
          </div>{/* rq-scope */}
        </>
      )}{/* hasLangContent */}
      {/* v12.2.47.10 (#276-U4): step delete-confirm dialog, shared with the Request node's step cards. */}
      {confirm && (
        <ConfirmDialog title={confirm.title} body={confirm.body} consequence={confirm.consequence} confirmWord={confirm.confirmWord ?? null}
          onCancel={closeConfirm} onConfirm={() => { confirm.run(); closeConfirm(); }} />
      )}
    </div>
  );
}

// v12.2.24.0 (#159/#152): Move this node up/down in its intent's node sequence, or remove it.
// Removal saves + closes via the parent (onRemove); reorder is a normal draft edit persisted on Done.
function NodeArrange({ card, doc, onUpdate, onRemove }: { card: Extract<CardRef, { kind: 'node' }>; doc: DesignerDocument; onUpdate: (mutator: (next: DesignerDocument) => void) => void; onRemove?: () => void }) {
  const intent = doc.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId);
  const nodes = intent?.nodes ?? [];
  const index = nodes.findIndex(n => n.id === card.nodeId);
  const count = nodes.length;
  const swap = (a: number, b: number) => onUpdate(next => {
    const list = next.workflows?.find(w => w.id === card.workflowId)?.intents?.find(i => i.id === card.intentId)?.nodes;
    if (!list || a < 0 || b < 0 || a >= list.length || b >= list.length) return;
    const tmp = list[a]; list[a] = list[b]; list[b] = tmp;
  });
  return (
    <div className="tenant-node-arrange">
      <div className="tenant-node-arrange-move">
        <span>Order · {count ? index + 1 : 0} of {count}</span>
        <button type="button" disabled={index <= 0} onClick={() => swap(index, index - 1)}>↑ Move up</button>
        <button type="button" disabled={index < 0 || index >= count - 1} onClick={() => swap(index, index + 1)}>↓ Move down</button>
      </div>
      {onRemove && (
        <button type="button" className="tenant-node-remove" onClick={onRemove}>Remove this node</button>
      )}
    </div>
  );
}

function StepEditor({ card, doc, language, languages, onLanguage, onUpdate }: { card: Extract<CardRef, { kind: 'step' }>; doc: DesignerDocument; language: string; languages: { code: string; displayName: string }[]; onLanguage: (code: string) => void; onUpdate: (mutator: (next: DesignerDocument) => void) => void }) {
  // v12.3.10.1 (#303): one served catalog, for the picker AND the unresolved-token check.
  const { catalog: vocabCatalog, vocab: vocabLabels, customFields: vocabCustom, lists: vocabLists } = useVocabulary();
  const step = findStep(doc, card);
  if (!step) return null;
  // v12.3.6 (#238 Card Layout Standard v1.0): identity box (Name / Stores) -> language strip -> per-language prompt box.
  return (
    <>
      <div className="tenant-drawer-section">
        <SectionTitle title="Step" note="identity - not spoken" help={[['What it does', 'One conversational turn within a node - the prompt the agent speaks and the slot it stores the answer into.'], ['When it fires', 'In order, when the node runs; each step asks its prompt and captures the reply.'], ['Example', 'A step "Ask DOB" prompts "What is your date of birth?" and stores the answer into subject.dob.']]} />
        <TextField label="Name" help={[['What it does', 'The internal name for this conversational step, shown in the node step list. Not spoken to the caller.'], ['When it fires', 'Builder only - it labels the step; the caller hears the step Prompt, not this.'], ['Example', 'Name a step "Ask DOB" so it is easy to find and reorder within the node.']]} value={step.label ?? ''} onChange={value => onUpdate(next => {
          const target = findStep(next, card);
          if (target) target.label = value;
        })} />
        <label className="tenant-form-field">
          <span>Stores token</span>
          <StoresField value={step.stores ?? ''} suggestions={storeKeySuggestions(doc, [], vocabCustom)}
            placeholder="e.g. appointment.date, appointment.time"
            onChange={value => onUpdate(next => { const target = findStep(next, card); if (target) target.stores = value || null; })} />
          <small className="tenant-field-note">Type a field name and press Enter, Tab or comma to add it - several fields capture from one answer.</small>
        </label>
      </div>

      <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />

      <div className="tenant-drawer-section">
        <SectionTitle title="Prompt" note={`per language - ${language.toUpperCase()}`} help={[['What it does', 'The line the agent speaks for this step, written per language.'], ['When it fires', 'When the node reaches this step.'], ['Example', 'English: "What day works best?"  Spanish: "Que dia le conviene?"']]} />
        <label className="tenant-form-field">
          <span>{`Prompt - ${language.toUpperCase()}`}</span>
          <PromptEditor value={step.prompt?.[language] ?? ''} rows={3} language={language} silentWhenBlank translateSource={step.prompt?.[primaryLangCode(doc)] ?? ''} translateSourceLang={primaryLangCode(doc)}
            groups={availableTokenGroups(doc, [], vocabCatalog, vocabLabels, vocabCustom, vocabLists)} known={availableTokens(doc, [], vocabCatalog, vocabLabels, vocabCustom, vocabLists)}
            onChange={value => onUpdate(next => {
              const target = findStep(next, card);
              if (!target) return;
              target.prompt ??= {};
              target.prompt[language] = value;
            })} />
        </label>
      </div>
    </>
  );
}

// v12.3.3 (#238 . 238-a): keyword phrases as removable chips + an add field (Enter or comma commits), replacing
// the old comma-separated text input so the terminal editor matches the BDR-004 mockup.
// v12.3.5: pick a target intent to copy a node into (any workflow/intent, including the same one to duplicate).
function CopyNodeDialog({ doc, sourceLabel, onCancel, onConfirm }: { doc: DesignerDocument; sourceLabel: string; onCancel: () => void; onConfirm: (workflowId: string, intentId: string) => void }) {
  const options: Array<{ wfId: string; wfName: string; intId: string; intLabel: string }> = [];
  for (const wf of doc.workflows ?? []) for (const it of wf.intents ?? []) if (wf.id && it.id) options.push({ wfId: wf.id, wfName: wf.name || 'Caller type', intId: it.id, intLabel: it.label || 'Intent' });
  const [sel, setSel] = useState(options[0] ? options[0].wfId + '::' + options[0].intId : '');
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,14,22,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onCancel}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', width: 'min(460px,92vw)', boxShadow: '0 12px 40px rgba(0,0,0,.25)' }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 6px', fontSize: 16 }}>Copy &ldquo;{sourceLabel}&rdquo; to&hellip;</h3>
        <p className="tenant-field-note" style={{ marginTop: 0 }}>A full copy (its steps + settings, with fresh ids) is added to the chosen intent. The original stays put.</p>
        <label className="tenant-form-field"><span>Target intent</span>
          <select value={sel} onChange={e => setSel(e.target.value)}>
            {options.map(o => <option key={o.wfId + '::' + o.intId} value={o.wfId + '::' + o.intId}>{o.wfName} &rsaquo; {o.intLabel}</option>)}
          </select>
        </label>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <button type="button" className="tenant-secondary" onClick={onCancel}>Cancel</button>
          <button type="button" className="tenant-primary" disabled={!sel} onClick={() => { const [w, i] = sel.split('::'); onConfirm(w, i); }}>Copy</button>
        </div>
      </div>
    </div>
  );
}

function KeywordChips({ value, onChange }: { value: string[]; onChange: (next: string[]) => void }) {
  const [draft, setDraft] = useState('');
  const commit = (raw: string) => {
    const parts = raw.split(',').map(x => x.trim()).filter(Boolean);
    if (parts.length === 0) { setDraft(''); return; }
    const next = [...value];
    for (const p of parts) if (!next.some(x => x.toLowerCase() === p.toLowerCase())) next.push(p);
    onChange(next); setDraft('');
  };
  const removeAt = (i: number) => onChange(value.filter((_, idx) => idx !== i));
  return (
    <div className="tenant-kw-chips" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center', border: '1px solid #d7dced', borderRadius: 8, padding: '6px 8px', background: '#fff' }}>
      {value.map((kw, i) => (
        <span key={kw + '-' + i} title="Click to edit" onClick={() => { setDraft(d => (d ? d + ', ' : '') + kw); removeAt(i); }} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#eef1fb', color: '#3730a3', borderRadius: 14, padding: '2px 6px 2px 10px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }}>
          {kw}
          <button type="button" aria-label={'Remove ' + kw} onClick={e => { e.stopPropagation(); removeAt(i); }}
            style={{ border: 'none', background: 'transparent', color: '#6366f1', cursor: 'pointer', fontSize: 14, lineHeight: 1, padding: 0 }}>&times;</button>
        </span>
      ))}
      <input type="text" value={draft}
        style={{ flex: '1 0 120px', border: 'none', outline: 'none', fontSize: 13, padding: '2px 4px', background: 'transparent' }}
        placeholder={value.length ? '+ add phrase' : "e.g. I'll call back, hang up, I have to go"}
        onChange={e => setDraft(e.target.value)}
        onPaste={e => { const t = e.clipboardData.getData('text'); if (t.includes(',') || t.includes('\n')) { e.preventDefault(); commit((draft ? draft + ',' : '') + t.replace(/\n/g, ',')); } }}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); commit(draft); } else if (e.key === 'Backspace' && draft === '' && value.length) { removeAt(value.length - 1); } }}
        onBlur={() => commit(draft)} />
    </div>
  );
}

function TerminalEditor({ card, doc, language, languages, onLanguage, onUpdate }: { card: Extract<CardRef, { kind: 'terminal' }>; doc: DesignerDocument; language: string; languages: { code: string; displayName: string }[]; onLanguage: (code: string) => void; onUpdate: (mutator: (next: DesignerDocument) => void) => void }) {
  const cardLine = useCardLines();   // v12.10.10 (#1408)
  // v12.3.16 (#371): THE TERMINAL HAD NO TOKEN PICKER AT ALL. Its PromptEditor was rendered with no `groups`
  // and no `known`, so nothing was ever offered here - not the reference number, not the caller's name, not
  // the practice name. Tushar: "i tried to put it in Thank you (success) but visit.reference number token did
  // not come there." It could not come there; nothing could.
  // The Thank-you terminal is the last thing a caller hears and the natural place to give them a reference,
  // which makes this the surface where the whole #356/#371 feature earns its keep.
  const { catalog: vocabCatalog, vocab: vocabLabels, customFields: vocabCustom, lists: vocabLists } = useVocabulary();
  const { data: aiAgent } = useQuery<AiAgentTokenSettings & HandoffSettingsView>({
    queryKey: ['t2-ai-agent'],
    queryFn: () => api.get<AiAgentTokenSettings & HandoffSettingsView>('/t2/settings/ai-agent'),
    staleTime: 60_000,
  });
  const identifiers: IdRow[] = [];   // v12.10.8 (#1190): Identity extraction is gone - Vocabulary is the only source
  const tokenGroups = availableTokenGroups(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists);
  const tokenKnown = availableTokens(doc, identifiers, vocabCatalog, vocabLabels, vocabCustom, vocabLists);
  // v12.10.1 (#1086): the two transfer cards
  const isTransfer = card.terminalKey === 'handoff' || card.terminalKey === 'fallback';
  const isOperator = card.terminalKey === 'fallback';
  const ho = aiAgent?.handoff;
  // v12.3.6 (#238 Card Layout Standard v1.0): identity box -> language strip -> spoken-content box.
  // v12.3.6 (#238-H): the spoken Message / action is now PER LANGUAGE. The default (first) language stays in
  // doc.terminal[key] (keeps the terminal key enumerable for route pickers + back-compat with T4 / the row
  // mapper); every other language is stored as an override in terminalConfig[key].message[lang]. The engine
  // reads terminalConfig[key].message[lang] first, then falls back to doc.terminal[key], then the built-in default.
  const cfg = doc.terminalConfig?.[card.terminalKey];
  const setCfg = (patch: Partial<TerminalConfig>) => onUpdate(next => {
    next.terminalConfig ??= {};
    next.terminalConfig[card.terminalKey] = { ...(next.terminalConfig[card.terminalKey] ?? {}), ...patch };
  });
  const askOn = cfg?.askAnythingElse === true;
  // v12.10.22 (#2038): Transfer to staff - Handoff | Take a message (unset = Take a message while handoff is off, as the engine decides)
  const handoffOn = aiAgent?.handoffEnabled === true;
  const hMode: 'handoff' | 'take-message' = cfg?.handoffMode ?? (handoffOn ? 'handoff' : 'take-message');
  const takeMsg = isTransfer && !isOperator && hMode === 'take-message';
  const canTakeMessage = card.terminalKey === 'voicemail' || card.terminalKey === 'end-call';   // v12.10.22 (#2039)
  // v12.10.22 (#2040): the reference block. Unset = the reference sentence the card's own message still carries (the engine moves it here).
  const refDerived = (lang: string) => {
    const raw = (lang === (languages[0]?.code ?? 'en') ? (doc.terminal?.[card.terminalKey] ?? '') : (cfg?.message?.[lang] ?? '')) || (doc.terminal?.[card.terminalKey] ?? '');
    return raw.split(/(?<=[.?!])\s+/).filter(x => /referenceNumber/i.test(x)).join(' ');
  };
  const refOn = cfg?.refEnabled ?? (refDerived(languages[0]?.code ?? 'en') !== '');
  const refOnlyIfNot = cfg?.refOnlyIfNotGiven !== false;
  const defaultLang = languages[0]?.code ?? 'en';
  const isDefault = language === defaultLang;
  const storedMessage = isDefault ? (doc.terminal?.[card.terminalKey] ?? '') : (cfg?.message?.[language] ?? '');
  // v12.9.28 (#1077): a card name left in the message ("Route to operator") is not spoken - show the box empty, with the
  // template line in light gray, exactly as the call behaves.
  const messageIsLabel = isTerminalLabel(storedMessage);
  const messageValue = messageIsLabel ? '' : storedMessage;
  const templateMessage = TERMINAL_MESSAGE_DEFAULTS[card.terminalKey]?.[language] ?? TERMINAL_MESSAGE_DEFAULTS[card.terminalKey]?.en ?? '';
  const setMessage = (value: string) => onUpdate(next => {
    if (isDefault) {
      next.terminal ??= {};
      next.terminal[card.terminalKey] = value;
    } else {
      next.terminalConfig ??= {};
      const c = next.terminalConfig[card.terminalKey] ?? {};
      const msg = { ...(c.message ?? {}) };
      msg[language] = value;
      next.terminalConfig[card.terminalKey] = { ...c, message: msg };
    }
  });
  return (
    <>
      <div className="tenant-drawer-section">
        <SectionTitle title="Terminal" note="identity - not spoken" help={[['What it does', 'Defines an end-state for the call - the outcome and the closing message the caller hears before hangup.'], ['When it fires', 'When a node routes here, or the flow reaches the end and falls to the default terminal.'], ['Example', 'A "Thank you" terminal speaks a closing line and ends the call after a booking completes.']]} />
        <TextField label="Key" help={[['What it does', "The terminal's internal key - the stable identifier nodes route to. Read-only."], ['When it fires', 'Referenced by node route-to pickers; not spoken to the caller.'], ['Example', 'A terminal keyed "handoff" is what a node route "go to Handoff" points at.']]} value={card.terminalKey} onChange={() => undefined} disabled />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'start' }}>
          <TextField label="Name" help={[['What it does', "The terminal card's display name on the canvas and in route-to pickers. A label for your team - never spoken to the caller."], ['When it fires', 'Builder only; the caller hears the Message / action below, not this.'], ['Example', 'Name a terminal "End call" or "Transfer to staff" so it is easy to recognize and pick.']]}
            value={cfg?.name ?? ''} placeholder={TERMINAL_LABELS[card.terminalKey] ?? card.terminalKey} onChange={v => setCfg({ name: v })} />
          <TextField label="Description" help={[['What it does', "A short subtitle shown under the card's name on the canvas - its purpose at a glance."], ['When it fires', 'Builder only; never spoken to the caller.'], ['Example', 'Warm transfer to the front desk.']]}
            value={cfg?.description ?? ''} placeholder="What this outcome is for..." onChange={v => setCfg({ description: v })} />   {/* grey-ok: an internal note, never spoken */}
        </div>
        {/* v12.10.22 (#2038, prototype v1.4): Transfer to staff - Handoff | Take a message, one only. Handoff = today's options as they are;
            Take a message = only its prompt. Unset = Take a message while handoff is off (UMG after the deploy - no configuration). */}
        {isTransfer && !isOperator && (
          <div className="tenant-form-field">
            <span>Action<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
              ['Handoff', 'The call is transferred to staff - Who answers, Announce, Whisper and If no one answers below.'],
              ['Take a message', 'The agent says the Take a message line, the caller speaks (no beep), the reference number is given and the call ends. Saved like a voicemail.'],
              ['Default', handoffOn ? 'Handoff is on in AI Agent › Handoff, so Handoff until you pick.' : 'Handoff is off in AI Agent › Handoff, so Take a message until you pick.'],
            ]} /></span></span>
            <span className="tm-seg" role="radiogroup" aria-label="Transfer to staff action">
              {(['handoff', 'take-message'] as const).map(m => (
                <button key={m} type="button" role="radio" aria-checked={hMode === m} className={hMode === m ? 'on' : ''}
                  onClick={() => setCfg({ handoffMode: m })}>{m === 'handoff' ? 'Handoff' : 'Take a message'}</button>
              ))}
            </span>
          </div>
        )}
        {/* v12.10.1 (#1086): who answers lives in Settings › AI Agent › Handoff - shown here read-only */}
        {isTransfer && !takeMsg && (
          <label className="tenant-form-field">
            <span>{isOperator ? 'Operator line' : 'Who answers'}<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={isOperator
              ? [['What it does', 'The outside operator line this card transfers the caller to - at any hour.'], ['When it fires', 'When a call reaches this card. Edited in Settings › AI Agent › Handoff; the line must be Verified there, or this card cannot run.'], ['Example', 'Your answering service.']]
              : [['What it does', 'Who the caller is transferred to: in office hours the business-hours line; after hours the one After hours line switched on (After-hours line or Outside operator line), rung for the ring timeout.'], ['When it fires', 'When a call reaches this card. Edited in Settings › AI Agent › Handoff.'], ['Example', 'Business-hours line (413) 822-2413, ring timeout 20 s.']]} /></span></span>
            <div className="tenant-field-note" style={{ margin: 0 }}>
              {isOperator
                ? <>{(ho?.operatorLine ?? '').trim() || '—'}{operatorLineOn(aiAgent) ? ' · Verified · any hour' : (ho?.operatorLine ?? '').trim() ? ' · not verified' : ''}</>
                : <>Business-hours line {ho?.bizLine || '—'}{ho?.bizLine && !ho?.checks?.biz?.verified ? ' (not verified)' : ''} · after hours {operatorAfterHours(aiAgent) ? `Outside operator line ${(ho?.operatorLine ?? '').trim()}` : (ho?.afterHoursOn && (ho?.afterHoursLine ?? '').trim()) ? `After-hours line ${ho?.afterHoursLine}` : 'none switched on (voicemail)'} · ring timeout {ho?.ringTimeoutSec ?? 20} s · logged-in users: off</>}
              {' · '}<a href={HANDOFF_SETTINGS_PATH}>Edit in AI Agent › Handoff →</a>
            </div>
          </label>
        )}
        {/* v12.10.7 (#937, §37): what happens after the closing line and the "anything else?" switch are the same in
            every language, so they sit in the settings box above the rail; only the spoken lines are below it. */}
        {/* v12.10.1 (#1086): After speaking / Wait are not on the transfer cards - the agent connects and leaves. */}
        {!isTransfer && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'start' }}>
          <SelectField
            label="After speaking"
            value={cfg?.action ?? 'end-call'}
            options={canTakeMessage ? ['end-call', 'voicemail', 'take-message'] : ['end-call', 'voicemail']}
            labels={{ 'end-call': 'End the call', 'voicemail': 'Send to voicemail', 'take-message': 'Take a message' }}   /* v12.10.22 (#2039): say the line, take what the caller says (no beep), end */
            help={[['What it does', 'What happens right after the closing line is spoken - hang up, or drop the caller into voicemail.'], ['When it fires', "Immediately after this terminal's message finishes playing."], ['Example', 'A "Thank You (Success)" terminal ends the call; a "Failure" terminal can send to voicemail so staff can follow up.']]}
            onChange={v => setCfg({ action: v })}
          />
          <label className="tenant-form-field">
            <span>Wait before ending (seconds)<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'How long to keep the line open after the closing line, before the action runs. Leave blank for the default.'], ['When it fires', 'Between the message finishing and the hang-up / voicemail.'], ['Example', 'Set 2-3 seconds so a caller who starts talking again is heard before the line drops.']]} /></span></span>
            <input type="number" min={0} max={30} value={cfg?.waitSeconds ?? ''} placeholder="default" onChange={event => {
              const raw = event.target.value;
              const n = raw === '' ? undefined : Math.max(0, Math.min(30, parseInt(raw, 10) || 0));
              setCfg({ waitSeconds: n });
            }} />
          </label>
        </div>}
        {/* v12.10.22 (#2040, prototype v1.4): the "Ask is there anything else?" switch moved to the end of the card - its own switch + prompt. */}
      </div>

      <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />

      <div className="tenant-drawer-section">
        <SectionTitle title="Spoken content" note={`per language - ${language.toUpperCase()}`} help={[['What it does', 'The closing line the caller hears and what happens after it. The Message and the Keywords are written per language; the action applies to every language.'], ['When it fires', 'When the call routes to this terminal.'], ['Example', 'English says "Thank you for calling. Goodbye."; Spanish says "Gracias por llamar. Que tenga un buen día."']]} />
        {!isOperator && <label className="tenant-form-field">
          <span>Keywords<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'Caller phrases that route the call to THIS terminal mid-call - the interceptor listens on every turn, before the current step reads the answer. Separate phrases with commas. Each language has its own list; the primary language’s list is matched in every language.'], ['When it fires', 'On any caller turn: a match ends or hands off the call here (the Message / action is spoken first).'], ['Example', '"I’ll call back, hang up, I have to go" on End Call. Use clear multi-word phrases - avoid bare words like "cancel" that are real answers.']]} /></span></span>
          {/* v12.9.25 (#927): per language. The primary language edits the list every saved document already
              holds (matched in every language, as before); another language edits its own list. Empty there =
              the platform's phrases for that language ("hablar con una persona", "dejar un mensaje"). */}
          {language === defaultLang
            ? <KeywordChips value={cfg?.keywords ?? []} onChange={next => setCfg({ keywords: next })} />
            : <KeywordChips value={cfg?.keywordsByLang?.[language] ?? []}
                onChange={next => setCfg({ keywordsByLang: { ...(cfg?.keywordsByLang ?? {}), [language]: next } })} />}
          {language !== defaultLang && (cfg?.keywordsByLang?.[language] ?? []).length === 0 && (
            <p className="tenant-field-note">No {language.toUpperCase()} phrases yet - the platform’s {language.toUpperCase()} phrases for this terminal are used. The {defaultLang.toUpperCase()} phrases always apply too.</p>
          )}
        </label>}
        {takeMsg ? null : isTransfer
          ? <label className="tenant-field-label">Announce before the transfer<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'What the caller hears before the call is transferred.'], ['When it fires', 'When a call reaches this card, right before the line rings.'], ['Example', isOperator ? 'Let me connect you with our operator.' : 'Let me connect you with our staff.']]} /></span></label>
          : <label className="tenant-field-label">Message / action</label>}
        {!takeMsg && <PromptEditor
          value={messageValue}
          language={language}
          translateSource={doc.terminal?.[card.terminalKey] ?? ''}
          translateSourceLang={defaultLang}
          rows={3}
          groups={tokenGroups}
          known={tokenKnown}
          placeholder="What the caller hears (insert {tokens} to read captured values back)..."   /* grey-ok: PromptEditor ignores placeholder */
          platformDefault={templateMessage || undefined}
          onChange={setMessage}
        />}
        {/* v12.10.22 (#2037 #2039): Transfer to staff › Take a message - only its prompt. Said straight away, then the caller speaks (no beep). */}
        {takeMsg && (
          <>
            <label className="tenant-field-label">Take a message<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
              ['What it does', 'Said straight away; then the caller speaks (no beep). On a repeat call it is saved as the addendum.'],
              ['Replaces', 'The Interceptor\u2019s \u201cOffer help when nobody can take the call\u201d line.'],
            ]} /></span></label>
            <PromptEditor value={cfg?.takeMessagePrompt?.[language] ?? ''} language={language}
              translateSource={cfg?.takeMessagePrompt?.[defaultLang] ?? ''} translateSourceLang={defaultLang} rows={2}
              groups={tokenGroups} known={tokenKnown}
              platformDefault={cardLine('terminal.takeMessage', language) || undefined}
              translateSourceDefault={cardLine('terminal.takeMessage', defaultLang)}
              onChange={v => setCfg({ takeMessagePrompt: { ...(cfg?.takeMessagePrompt ?? {}), [language]: v } })} />
          </>
        )}
        {templateMessage && !isTransfer && (
          <p className="tenant-field-note">Blank{messageIsLabel ? <> (this card held only its name, &ldquo;{storedMessage}&rdquo;, which is never spoken)</> : null} &mdash; the light-gray line plays. Type to use your own words.</p>
        )}
        {card.terminalKey === 'voicemail' && (
          <p className="tenant-field-note">A sentence here is spoken first, then the voicemail greeting from Settings plays. Leave it blank and only the greeting plays.</p>
        )}
        {/* v12.10.1 (#1086): the operator number moved to Settings › AI Agent › Handoff › Outside operator line. */}
        {isTransfer && !takeMsg && <TransferCardSections cfg={cfg} setCfg={setCfg} language={language} defaultLang={defaultLang}
          isOperator={isOperator} handoff={aiAgent} groups={tokenGroups} known={tokenKnown} />}
        {/* ══ v12.10.22 (#2040, prototype v1.4): every terminal ends with the Reference number block (always the last thing before goodbye)
            and then its own "Anything else?" switch + prompt. ══ */}
        {!isOperator && (
          <div className="tm-blk">
            <div className="tm-blk-h">
              <span className="tm-sw-l">
                <button type="button" role="switch" aria-checked={refOn} aria-label="Reference number" className={'rq-sw' + (refOn ? ' on' : '')}
                  onClick={() => setCfg({ refEnabled: !refOn })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
                <b>Reference number</b><span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
                  ['What it does', 'Gives the caller the call\u2019s reference number - always the last thing before goodbye. A call with no reference number says nothing here.'],
                  ['Announce only if not provided earlier', 'On: not repeated when the caller already heard it on this call (a Call Reference card). Off: always said.'],
                ]} /></span>
              </span>
              {refOn && (
                <span className="tm-sw-r" title="Announce only if not provided earlier">
                  <span className="tm-sw-r-l">Announce only if not provided earlier</span>
                  <button type="button" role="switch" aria-checked={refOnlyIfNot} aria-label="Announce only if not provided earlier" className={'rq-sw sm' + (refOnlyIfNot ? ' on' : '')}
                    onClick={() => setCfg({ refOnlyIfNotGiven: !refOnlyIfNot })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
                </span>
              )}
            </div>
            {refOn && (
              <PromptEditor value={cfg?.refPrompt?.[language] ?? ''} language={language}
                translateSource={cfg?.refPrompt?.[defaultLang] ?? ''} translateSourceLang={defaultLang} rows={1}
                groups={tokenGroups} known={tokenKnown}
                platformDefault={refDerived(language) || cardLine('terminal.reference', language) || undefined}
                translateSourceDefault={refDerived(defaultLang) || cardLine('terminal.reference', defaultLang)}
                onChange={v => setCfg({ refEnabled: true, refPrompt: { ...(cfg?.refPrompt ?? {}), [language]: v } })} />
            )}
          </div>
        )}
        <div className="tm-blk">
          <div className="tm-blk-h">
            <span className="tm-sw-l">
              <button type="button" role="switch" aria-checked={askOn} aria-label="Anything else?" className={'rq-sw' + (askOn ? ' on' : '')}
                onClick={() => setCfg({ askAnythingElse: !askOn })}><span className="rq-sw-thumb" aria-hidden="true" /></button>
              <b>Anything else?</b><span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'After the closing line the agent asks whether the caller needs anything else and loops back into the workflow if they do - ending only when the caller says no.'], ['When it fires', "Right after this terminal's message, before the call ends."], ['Example', 'Turn this on for "Thank You (Success)" so a caller can book a second appointment without calling back.']]} /></span>
            </span>
          </div>
          {askOn && (
          <>
            <PromptEditor
              value={cfg?.anythingElsePrompt?.[language] ?? ''}
              language={language}
              translateSource={cfg?.anythingElsePrompt?.[defaultLang] ?? ''}
              translateSourceLang={defaultLang}
              rows={2}
              /* v12.4.1 (#405): Tushar found this one himself - "why request.referenenumber is not visible in
                 anything else prompt?" #371 wired the Message editor eight lines above and left this one. */
              groups={tokenGroups}
              known={tokenKnown}
              platformDefault={cardLine('wrapup.anythingElse', language)}   /* v12.10.10 (#1408): the engine line, as written text */
              translateSourceDefault={cardLine('wrapup.anythingElse', defaultLang)}
              onChange={value => onUpdate(next => {
                next.terminalConfig ??= {};
                const c = next.terminalConfig[card.terminalKey] ?? {};
                const prompt = { ...(c.anythingElsePrompt ?? {}) };
                prompt[language] = value;
                next.terminalConfig[card.terminalKey] = { ...c, anythingElsePrompt: prompt };
              })}
            />
          </>
          )}
        </div>
      </div>
    </>
  );
}

// ══ v12.10.1 (#1086, UI-LOCK-12.10.1 v1.5 LOCKED): WHAT A TRANSFER CARD SAYS. ════════════════════════════════
// Whisper (one, English, tokens - an empty clause is left out by the engine; Press 1 is Phase 2 and locked) and
// If no one answers (Say per language, Then). Blank boxes show what plays: the card's own value, else the old
// Handoff setting it carried before 12.10.1, else the platform line. No helper text - help lives in the ? tooltips.
function TransferCardSections({ cfg, setCfg, language, defaultLang, isOperator, handoff, groups, known }: {
  cfg: TerminalConfig | undefined; setCfg: (patch: Partial<TerminalConfig>) => void; language: string; defaultLang: string;
  isOperator: boolean; handoff: HandoffSettingsView | undefined; groups: ReturnType<typeof availableTokenGroups>; known: ReturnType<typeof availableTokens>;
}) {
  const legacyBusy = handoff?.handoff?.busyMessages?.find(m => m.code === language)?.message ?? handoff?.handoff?.busyMessages?.find(m => m.code === 'en')?.message ?? '';
  const sayDefault = (legacyBusy ?? '').trim() || NO_ANSWER_DEFAULTS[language] || NO_ANSWER_DEFAULTS.en;
  // v12.10.2 (#1096): the whisper shipped before 12.10.1 is not the tenant's wording - it counts as not set.
  const storedWhisper = (handoff?.handoff?.whisper ?? '').trim();
  const whisperDefault = storedWhisper && storedWhisper.replace(/\s+/g, ' ').toLowerCase() !== LEGACY_SHIPPED_WHISPER.toLowerCase() ? storedWhisper : WHISPER_TEMPLATE;
  const legacyThen = (handoff?.handoff?.fallback ?? 'voicemail').replace('-', '_');
  const then = cfg?.noAnswerThen ?? (['voicemail', 'end_summary', 'hold', 'anything_else'].includes(legacyThen) ? legacyThen : 'voicemail');
  const who = isOperator ? 'operator' : 'staff';
  return (
    <>
      <div className="rq" style={{ marginTop: 12 }}>
        <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
          <span className="t">Whisper to {who}</span>
          <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
            ['What it does', `Played only to the ${who} who answers, before the caller is joined. One whisper, in English, for every caller language. Anything not captured yet is left out.`],
            ['When it fires', 'When the line is answered, before the two are connected.'],
            ['Example', 'Name and reason: "Incoming call, reference 40 64. Vishwas Patel, about blood work." Only the name: "Incoming call, reference 40 64. Vishwas Patel." Nothing yet: "Incoming call, reference 40 64. No details captured yet."']]} /></span>
        </div>
        <PromptEditor value={cfg?.whisper ?? ''} rows={2} language="en" groups={groups} known={known}
          placeholder={WHISPER_TEMPLATE} platformDefault={whisperDefault}
          onChange={v => setCfg({ whisper: v.trim() ? v : undefined })} />
        <label className="tenant-form-field tenant-inline-switch">{/* v12.10.2 (#1087): warm transfer - on by default */}
          <label className="tenant-mini-switch">
            <input type="checkbox" checked={cfg?.pressOne !== false} onChange={event => setCfg({ pressOne: event.target.checked ? undefined : false })} />
            <span />
          </label>
          <span>Press 1 to take this call<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', `The ${who} presses 1 to accept the call, so a voicemail on their phone never takes the caller. The caller waits on hold meanwhile.`], ['When it fires', 'After the whisper, on the ' + who + '\u2019s phone. No key, or their voicemail answers: the caller goes to If no one answers.'], ['Example', '"Press 1 to take this call." - 1: the caller hears "Connecting you now" and the two are joined.']]} /></span></span>
        </label>
      </div>

      <div className="rq" style={{ marginTop: 12 }}>
        <div className="rq-rthead" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
          <span className="t">If no one answers</span>
          <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
            ['What it does', 'What the caller hears when nobody picks up within the ring timeout, and what happens next.'],
            ['When it fires', 'After the ring timeout in Settings › AI Agent › Handoff.'],
            ['Example', '"Sorry, no one is available right now." then Route to voicemail.']]} /></span>
        </div>
        <label className="tenant-field-label">Say<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[['What it does', 'The line the caller hears, per language.'], ['When it fires', 'When no one answered.'], ['Example', 'Sorry, no one is available right now.']]} /></span></label>
        <PromptEditor value={cfg?.noAnswerSay?.[language] ?? ''} rows={2} language={language} groups={groups} known={known}
          translateSource={cfg?.noAnswerSay?.[defaultLang] ?? ''} translateSourceLang={defaultLang}
          placeholder={NO_ANSWER_DEFAULTS[language] ?? NO_ANSWER_DEFAULTS.en} platformDefault={sayDefault}
          onChange={v => setCfg({ noAnswerSay: { ...(cfg?.noAnswerSay ?? {}), [language]: v } })} />
        <label className="tenant-form-field">
          <span>Then<span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={[
            ['What it does', 'What happens after the line above.'],
            ['When it fires', 'When no one answered.'],
            ['Example', 'Route to voicemail takes a message. Ask "Is there anything else?" uses the prompt below - a new request goes back into the workflow, no ends the call. Hold the line and keep trying: the caller stays on hold while the line is called again - 2 more rounds, at most 3 minutes - then voicemail.']]} /></span></span>
          <select value={then} onChange={event => setCfg({ noAnswerThen: event.target.value })}>
            <option value="voicemail">Route to voicemail</option>
            <option value="anything_else">Ask &ldquo;Is there anything else?&rdquo;</option>
            <option value="end_summary">End call after summarizing</option>
            <option value="hold">Hold the line and keep trying</option>
          </select>
        </label>
      </div>
    </>
  );
}

// v12.3.6 (#238 Card Layout Standard v1.0): the shared language strip, rendered INSIDE an editor between the
// ══ v12.9.26 (#969, #966): THE AGENT'S SPOKEN LINES. ════════════════════════════════════════════════════════
// The rows come from the engine's own table (GET /t2/settings/organization -> phraseCatalog: only rows a tenant may
// reword - no listening word lists, nothing the engine composes with {0}, nothing owned by another card). A blank box
// SHOWS the platform line that will play (PromptEditor platformDefault). Saving writes tenant agentPhrases - the same
// store Personalization > Agent phrases wrote - so the nine existing overrides carry over untouched. It is NOT part of
// the workflow document, so it has its own Save: Done on the drawer does not save these lines.
// `onlyKeys` reuses the editor on a card that owns one of these lines (Classify's re-ask, #966) - one stored value,
// two places to reach it.
interface PhraseCatalogRow { key: string; stage: string; stageTitle: string; stageOrder: number; text: Record<string, string> }
function phraseRowLabel(key: string): string {
  const rest = key.includes('.') ? key.slice(key.indexOf('.') + 1) : key;
  const words = rest.replace(/\./g, ' · ').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

// v12.10.21 (#1957): READBACK_ROWS + ReadbackLinesBlock (#1928, 12.10.19) REMOVED - replaced by the Read-backs card below and
// one pointer line per step (ReadbackPointer). The "Ask only" re-ask lines it also showed are asks, not read-backs: they stay
// in Workflow > Phrases (Agent phrases).
// ══ v12.10.21 (#1957 T164, UI-PROTO-READBACKS v1.4 - LOCKED 10/25): THE READ-BACKS CARD (lane 7). ═══════════════════════════════
// The #1928 block "Lines this step can also speak" (12.10.19) is GONE: every read-back lives on ONE card, and a step shows one
// pointer line. Rule (Q1 a): a read-back is spoken when the answer's confidence score is under the step's Confidence (blank =
// the field type's default) and that field's switch is on. The card holds NO numbers. Never: a field matched to a contact,
// free text (#1881), a name already on a loaded contact (#1955). Lines = platform phrase rows (readback.line / lineAlt /
// nameBoth / nameBothAlt / retryAsk - contract C2) edited through PhrasesEditor (tenant agentPhrases, one source with
// Workflow > Phrases). Switches = doc.readbacks { enabled, off[] } (contract C1). The field list is BUILT from the document's
// Collect steps (every workflow / intent / request type / shared node) - no field list in code.
const READBACKS_COLOR = '#7c3aed';
const READBACK_LINE_KEYS = ['readback.line', 'readback.lineAlt', 'readback.nameBoth', 'readback.nameBothAlt', 'readback.retryAsk'];
const READBACK_TOKEN_GROUP: TokenGroup = { label: 'Read-back', tokens: ['field', 'value', 'first', 'last'] };
/** The drawer's card opener, so a step's pointer line can open the Read-backs card (null outside a drawer). */
const OpenCardContext = createContext<((card: CardRef) => void) | null>(null);

interface ReadbackField { token: string; label: string; type?: string; freeText: boolean; chips: string[] }
interface ReadbackGroup { id: string; workflow: string; card: string; fields: ReadbackField[] }

/** The field(s) one step's Stores capture, as read-back fields. A person's first / last / full name = ONE field "<entity>.name". */
function readbackFieldsOfStores(stores: string | null | undefined,
                                catalog: VocabCatalogEntity[] | undefined, vocab: Record<string, string>,
                                custom: Record<string, CustomField>): ReadbackField[] {
  const keys = (stores ?? '').split(/[,;\n]+/).map(k => canonStoreKey(k).trim()).filter(Boolean);
  const out: ReadbackField[] = [];
  for (const k of keys) {
    const dot = k.indexOf('.');
    if (stepCapturesAPersonName(k) && dot > 0) {
      const entity = k.slice(0, dot);
      const token = entity + '.name';
      const have = out.find(f => f.token.toLowerCase() === token.toLowerCase());
      const part = k.slice(dot + 1);
      if (have) { if (part.toLowerCase() !== 'name' && !have.chips.includes(k)) have.chips.push(k); continue; }
      out.push({ token, label: 'Name', type: 'Name', freeText: false, chips: [k] });
      continue;
    }
    if (out.some(f => f.token.toLowerCase() === k.toLowerCase())) continue;
    const type = stepFieldType(k, catalog, custom);
    const full = tokenLabel(k, vocab, custom) ?? prettyField(dot > 0 ? k.slice(dot + 1) : k);
    const label = full.includes('›') ? full.slice(full.lastIndexOf('›') + 1).trim() : full;
    out.push({ token: k, label, type: type ? type.charAt(0).toUpperCase() + type.slice(1) : undefined, freeText: type === 'text', chips: [k] });
  }
  for (const f of out) if (f.type === 'Name') {
    // first name before last name, whatever order the step stores them in
    f.chips.sort((a, b) => (/first/i.test(a) ? 0 : /last/i.test(a) ? 2 : 1) - (/first/i.test(b) ? 0 : /last/i.test(b) ? 2 : 1));
  }
  return out;
}

/** Every Collect step of the document, grouped workflow > card. Disabled steps / request types / nodes / intents collect nothing and are left out. */
function collectReadbackGroups(doc: DesignerDocument, catalog: VocabCatalogEntity[] | undefined, vocab: Record<string, string>,
                               custom: Record<string, CustomField>): ReadbackGroup[] {
  const groups: ReadbackGroup[] = [];
  const add = (id: string, workflow: string, card: string, steps: (WorkflowStep | undefined)[]) => {
    let g = groups.find(x => x.id === id);
    for (const st of steps) {
      if (!st || st.enabled === false) continue;
      for (const f of readbackFieldsOfStores(st.stores, catalog, vocab, custom)) {
        if (!g) { g = { id, workflow, card, fields: [] }; groups.push(g); }
        const have = g.fields.find(x => x.token.toLowerCase() === f.token.toLowerCase());
        if (have) { for (const c of f.chips) if (!have.chips.includes(c)) have.chips.push(c); }
        else g.fields.push(f);
      }
    }
  };
  const stepsOf = (node: WorkflowNode): { steps: WorkflowStep[]; types: string[] } => {
    const types = (node.requestTypes ?? []).filter(rt => rt.enabled !== false && (rt.steps ?? []).length > 0);
    // the Callback card stores its number through callbackStore, not a step (#1663)
    const cb: WorkflowStep[] = node.type === 'Callback' ? [{ stores: (node.callbackStore ?? '').trim() || 'caller.callback' }] : [];   // blank = caller.callback (#1675)
    return { steps: [...(node.steps ?? []), ...types.flatMap(rt => rt.steps ?? []), ...cb], types: types.map(rt => (rt.name ?? '').trim()).filter(Boolean) };
  };
  const workflows = doc.workflows ?? [];
  const shared = doc.sharedNodes ?? [];
  for (const wf of workflows) {
    const wfName = (wf.name ?? '').trim() || 'Workflow';
    for (const sn of shared.filter(n => n.sharedWorkflowId === wf.id && n.enabled !== false)) {
      const { steps } = stepsOf(sn);
      add('s:' + sn.id, wfName, `${(sn.label ?? '').trim() || 'Shared card'} (shared - every ${wfName} intent)`, steps);
    }
    for (const intent of wf.intents ?? []) {
      if (intent.enabled === false) continue;
      const intentName = (intent.label ?? '').trim() || 'Intent';
      for (const node of intent.nodes ?? []) {
        if (node.sharedNodeId || node.enabled === false) continue;   // a shared reference is listed once, above
        const { steps, types } = stepsOf(node);
        const card = types.length ? `${intentName} › ${types.join(' / ')}` : `${intentName} › ${(node.label ?? '').trim() || node.type || 'Card'}`;
        add(`n:${wf.id}:${intent.id}:${node.id}`, wfName, card, steps);
      }
    }
  }
  // shared nodes with no caller type of their own (legacy) run everywhere
  for (const sn of shared.filter(n => (!n.sharedWorkflowId || !workflows.some(w => w.id === n.sharedWorkflowId)) && n.enabled !== false)) {
    add('s:' + sn.id, 'Every caller type', `${(sn.label ?? '').trim() || 'Shared card'} (shared)`, stepsOf(sn).steps);
  }
  return groups;
}

/** on / off / never for one field, as the engine reads doc.readbacks (absent = enabled, nothing off). */
function readbackState(doc: DesignerDocument, f: ReadbackField): 'on' | 'off' | 'never' {
  if (f.freeText) return 'never';
  if (doc.readbacks?.enabled === false) return 'off';
  const off = (doc.readbacks?.off ?? []).map(t => t.toLowerCase());
  return off.includes(f.token.toLowerCase()) ? 'off' : 'on';
}
function readbackDomId(token: string): string { return 'rb-field-' + token.replace(/[^A-Za-z0-9_-]/g, '_'); }

/** v12.10.21 (#1957): the field type's Confidence default, when the platform serves it (GET /t2/settings/organization ->
 *  confidenceDefaults { name, other }). Not served = null, and the step box shows exactly what it showed before 12.10.21. */
function useConfidenceDefaults(): { name?: number; other?: number } | null {
  const { data } = useQuery<{ confidenceDefaults?: { name?: number; other?: number } | null }>({
    queryKey: ['t2-org-vocabulary'], queryFn: () => api.get('/t2/settings/organization'), staleTime: 60_000 });
  const d = data?.confidenceDefaults;
  return d && (typeof d.name === 'number' || typeof d.other === 'number') ? d : null;
}
function confidencePlaceholderFor(type: string | undefined, isName: boolean, defs: { name?: number; other?: number } | null, today: string): string {
  if (!defs) return today;
  const v = (isName || (type ?? '').toLowerCase() === 'name') ? defs.name : defs.other;
  return typeof v === 'number' ? 'default · ' + v.toFixed(2) : today;
}

/** Lane 7's second card. */
function ReadbacksFlowCard({ doc, onOpen }: { doc: DesignerDocument; onOpen: () => void }) {
  const { catalog, vocab, customFields } = useVocabulary();
  const groups = useMemo(() => collectReadbackGroups(doc, catalog, vocab, customFields), [doc, catalog, vocab, customFields]);
  const seen = new Map<string, ReadbackField>();
  for (const g of groups) for (const f of g.fields) if (!f.freeText) seen.set(f.token.toLowerCase(), f);
  const all = [...seen.values()];
  const on = all.filter(f => readbackState(doc, f) === 'on').length;
  const master = doc.readbacks?.enabled !== false;
  return (
    <FlowCard kind="READ-BACKS" badge="RB" title="Read-backs" color={READBACKS_COLOR} disabled={!master}
      description={master ? `On · ${on} of ${all.length} fields · read back when the confidence score is under the step's Confidence` : 'Off · nothing is read back'}
      onClick={onOpen} onEdit={onOpen} />
  );
}

/** v12.10.21 (#1957, LOCKED 10/25): the ONE line below a step's prompt - "Read-back · <Field>: on|off|never". */
function ReadbackPointer({ doc, stores }: { doc: DesignerDocument; stores: string | null | undefined }) {
  const open = useContext(OpenCardContext);
  const { catalog, vocab, customFields } = useVocabulary();
  const fields = readbackFieldsOfStores(stores, catalog, vocab, customFields);
  if (fields.length === 0) return null;
  return (
    <div className="rb-ptr">
      Read-back {fields.map((f, i) => {
        const st = readbackState(doc, f);
        const text = `${f.label}: ${st}`;
        return (
          <span key={f.token}>{i === 0 ? '· ' : ' · '}
            {st !== 'never' && open
              ? <a href="#" title="Open in Read-backs (lane 7)" onClick={e => { e.preventDefault(); open({ kind: 'readbacks', focus: f.token }); }}>{text}</a>
              : <span className={st === 'never' ? 'rb-never' : undefined} title={st === 'never' ? 'Free text is never read back (#1881)' : undefined}>{text}</span>}
          </span>
        );
      })}
    </div>
  );
}

/** The Read-backs drawer. The master switch is the drawer's Enabled switch (doc.readbacks.enabled). */
function ReadbacksEditor({ doc, focus, language, languages, onLanguage, onUpdate }: {
  doc: DesignerDocument; focus?: string; language: string;
  languages: { code: string; displayName: string }[]; onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
}) {
  const { catalog, vocab, customFields } = useVocabulary();
  const groups = useMemo(() => collectReadbackGroups(doc, catalog, vocab, customFields), [doc, catalog, vocab, customFields]);
  const master = doc.readbacks?.enabled !== false;
  const [flash, setFlash] = useState<string | null>(null);
  useEffect(() => {
    if (!focus) return;
    const t = window.setTimeout(() => {
      const el = document.getElementById(readbackDomId(focus));
      if (el) { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); setFlash(focus); }
    }, 60);
    const clear = window.setTimeout(() => setFlash(null), 2000);
    return () => { window.clearTimeout(t); window.clearTimeout(clear); };
  }, [focus, groups.length]);
  const setOn = (token: string, on: boolean) => onUpdate(next => {
    const rb: ReadbacksConfig = { ...(next.readbacks ?? {}) };
    const off = (rb.off ?? []).filter(t => t.toLowerCase() !== token.toLowerCase());
    if (!on) off.push(token);
    rb.off = off;
    next.readbacks = rb;
  });
  const chip = (t: string) => <span key={t} className="rb-tok">{'{' + t + '}'}</span>;
  return (
    <>
      {!master && (
        <div className="rb-offnote">Read-backs are OFF. Nothing the caller said is spoken back. A doubtful value is kept and marked <b>CHECK</b> for staff. The Confirm card still runs - it is separate.</div>
      )}
      <div className={'rb-body' + (master ? '' : ' is-off')}>
        <div className="tenant-drawer-section">
          <SectionTitle title="When a read-back is spoken" help={[
            ['What it does', 'Reads a doubtful answer back to the caller once, so a wrong value can be corrected at the step where it was asked.'],
            ['When it fires', 'At most once per step. Every read-back counts in the step’s Ask cap; at the cap the value is kept as heard and marked CHECK.'],
            ['Example', '“I have the date of birth as March 4, 1951 - is that right?”'],
          ]} />
          <div className="rb-rule">When the caller's answer has a <b>confidence score</b> under the step's <b>Confidence</b> (blank = the field type's default) and that field's switch is on.</div>
          <div className="tenant-field-note" style={{ marginTop: 6 }}>Never read back: a field matched to a contact · free text · a name already on a loaded contact.</div>
        </div>

        <div className="tenant-drawer-section">
          <SectionTitle title="Lines - one set for every field" note="{field} is the field's spoken label, {value} what was heard" help={[
            ['What it does', 'The words of every read-back. One line and one variation (V) for all fields; the name has its own pair.'],
            ['When it fires', 'The first read-back in a call uses line 1, the next one V. A spelled answer is read back as a word, never as letters.'],
            ['One source', 'These are platform lines from Workflow › Phrases - a blank box plays the platform line; editing here or there changes both.'],
          ]} />
          <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />
          <PhrasesEditor language={language} languages={languages} onLanguage={onLanguage} embedded tokenGroup={READBACK_TOKEN_GROUP}
            labels={{
              'readback.line': '1', 'readback.lineAlt': 'V',
              'readback.nameBoth': '1', 'readback.nameBothAlt': 'V',
              'readback.retryAsk': '1',
            }}
            sections={[
              { title: 'Any field', keys: ['readback.line', 'readback.lineAlt'], note: 'The second read-back in a call uses V. One part of a name in doubt uses these lines with {field} = first name / last name.' },
              { title: 'Name - both parts in doubt', keys: ['readback.nameBoth', 'readback.nameBothAlt'], note: 'A spelled answer is read back as a word (#1955).' },
              { title: 'After a “no”', keys: ['readback.retryAsk'], note: 'Then the field is asked once more within its step’s Ask cap.' },
            ]}
            onlyKeys={READBACK_LINE_KEYS} />
        </div>

        <div className="tenant-drawer-section">
          <SectionTitle title="Every field the workflows collect" note="grouped by workflow › card · one switch per field" help={[
            ['What it is', 'Every field a Collect step stores, read from this workflow - a new field appears here by itself.'],
            ['Switch', 'Off = that field is never read back, in every workflow that collects it. The Name switch covers first and last name together.'],
          ]} />
          {groups.length === 0 && <p className="tenant-field-note">No step stores a field yet.</p>}
          {groups.map(g => (
            <div key={g.id} className="rb-grp">
              {/* v12.10.22 (#1988): how many of this block's fields are read back (on) and how many are not */}
              {(() => {
                const sw = g.fields.filter(f => !f.freeText);
                const onN = sw.filter(f => master && !(doc.readbacks?.off ?? []).some(t => t.toLowerCase() === f.token.toLowerCase())).length;
                return <div className="rb-gh"><b>{g.workflow}</b> › {g.card}<span className="rb-cnt">{onN} on · {sw.length - onN} off{sw.length < g.fields.length ? ` · ${g.fields.length - sw.length} free text` : ''}</span></div>;
              })()}
              {g.fields.map(f => {
                const st = readbackState(doc, f);
                const on = st === 'on';
                return (
                  <div key={f.token} id={readbackDomId(f.token)} className={'rb-fr' + (st !== 'on' ? ' is-off' : '') + (flash && flash.toLowerCase() === f.token.toLowerCase() ? ' rb-flash' : '')}>
                    <div className="rb-fh">
                      <div><b>{f.label}</b> {f.chips.map(chip)} {f.type && <span className="rb-ty">{f.type}</span>}</div>
                      {f.freeText
                        ? <span className="rb-lock">never read back · free text</span>
                        : <button type="button" role="switch" aria-checked={!(doc.readbacks?.off ?? []).some(t => t.toLowerCase() === f.token.toLowerCase())}
                            className={'rq-sw' + (!(doc.readbacks?.off ?? []).some(t => t.toLowerCase() === f.token.toLowerCase()) ? ' on' : '')}
                            title={on ? 'On - read back when the confidence score is under the step’s Confidence' : master ? 'Off - this field is never read back' : 'Read-backs are off (master switch)'}
                            disabled={!master}
                            onClick={() => setOn(f.token, (doc.readbacks?.off ?? []).some(t => t.toLowerCase() === f.token.toLowerCase()))}><span className="rq-sw-thumb" aria-hidden="true" /></button>}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// v12.10.21 (#1957): + embedded (no intro, no rail - the card renders its own), sections (own sub-titles, rows in onlyKeys order),
// labels (per-key row label), tokenGroup (the line's own {tokens}, shown as chips and known to the unresolved-token check).
function PhrasesEditor({ language, languages, onLanguage, onlyKeys, compact, embedded, sections, labels, tokenGroup }: {
  language: string; languages: { code: string; displayName: string }[]; onLanguage: (code: string) => void;
  onlyKeys?: string[]; compact?: boolean;
  embedded?: boolean; sections?: { title: string; keys: string[]; note?: string }[]; labels?: Record<string, string>; tokenGroup?: TokenGroup;
}) {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery<{ agentPhrases?: Record<string, Record<string, string>>; phraseCatalog?: PhraseCatalogRow[] }>({
    queryKey: ['t2-org-vocabulary'],
    queryFn: () => api.get('/t2/settings/organization'),
    staleTime: 60_000,
  });
  const saved = data?.agentPhrases ?? {};
  const [draft, setDraft] = useState<Record<string, Record<string, string>> | null>(null);
  const current = draft ?? saved;
  const dirty = draft !== null && JSON.stringify(draft) !== JSON.stringify(saved);
  const save = useMutation({
    mutationFn: (m: Record<string, Record<string, string>>) => api.put<{ agentPhrases?: Record<string, Record<string, string>> }>('/t2/settings/organization/agent-phrases', m),
    onSuccess: (res) => {
      queryClient.setQueryData(['t2-org-vocabulary'], (prev: object | undefined) => ({ ...(prev ?? {}), ...(res ?? {}) }));
      setDraft(null);
      toast('success', 'Phrases saved');
    },
    onError: () => toast('error', 'Phrases not saved', 'Nothing was changed - try again.'),
  });
  const rows = (data?.phraseCatalog ?? []).filter(r => !onlyKeys || onlyKeys.includes(r.key));
  const groups: { title: string; note?: string; rows: PhraseCatalogRow[] }[] = sections
    ? sections.map(sec => ({ title: sec.title, note: sec.note, rows: sec.keys.map(k => rows.find(r => r.key === k)).filter((r): r is PhraseCatalogRow => !!r) })).filter(g => g.rows.length > 0)
    : rows.reduce<{ title: string; rows: PhraseCatalogRow[] }[]>((acc, r) => {
    const g = acc.find(x => x.title === r.stageTitle);
    if (g) g.rows.push(r); else acc.push({ title: r.stageTitle, rows: [r] });
    return acc;
  }, []);
  // v12.10.21 (#1957): a key asked for that the platform phrase list does not serve as editable is NAMED, never silently dropped.
  const missing = onlyKeys && !isLoading && !error ? onlyKeys.filter(k => !rows.some(r => r.key === k)) : [];
  const setText = (key: string, v: string) => setDraft(prev => {
    const base = structuredClone(prev ?? saved);
    base[key] = { ...(base[key] ?? {}), [language]: v };
    if (!v.trim()) delete base[key][language];
    if (Object.keys(base[key]).length === 0) delete base[key];
    return base;
  });
  if (isLoading) return <p className="tenant-field-note">Loading the agent’s lines…</p>;
  if (error) return <Alert variant="warn">The agent’s lines could not be loaded. Nothing here was changed.</Alert>;
  return (
    <div className={'rq-phrases' + (compact ? ' is-compact' : '')}>
      {!compact && !embedded && (
        <p className="tenant-field-note" style={{ marginTop: 0 }}>
          Every line below is spoken by the agent. A blank box shows - and plays - the platform line for that language;
          type to use your own wording. Words the agent LISTENS for, and lines it builds from the call’s own values, are
          not editable here.
        </p>
      )}
      {!compact && !embedded && <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />}
      {groups.map(g => (
        <div key={g.title} className={'rq-phrases-group' + (labels ? ' has-labels' : '')}>
          {!compact && <div className="rq-phrases-h">{g.title}</div>}
          {g.rows.map(r => (
            <div key={r.key} className={'rq-phrases-row' + (labels ? ' rb-line' : '')}>
              <div className={labels ? 'rb-n' : 'rq-phrases-lab'} title={r.key}>{labels?.[r.key] ?? (compact ? 'Re-ask line' : phraseRowLabel(r.key))}</div>
              <div className="rq-phrases-ed">
                <PromptEditor value={current[r.key]?.[language] ?? ''} rows={2} language={language} noTokens={!tokenGroup}
                  groups={tokenGroup ? [tokenGroup] : undefined} known={tokenGroup ? tokenGroup.tokens : undefined}
                  platformDefault={r.text[language] ?? r.text.en ?? ''}
                  onChange={v => setText(r.key, v)} />
              </div>
            </div>
          ))}
          {'note' in g && g.note && <div className="tenant-field-note">{g.note}</div>}
        </div>
      ))}
      {rows.length === 0 && !onlyKeys?.length && <p className="tenant-field-note">No lines to show.</p>}
      {missing.length > 0 && (
        <p className="tenant-field-note" style={{ color: '#b45309' }}>Not served by the platform phrase list yet: {missing.join(', ')} - the engine still speaks its platform line.</p>
      )}
      {dirty && (
        <div className="rq-phrases-save">
          <span>Unsaved changes to the agent’s lines.</span>
          <button type="button" className="tenant-secondary" onClick={() => setDraft(null)} disabled={save.isPending}>Discard</button>
          <button type="button" className="tenant-primary" onClick={() => save.mutate(current)} disabled={save.isPending}>{save.isPending ? 'Saving…' : 'Save lines'}</button>
        </div>
      )}
    </div>
  );
}

// identity box and the per-language box. Same tabs as the drawer header strip, editor-local margins (.inline).
// v12.10.7 (#937, T2 UI Principles §16): THE ONE LANGUAGE RAIL. The retired strip (.tenant-drawer-languages) is gone;
// every card - pre-routing, node, step, terminal, interceptor, phrases - renders this. Placement is the caller's job
// (§37: after the settings box, before the per-language content). `note` = one line under the rail saying what the
// tabs hold when that differs by tab (Language detect).
/** v12.10.10 (#1408 Q3, Tushar 10/8): the caller-type / intent name per language - spoken in the auto-built keypad menu and
 *  matched when the caller says it. The standard rail; the primary tab shows the name itself (edited above); every other tab
 *  shows that language's name (filled at publish, #902) - visible and correctable, with Auto-translate from the primary + Reset. */
function SpokenNameRail({ doc, name, byLang, language, languages, onLanguage, onChange, what }: {
  doc: DesignerDocument; name: string; byLang?: Record<string, string>; language?: string;
  languages?: { code: string; displayName: string }[]; onLanguage?: (code: string) => void;
  onChange: (lang: string, value: string) => void; what: string;
}) {
  const primary = primaryLangCode(doc);
  const [xl, setXl] = useState<'idle' | 'loading' | 'error'>('idle');
  if (!languages || languages.length < 2 || !onLanguage) return null;
  const lang = language || primary;
  const isPrimary = canonLang(lang) === canonLang(primary);
  const value = isPrimary ? name : (byLang?.[lang] ?? '');
  const translate = async () => {
    if (!name.trim() || value.trim()) return;
    setXl('loading');
    try {
      const res = await api.post<{ ok?: boolean; translated?: string | null }>('/t2/workflow/translate', { text: name, sourceLang: primary, targetLang: lang });
      if (res.ok && res.translated) { onChange(lang, res.translated); setXl('idle'); } else setXl('error');
    } catch { setXl('error'); }
  };
  return (
    <div className="tenant-drawer-section">
      <SectionTitle title={`Spoken ${what} name`} note="per language" help={[['What it does', `The ${what} name in each language - spoken in the keypad menu and matched when the caller says it.`], ['When it fires', 'When the keypad menu is built, and when the caller names it.'], ['Example', 'Patient - Paciente']]} />
      <LanguageRail languages={languages} active={lang} onLanguage={onLanguage} />
      {isPrimary ? (
        <p className="tenant-field-note">On the {lang.toUpperCase()} (primary) tab the spoken name is the Name above: <strong>{name || '-'}</strong></p>
      ) : (
        <label className="tenant-form-field">
          <span>{`Name - ${lang.toUpperCase()}`}</span>
          <input value={value} onChange={e => onChange(lang, e.target.value)} />
          <span className="tenant-xl-row" style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6, flexWrap: 'wrap' }}>
            <button type="button" className="tenant-xl-btn" disabled={!name.trim() || !!value.trim() || xl === 'loading'}
              title={!name.trim() ? 'Write the primary name first' : value.trim() ? 'Clear this field (Reset) first to auto-translate' : `Translate from ${primary.toUpperCase()}`}
              onClick={translate}>{xl === 'loading' ? '\u2026 Translating' : `\u2728 Auto-translate from ${primary.toUpperCase()}`}</button>
            <button type="button" className="tenant-xl-reset" disabled={!value.trim()} onClick={() => onChange(lang, '')}>{'\u21bb'} Reset</button>
            {!name.trim() && <small className="tenant-xl-msg">Write the {primary.toUpperCase()} name first</small>}
            {xl === 'error' && <small className="tenant-xl-msg is-error">Could not translate - type it manually.</small>}
          </span>
          <small className="tenant-field-note">Blank = the {lang.toUpperCase()} name is filled automatically when you publish.</small>
        </label>
      )}
    </div>
  );
}

/** v12.10.10 (#1408): the engine's own line for a box left blank (platform rows served as cardLines) - the Template default. */
function useCardLines(): (key: string, lang: string) => string {
  const { data } = useQuery<{ cardLines?: Record<string, Record<string, string>> }>({
    queryKey: ['t2-org-vocabulary'], queryFn: () => api.get('/t2/settings/organization'), staleTime: 60_000 });
  return (key: string, lang: string) => {
    const row = data?.cardLines?.[key];
    if (!row) return '';
    return row[lang] ?? row[canonLang(lang)] ?? row[(lang || '').split(/[-_]/)[0]] ?? '';
  };
}

function LanguageRail({ languages, active, onLanguage, note }: { languages: { code: string; displayName: string }[]; active: string; onLanguage: (code: string) => void; note?: string }) {
  if (!languages || languages.length === 0) return null;
  return (
    <>
      <div className="rq-lrail" role="tablist" aria-label="Language">
        {languages.map(l => (
          <button key={l.code} type="button" role="tab" className={'rq-ltab' + (l.code === active ? ' sel' : '')}
            aria-selected={l.code === active} onClick={() => onLanguage(l.code)}>{langLabel(l)}</button>
        ))}
      </div>
      {note ? <p className="rq-lhint">{note}</p> : null}
    </>
  );
}

function SectionTitle({ title, note, help, action }: { title: string; note?: string; help?: HelpSection[]; action?: ReactNode }) {
  return (
    <div className="tenant-section-title">
      <strong>
        {title}
        {/* Explanations live in the standard Settings "?" tooltip (What it does / When it fires / …),
            not as long inline paragraphs. Wrapped in `.ai-agent-panel` so the tooltip's scoped styles apply. */}
        {help && <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={help} /></span>}
      </strong>
      {note ? <span>{note}</span> : null}
      {/* v12.10.7 (#947): a switch that belongs to the section sits on its title row (Offer Spanish · Announce). */}
      {action ? <span className="tenant-section-action">{action}</span> : null}
    </div>
  );
}

// v12.3.1 (#238): the global mid-call interceptor editor. Slice 1 = terminal-keyword routing (configured ON the
// terminal cards, summarized here read-only). Slice 2 adds Knowledge-Base quick answers. Light + informational.
// ── v12.4.0 (#398/#399/#400/#401/#402) INTERCEPTOR CARDS ────────────────────────────────────────────
//
// BUILT FROM THE APPROVED PROTOTYPE, NOT FROM A DESCRIPTION OF IT:
//   Documents\UI Principles\Prototype\interceptor_cards_v1_1.html
// Tushar, 2026-09-02: "in the past you presented prototype but the built version was not matching and we had
// to do 2-3 build to correct it, so follow the approved ui and implement exactly." So the DOM below mirrors the
// prototype element for element, the CSS is ported under an icp- prefix, and every visible string here is the
// prototype's string. If this and the prototype disagree, the prototype wins and this is the defect.
//
// WHAT WENT: the six terminal blocks (three of them saying "no keywords" and taking a block each, with the one
// useful sentence trailing at the bottom) and the numbered decision list, which described an ORDER. The cards
// are that list, and each one says where it fires instead.
//
// THERE IS NO DRAG-AND-DROP AND NO ORDER CONTROL. Tushar: "i would be happy if there is no order needed for the
// card. all these cards should fire based on situation should be the perfect thing." The engine still needs a
// tie-break for the rare overlap ("what did you say?" satisfies both Say-that-again and the question cues), so
// it applies a fixed one - say-again first - and the panel shows it as a locked note, never as a control.
function IcpHelp({ sections }: { sections: HelpSection[] }) {
  return <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={sections} /></span>;
}

// v12.4.0 (#398): one phrase list. Platform defaults render violet (.plat) so a tenant can see at a glance
// which phrases are ours and which are theirs.
function IcpPhrases({ value, platform, onChange }: {
  value: string[]; platform: boolean; onChange: (next: string[]) => void;
}) {
  const [adding, setAdding] = useState('');
  return (
    <div className="icp-chips">
      {value.map((p, i) => (
        <span key={`${p}-${i}`} className={'icp-ph' + (platform ? ' plat' : '')}>
          <b>{p}</b>
          <button type="button" aria-label={`Remove ${p}`}
            onClick={() => onChange(value.filter((_, j) => j !== i))}>&times;</button>
        </span>
      ))}
      {adding !== '' ? (
        <input type="text" autoFocus value={adding} style={{ width: 180 }}
          onChange={e => setAdding(e.target.value)}
          onBlur={() => { const v = adding.trim(); if (v) onChange([...value, v]); setAdding(''); }}
          onKeyDown={e => {
            if (e.key === 'Enter') { e.preventDefault(); const v = adding.trim(); if (v) onChange([...value, v]); setAdding(''); }
            if (e.key === 'Escape') setAdding('');
          }} />
      ) : (
        <button type="button" className="icp-addph" onClick={() => setAdding(' ')}>+ add phrase</button>
      )}
    </div>
  );
}

function IcpCard({ icon, title, chip, chipKind, description, fires, help, enabled, onToggle, disabledToggle, children }: {
  icon: string; title: string; chip: string; chipKind: 'live' | 'new' | 'later';
  description: string; fires: string; help: HelpSection[];
  enabled: boolean; onToggle?: () => void; disabledToggle?: boolean; children?: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const cls = 'icp-card' + (open ? ' open' : '') + (enabled ? '' : ' off') + (chipKind === 'later' ? ' later' : '');
  return (
    <div className={cls}>
      <div className="icp-head" role="button" tabIndex={0}
        onClick={() => setOpen(o => !o)}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(o => !o); } }}>
        <div className="icp-ico">{icon}</div>
        <div className="icp-main">
          <div className="icp-ttlrow">
            <span className="icp-ttl">{title}</span>
            <span className={`icp-chip ${chipKind}`}>{chip}</span>
            <IcpHelp sections={help} />
          </div>
          <div className="icp-desc">{description}</div>
          <div className="icp-fires"><b>Fires during:</b> {fires}</div>
        </div>
        <div className="icp-right" onClick={e => e.stopPropagation()}>
          <label className="tenant-mini-switch">
            <input type="checkbox" checked={enabled} disabled={disabledToggle} onChange={() => onToggle?.()} />
            <span />
          </label>
          <span className="icp-caret">&#9654;</span>
        </div>
      </div>
      <div className="icp-body">{children}</div>
    </div>
  );
}

function InterceptorEditor({ doc, language, languages, onLanguage, onUpdate, onOpen }: {
  doc: DesignerDocument;
  language: string;
  languages: { code: string; displayName: string }[];
  onLanguage: (code: string) => void;
  onUpdate: (mutator: (next: DesignerDocument) => void) => void;
  onOpen?: (card: CardRef) => void;
}) {
  const on = doc.interceptor?.enabled !== false;
  const icpLine = useCardLines();   // v12.10.10.1 (#1418 gate): the decline line's platform text, shown as written text
  const kbOn = doc.interceptor?.quickAnswers === true;
  const looseOn = doc.interceptor?.looseKeywords === true;   // v12.3.8 (#238 D-12)
  const cmds = doc.interceptor?.commands ?? {};
  // v12.4.1 (#404/#409): absent means ON. Never `=== true` here - that would silently switch two cards off for
  // every tenant on the first render after the deploy.
  const termKwOn = cmds.terminalKeyword?.enabled !== false;
  const offScriptOn = cmds.offScript?.enabled !== false;

  const rows = terminalOrderedKeys(doc).map(key => {
    const cfg = doc.terminalConfig?.[key];
    return { key, name: (cfg?.name && cfg.name.trim()) || TERMINAL_LABELS[key] || key, keywords: cfg?.keywords ?? [], enabled: cfg?.enabled !== false };
  });
  const withKw = rows.filter(r => r.keywords.length > 0);
  const withoutKw = rows.filter(r => r.keywords.length === 0);

  // A tenant list REPLACES the built-in one for that language; empty means "use the built-ins", which is what
  // the engine does too (CommandPhrases). Showing the defaults is the point - they were invisible in code.
  const phrasesOf = (cmd: InterceptorCommand | undefined, defaults: LangPhrases) => {
    const own = cmd?.phrases?.[language];
    return own && own.length > 0
      ? { list: own, platform: false }
      : { list: defaultPhrases(defaults, language), platform: true };   // v12.4.1 (#412): THIS language's set
  };
  const setPhrases = (key: 'sayAgain' | 'goBack' | 'startOver', next: string[]) => onUpdate(d => {
    d.interceptor ??= {}; d.interceptor.commands ??= {};
    const c = (d.interceptor.commands[key] ??= {});
    c.phrases = { ...(c.phrases ?? {}), [language]: next };
  });
  const toggleCmd = (key: 'sayAgain' | 'goBack' | 'startOver') => onUpdate(d => {
    d.interceptor ??= {}; d.interceptor.commands ??= {};
    const c = (d.interceptor.commands[key] ??= {});
    c.enabled = c.enabled === false;
  });

  const sayAgain = phrasesOf(cmds.sayAgain, SAY_AGAIN_DEFAULTS);
  const goBack = phrasesOf(cmds.goBack, GO_BACK_DEFAULTS);
  const startOver = phrasesOf(cmds.startOver, START_OVER_DEFAULTS);
  const cues = (cmds.questionCues?.[language] ?? []).length > 0
    ? { list: cmds.questionCues![language], platform: false }
    : { list: defaultPhrases(QUESTION_CUE_DEFAULTS, language), platform: true };   // v12.4.1 (#412)

  return (
    <div className="tenant-drawer-section">
      <SectionTitle title="Interceptor" note="Runs on every caller turn, before the current step reads the answer"
        help={[['What it does', 'Watches each caller turn mid-call and can act before the current step treats the words as an answer.'], ['When it fires', 'Every caller turn. Each card below says which phases it covers.'], ['Example', 'A caller says "I have to go" during identity capture -> the call routes to the End Call terminal and closes gracefully.']]} />

      <div className="icp-strip">
        <span className="k">{on ? 'Interceptor on' : 'Interceptor off'}</span>
        <span className="t">These run on every caller turn, before the current step reads the answer. Each fires on its own situation &mdash; there is no order to set.</span>
      </div>

      {/* v12.4.0: the STANDARD language rail (.rq-lrail / .rq-ltab), not buttons. Tushar corrected the v1.0
          prototype on exactly this: "language should follow this patter as this is our standard. not buttons." */}
      <LanguageRail languages={languages} active={language} onLanguage={onLanguage} />

      {/* v12.4.0: THE CARDS STAY LIVE WHEN THE HEADER SWITCH IS OFF. Tushar: "otherwise just to change
          configuration user need to enable and that can interrupt live calls." A disabled feature stays
          configurable - greying these out would make turning the layer on the only way to edit it. */}

      {/* ══ v12.10.15 (#1653, UI-PROTO-INTERCEPTOR-INTENT-VERIFICATION-B1 v1.2 LOCKED): Call intent verification ══ */}
      {(() => {
        const iv = cmds.intentVerification ?? {};
        const ivOn = iv.enabled === true;
        const mode = iv.mode === 'listen' ? 'listen' : 'act';
        const tOpen = iv.turnOpening !== false, tId = iv.turnFirstIdentity !== false, tEvery = iv.turnEvery === true;
        const patchIv = (m: (x: NonNullable<InterceptorCommands['intentVerification']>) => void) => onUpdate(d => {
          d.interceptor ??= {}; d.interceptor.commands ??= {};
          const x = (d.interceptor.commands.intentVerification ??= {});
          m(x);
        });
        const turnsTxt = [tOpen && 'opening', tId && 'first identity answer', tEvery && 'every turn'].filter(Boolean).join(' · ') || 'no turns picked';
        const KINDS: [string, string, string][] = [
          ['notPatient', 'Not the patient', 'interceptor.guard.notPatient.phrases'],
          ['routeCorrection', 'Route correction', 'interceptor.guard.routeCorrection.phrases'],
          ['repeat', '\u201cI said\u2026\u201d', 'interceptor.guard.repeat.phrases'],
          ['didntUnderstand', 'Didn\u2019t understand', 'interceptor.guard.didntUnderstand.phrases'],
          ['neverAName', 'Never a name', 'interceptor.neverAName.phrases'],
        ];
        const LINES: [string, string][] = [['whatNeed', 'Not the patient'], ['differently', 'Route correction'], ['sorry', '\u201cI said\u2026\u201d'], ['simpler', 'Didn\u2019t understand']];
        return (
          <IcpCard
            icon="&#10003;" title="Call intent verification" chip="New" chipKind="new"
            description="Changes course when the caller's words don't fit what we asked."
            fires={ivOn ? `${mode === 'listen' ? 'listen only' : 'act'} · ${turnsTxt}${iv.useAi === false ? '' : ' · AI'} · budget ${iv.recoveryBudget ?? 1}` : 'off'}
            enabled={ivOn}
            onToggle={() => patchIv(x => { x.enabled = !ivOn; })}
            help={[
              ['What it does', 'Checks whether the caller\u2019s answer fits what was asked. A caller who says \u201cit\u2019s not a patient\u201d or \u201cI\u2019m a rep\u201d is not pushed through the identity questions - the agent asks what they need and routes the call again. Nothing already captured is emptied.'],
              ['Off', 'Switched off, the call runs exactly as before - nothing is checked.'],
              ['Listen only', 'Judges every checked turn and writes what it would have done on the call path, without changing anything.'],
            ]}>
            <div className="icp-fld">
              <div className="lab">When on <IcpHelp sections={[['Act', 'Changes course.'], ['Listen only', 'Writes \u201c[guard\u00b7listen] would have \u2026\u201d on the call path and changes nothing - for a trial.']]} /></div>
              <div className="icp-inline">
                {(['act', 'listen'] as const).map(m => (
                  <label key={m} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginRight: 12 }}>
                    <input type="radio" checked={mode === m} onChange={() => patchIv(x => { x.mode = m; })} /> {m === 'act' ? 'Act' : 'Listen only'}
                  </label>
                ))}
              </div>
            </div>
            <div className="icp-fld">
              <div className="lab">Turns checked <IcpHelp sections={[['What it does', 'Which caller turns are checked. The first two turns matter most.']]} /></div>
              <div className="icp-inline">
                <label style={{ marginRight: 12 }}><input type="checkbox" checked={tOpen} onChange={e => patchIv(x => { x.turnOpening = e.target.checked; })} /> Opening answer</label>
                <label style={{ marginRight: 12 }}><input type="checkbox" checked={tId} onChange={e => patchIv(x => { x.turnFirstIdentity = e.target.checked; })} /> First identity answer</label>
                <label><input type="checkbox" checked={tEvery} onChange={e => patchIv(x => { x.turnEvery = e.target.checked; })} /> Every turn</label>
              </div>
            </div>
            <div className="icp-fld">
              <div className="icp-inline">
                <label style={{ marginRight: 16 }}><input type="checkbox" checked={iv.useAi !== false} onChange={e => patchIv(x => { x.useAi = e.target.checked; })} /> Use AI to judge
                  <IcpHelp sections={[['What it does', 'Lets the AI that already reads the caller\u2019s answer also say whether it fits. The cue lists below always apply.'], ['How it decides', 'The cue lists below decide first. A checked turn they do not decide is judged by the AI - fits, not the patient, wrong route, repeat, did not understand - and in Act mode the guard acts on it; Listen only writes what it would have done. The call path names the verdict and whether it came from a cue list or the AI. Off = the cue lists only.']]} /></label>
                <span>Recovery budget <input type="number" min={0} max={3} style={{ width: 56 }} value={iv.recoveryBudget ?? 1}
                  onChange={e => patchIv(x => { x.recoveryBudget = Math.max(0, Math.min(3, Number(e.target.value) || 0)); })} />
                  <IcpHelp sections={[['What it does', 'How many times per kind the agent changes course before it takes a free-form message (the Classify card\u2019s catch-all request, else voicemail).']]} /></span>
              </div>
            </div>
            <div className="icp-fld">
              <div className="lab">What the caller says - cue lists <IcpHelp sections={[['What it does', 'Your words add to the platform\u2019s list for each kind, per language. \u201cNever a name\u201d words are never stored as a name.']]} /></div>
              {KINDS.map(([k, label, row]) => {
                const own = iv.cues?.[k]?.[language] ?? [];
                const plat = (icpLine(row, language) || '').split(',').map(x => x.trim()).filter(Boolean);
                return (
                  <div key={k} style={{ marginBottom: 6 }}>
                    <div className="icp-note" style={{ margin: '2px 0' }}><b>{label}</b>{plat.length > 0 && <> &middot; platform: {plat.slice(0, 6).join(', ')}{plat.length > 6 ? ` +${plat.length - 6}` : ''}</>}</div>
                    <IcpPhrases value={own} platform={false} onChange={n => patchIv(x => { x.cues ??= {}; x.cues[k] = { ...(x.cues[k] ?? {}), [language]: n }; })} />
                  </div>
                );
              })}
            </div>
            <div className="icp-fld">
              <div className="lab">Lines the agent says <IcpHelp sections={[['What it does', 'Blank = the platform line, shown as written text.']]} /></div>
              {LINES.map(([k, label]) => (
                <label key={k} className="tenant-form-field" style={{ marginBottom: 6 }}>
                  <span>{label}</span>
                  <input type="text" value={(iv.lines?.[k]?.[language] ?? '') || icpLine('interceptor.guard.line.' + k, language)}
                    onChange={e => { const typed = e.target.value; const plat = icpLine('interceptor.guard.line.' + k, language);
                      patchIv(x => { x.lines ??= {}; x.lines[k] = { ...(x.lines[k] ?? {}), [language]: typed === plat ? '' : typed }; }); }} />
                </label>
              ))}
            </div>
            <div className="icp-pin"><span>&#128274;</span> Wants a person is not checked here - &ldquo;operator&rdquo;, &ldquo;real person&rdquo;, &ldquo;speak to someone&rdquo;&hellip; go to Transfer or end call on every turn.</div>
          </IcpCard>
        );
      })()}

      <IcpCard
        icon="&#8635;" title="Say that again" chip="New" chipKind="new"
        description="Repeats the agent’s last line when the caller did not catch it."
        fires="greeting · classify · capture · confirm · wrap-up"
        enabled={cmds.sayAgain?.enabled !== false}
        onToggle={() => toggleCmd('sayAgain')}
        help={[
          ['What it does', 'The caller did not hear you. The agent repeats exactly what it last said and the call carries on from the same place.'],
          ['When it fires', 'Any caller turn where the caller is expected to speak.'],
          ['Example', '“Sorry?” → the agent repeats its last line, then waits again.'],
        ]}>
        <div className="icp-fld">
          <div className="lab">Phrases the caller might say
            <IcpHelp sections={[['What it does', 'Any of these, said on their own, triggers the repeat. A phrase inside a real answer does not — “sorry, it’s Tylenol” still captures Tylenol.']]} />
          </div>
          <IcpPhrases value={sayAgain.list} platform={sayAgain.platform} onChange={n => setPhrases('sayAgain', n)} />
          <p className="icp-note">Whole-utterance match only, per language.</p>
        </div>
        <div className="icp-fld">
          <div className="lab">Repeat at most
            <IcpHelp sections={[['What it does', 'After this many repeats in a row the call stops repeating and falls through to the normal clarify / hand-off ladder, so a caller who keeps saying “what?” is not left in a loop.']]} />
          </div>
          <div className="icp-inline">
            <input type="number" min={1} max={5} value={cmds.sayAgain?.repeatMax ?? 2}
              onChange={e => onUpdate(d => {
                d.interceptor ??= {}; d.interceptor.commands ??= {};
                (d.interceptor.commands.sayAgain ??= {}).repeatMax = Math.max(1, Math.min(5, Number(e.target.value) || 2));
              })} />
            {/* v12.4.1 (#408): "then continue as normal" is the platform's phrase for the clarify / hand-off
                ladder and a tenant has no reason to know that - it reads as "the agent carries on", which is
                the opposite of what happens. The sentence a tenant needs was behind the tooltip. */}
            <span className="icp-note" style={{ margin: 0 }}>times in a row, then stop repeating and re-ask normally</span>
          </div>
        </div>
        <div className="icp-pin"><span>&#128274;</span> Checked before terminal keywords and off-script questions</div>
      </IcpCard>

      <IcpCard
        icon="&#8677;" title="Transfer or end call" chip="Live" chipKind="live"
        description="Words that take the caller out of the call flow - to staff, voicemail, or the end of the call."
        fires="greeting · classify · capture · confirm · wrap-up"
        /* v12.4.1 (#404): a REAL switch. It read the interceptor header flag and was then disabled, so the card
           said "Live" and could not be moved, with nothing on screen explaining why. Now it writes its own
           field, which TryInterceptTerminalKeyword honours - off behaves exactly like the whole layer being
           off for keywords alone: still scanned and traced, never routed. */
        enabled={termKwOn}
        onToggle={() => onUpdate(d => {
          d.interceptor ??= {}; d.interceptor.commands ??= {};
          d.interceptor.commands.terminalKeyword = { enabled: !termKwOn };
        })}
        help={[
          ['What it does', 'The caller asks to leave, or to be put through. The call goes straight to that terminal from wherever it is.'],
          ['When it fires', 'Any caller turn once the call is past the greeting.'],
          ['Example', '“Can I speak to a person?” → Transfer to staff.'],
        ]}>
        <div className="icp-fld">
          {/* v12.4.0 (#400): a SUMMARY, not a replica. Six bordered blocks - three of them reading "no
              keywords" - became rows for the ones that have keywords, one line for the ones that do not, and
              the count leading instead of trailing. Each row navigates to the terminal card that owns it. */}
          <div className="lab">Keywords <span className="icp-note" style={{ fontWeight: 400, margin: 0 }}>&mdash; {withKw.length} of {rows.length} terminals have them. Edit on the terminal card.</span></div>
          {withKw.map(r => (
            <div key={r.key} className="icp-kwrow">
              <button type="button" className="lnk" onClick={() => onOpen?.({ kind: 'terminal', terminalKey: r.key })}>{r.name} &rarr;</button>
              <span className="kws">{r.keywords.map((k, i) => <span key={`${k}-${i}`} className="kw">{k}</span>)}</span>
            </div>
          ))}
          {withoutKw.length > 0 && (
            <p className="icp-none">No keywords: {withoutKw.map(r => r.name).join(', ')}.</p>
          )}
        </div>
        <div className="icp-fld" style={{ marginBottom: 0 }}>
          <div className="icp-row">
            <div>
              <div className="rt">Match word variants</div>
              <div className="rs">Lets “hanging up” match “hang up”. More forgiving, more likely to over-match &mdash; use clear multi-word phrases.</div>
            </div>
            <label className="tenant-mini-switch" style={{ marginLeft: 'auto' }}>
              <input type="checkbox" checked={looseOn}
                onChange={e => onUpdate(d => { d.interceptor = { ...(d.interceptor ?? {}), looseKeywords: e.target.checked }; })} />
              <span />
            </label>
          </div>
        </div>
      {/* v12.10.22 (#2037, prototype v1.4): "Offer help when nobody can take the call" moved to Transfer to staff › Take a message - the
          switch and its line are no longer here (the stored value is kept, untouched). */}
        <div className="icp-fld" style={{ marginTop: 10, marginBottom: 0 }}>
          <div className="icp-row">
            <div>
              <div className="rt">Offer help when nobody can take the call</div>
              <div className="tenant-field-note" style={{ margin: 0 }}>Moved to <b>Transfer to staff › Take a message</b>.</div>
            </div>
          </div>
        </div>
      </IcpCard>

      <IcpCard
        icon="?" title="Off-script question" chip="Live" chipKind="live"
        description="Answers a mid-call question from the Knowledge Base, then picks the call back up."
        fires="classify · capture · confirm · wrap-up"
        /* v12.4.1 (#409): the header switch and the inner "Answer from the Knowledge Base" row were BOTH bound
           to quickAnswers - one field wearing two controls - and the #402 decline read neither, so turning the
           card off still declined. They are now two questions, because they are two questions:
             header = does the agent recognize an off-script question at all (default ON)
             inner  = having recognized one, does it try the Knowledge Base (opt-in, default off) */
        enabled={offScriptOn}
        onToggle={() => onUpdate(d => {
          d.interceptor ??= {}; d.interceptor.commands ??= {};
          d.interceptor.commands.offScript = { enabled: !offScriptOn };
        })}
        help={[
          ['What it does', 'The caller asks something instead of answering. If it matches a Quick Answer the agent answers it, then re-asks the question. If nothing matches, it says so rather than storing the question as the answer.'],
          ['When it fires', 'After the current step has tried to read the words as an answer — so “how about Tuesday?” is still captured as Tuesday.'],
        ]}>
        <div className="icp-fld">
          <div className="icp-row">
            <div>
              <div className="rt">Answer from the Knowledge Base</div>
              <div className="rs">Uses your <b>Quick Answers</b>. Matching is conservative and declines rather than guessing.</div>
            </div>
            <label className="tenant-mini-switch" style={{ marginLeft: 'auto' }}>
              <input type="checkbox" checked={kbOn}
                onChange={() => onUpdate(d => { d.interceptor = { ...(d.interceptor ?? {}), quickAnswers: !kbOn }; })} />
              <span />
            </label>
          </div>
        </div>
        <div className="icp-fld">
          <div className="lab">Words that make it a question
            <IcpHelp sections={[['What it does', 'How the agent tells a question from an answer. Grammar only — no industry words. Add your own if callers phrase things differently.']]} />
          </div>
          <IcpPhrases value={cues.list} platform={cues.platform}
            onChange={n => onUpdate(d => {
              d.interceptor ??= {}; d.interceptor.commands ??= {};
              d.interceptor.commands.questionCues = { ...(d.interceptor.commands.questionCues ?? {}), [language]: n };
            })} />
          <p className="icp-note">
            {cues.platform ? 'Platform defaults. ' : 'Your wording. '}
            <button type="button" className="icp-lnk" onClick={() => onUpdate(d => {
              d.interceptor ??= {}; d.interceptor.commands ??= {};
              d.interceptor.commands.questionCues = { ...(d.interceptor.commands.questionCues ?? {}), [language]: [] };
            })}>Reset to defaults</button>
          </p>
        </div>
        <div className="icp-fld" style={{ marginBottom: 0 }}>
          <div className="lab">When nothing matches, say
            <IcpHelp sections={[['What it does', 'Spoken when the caller clearly asked something and no Quick Answer covers it. The agent then re-asks the current question. Without this the words would be stored as the answer.']]} />
          </div>
          <input type="text" value={(cmds.declineMessage?.[language] ?? '') || icpLine('interceptor.decline', language)}
            onChange={e => onUpdate(d => {
              d.interceptor ??= {}; d.interceptor.commands ??= {};
              const typed = e.target.value.trim() === icpLine('interceptor.decline', language).trim() ? '' : e.target.value;
              d.interceptor.commands.declineMessage = { ...(d.interceptor.commands.declineMessage ?? {}), [language]: typed };
            })} />
          <p className="icp-note">Spoken to the caller, then the current question is asked again.</p>
        </div>
      </IcpCard>

      <IcpCard
        icon="&#8634;" title="Go back &amp; start over" chip="Moved here" chipKind="new"
        description="Steps the caller back one question, or restarts the request."
        fires="capture · confirm"
        enabled={cmds.goBack?.enabled !== false}
        onToggle={() => toggleCmd('goBack')}
        /* v12.4.1 (#414/#415): THE NOTE HERE USED TO SAY "These already work - the phrases were fixed in code
           and are now yours to edit." Neither half of that was true. DetectMeta matched its OWN hardcoded list
           and never read the document, so an edited phrase changed nothing (#414, fixed in this build); and
           "start over" has no engine implementation AT ALL - no MetaCommand, no branch, nothing reads the list
           (#415, open). Third and fourth instances of the same defect as #404 and #409 in one panel: a control
           with no field behind it. The copy now says what is true. */
        help={[
          ['What it does', 'Lets the caller step back to the previous question. Restarting the whole request is designed but not built yet.'],
          ['When it fires', 'Any caller turn inside a request.'],
          ['Note', 'Go back reads the phrases below. Start over does not yet — the phrases are saved and will be used when it ships.'],
        ]}>
        <div className="icp-fld">
          <div className="lab">Go back</div>
          <IcpPhrases value={goBack.list} platform={goBack.platform} onChange={n => setPhrases('goBack', n)} />
        </div>
        <div className="icp-fld" style={{ marginBottom: 0 }}>
          <div className="lab">Start over <span className="icp-chip later" style={{ marginLeft: 6 }}>Not yet available</span></div>
          <IcpPhrases value={startOver.list} platform={startOver.platform} onChange={n => setPhrases('startOver', n)} />
          <p className="icp-note">Saved, but not yet acted on — the call will not restart from these.</p>
        </div>
      </IcpCard>

      <IcpCard
        icon="&#8644;" title="Change of intent" chip="Not yet available" chipKind="later"
        description="Re-routes the call when the caller switches to a different request."
        fires="capture · confirm · wrap-up"
        enabled={false} disabledToggle
        help={[
          ['What it will do', 'The caller switches to a different request mid-call — booking an appointment, then asking about a refill — and the call re-routes without starting over.'],
          ['Status', 'Designed, not built. Turning this on will do nothing yet.'],
        ]}>
        <p className="icp-note" style={{ margin: 0 }}>Nothing to configure yet. This card is here so the layer is complete and you can see what is coming.</p>
      </IcpCard>
    </div>
  );
}

// v12.9.26 (#946): a machineFilled path ("workflows[0].intents[1].nodes[2].steps[0].prompt|es") in words staff can
// find: the names of the cards it walks through, the field, and the language - "Patient > Appointment > Confirm >
// prompt > Spanish". Unknown shapes fall back to the path itself rather than to nothing.
function describeDocPath(doc: DesignerDocument, key: string): string {
  const bar = key.lastIndexOf('|');
  const path = bar >= 0 ? key.slice(0, bar) : key;
  const lang = bar >= 0 ? key.slice(bar + 1) : '';
  const parts: string[] = [];
  let cur: unknown = doc;
  for (const seg of path.split('.')) {
    const m = /^([^[\]]+)((?:\[\d+\])*)$/.exec(seg);
    if (!m) { parts.push(seg); cur = undefined; continue; }
    cur = cur && typeof cur === 'object' ? (cur as Record<string, unknown>)[m[1]] : undefined;
    const idx = [...m[2].matchAll(/\[(\d+)\]/g)].map(x => Number(x[1]));
    for (const i of idx) cur = Array.isArray(cur) ? cur[i] : undefined;
    if (idx.length > 0 && cur && typeof cur === 'object') {
      const o = cur as Record<string, unknown>;
      const name = [o.name, o.label, o.displayName].find(v => typeof v === 'string' && (v as string).trim()) as string | undefined;
      parts.push(name ?? m[1]);
    } else {
      parts.push(m[1]);
    }
  }
  const langName = lang ? (LANGUAGE_INFO as Record<string, { name?: string }>)[lang]?.name ?? lang.toUpperCase() : '';
  return [...parts, langName].filter(Boolean).join(' \u203a ');
}

// v12.9.26 (#934): the confidence dropdown ALWAYS shows the stored value. 0.75 is offered; any other stored value
// appears as its own option instead of the select silently showing the first one (Harlem's 0.75 read '0.50 · lenient').
const THRESHOLD_BASE = ['0.5', '0.6', '0.7', '0.75', '0.8', '0.9'];
function thresholdOptions(stored?: number): string[] {
  const v = stored === undefined || stored === null ? null : String(stored);
  return v && !THRESHOLD_BASE.includes(v) ? [...THRESHOLD_BASE, v].sort((a, b) => Number(a) - Number(b)) : THRESHOLD_BASE;
}
function thresholdLabels(stored?: number): Record<string, string> {
  const l: Record<string, string> = { '0.5': '0.50 \u00b7 lenient', '0.6': '0.60', '0.7': '0.70', '0.75': '0.75', '0.8': '0.80 \u00b7 strict', '0.9': '0.90 \u00b7 very strict' };
  if (stored !== undefined && stored !== null && !l[String(stored)]) l[String(stored)] = Number(stored).toFixed(2);
  return l;
}

// v12.9.26 (#967): Classify / Language detect 'Ask cap' - total asks. A workflow saved before 12.9.26 holds only
// repeatFrequency (re-asks) and shows as repeatFrequency + 1, so Harlem's '1 re-ask' reads 'Ask cap 2' and no call changes.
const ASK_CAP_OPTIONS = ['1', '2', '3', '4'];
const ASK_CAP_LABELS: Record<string, string> = { '1': '1 \u00b7 ask once', '2': '2 \u00b7 ask, then once more', '3': '3 \u00b7 ask, then twice more', '4': '4 \u00b7 ask, then three more times' };

function TextField({ label, value, disabled, onChange, help, placeholder }: { label: string; value: string; disabled?: boolean; onChange: (value: string) => void; help?: HelpSection[]; placeholder?: string }) {
  return (
    <label className="tenant-form-field">
      <span>{label}{help && <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={help} /></span>}</span>
      <input disabled={disabled} value={value} placeholder={placeholder} onChange={event => onChange(event.target.value)} />
    </label>
  );
}

function TextArea({ label, value, onChange, help }: { label: string; value: string; onChange: (value: string) => void; help?: HelpSection[] }) {
  return (
    <label className="tenant-form-field">
      <span>{label}{help && <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={help} /></span>}</span>
      <textarea value={value} onChange={event => onChange(event.target.value)} />
    </label>
  );
}

// v12.10.4 (#1119): `off` = options shown but not selectable, with why ("off - switch the Outside operator line on ...").
function SelectField({ label, value, options, labels, onChange, help, off }: { label: string; value: string; options: string[]; labels?: Record<string, string>; onChange: (value: string) => void; help?: HelpSection[]; off?: Record<string, string> }) {
  return (
    <label className="tenant-form-field">
      <span>{label}{help && <span className="ai-agent-panel tenant-help-scope"><HelpTooltip sections={help} /></span>}</span>
      <select value={value} onChange={event => onChange(event.target.value)}>
        {options.map(option => <option key={option} value={option} disabled={!!off?.[option]}>{labels?.[option] ?? option}{off?.[option] ? ` (${off[option]})` : ''}</option>)}
      </select>
    </label>
  );
}

function findCardContext(doc: DesignerDocument, card: CardRef) {
  if (card.kind === 'preRouting') {
    const pre = PRE_ROUTING_CARDS.find(item => item.key === card.key)!;
    return { title: cardTitleForPreRouting(doc, card.key), subtitle: pre.stage, color: pre.color };
  }
  if (card.kind === 'workflow') {
    const workflow = doc.workflows?.find(item => item.id === card.workflowId);
    return workflow ? { title: workflow.name || 'Workflow', subtitle: 'Workflow', color: HIERARCHY_COLORS.workflow } : null;
  }
  if (card.kind === 'intent') {
    const intent = doc.workflows?.find(item => item.id === card.workflowId)?.intents?.find(item => item.id === card.intentId);
    return intent ? { title: intent.label || 'Intent', subtitle: 'Intent', color: HIERARCHY_COLORS.intent } : null;
  }
  if (card.kind === 'node') {
    const node = findNode(doc, card);
    return node ? { title: node.label || 'Node', subtitle: node.type || 'Node', color: nodeColor(node.type) } : null;
  }
  if (card.kind === 'step') {
    const step = findStep(doc, card);
    return step ? { title: step.label || 'Step', subtitle: step.kind || 'Step', color: HIERARCHY_COLORS.steps } : null;
  }
  if (card.kind === 'interceptor') {
    return { title: 'Interceptor', subtitle: 'Mid-call handling', color: '#6d28d9' };
  }
  if (card.kind === 'phrases') {
    return { title: 'Phrases', subtitle: 'Every line the agent speaks', color: '#0f766e' };
  }
  if (card.kind === 'readbacks') {   // v12.10.21 (#1957)
    return { title: 'Read-backs', subtitle: 'Shared - every workflow and intent · lane 7', color: READBACKS_COLOR };
  }
  // v12.3.11 (#312): a shared node's drawer says so in the subtitle, so an edit's blast radius is never a surprise.
  if (card.kind === 'sharedNode') {
    const sn = (doc.sharedNodes ?? []).find(n => n.id === card.nodeId);
    // v12.3.16 (#383 copy): a shared node runs in every intent of ONE caller type now, not the whole document.
    const ownerName = (doc.workflows ?? []).find(w => w.id === sn?.sharedWorkflowId)?.name;
    return sn ? { title: sn.label || 'Shared node',
      subtitle: ownerName ? `Shared — runs in every ${ownerName} intent` : 'Shared — runs in every intent',
      color: SHARED_NODE_COLOR } : null;
  }
  // v12.3.0 (#238): the terminal drawer title uses its Name when set, else the built-in label.
  const tName = doc.terminalConfig?.[card.terminalKey]?.name;
  return { title: (tName && tName.trim()) || TERMINAL_LABELS[card.terminalKey] || card.terminalKey, subtitle: 'Terminal', color: HIERARCHY_COLORS.terminal };
}

// v12.2.41.0 (#239): set/clear a node outcome that routes to a terminal ('' target clears it -> engine default).
function setOutcomeTerminal(list: WorkflowOutcome[] | undefined, key: string, target: string): WorkflowOutcome[] {
  const rest = (list ?? []).filter(oc => oc.key !== key);
  return target ? [...rest, { key, routeKind: 'terminal', routeTarget: target }] : rest;
}

// v12.4.16 (#503): the sentinel for "carry on down the node sequence" in a routing dropdown.
// It is not a terminal key, so it cannot collide with one - terminals are plain words like "thankyou".
const ROUTE_CONTINUE = '__continue__';

// v12.4.16 (#503): a routing choice that may be CONTINUE, a terminal, or nothing (use the tenant default).
//
// Tushar, 2026-09-19, on a failed integration: "we need one choice here instead of only terminal cards
// 'Continue to next node'. what that will do is, the api connectivity is a failure but the call itself is not
// a failure." Exactly right - a booking that could not be made still wants to give the caller a reference
// number and close properly, which is what the cards AFTER the Connect node are for.
//
// The data model already supported this: WorkflowDesignerOutcome.RouteKind has always been
// continue | card | terminal. Only the dropdown was missing the option.
function setOutcomeRoute(list: WorkflowOutcome[] | undefined, key: string, choice: string): WorkflowOutcome[] {
  const rest = (list ?? []).filter(oc => oc.key !== key);
  if (choice === ROUTE_CONTINUE) return [...rest, { key, routeKind: 'continue', routeTarget: null }];
  return choice ? [...rest, { key, routeKind: 'terminal', routeTarget: choice }] : rest;
}

// The current value of a routing dropdown: CONTINUE, a terminal key, or '' for "use the default".
function outcomeRouteValue(list: WorkflowOutcome[] | undefined, key: string): string {
  const oc = (list ?? []).find(o => o.key === key);
  if (!oc) return '';
  return oc.routeKind === 'continue' ? ROUTE_CONTINUE : (oc.routeTarget ?? '');
}

function findNode(doc: DesignerDocument, card: Extract<CardRef, { kind: 'node' | 'step' | 'sharedNode' }>) {
  // v12.3.11 (#312): a shared node lives at document level, not inside an intent. Resolving it here means
  // every mutator in NodeEditor/StepEditor — which all go through findNode — edits the ONE shared definition,
  // so a change made from any intent lands everywhere with no duplicated editor code.
  if (card.kind === 'sharedNode') return (doc.sharedNodes ?? []).find(node => node.id === card.nodeId);
  return doc.workflows
    ?.find(workflow => workflow.id === card.workflowId)
    ?.intents?.find(intent => intent.id === card.intentId)
    ?.nodes?.find(node => node.id === card.nodeId);
}

function findStep(doc: DesignerDocument, card: Extract<CardRef, { kind: 'step' }>) {
  return findNode(doc, card)?.steps?.find(step => step.id === card.stepId);
}

// v12.10.7 (#1125, UI-LOCK-WORKFLOW-TEMPLATES v1.2 §4): pick a newer version of your template or a different one, then
// HOW to take it - "Keep my changes, add what is new" (recommended) or "Replace everything". The summary (kept as yours /
// updated / added / removed in vN) shows BEFORE anything is saved, from POST change-template/preview.
type MergeSummaryDto = { keptAsYours: string[]; updated: string[]; added: string[]; removedKept: string[]; unchanged: number };
function ChangeTemplateDialog({
  currentId,
  currentVersion,
  selectedId,
  templates,
  saving,
  onSelect,
  onClose,
  onCopy,
}: {
  currentId: number;
  currentVersion: number;
  selectedId: number | null;
  templates: WorkflowTemplateOption[];
  saving: boolean;
  onSelect: (id: number) => void;
  onClose: () => void;
  onCopy: (mode: 'keep' | 'replace') => void;
}) {
  const selected = templates.find(template => template.id === selectedId);
  const current = templates.find(t => t.id === currentId);
  const [mode, setMode] = useState<'keep' | 'replace'>('keep');
  const changing = !!selected && selected.id !== currentId;
  const { data: preview, isFetching } = useQuery<{ canKeep: boolean; reason?: string | null; version: number; summary?: MergeSummaryDto | null }>({
    queryKey: ['t2-change-template-preview', selectedId],
    queryFn: () => api.post('/t2/workflow-modal/change-template/preview', { templateId: selectedId }),
    enabled: changing,
  });
  useEffect(() => { if (preview && !preview.canKeep) setMode('replace'); }, [preview]);
  const v = selected?.templateVersion;
  const sorted = [...templates].sort((a, b) =>
    Number(b.templateKey === current?.templateKey) - Number(a.templateKey === current?.templateKey) || b.templateVersion - a.templateVersion);
  const sum = preview?.summary;
  const list = (items: string[]) => items.length ? <ul style={{ margin: '4px 0 0 18px' }}>{items.slice(0, 8).map(x => <li key={x}>{x}</li>)}{items.length > 8 && <li>and {items.length - 8} more</li>}</ul> : null;
  return (
    <div className="tenant-dialog-backdrop" onClick={onClose}>
      <section className="tenant-template-dialog" onClick={event => event.stopPropagation()}>
        <header>
          <div>
            <h2>Change template</h2>
            <p>Pick a newer version of your template, or a different template.</p>
          </div>
          <button type="button" onClick={onClose}>x</button>
        </header>
        <div className="tenant-template-option-list">
          {sorted.map(template => (
            <button
              key={template.id}
              type="button"
              className={selectedId === template.id ? 'active' : ''}
              onClick={() => onSelect(template.id)}
            >
              <strong>{template.templateName} v{template.templateVersion}</strong>
              <span>{template.id === currentId ? 'your current version'
                : template.templateKey === current?.templateKey && template.templateVersion > currentVersion ? `newer${template.publishedAt ? ` · published ${new Date(template.publishedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}` : ''}`
                : template.templateKey === current?.templateKey ? 'an older version' : `a different template · ${template.categoryName}`}</span>
              {template.id === currentId && <em>Current template</em>}
            </button>
          ))}
        </div>
        {changing && (
          <div className="tenant-change-modes">
            <strong>How to take it</strong>
            <label className={mode === 'keep' ? 'on' : ''}>
              <input type="radio" name="change-mode" checked={mode === 'keep'} disabled={preview ? !preview.canKeep : false} onChange={() => setMode('keep')} />
              <span><b>Keep my changes, add what is new</b> <em>Recommended</em><br />Cards you edited stay as you have them; cards you never touched take v{v}; cards new in v{v} are added switched off, for you to review.</span>
            </label>
            <label className={mode === 'replace' ? 'on' : ''}>
              <input type="radio" name="change-mode" checked={mode === 'replace'} onChange={() => setMode('replace')} />
              <span><b>Replace everything</b><br />Your workflow becomes exactly v{v}. Your current one is kept as "Replaced" so it can be looked at.</span>
            </label>
            {preview && !preview.canKeep && <Alert variant="warn">{preview.reason}</Alert>}
            {mode === 'keep' && isFetching && <p className="tenant-field-note">Working out what changes…</p>}
            {mode === 'keep' && sum && (
              <div className="tenant-change-summary">
                <div><b>Kept as yours ({sum.keptAsYours.length})</b>{list(sum.keptAsYours)}</div>
                <div><b>Updated to v{v} ({sum.updated.length})</b>{list(sum.updated)}</div>
                <div><b>Added, switched off ({sum.added.length})</b>{list(sum.added)}</div>
                <div><b>Removed in v{v} - kept, marked ({sum.removedKept.length})</b>{list(sum.removedKept)}</div>
                <div className="tenant-field-note">{sum.unchanged} card{sum.unchanged === 1 ? '' : 's'} already the same.</div>
              </div>
            )}
            {mode === 'replace' && <Alert variant="warn">Replace everything: your current workflow is kept as Replaced and {selected?.templateName} v{v} becomes active exactly as published.</Alert>}
          </div>
        )}
        <footer>
          <button className="tenant-secondary" type="button" onClick={onClose}>Cancel</button>
          <button className="tenant-primary" type="button" disabled={!changing || saving || (mode === 'keep' && (!preview || !preview.canKeep))} onClick={() => onCopy(mode)}>
            {saving ? 'Changing...' : `Change to v${v ?? ''}`}
          </button>
        </footer>
      </section>
    </div>
  );
}

// VoiceSpectrum.Web.T2 - v12.2.12.0 - 2026-07-10 - VoiceSpectrum AI
